<div [formGroup]="_form" class="page-chat content-layout" fxLayout="column">
  <calsoft-page-header [height]="'160px'" background="url(assets/images/headers/pattern-3.png)" [reverse]="true">
  </calsoft-page-header>

  <div class="container" fxFlex fxLayout="column">
    <calsoft-breadcrumbs [url]="title" [currentPage]="title" [header]="'primary'">
    </calsoft-breadcrumbs>

    <div class="card" fxFlex fxLayout="column">
      <mat-drawer-container>
        <mat-drawer [mode]="mobileQuery.matches ? 'over' : 'side'" (openedChange)="drawerChange($event)"
          [opened]="drawerOpen$ | async" class="mat-elevation-z1 drawer" position="start">
          <div class="sidenav-container" fxFlex fxLayout="column">
            <div class="chat-toolbar" fxLayout="row" fxLayoutAlign="start center">
              <button [attr.guide]="'template-btn-1' + '__' + sanitizedUrl" fxHide fxShow.gt-md fxShow.gt-sm
                matTooltip="Back" (click)="cancel()" color="primary" mat-icon-button>
                <mat-icon>keyboard_arrow_left</mat-icon>
              </button>
              <span fxHide fxShow.gt-md fxShow.gt-sm>{{title | slice:0:30 }}</span>
              <span fxHide fxShow.lt-md fxShow.lt-sm>Select a Tab</span>
              <!-- <img class="avatar pointer" src="assets/img/demo/avatars/noavatar.png"> -->
              <span fxFlex>
                <!-- fill space -->
              </span>
              <!-- <button [attr.guide]="'template-btn-2' + '__' + sanitizedUrl" mat-icon-button [matMenuTriggerFor]="userMenu">
                <mat-icon>more_vert</mat-icon>
              </button> -->
            </div>
            <calsoft-scrollbar class="flex-auto" *ngIf="layoutMainType==1">
              <mat-nav-list class="chat-contacts">
                <mat-list-item class="chat-contact" *ngFor="let link of links; let i = index" (click)="menuLink(i)"
                  [class.highlighted]="i == menu">
                  <div fxLayoutAlign="start center">
                    <p class="name">{{ link.viewValue }}</p>
                  </div>
                </mat-list-item>
              </mat-nav-list>
            </calsoft-scrollbar>
            <!-- <calsoft-scrollbar class="flex-auto" *ngIf="layoutMainType==2">
              <mat-nav-list class="chat-contacts">

                <span *ngFor="let link of links; let i = index">
                  <p style="font-weight: bold;font-size: 15px;">{{ link.viewValue }}</p>
                </span>

                <mat-list-item *ngFor="let item of filedName; let i = index" (click)="addNew1(item.value , i)">
                  <div fxLayoutAlign="start center">
                    <p class="name">{{ item.viewValue }}</p>
                  </div>
                </mat-list-item>
              </mat-nav-list>
            </calsoft-scrollbar> -->

            <div class="flex-auto" *ngIf="layoutMainType==3 ">

              <mat-nav-list class="chat-contacts">
                <mat-list-item class="chat-contact" formArrayName="conditions" *ngFor="
                let comp of _form.get('conditions')['controls']; let i = index" (click)="setDefaultIndex(i)"
                  [class.highlighted]="i == defaultIndex " isMatnavlistOpen=false; class="nav-list">
                  <div [formGroupName]="i">
                    <div fxLayoutAlign="start center" fxLayoutGap="20px">
                      <a matLinevalue="menu">
                        {{ comp.value.type }}


                      </a>
                      <div>

                        <div *ngIf="comp.status=='VALID'; else elseBlock">
                          <mat-icon class="success">
                            check_circle_outline</mat-icon>

                        </div>
                        <ng-template #elseBlock>
                          <mat-icon class="danger">
                            error_outline</mat-icon>
                        </ng-template>
                      </div>
                    </div>






                  </div>
                </mat-list-item>
              </mat-nav-list>
              <!-- <mat-nav-list class="chat-contacts">
              
                <span  *ngFor="let link of links; let i = index">
                  <p style="font-weight: bold;font-size: 15px;" >{{ link.viewValue }}</p>
                </span>

                <mat-list-item *ngFor="let item of filedName; let i = index" (click)="addNew1(item.value , i)">
                  <div fxLayoutAlign="start center">
                    <p class="name">{{ item.viewValue }}</p>
                  </div>
                </mat-list-item> 
              </mat-nav-list> -->
            </div>

            <div class="flex-auto" *ngIf="layoutMainType==4">
              <mat-nav-list class="custom-nav-list">
                <mat-list-item class="custom-list-item" formArrayName="conditions"
                  *ngFor="let comp of _form.get('conditions')['controls']; let i = index"
                  (click)="setDefaultIndex(i);scrollToFormSection(i)" [class.selected]="i === defaultIndex">
                  <div [formGroupName]="i" fxLayoutAlign="start center" fxLayoutGap="12px" class="item-content">
                    <mat-icon class="radio-icon">radio_button_checked</mat-icon>
                    <span class="item-label">{{ comp.value.type | titlecase }}</span>
                  </div>
                </mat-list-item>
              </mat-nav-list>
            </div>

          </div>
        </mat-drawer>
        <mat-drawer-content>

          <div class="chat-inner-container" fxLayout="column">
            <div class="chat-toolbar" fxLayout="row" fxLayoutAlign="start center">
              <button [attr.guide]="'template-btn-3' + '__' + sanitizedUrl" fxHide fxShow.lt-md type="button"
                mat-icon-button (click)="openDrawer()">
                <mat-icon>menu</mat-icon>
              </button>

              <div class="current-contact" fxLayout="row" fxLayoutAlign="start center">
                <!-- <img class="avatar pointer" [src]="activeChat.picture"> -->

                <div fxLayout="column" fxLayoutAlign="center">
                  <!-- <span class="name">{{ activeChat.name }}</span> -->
                  <span class="status"></span>
                </div>
              </div>

              <span fxFlex>
                <!-- fill space -->
              </span>
              <div fxLayout="row" fxLayoutGap="10px">

                <button [attr.guide]="'template-btn-5' + '__' + sanitizedUrl" *ngIf="_form.value.conditions.length==0"
                  (click)="useTemplate()" mat-raised-button>
                  Use Template
                </button>

                <button [attr.guide]="'template-btn-6' + '__' + sanitizedUrl" *ngIf="_form.value.conditions.length==0"
                  (click)="copy()" mat-raised-button>
                  Copy From Other layout
                </button>

                <button [attr.guide]="'template-btn-7' + '__' + sanitizedUrl" (click)="saveData()"
                  [disabled]="text != 'Save'" mat-raised-button>
                  {{ text }}
                  <mat-icon *ngIf="text != 'Save'">
                    <mat-spinner color="primary" diameter="20"> </mat-spinner>
                  </mat-icon>
                </button>
              </div>

              <!-- <button [attr.guide]="'template-btn-8' + '__' + sanitizedUrl" mat-icon-button>
              <mat-icon>attach_file</mat-icon>
            </button>
  
            <button [attr.guide]="'template-btn-9' + '__' + sanitizedUrl" mat-icon-button [matMenuTriggerFor]="chatMenu">
              <mat-icon>more_vert</mat-icon>
            </button> -->
            </div>

            <div class="flex-auto overflow-hidden">
              <calsoft-scrollbar class="p-4 flex-auto">
                <div class="messages-container">
                  <div *ngIf="menu == 0">
                    <div class="editSets1" style="overflow: scroll;">
                      <div class="title" fxLayout="row" fxLayoutAlign.xs="end center"
                        [fxLayoutAlign]="type != 1 ? 'space-between center' : 'space-between center'">
                        <span fxHide fxShow.gt-md fxShow.gt-sm>{{title | slice:0:30 }}</span>

                        <ng-container *ngIf="!layoutRestriction && layoutMainType !== 2">
                          <button [attr.guide]="'template-btn-10' + '__' + sanitizedUrl" [disabled]="!create"
                            mat-mini-fab (click)="addNew()" color="primary">
                            <mat-icon>add</mat-icon>
                          </button>
                        </ng-container>




                        <ng-container *ngIf="layoutRestriction" fxLayoutAlign="end end">

                          <button [attr.guide]="'template-btn-11' + '__' + sanitizedUrl"
                            [disabled]="!(this._form.value.conditions.length<layoutRestrictionValue)" mat-mini-fab
                            (click)="addNew()" color="primary">
                            <mat-icon>add</mat-icon>
                          </button>
                        </ng-container>

                      </div>

                      <div class="products-padding">
                        <div [formGroup]="_form">
                          <div formArrayName="conditions" fxLayout="column" fxLayoutGap="10px">
                            <div *ngFor="
                                  let comp of _form.get('conditions')['controls'];
                              e    let i = index
                                ">
                              <div [formGroupName]="i">
                                <div *ngIf="(defaultIndex == i && layoutMainType == 3)||layoutMainType!=3 ">
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                                    <div fxFlex *ngIf="comp.controls.type.value==''" [id]="'formSection-' + i">

                                      <mat-form-field fxFlex *ngIf="!homepageLimitedRestriction">
                                        <mat-label>Type</mat-label>
                                        <mat-select [disabled]="disabled(comp.controls.type.value)" (selectionChange)="
                                            onChangeImage($event, i)
                                          " required formControlName="type" name="item">
                                          <mat-option *ngFor="
                                              let item of filedName;
                                              let i = index
                                            " [value]="item.value">
                                            {{ item.viewValue }}
                                          </mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="
                                            comp.controls.type.errors?.required && comp.controls.type.value!='image'
                                          ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>

                                      <mat-form-field fxFlex *ngIf="homepageLimitedRestriction">
                                        <mat-label>Type</mat-label>
                                        <mat-select (selectionChange)="
                                            onChangeImage($event, i)
                                          " required formControlName="type" name="item">
                                          <mat-option *ngFor="
                                              let item of filedName1;
                                              let i = index
                                            " [value]="item.value">
                                            {{ item.viewValue }}
                                          </mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="
                                            comp.controls.type.errors?.required && comp.controls.type.value!='image'
                                          ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>

                                    </div>

                                    <div fxFlex *ngIf="comp.controls.type.value!=''" [id]="'formSection-' + i">

                                      <mat-form-field fxFlex>
                                        <mat-label>Type</mat-label>
                                        <input [attr.guide]="'template-inp-type' + '__' + sanitizedUrl" readonly
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          required matInput formControlName="type" />

                                      </mat-form-field>

                                    </div>
                                    <div fxFlex *ngIf="comp.controls.type.value!='' && layoutMainType !== 4">


                                      <mat-form-field fxFlex>
                                        <mat-label>ID</mat-label>
                                        <input [attr.guide]="'template-inp-customfield35' + '__' + sanitizedUrl"
                                          trim="blur" [autocomplete]="'off'" matInput formControlName="customField35" />

                                      </mat-form-field>

                                    </div>




                                    <ng-container
                                      *ngIf="comp.controls['type'].value == 'category' || comp.controls['type'].value == 'subscription'">
                                      <mat-form-field fxFlex>
                                        <mat-label>Category</mat-label>
                                        <mat-select required formControlName="value" [disableOptionCentering]="true"
                                          #singleSelect name="item">
                                          <mat-option>
                                            <ngx-mat-select-search name="Category Search" ngDefaultControl
                                              [formControl]="
                                                categoryFilterControl
                                              " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                true
                                              " noEntriesFoundLabel="No data found">
                                            </ngx-mat-select-search>
                                          </mat-option>
                                          <mat-option *ngFor="
                                              let opt of filteredCategoryTypeList
                                            " [value]="opt.categoryId">
                                            {{ opt.categoryName }}
                                          </mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="
                                            comp.controls.value.errors?.required
                                          ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>


                                    <ng-container *ngIf="comp.controls['type'].value == 'productScope'">
                                      <mat-form-field fxFlex>
                                        <mat-label>Custom Product Scope</mat-label>
                                        <mat-select required formControlName="value" [disableOptionCentering]="true"
                                          #singleSelect name="item" required>
                                          <mat-option>
                                            <ngx-mat-select-search name="Custom Product Scope Search" ngDefaultControl
                                              [formControl]="
                                            productScopeFilterControl
                                              " placeholderLabel="Product Scope Search" [preventHomeEndKeyPropagation]="
                                                true
                                              " noEntriesFoundLabel="No data found">
                                            </ngx-mat-select-search>
                                          </mat-option>
                                          <mat-option (onSelectionChange)="setProductScope($event,opt,'customField1',i)"
                                            *ngFor="let opt of filteredproductScopeTypeList;"
                                            [value]="opt.customProductScopeId">
                                            {{ opt.type }}
                                          </mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="
                                            comp.controls.value.errors?.required
                                          ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container *ngIf="comp.controls['type'].value == 'customerReviews'">
                                      <mat-form-field fxFlex>
                                        <mat-label>Custom Review Scope</mat-label>
                                        <mat-select required formControlName="value" [disableOptionCentering]="true"
                                          #singleSelect name="item">
                                          <mat-option>
                                            <ngx-mat-select-search name="Custom Review Product Scope Search"
                                              ngDefaultControl [formControl]="
                                            customScopeFilterControl
                                              " placeholderLabel="Product ReviewScope Search"
                                              [preventHomeEndKeyPropagation]="
                                                true
                                              " noEntriesFoundLabel="No data found">
                                            </ngx-mat-select-search>
                                          </mat-option>
                                          <mat-option (onSelectionChange)="setCustomScope($event,opt,'customField1',i)"
                                            *ngFor="let opt of filteredcustomScopeTypeList;"
                                            [value]="opt.customReviewScopeId">
                                            {{ opt.type }}
                                          </mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="
                                            comp.controls.value.errors?.required
                                          ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <!-- <ng-container *ngIf="comp.controls['type'].value == 'otherCustomization'">
                                      <mat-form-field fxFlex>
                                        <mat-label>Category</mat-label>
                                        <mat-select required formControlName="value" [disableOptionCentering]="true"
                                          #singleSelect name="item">
                                          <mat-option>
                                            <ngx-mat-select-search name="Category Search" ngDefaultControl [formControl]="
                                                categoryFilterControl
                                              " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                true
                                              " noEntriesFoundLabel="No data found">
                                            </ngx-mat-select-search>
                                          </mat-option>
                                          <mat-option [value]="0">
                                            Features Category
                                      </mat-option>
                                          <mat-option *ngFor="
                                              let opt of filteredCategoryTypeList
                                            " [value]="opt.categoryId">
                                            {{ opt.categoryName }}
                                          </mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="
                                            comp.controls.value.errors?.required
                                          ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container> -->

                                    <ng-container *ngIf="comp.controls['type'].value == 'textWithImage'">
                                      <mat-form-field fxFlex>
                                        <mat-label>Navigation</mat-label>
                                        <mat-select (selectionChange)="doSomething($event,i,'customField2')" required
                                          formControlName="categoryId6" name="item">
                                          <mat-option *ngFor="
                                              let item of navigation;
                                              let i = index
                                            " [value]="item.value">
                                            {{ item.viewValue }}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>
                                    </ng-container>
                                    <ng-container *ngIf="comp.controls['type'].value == 'textWithImage'">
                                      <mat-form-field fxFlex>
                                        <mat-label>
                                          <!-- {{ comp.controls['categoryId6'].value==0? 'Category' :
                                          (comp.controls['categoryId6'].value==1 ? 'Url' : 'Form') }} -->
                                          {{
                                          comp.controls['categoryId6'].value == 0 ? 'Category' :
                                          comp.controls['categoryId6'].value == 1 ? 'Url' :
                                          comp.controls['categoryId6'].value == 2 ? 'Form' :
                                          comp.controls['categoryId6'].value == 3 ? 'Scroll Top' : ''
                                          }}
                                        </mat-label>
                                        <ng-container *ngIf="comp.controls['categoryId6'].value==0">
                                          <mat-select required formControlName="customField2"
                                            [disableOptionCentering]="true" #singleSelect name="item">
                                            <mat-option>
                                              <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                [formControl]="
                                              categoryFilterControl
                                            " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                              true
                                            " noEntriesFoundLabel="No data found">
                                              </ngx-mat-select-search>
                                            </mat-option>
                                            <mat-option *ngFor="
                                            let opt of filteredCategoryTypeList
                                          " [value]="opt.categoryId">
                                              {{ opt.categoryName }}
                                            </mat-option>
                                          </mat-select>
                                        </ng-container>

                                        <ng-container *ngIf="comp.controls['categoryId6'].value==2">
                                          <mat-select formControlName="customField2" [disableOptionCentering]="true"
                                            #singleSelect name="item">
                                            <mat-option>
                                              <ngx-mat-select-search name="Dynamic Form Search" ngDefaultControl
                                                [formControl]="
                                  dynamicFormFilterControl
                                    " placeholderLabel="Dynamic Form Search" [preventHomeEndKeyPropagation]="
                                      true
                                    " noEntriesFoundLabel="No data found">
                                              </ngx-mat-select-search>
                                            </mat-option>
                                            <mat-option *ngFor="let opt of filtereddynamicFormTypeList;"
                                              [value]="opt.formGroupId">
                                              {{ opt.name }}
                                            </mat-option>
                                          </mat-select>
                                        </ng-container>

                                        <ng-container *ngIf="comp.controls['categoryId6'].value==1">
                                          <input [attr.guide]="'template-inp-customfield2' + '__' + sanitizedUrl"
                                            required trim="blur" (keydown.enter)="$event.preventDefault()"
                                            [autocomplete]="'off'" required matInput formControlName="customField2" />
                                        </ng-container>
                                        <ng-container *ngIf="comp.controls['categoryId6'].value==3">
                                          <mat-select formControlName="customField2" disabled>
                                            <mat-option [value]="'scrollTop'">Scroll Top</mat-option>
                                          </mat-select>
                                        </ng-container>
                                        <mat-error *ngIf="
                                          comp.controls.customField2.errors?.required
                                        ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>


                                    <ng-container
                                      *ngIf="comp.controls['type'].value == 'textwithform'|| comp.controls['type'].value == 'scrolltextwithform'">
                                      <mat-form-field fxFlex>
                                        <mat-label>Layout</mat-label>
                                        <mat-select required formControlName="layout" name="item">
                                          <mat-option *ngFor="let item of formLayoutType" [value]="item.value">
                                            {{item.viewValue}}
                                          </mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="comp.controls.layout.errors?.required">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>


                                    <ng-container *ngIf="comp.controls['type'].value == 'category'
                                       || comp.controls['type'].value == 'otherCustomization'
                                       || comp.controls['type'].value == 'productScope'
                                       || comp.controls['type'].value == 'tabLayout'
                                       ">
                                      <mat-form-field fxFlex>
                                        <mat-label>Layout</mat-label>
                                        <mat-select required formControlName="layout" name="item">
                                          <mat-option *ngFor="
                                              let item of layout1;
                                              let i = index
                                            " [value]="item.type">
                                            {{ item.viewValue }} -
                                            {{ item.value }}
                                          </mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="
                                            comp.controls.layout.errors?.required
                                          ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container *ngIf="comp.controls['type'].value=='blogData'">
                                      <mat-form-field fxFlex>
                                        <mat-label>Layout</mat-label>
                                        <mat-select formControlName="layout">
                                          <mat-option *ngFor="let item of blogType" [value]="item.value">
                                            {{item.viewValue}}
                                          </mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="
                                            comp.controls.layout.errors?.required
                                          ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container *ngIf="comp.controls['type'].value=='partnerData'">
                                      <mat-form-field fxFlex>
                                        <mat-label>Layout</mat-label>
                                        <mat-select formControlName="layout">
                                          <mat-option *ngFor="let item of partnerType" [value]="item.value">
                                            {{item.viewValue}}
                                          </mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="
                                            comp.controls.layout.errors?.required
                                          ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <!-- select layout type -->

                                    <ng-container *ngIf="comp.controls['type'].value == 'banner'">
                                      <mat-form-field fxFlex>
                                        <mat-label>Select Layout Type</mat-label>
                                        <mat-select required formControlName="customField1" name="item">
                                          <mat-option *ngFor="let item of layoutType" [value]="item.viewValue">
                                            {{item.value}}
                                          </mat-option>
                                        </mat-select>
                                        <mat-error *ngIf=" comp.controls.customField1.errors?.required ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container *ngIf="comp.controls['type'].value == 'bannerTextWithButton' ">
                                      <mat-form-field fxFlex>
                                        <mat-label>Select Layout Type</mat-label>
                                        <mat-select required formControlName="customField1" name="item">
                                          <mat-option *ngFor="let item of layoutType4" [value]="item.viewValue">
                                            {{item.value}}
                                          </mat-option>

                                        </mat-select>
                                        <mat-error *ngIf=" comp.controls.customField1.errors?.required ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>
                                    <ng-container *ngIf="comp.controls['type'].value == 'categoryCarouselWithBanner' ">
                                      <mat-form-field fxFlex>
                                        <mat-label>Select Layout Type</mat-label>
                                        <mat-select required formControlName="customField1" name="item">
                                          <mat-option *ngFor="let item of layoutType3" [value]="item.viewValue">
                                            {{item.value}}
                                          </mat-option>

                                        </mat-select>
                                        <mat-error *ngIf=" comp.controls.customField1.errors?.required ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container *ngIf="
                                        comp.controls['type'].value == 'category'
                                        || comp.controls['type'].value == 'otherCustomization'    ">
                                      <mat-form-field fxFlex>
                                        <mat-label>SortOrder</mat-label>

                                        <mat-select required formControlName="sortOrder" name="item">
                                          <mat-option *ngFor="
                                              let item of sortings;
                                              let i = index
                                            " [value]="item.value">
                                            {{ item.viewValue }}
                                          </mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="
                                            comp.controls.sortOrder.errors
                                              ?.required
                                          ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container *ngIf="comp.controls['type'].value != 'banner'
                                  && comp.controls['type'].value != 'image'  
                                  && comp.controls['type'].value != 'tabLayout'  
                                  && comp.controls['type'].value != 'categoryCarousel'  
                                  && comp.controls['type'].value != 'blogData'
                                  && comp.controls['type'].value != 'maps'
                                  && comp.controls['type'].value != 'mapsWithContactForm'  ">
                                      <mat-form-field fxFlex>
                                        <mat-label>Title</mat-label>
                                        <input [attr.guide]="'template-inp-title' + '__' + sanitizedUrl" trim="blur"
                                          (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" required
                                          matInput formControlName="title" />
                                        <mat-error *ngIf="
                                            comp.controls.title.errors?.required
                                          ">
                                          Please fill out this field.
                                        </mat-error>
                                        <mat-icon class="clickable"
                                          (click)="openEditorText(comp.controls['title'].value,i,'title')" matSuffix>
                                          post_add
                                        </mat-icon>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container *ngIf="comp.controls['type'].value == 'tabLayout'">
                                      <mat-form-field fxFlex>
                                        <mat-label>Title</mat-label>
                                        <input [attr.guide]="'template-inp-title' + '__' + sanitizedUrl" trim="blur"
                                          (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" matInput
                                          formControlName="title" />

                                        <mat-icon class="clickable"
                                          (click)="openEditorText(comp.controls['title'].value,i,'title')" matSuffix>
                                          post_add
                                        </mat-icon>
                                      </mat-form-field>
                                    </ng-container>

                                    <mat-form-field fxFlex *ngIf="comp.controls['type'].value == 'partners'">
                                      <mat-label>Type</mat-label>
                                      <mat-select formControlName="customField23">
                                        <mat-option *ngFor="let status of partner_type" [value]="status.viewValue">
                                          {{status.value}}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>

                                    <mat-form-field fxFlex
                                      *ngIf="comp.controls['type'].value == 'ScrollWithAnimatedReview'">
                                      <mat-label>Layout Type</mat-label>
                                      <mat-select formControlName="customField14">
                                        <mat-option *ngFor="let item of scrolltype" [value]="item.value">
                                          {{item.viewValue}}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>



                                    <ng-container *ngIf="(comp.controls['type'].value == 'maps'
                                  || comp.controls['type'].value == 'mapsWithContactForm'  
                                  )">
                                      <mat-form-field fxFlex>
                                        <mat-label>Link</mat-label>
                                        <input [attr.guide]="'template-inp-title' + '__' + sanitizedUrl" trim="blur"
                                          (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" required
                                          matInput formControlName="title" />
                                        <mat-error *ngIf="
                                            comp.controls.title.errors?.required
                                          ">
                                          Please fill out this field.
                                        </mat-error>
                                        <!-- <mat-icon class="clickable"
                                        (click)="openEditorText(comp.controls['title'].value,i,'title')" matSuffix>
                                        post_add
                                      </mat-icon> -->
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container *ngIf="( comp.controls['type'].value == 'image')">
                                      <mat-form-field fxFlex>
                                        <mat-label>Image Count</mat-label>
                                        <mat-select [disabled]="
                                            comp.controls['layout'].value != ''
                                          " (selectionChange)="onChange($event, i)" required formControlName="layout"
                                          name="item">
                                          <mat-option *ngFor="let item of [1, 2, 3, 4]" [value]="item">
                                            {{ item }}
                                          </mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="
                                        comp.controls['type'].value == 'image' &&
                                        comp.controls['value'].value == ''
                                      ">
                                          Please fill out this field.
                                        </mat-error>

                                      </mat-form-field>


                                    </ng-container>

                                    <ng-container *ngIf="( comp.controls['type'].value == 'image')">
                                      <mat-form-field fxFlex>
                                        <mat-label>Layout</mat-label>

                                        <mat-select formControlName="customField10" name="item">
                                          <mat-option *ngFor="let item of layoutType1" [value]="item.value">
                                            {{item.value}}
                                          </mat-option>

                                        </mat-select>

                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container
                                      *ngIf="( comp.controls['type'].value == 'ScrollWithTextAndImage'  || comp.controls['type'].value == 'vedioBanner')">
                                      <mat-form-field fxFlex>
                                        <mat-label>Type</mat-label>

                                        <mat-select formControlName="customField10" name="item">
                                          <mat-option *ngFor="let item of layoutType5" [value]="item.value">
                                            {{item.value}}
                                          </mat-option>

                                        </mat-select>

                                      </mat-form-field>
                                    </ng-container>




                                    <ng-container *ngIf="comp.controls['type'].value == 'textWithImage'|| comp.controls['type'].value == 'mapsWithContactForm' || comp.controls['type'].value == 'tabLayout' 
                                    || comp.controls['type'].value == 'textwithform' || comp.controls['type'].value == 'scrolltextwithform' 
                                    || comp.controls['type'].value == 'faq'  ">
                                      <mat-form-field fxFlex>
                                        <mat-label>Image Side</mat-label>
                                        <mat-select required formControlName="customField3" name="item">
                                          <mat-option *ngFor="let item of ['left','right']" [value]="item">
                                            {{ item | uppercase}}
                                          </mat-option>

                                        </mat-select>
                                        <mat-error *ngIf=" comp.controls.customField3.errors?.required ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container *ngIf=" comp.controls['type'].value == 'mapsWithContactForm'">
                                      <mat-form-field fxFlex>
                                        <mat-label>Title</mat-label>
                                        <input [attr.guide]="'template-inp-customfield4' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          required matInput formControlName="customField4" />
                                        <mat-error *ngIf="
                                            comp.controls.position.errors
                                              ?.required
                                          ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <button [attr.guide]="'template-btn-12' + '__' + sanitizedUrl"
                                      [disabled]="!updatepermission" mat-icon-button color="warn"
                                      (click)="removeOption(i)">
                                      <mat-icon>remove_circle_outline</mat-icon>
                                    </button>
                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="( comp.controls['type'].value == 'subscription') ">
                                    <mat-form-field fxFlex>
                                      <mat-label>Title Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield33' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField33" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Title Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield34' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField34" />
                                    </mat-form-field>



                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="( comp.controls['type'].value == 'partnerData') ">
                                    <mat-form-field fxFlex>
                                      <mat-label>Title Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield33' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField33" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Title Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield34' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField34" />
                                    </mat-form-field>



                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="( comp.controls['type'].value == 'PyramidWithTextAndImage') ">
                                    <mat-form-field fxFlex>
                                      <mat-label>Title Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield33' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField33" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Title Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield34' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField34" />
                                    </mat-form-field>



                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value == 'banner' && comp.controls.customField1.value == 'type13' && layoutMainType !== 4">
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Sub Title</mat-label>
                                        <input [attr.guide]="'template-inp-customfield27' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField27" />
                                        <mat-error *ngIf="
                                          comp.controls.title.errors?.required
                                        ">
                                          Please fill out this field.
                                        </mat-error>
                                        <mat-icon class="clickable"
                                          (click)="openEditorText(comp.controls['title'].value,i,'title')" matSuffix>
                                          post_add
                                        </mat-icon>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Button name 1</mat-label>
                                        <input [attr.guide]="'template-inp-customfield25' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField25" />
                                        <mat-error *ngIf="
                                          comp.controls.position.errors
                                            ?.required
                                        ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Button name 2</mat-label>
                                        <input [attr.guide]="'template-inp-customfield26' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField26" />
                                        <mat-error *ngIf="
                                          comp.controls.position.errors
                                            ?.required
                                        ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Button Link 1</mat-label>
                                        <input [attr.guide]="'template-inp-customfield23' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField23" />
                                        <mat-error *ngIf="
                                          comp.controls.position.errors
                                            ?.required
                                        ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Button Link 2</mat-label>
                                        <input [attr.guide]="'template-inp-customfield24' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField24" />
                                        <mat-error *ngIf="
                                          comp.controls.position.errors
                                            ?.required
                                        ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="(comp.controls['type'].value == 'ScrollWithAnimatedReview' || 'ScrollWithAnimatedReviewTwo') && comp.controls['type'].value != 'ScrollWithTextAndImage' && comp.controls['type'].value != 'FreeTextWithBanner' && comp.controls['type'].value != 'ImageWithTextTwo' && layoutMainType !== 4">
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Sub Title One</mat-label>
                                        <input [attr.guide]="'template-inp-customfield20' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField20" />
                                        <mat-error *ngIf="
                                      comp.controls.position.errors
                                        ?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Sub Title Two</mat-label>
                                        <input [attr.guide]="'template-inp-customfield21' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField21" />
                                        <mat-error *ngIf="
                                      comp.controls.position.errors
                                        ?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container *ngIf="( comp.controls['type'].value != 'table')">
                                      <mat-form-field fxFlex>
                                        <mat-label>Sub Paragraph</mat-label>
                                        <textarea [attr.guide]="'template-sel-customfield22' + '__' + sanitizedUrl"
                                          trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5
                                          matInput formControlName="customField22"></textarea>
                                        <mat-error *ngIf="
                                      comp.controls.position.errors
                                        ?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container *ngIf="( comp.controls['type'].value == 'table')">
                                      <mat-form-field fxFlex>
                                        <mat-label>Sub Paragraph</mat-label>
                                        <input [attr.guide]="'template-inp-customfield24' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField24" />
                                        <mat-error *ngIf="
                                      comp.controls.position.errors
                                        ?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                        <mat-icon class="clickable"
                                          (click)="openEditorText(comp.controls['customField24'].value,i,'customField24')"
                                          matSuffix>
                                          post_add
                                        </mat-icon>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Card Height</mat-label>
                                        <input [attr.guide]="'template-inp-customfield17' + '__' + sanitizedUrl"
                                          (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                          formControlName="customField17" matInput />
                                      </mat-form-field>
                                    </ng-container>



                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value == 'ScrollWithAnimatedReview'">
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Sub Review One</mat-label>
                                        <input [attr.guide]="'template-inp-customfield23' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField23" />
                                        <mat-error *ngIf="
                                      comp.controls.position.errors
                                        ?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Sub Review Two</mat-label>
                                        <input [attr.guide]="'template-inp-customfield24' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField24" />
                                        <mat-error *ngIf="
                                      comp.controls.position.errors
                                        ?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Sub Review One Color</mat-label>
                                        <input [attr.guide]="'template-inp-customfield25' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField25" />
                                        <mat-error *ngIf="
                                      comp.controls.position.errors
                                        ?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Sub Review Two Color</mat-label>
                                        <input [attr.guide]="'template-inp-customfield26' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField26" />
                                        <mat-error *ngIf="
                                      comp.controls.position.errors
                                        ?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>



                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value == 'ScrollWithAnimatedReview'">
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Sub Review One Count</mat-label>
                                        <input [attr.guide]="'template-inp-customfield27' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField27" />
                                        <mat-error *ngIf="
                                      comp.controls.position.errors
                                        ?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Sub Review Two Count</mat-label>
                                        <input [attr.guide]="'template-inp-customfield28' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField28" />
                                        <mat-error *ngIf="
                                      comp.controls.position.errors
                                        ?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Secondary Color</mat-label>
                                        <input [attr.guide]="'template-inp-customfield29' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField29" />
                                        <mat-error *ngIf="
                                      comp.controls.position.errors
                                        ?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Primary Color</mat-label>
                                        <input [attr.guide]="'template-inp-customfield30' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField30" />
                                        <mat-error *ngIf="
                                      comp.controls.position.errors
                                        ?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>



                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value == 'ScrollWithAnimatedReview'">
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Title font size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield31' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField31" />
                                        <mat-error *ngIf="
                                      comp.controls.position.errors
                                        ?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Title mobile font size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield32' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField32" />
                                        <mat-error *ngIf="
                                      comp.controls.position.errors
                                        ?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Review Content font size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield33' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField33" />
                                        <mat-error *ngIf="
                                      comp.controls.position.errors
                                        ?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Review Content mobile font size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield34' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField34" />
                                        <mat-error *ngIf="
                                      comp.controls.position.errors
                                        ?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>



                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value == 'ComparisonCorrection' || comp.controls['type'].value == 'OrderSuccess'">
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Title font size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield31' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField31" />
                                        <mat-error *ngIf="
                                      comp.controls.position.errors
                                        ?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>
                                    <mat-form-field fxFlex>
                                      <mat-label>Sub Title</mat-label>
                                      <input [attr.guide]="'template-inp-customfield20' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField20" />
                                      <mat-error *ngIf="
                                        comp.controls.title.errors?.required
                                      ">
                                        Please fill out this field.
                                      </mat-error>
                                      <mat-icon class="clickable"
                                        (click)="openEditorText(comp.controls['customField20'].value,i,'customField20')"
                                        matSuffix>
                                        post_add
                                      </mat-icon>
                                    </mat-form-field>

                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Title mobile font size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield32' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField32" />
                                        <mat-error *ngIf="
                                      comp.controls.position.errors
                                        ?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Subtitle font size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield33' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField33" />
                                        <mat-error *ngIf="
                                      comp.controls.position.errors
                                        ?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Subtitle mobile font size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield34' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField34" />
                                        <mat-error *ngIf="
                                      comp.controls.position.errors
                                        ?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>



                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value == 'ComparisonCorrection'">
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Left title</mat-label>
                                        <input [attr.guide]="'template-inp-customfield35' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField35" />
                                        <mat-error *ngIf="
                                      comp.controls.position.errors
                                        ?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Right Title</mat-label>
                                        <input [attr.guide]="'template-inp-customfield36' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField36" />
                                        <mat-error *ngIf="
                                      comp.controls.position.errors
                                        ?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Table Title font size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield37' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField37" />
                                        <mat-error *ngIf="
                                      comp.controls.position.errors
                                        ?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Table Title mobile font size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield38' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField38" />
                                        <mat-error *ngIf="
                                      comp.controls.position.errors
                                        ?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>



                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value == 'ComparisonCorrection'">
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Left Array Size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield39' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField39" />
                                        <mat-error *ngIf="
                                      comp.controls.position.errors
                                        ?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Right Array Size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield40' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField40" />
                                        <mat-error *ngIf="
                                      comp.controls.position.errors
                                        ?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Table Content font size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield28' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField28" />
                                        <mat-error *ngIf="
                                      comp.controls.position.errors
                                        ?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Table Content mobile font size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield29' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField29" />
                                        <mat-error *ngIf="
                                      comp.controls.position.errors
                                        ?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>



                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value == 'ComparisonCorrection'">
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Left Button</mat-label>
                                        <input [attr.guide]="'template-inp-customfield14' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField14" />
                                        <mat-error *ngIf="
                                      comp.controls.position.errors
                                        ?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Right Button</mat-label>
                                        <input [attr.guide]="'template-inp-customfield15' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField15" />
                                        <mat-error *ngIf="
                                      comp.controls.position.errors
                                        ?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Left Button link</mat-label>
                                        <input [attr.guide]="'template-inp-customfield16' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField16" />
                                        <mat-error *ngIf="
                                      comp.controls.position.errors
                                        ?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Right Button link</mat-label>
                                        <input [attr.guide]="'template-inp-customfield17' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField17" />
                                        <mat-error *ngIf="
                                      comp.controls.position.errors
                                        ?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>



                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value == 'ComparisonCorrection'">
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Left Paragraph</mat-label>
                                        <input [attr.guide]="'template-inp-customfield18' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField18" />
                                        <mat-error *ngIf="
                                      comp.controls.position.errors
                                        ?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Right Paragraph</mat-label>
                                        <input [attr.guide]="'template-inp-customfield19' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField19" />
                                        <mat-error *ngIf="
                                      comp.controls.position.errors
                                        ?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>type</mat-label>

                                        <mat-select formControlName="customField10" name="item">
                                          <mat-option *ngFor="let item of comparetype" [value]="item.value">
                                            {{item.value}}
                                          </mat-option>

                                        </mat-select>

                                      </mat-form-field>
                                    </ng-container>

                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value == 'ScrollWithAnimatedReview'">

                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Reviewer Name font size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield37' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField37" />
                                        <mat-error *ngIf="
                                    comp.controls.position.errors
                                      ?.required
                                  ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Reviewer Name mobile font size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield38' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField38" />
                                        <mat-error *ngIf="
                                    comp.controls.position.errors
                                      ?.required
                                  ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>



                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value == 'ScrollWithAnimatedReview'">
                                    <ng-container>

                                      <calsoft-image fxFlex="40" style="padding-bottom: 10px;"
                                        (deleteResult)="updatesIMage($event, i,'customField15')" (fileUploadResult)="
                                    getResultts($event, i,'customField15') " [index]="i"
                                        [value]="comp.controls['customField15'].value">
                                      </calsoft-image>
                                    </ng-container>
                                    <ng-container>
                                      <calsoft-image fxFlex="40" style="padding-bottom: 10px;"
                                        (deleteResult)="updatesIMage($event, i,'customField16')" (fileUploadResult)="
                                getResultts($event, i,'customField16') " [index]="i"
                                        [value]="comp.controls['customField16'].value">
                                      </calsoft-image>
                                    </ng-container>




                                  </div>



                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value == 'ScrollWithTextAndImage'">
                                    <ng-container
                                      *ngIf="comp.controls.customField10.value == 'Type 1' || comp.controls.customField10.value == 'Type 3' || comp.controls.customField10.value == 'Type 4' ">
                                      <mat-form-field fxFlex>
                                        <mat-label>Sub Title</mat-label>
                                        <input [attr.guide]="'template-inp-customfield20' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField20" />
                                        <mat-error *ngIf="
                                        comp.controls.title.errors?.required
                                      ">
                                          Please fill out this field.
                                        </mat-error>
                                        <mat-icon class="clickable"
                                          (click)="openEditorText(comp.controls['customField20'].value,i,'customField20')"
                                          matSuffix>
                                          post_add
                                        </mat-icon>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container
                                      *ngIf="comp.controls.customField10.value == 'Type 1' || comp.controls.customField10.value == 'Type 3' ">
                                      <mat-form-field fxFlex>
                                        <mat-label>Web Sub Title Font Size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield21' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField21" />
                                        <mat-error *ngIf="
                                        comp.controls.position.errors
                                          ?.required
                                      ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container
                                      *ngIf="comp.controls.customField10.value == 'Type 1' || comp.controls.customField10.value == 'Type 3' ">
                                      <mat-form-field fxFlex>
                                        <mat-label>Mobile Sub Title Font Size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield22' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField22" />
                                        <mat-error *ngIf="
                                        comp.controls.position.errors
                                          ?.required
                                      ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container *ngIf="comp.controls.customField10.value == 'Type 2' ">
                                      <mat-form-field fxFlex>
                                        <mat-label>Top Space</mat-label>
                                        <input [attr.guide]="'template-inp-customfield22' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField22" />
                                        <mat-error *ngIf="
                                        comp.controls.position.errors
                                          ?.required
                                      ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container *ngIf="comp.controls.customField10.value == 'Type 2' ">
                                      <mat-form-field fxFlex>
                                        <mat-label>Gap Between Image</mat-label>
                                        <input [attr.guide]="'template-inp-gapbetweenimage' + '__' + sanitizedUrl"
                                          (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                          formControlName="gapBetweenImage" matInput />

                                      </mat-form-field>

                                    </ng-container>

                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Right Side Image Height</mat-label>
                                        <input [attr.guide]="'template-inp-customfield23' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField23" />
                                        <mat-error *ngIf="
                                        comp.controls.position.errors
                                          ?.required
                                      ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Right Side Image width</mat-label>
                                        <input [attr.guide]="'template-inp-customfield24' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField24" />
                                        <mat-error *ngIf="
                                        comp.controls.position.errors
                                          ?.required
                                      ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value == 'ImageWithTextTwo'">
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Sub Title</mat-label>
                                        <input [attr.guide]="'template-inp-customfield10' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField10" />
                                        <mat-error *ngIf="
                                      comp.controls.title.errors?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                        <mat-icon class="clickable"
                                          (click)="openEditorText(comp.controls['customField10'].value,i,'customField10')"
                                          matSuffix>
                                          post_add
                                        </mat-icon>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Web Sub Title Font Size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield11' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField11" />
                                        <mat-error *ngIf="
                                      comp.controls.position.errors
                                        ?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Mobile Sub Title Font Size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield12' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField12" />
                                        <mat-error *ngIf="
                                      comp.controls.position.errors
                                        ?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Enter Type Writing Text with Comas</mat-label>
                                        <input [attr.guide]="'template-inp-customfield22' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField22" />
                                        <mat-error *ngIf="
                                      comp.controls.position.errors
                                        ?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>



                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value == 'ImageWithTextTwo'">
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Sub Paragraph</mat-label>
                                        <input [attr.guide]="'template-inp-customfield14' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField14" />
                                        <mat-error *ngIf="
                                    comp.controls.title.errors?.required
                                  ">
                                          Please fill out this field.
                                        </mat-error>
                                        <mat-icon class="clickable"
                                          (click)="openEditorText(comp.controls['customField14'].value,i,'customField14')"
                                          matSuffix>
                                          post_add
                                        </mat-icon>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Web Sub Paragraph Font Size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield15' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField15" />
                                        <mat-error *ngIf="
                                    comp.controls.position.errors
                                      ?.required
                                  ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Mobile Sub Paragraph Font Size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield16' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField16" />
                                        <mat-error *ngIf="
                                    comp.controls.position.errors
                                      ?.required
                                  ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Button One Text</mat-label>
                                        <input [attr.guide]="'template-inp-customfield17' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField17" />
                                        <mat-error *ngIf="
                                    comp.controls.position.errors
                                      ?.required
                                  ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Button Two Text</mat-label>
                                        <input [attr.guide]="'template-inp-customfield18' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField18" />
                                        <mat-error *ngIf="
                                    comp.controls.position.errors
                                      ?.required
                                  ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>


                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value == 'ImageWithTextTwo'">


                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Buttons Text Color</mat-label>
                                        <input [attr.guide]="'template-inp-customfield19' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField19" />
                                        <mat-error *ngIf="
                                  comp.controls.position.errors
                                    ?.required
                                ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Button 1 BackGround Color</mat-label>
                                        <input [attr.guide]="'template-inp-customfield20' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField20" />
                                        <mat-error *ngIf="
                                  comp.controls.position.errors
                                    ?.required
                                ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Button 2 BackGround Color</mat-label>
                                        <input [attr.guide]="'template-inp-customfield21' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField21" />
                                        <mat-error *ngIf="
                                  comp.controls.position.errors
                                    ?.required
                                ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container>
                                      <calsoft-image fxFlex="100" style="padding-bottom: 10px;"
                                        (deleteResult)="updatesIMage($event, i,'customField22')" (fileUploadResult)="
                               getResultts($event, i,'customField22') " [index]="i"
                                        [value]="comp.controls['customField22'].value">
                                      </calsoft-image>
                                    </ng-container>



                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value == 'ImageWithTextTwo'">


                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Buttons 1 Navigation</mat-label>
                                        <input [attr.guide]="'template-inp-customfield23' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField23" />
                                        <mat-error *ngIf="
                                    comp.controls.position.errors
                                      ?.required
                                  ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Buttons 2 Navigation</mat-label>
                                        <input [attr.guide]="'template-inp-customfield24' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField24" />
                                        <mat-error *ngIf="
                                    comp.controls.position.errors
                                      ?.required
                                  ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Primary Color</mat-label>
                                        <input [attr.guide]="'template-inp-customfield25' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField25" />
                                        <mat-error *ngIf="
                                    comp.controls.position.errors
                                      ?.required
                                  ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Secondary Color</mat-label>
                                        <input [attr.guide]="'template-inp-customfield26' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField26" />
                                        <mat-error *ngIf="
                                    comp.controls.position.errors
                                      ?.required
                                  ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>




                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value == 'FreeTextWithBanner'">
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Sub Title</mat-label>
                                        <input [attr.guide]="'template-inp-customfield10' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField10" />
                                        <mat-error *ngIf="
                                        comp.controls.title.errors?.required
                                      ">
                                          Please fill out this field.
                                        </mat-error>
                                        <mat-icon class="clickable"
                                          (click)="openEditorText(comp.controls['customField10'].value,i,'customField10')"
                                          matSuffix>
                                          post_add
                                        </mat-icon>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Web Sub Title Font Size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield11' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField11" />
                                        <mat-error *ngIf="
                                        comp.controls.position.errors
                                          ?.required
                                      ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Mobile Sub Title Font Size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield12' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField12" />
                                        <mat-error *ngIf="
                                        comp.controls.position.errors
                                          ?.required
                                      ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Background Color</mat-label>
                                        <input [attr.guide]="'template-inp-customfield22' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField22" />
                                        <mat-error *ngIf="
                                        comp.controls.position.errors
                                          ?.required
                                      ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>



                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value == 'FreeTextWithBanner'">
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Sub Paragraph</mat-label>
                                        <input [attr.guide]="'template-inp-customfield14' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField14" />
                                        <mat-error *ngIf="
                                      comp.controls.title.errors?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                        <mat-icon class="clickable"
                                          (click)="openEditorText(comp.controls['customField14'].value,i,'customField14')"
                                          matSuffix>
                                          post_add
                                        </mat-icon>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Web Sub Paragraph Font Size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield15' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField15" />
                                        <mat-error *ngIf="
                                      comp.controls.position.errors
                                        ?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Mobile Sub Paragraph Font Size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield16' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField16" />
                                        <mat-error *ngIf="
                                      comp.controls.position.errors
                                        ?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Button One Text</mat-label>
                                        <input [attr.guide]="'template-inp-customfield17' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField17" />
                                        <mat-error *ngIf="
                                      comp.controls.position.errors
                                        ?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Button Two Text</mat-label>
                                        <input [attr.guide]="'template-inp-customfield18' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField18" />
                                        <mat-error *ngIf="
                                      comp.controls.position.errors
                                        ?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>


                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value == 'FreeTextWithBanner'">


                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Buttons Text Color</mat-label>
                                        <input [attr.guide]="'template-inp-customfield19' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField19" />
                                        <mat-error *ngIf="
                                    comp.controls.position.errors
                                      ?.required
                                  ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Button 1 BackGround Color</mat-label>
                                        <input [attr.guide]="'template-inp-customfield20' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField20" />
                                        <mat-error *ngIf="
                                    comp.controls.position.errors
                                      ?.required
                                  ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Button 2 BackGround Color</mat-label>
                                        <input [attr.guide]="'template-inp-customfield21' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField21" />
                                        <mat-error *ngIf="
                                    comp.controls.position.errors
                                      ?.required
                                  ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container>
                                      <calsoft-image fxFlex="100" style="padding-bottom: 10px;"
                                        (deleteResult)="updatesIMage($event, i,'customField22')" (fileUploadResult)="
                                  getResultts($event, i,'customField22') " [index]="i"
                                        [value]="comp.controls['customField22'].value">
                                      </calsoft-image>
                                    </ng-container>



                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value == 'FreeTextWithBanner'">


                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Buttons 1 Navigation</mat-label>
                                        <input [attr.guide]="'template-inp-customfield23' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField23" />
                                        <mat-error *ngIf="
                                    comp.controls.position.errors
                                      ?.required
                                  ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Buttons 2 Navigation</mat-label>
                                        <input [attr.guide]="'template-inp-customfield24' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField24" />
                                        <mat-error *ngIf="
                                    comp.controls.position.errors
                                      ?.required
                                  ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>
                                    </ng-container>




                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value == 'PyramidWithTextAndImage'">
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Slide One Title</mat-label>
                                        <input [attr.guide]="'template-inp-customfield20' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField20" />
                                        <mat-error *ngIf="
                                      comp.controls.title.errors?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                        <mat-icon class="clickable"
                                          (click)="openEditorText(comp.controls['customField20'].value,i,'customField20')"
                                          matSuffix>
                                          post_add
                                        </mat-icon>
                                      </mat-form-field>
                                    </ng-container>
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Slide One Description</mat-label>
                                        <input [attr.guide]="'template-inp-customfield21' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField21" />
                                        <mat-error *ngIf="
                                      comp.controls.title.errors?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                        <mat-icon class="clickable"
                                          (click)="openEditorText(comp.controls['customField21'].value,i,'customField21')"
                                          matSuffix>
                                          post_add
                                        </mat-icon>
                                      </mat-form-field>
                                    </ng-container>
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Slide Two Title</mat-label>
                                        <input [attr.guide]="'template-inp-customfield22' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField22" />
                                        <mat-error *ngIf="
                                      comp.controls.title.errors?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                        <mat-icon class="clickable"
                                          (click)="openEditorText(comp.controls['customField22'].value,i,'customField22')"
                                          matSuffix>
                                          post_add
                                        </mat-icon>
                                      </mat-form-field>
                                    </ng-container>
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Slide Two Description</mat-label>
                                        <input [attr.guide]="'template-inp-customfield23' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField23" />
                                        <mat-error *ngIf="
                                      comp.controls.title.errors?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                        <mat-icon class="clickable"
                                          (click)="openEditorText(comp.controls['customField23'].value,i,'customField23')"
                                          matSuffix>
                                          post_add
                                        </mat-icon>
                                      </mat-form-field>
                                    </ng-container>


                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value == 'PyramidWithTextAndImage'">
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Slide Three Title</mat-label>
                                        <input [attr.guide]="'template-inp-customfield24' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField24" />
                                        <mat-error *ngIf="
                                    comp.controls.title.errors?.required
                                  ">
                                          Please fill out this field.
                                        </mat-error>
                                        <mat-icon class="clickable"
                                          (click)="openEditorText(comp.controls['customField24'].value,i,'customField24')"
                                          matSuffix>
                                          post_add
                                        </mat-icon>
                                      </mat-form-field>
                                    </ng-container>
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Slide Three Description</mat-label>
                                        <input [attr.guide]="'template-inp-customfield25' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField25" />
                                        <mat-error *ngIf="
                                    comp.controls.title.errors?.required
                                  ">
                                          Please fill out this field.
                                        </mat-error>
                                        <mat-icon class="clickable"
                                          (click)="openEditorText(comp.controls['customField25'].value,i,'customField25')"
                                          matSuffix>
                                          post_add
                                        </mat-icon>
                                      </mat-form-field>
                                    </ng-container>
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label> Slide Title Web Font Size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield26' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField26" />
                                      </mat-form-field>
                                    </ng-container>
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label>Slide Title Mobile Font Size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield27' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField27" />
                                      </mat-form-field>
                                    </ng-container>


                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value == 'PyramidWithTextAndImage'">
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label> Slide Description Web font Size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield35' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField35" />
                                      </mat-form-field>
                                    </ng-container>
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label> Slide Description Mobile Font Size </mat-label>
                                        <input [attr.guide]="'template-inp-customfield36' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField36" />
                                      </mat-form-field>
                                    </ng-container>




                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value == 'PyramidWithTextAndImage'">
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label> Image Web Height</mat-label>
                                        <input [attr.guide]="'template-inp-customfield28' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField28" />
                                      </mat-form-field>
                                    </ng-container>
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label> Image Web Width</mat-label>
                                        <input [attr.guide]="'template-inp-customfield29' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField29" />
                                      </mat-form-field>
                                    </ng-container>
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label> Image Mobile Height</mat-label>
                                        <input [attr.guide]="'template-inp-customfield30' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField30" />
                                      </mat-form-field>
                                    </ng-container>
                                    <ng-container>
                                      <mat-form-field fxFlex>
                                        <mat-label> Image Mobile Width</mat-label>
                                        <input [attr.guide]="'template-inp-customfield31' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField31" />
                                      </mat-form-field>
                                    </ng-container>



                                  </div>

                                  <!-- <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                            *ngIf="comp.controls['type'].value == 'PyramidWithTextAndImage'">
                            pavo
                            <calsoft-image fxFlex="100" style="padding-bottom: 10px;"
                            (deleteResult)="updatesImageArray($event, i,'customField8',y)"
                            (fileUploadResult)="
              getResultArray($event, i,'customField8',y) " [index]="y"
                            [value]="ImageInfo.controls['customField8'].value">
                          </calsoft-image>
                          </div> -->

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="( comp.controls['type'].value == 'ScrollWithTextAndImage' || comp.controls['type'].value == 'ScrollWithTextAndAnimatedImage') ">
                                    <mat-form-field fxFlex>
                                      <mat-label>Mobile Right Side Image Height</mat-label>
                                      <input [attr.guide]="'template-inp-customfield25' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField25" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Mobile Right Side Image width</mat-label>
                                      <input [attr.guide]="'template-inp-customfield26' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField26" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Title Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield33' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField33" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Title Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield34' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField34" />
                                    </mat-form-field>
                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="( comp.controls['type'].value == 'ScrollWithTextAndImage' || comp.controls['type'].value == 'ScrollWithTextAndAnimatedImage') ">
                                    <mat-form-field fxFlex>
                                      <mat-label>Right side Title Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield27' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField27" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Right side Title Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield28' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField28" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Right side Description Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield29' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField29" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Right side Description Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield31' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField31" />
                                    </mat-form-field>

                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value == 'ScrollWithTextAndImage' && comp.controls.customField10.value == 'Type 4'  ">
                                    <calsoft-image fxFlex="100" style="padding-bottom: 10px;"
                                      (deleteResult)="updatesIMage($event, i,'customField30')" (fileUploadResult)="
                              getResultts($event, i,'customField30') " [index]="i"
                                      [value]="comp.controls['customField30'].value">
                                    </calsoft-image>
                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="(comp.controls['type'].value == 'ScrollWithTextAndAnimatedImage') ">
                                    <mat-form-field fxFlex>
                                      <mat-label>Main BackGround Color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield35' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField35" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Primary Color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield36' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField36" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Secondary Color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield37' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField37" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Navigation Link</mat-label>
                                      <input [attr.guide]="'template-inp-customfield38' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField38" />
                                    </mat-form-field>
                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="(comp.controls['type'].value == 'ScrollWithTextAndAnimatedImage') ">
                                    <mat-form-field fxFlex>
                                      <mat-label>Secondary Title</mat-label>
                                      <input [attr.guide]="'template-inp-customfield39' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField39" />
                                    </mat-form-field>

                                  </div>
                                  <div *ngIf="(comp.controls['type'].value == 'ScrollWithAnimatedReviewTwo')">

                                    <div class="editSets">
                                      <div class="title-head3" fxLayoutAlign="space-between center" color="primary">
                                        <span>Review Information</span>

                                        <button [attr.guide]="'template-btn-13' + '__' + sanitizedUrl" class="create"
                                          (click)=" addFaq(i)" type="button" mat-mini-fab color="primary">
                                          <mat-icon>add</mat-icon>
                                        </button>
                                      </div>
                                      <div id="responsieTable" class="container">
                                        <table fxFlex="100">
                                          <tbody fxFlex="100">
                                            <ng-container formArrayName="images">
                                              <tr fxLayout.xs="column"
                                                *ngFor="let ImageInfo of comp.get('images')?.controls; let y = index">
                                                <ng-container [formGroupName]="y" fxLayoutAlign="space-between center">
                                                  <td fxFlex.xs="100" fxFlex="30" data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="100" appearance="outline">
                                                        <mat-label>Review Content</mat-label>
                                                        <textarea
                                                          [attr.guide]="'template-sel-customfield10' + '__' + sanitizedUrl"
                                                          trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                          matAutosizeMaxRows=5 matInput
                                                          formControlName="customField10"></textarea>
                                                      </mat-form-field>
                                                    </span>
                                                  </td>


                                                  <td fxFlex.xs="100" fxFlex="30" data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="100" appearance="outline">
                                                        <mat-label>Reviewer Count</mat-label>
                                                        <textarea
                                                          [attr.guide]="'template-sel-customfield11' + '__' + sanitizedUrl"
                                                          trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                          matAutosizeMaxRows=5 matInput
                                                          formControlName="customField11"></textarea>

                                                      </mat-form-field>
                                                    </span>
                                                  </td>



                                                  <td fxFlex.xs="100" fxFlex="30" data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <calsoft-image fxFlex="100" style="padding-bottom: 10px;"
                                                        (deleteResult)="updatesImageArray($event, i,'customField13',y)"
                                                        (fileUploadResult)="
                                    getResultArray($event, i,'customField13',y) " [index]="y"
                                                        [value]="ImageInfo.controls['customField13'].value">
                                                      </calsoft-image>
                                                    </span>
                                                  </td>


                                                  <td data-th="Action">
                                                    <span class="wordBreak">
                                                      <button [attr.guide]="'template-btn-14' + '__' + sanitizedUrl"
                                                        color="warn" mat-icon-button type="button"
                                                        (click)="deleteText(i,y)">
                                                        <mat-icon>remove_circle_outline
                                                        </mat-icon>
                                                      </button>
                                                    </span>
                                                  </td>
                                                </ng-container>
                                              </tr>
                                            </ng-container>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                  <div *ngIf="(comp.controls['type'].value == 'ComparisonCorrection')">

                                    <div class="editSets">
                                      <div class="title-head3" fxLayoutAlign="space-between center" color="primary">
                                        <span>Comparison Information</span>

                                        <button [attr.guide]="'template-btn-15' + '__' + sanitizedUrl" class="create"
                                          (click)=" addFaq(i)" type="button" mat-mini-fab color="primary">
                                          <mat-icon>add</mat-icon>
                                        </button>
                                      </div>
                                      <div id="responsieTable" class="container">
                                        <table fxFlex="100">
                                          <tbody fxFlex="100">
                                            <ng-container formArrayName="images">
                                              <tr fxLayout.xs="column"
                                                *ngFor="let ImageInfo of comp.get('images')?.controls; let y = index">
                                                <ng-container [formGroupName]="y" fxLayoutAlign="space-between center">
                                                  <td fxFlex.xs="100" fxFlex="30" data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="100" appearance="outline">
                                                        <mat-label>Slide Description</mat-label>
                                                        <textarea
                                                          [attr.guide]="'template-sel-customfield7' + '__' + sanitizedUrl"
                                                          trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                          matAutosizeMaxRows=5 matInput
                                                          formControlName="customField7"></textarea>
                                                        <mat-icon class="clickable"
                                                          (click)="openEditorTextForImageArray(ImageInfo.controls['customField7'].value,i,'customField7',y)"
                                                          matSuffix>
                                                          post_add
                                                        </mat-icon>
                                                      </mat-form-field>
                                                    </span>
                                                  </td>

                                                  <td data-th="Action">
                                                    <span class="wordBreak">
                                                      <button [attr.guide]="'template-btn-16' + '__' + sanitizedUrl"
                                                        color="warn" mat-icon-button type="button"
                                                        (click)="deleteText(i,y)">
                                                        <mat-icon>remove_circle_outline
                                                        </mat-icon>
                                                      </button>
                                                    </span>
                                                  </td>
                                                </ng-container>
                                              </tr>
                                            </ng-container>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>

                                  <div *ngIf="(comp.controls['type'].value == 'ScrollWithAnimatedReview')">

                                    <div class="editSets">
                                      <div class="title-head3" fxLayoutAlign="space-between center" color="primary">
                                        <span>Review Information</span>

                                        <button [attr.guide]="'template-btn-17' + '__' + sanitizedUrl" class="create"
                                          (click)=" addFaq(i)" type="button" mat-mini-fab color="primary">
                                          <mat-icon>add</mat-icon>
                                        </button>
                                      </div>
                                      <div id="responsieTable" class="container">
                                        <table fxFlex="100">
                                          <tbody fxFlex="100">
                                            <ng-container formArrayName="images">
                                              <tr fxLayout.xs="column"
                                                *ngFor="let ImageInfo of comp.get('images')?.controls; let y = index">
                                                <ng-container [formGroupName]="y" fxLayoutAlign="space-between center">
                                                  <td fxFlex.xs="100" fxFlex="30" data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="100" appearance="outline">
                                                        <mat-label>Review Content</mat-label>
                                                        <input
                                                          [attr.guide]="'template-inp-customfield10' + '__' + sanitizedUrl"
                                                          trim="blur" (keydown.enter)="$event.preventDefault()"
                                                          [autocomplete]="'off'" matInput
                                                          formControlName="customField10" />
                                                        <mat-icon class="clickable"
                                                          (click)="openEditorTextForImageArray(ImageInfo.controls['customField10'].value,i,'customField10',y)"
                                                          matSuffix>
                                                          post_add
                                                        </mat-icon>
                                                      </mat-form-field>
                                                    </span>
                                                  </td>


                                                  <td fxFlex.xs="100" fxFlex="30" data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="100" appearance="outline">
                                                        <mat-label>Reviewer Name</mat-label>
                                                        <input
                                                          [attr.guide]="'template-inp-customfield11' + '__' + sanitizedUrl"
                                                          trim="blur" (keydown.enter)="$event.preventDefault()"
                                                          [autocomplete]="'off'" matInput
                                                          formControlName="customField11" />
                                                        <mat-icon class="clickable"
                                                          (click)="openEditorTextForImageArray(ImageInfo.controls['customField11'].value,i,'customField11',y)"
                                                          matSuffix>
                                                          post_add
                                                        </mat-icon>

                                                      </mat-form-field>
                                                    </span>
                                                  </td>
                                                  <td fxFlex.xs="100" fxFlex="30" data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="100" appearance="outline">
                                                        <mat-label>Two letter Display</mat-label>
                                                        <input
                                                          [attr.guide]="'template-inp-customfield12' + '__' + sanitizedUrl"
                                                          trim="blur" (keydown.enter)="$event.preventDefault()"
                                                          [autocomplete]="'off'" matInput
                                                          formControlName="customField12" />
                                                        <mat-icon class="clickable"
                                                          (click)="openEditorTextForImageArray(ImageInfo.controls['customField12'].value,i,'customField12',y)"
                                                          matSuffix>
                                                          post_add
                                                        </mat-icon>

                                                      </mat-form-field>
                                                    </span>
                                                  </td>


                                                  <td fxFlex.xs="100" fxFlex="30" data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <calsoft-image fxFlex="100" style="padding-bottom: 10px;"
                                                        (deleteResult)="updatesImageArray($event, i,'customField13',y)"
                                                        (fileUploadResult)="
                                    getResultArray($event, i,'customField13',y) " [index]="y"
                                                        [value]="ImageInfo.controls['customField13'].value">
                                                      </calsoft-image>
                                                    </span>
                                                  </td>


                                                  <td data-th="Action">
                                                    <span class="wordBreak">
                                                      <button [attr.guide]="'template-btn-18' + '__' + sanitizedUrl"
                                                        color="warn" mat-icon-button type="button"
                                                        (click)="deleteText(i,y)">
                                                        <mat-icon>remove_circle_outline
                                                        </mat-icon>
                                                      </button>
                                                    </span>
                                                  </td>
                                                </ng-container>
                                              </tr>
                                            </ng-container>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                  <div *ngIf="(comp.controls['type'].value == 'ScrollWithTextAndImage')">
                                    1
                                    <div class="editSets">
                                      <div class="title-head3" fxLayoutAlign="space-between center" color="primary">
                                        <span>Right Slider Information</span>

                                        <button [attr.guide]="'template-btn-19' + '__' + sanitizedUrl" class="create"
                                          (click)=" addFaq(i)" type="button" mat-mini-fab color="primary">
                                          <mat-icon>add</mat-icon>
                                        </button>
                                      </div>
                                      <div id="responsieTable" class="container">
                                        <table fxFlex="100">
                                          <tbody fxFlex="100">
                                            <ng-container formArrayName="images">
                                              <tr fxLayout.xs="column"
                                                *ngFor="let ImageInfo of comp.get('images')?.controls; let y = index">
                                                <ng-container [formGroupName]="y" fxLayoutAlign="space-between center">
                                                  <td fxFlex.xs="100" fxFlex="30" data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="100" appearance="outline">
                                                        <mat-label>Slide title</mat-label>
                                                        <textarea
                                                          [attr.guide]="'template-sel-customfield6' + '__' + sanitizedUrl"
                                                          trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                          matAutosizeMaxRows=5 matInput
                                                          formControlName="customField6"></textarea>
                                                        <mat-icon class="clickable"
                                                          (click)="openEditorTextForImageArray(ImageInfo.controls['customField6'].value,i,'customField6',y)"
                                                          matSuffix>
                                                          post_add
                                                        </mat-icon>
                                                      </mat-form-field>
                                                    </span>
                                                  </td>
                                                  <td fxFlex.xs="100" fxFlex="30" data-th="Filename" fxLayoutGap="10px"
                                                    *ngIf="comp.controls.customField10.value == 'Type 2'">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex>
                                                        <mat-label>Navigation Link</mat-label>
                                                        <input
                                                          [attr.guide]="'template-inp-customfield35' + '__' + sanitizedUrl"
                                                          trim="blur" (keydown.enter)="$event.preventDefault()"
                                                          [autocomplete]="'off'" matInput
                                                          formControlName="customField35" />
                                                      </mat-form-field>
                                                    </span>
                                                  </td>
                                                  <td fxFlex.xs="100" fxFlex="30" data-th="Margintop" fxLayoutGap="10px"
                                                    *ngIf="comp.controls.customField10.value == 'Type 2'">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex>
                                                        <mat-label>Margin-top</mat-label>
                                                        <input
                                                          [attr.guide]="'template-inp-customfield30' + '__' + sanitizedUrl"
                                                          trim="blur" (keydown.enter)="$event.preventDefault()"
                                                          [autocomplete]="'off'" matInput
                                                          formControlName="customField30" />
                                                      </mat-form-field>
                                                    </span>
                                                  </td>


                                                  <td fxFlex.xs="100" fxFlex="30" data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="100" appearance="outline">
                                                        <mat-label>Slide Description</mat-label>
                                                        <textarea
                                                          [attr.guide]="'template-sel-customfield7' + '__' + sanitizedUrl"
                                                          trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                          matAutosizeMaxRows=5 matInput
                                                          formControlName="customField7"></textarea>
                                                        <mat-icon class="clickable"
                                                          (click)="openEditorTextForImageArray(ImageInfo.controls['customField7'].value,i,'customField7',y)"
                                                          matSuffix>
                                                          post_add
                                                        </mat-icon>
                                                      </mat-form-field>
                                                    </span>
                                                  </td>

                                                  <td fxFlex.xs="100" fxFlex="30" data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <calsoft-image fxFlex="100" style="padding-bottom: 10px;"
                                                        (deleteResult)="updatesImageArray($event, i,'customField8',y)"
                                                        (fileUploadResult)="
                                    getResultArray($event, i,'customField8',y) " [index]="y"
                                                        [value]="ImageInfo.controls['customField8'].value">
                                                      </calsoft-image>
                                                    </span>
                                                  </td>


                                                  <td data-th="Action">
                                                    <span class="wordBreak">
                                                      <button [attr.guide]="'template-btn-20' + '__' + sanitizedUrl"
                                                        color="warn" mat-icon-button type="button"
                                                        (click)="deleteText(i,y)">
                                                        <mat-icon>remove_circle_outline
                                                        </mat-icon>
                                                      </button>
                                                    </span>
                                                  </td>
                                                </ng-container>
                                              </tr>
                                            </ng-container>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                  <div *ngIf="(comp.controls['type'].value == 'ScrollWithTextAndAnimatedImage')">

                                    <div class="editSets">
                                      <div class="title-head3" fxLayoutAlign="space-between center" color="primary">
                                        <span>Right Slider Information</span>

                                        <button [attr.guide]="'template-btn-21' + '__' + sanitizedUrl" class="create"
                                          (click)=" addFaq(i)" type="button" mat-mini-fab color="primary">
                                          <mat-icon>add</mat-icon>
                                        </button>
                                      </div>
                                      <div id="responsieTable" class="container">
                                        <table fxFlex="100">
                                          <tbody fxFlex="100">
                                            <ng-container formArrayName="images">
                                              <tr fxLayout.xs="column"
                                                *ngFor="let ImageInfo of comp.get('images')?.controls; let y = index">
                                                <ng-container [formGroupName]="y" fxLayoutAlign="space-between center">
                                                  <td fxFlex.xs="100" fxFlex="30" data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="100" appearance="outline">
                                                        <mat-label>Slide title</mat-label>
                                                        <textarea
                                                          [attr.guide]="'template-sel-customfield6' + '__' + sanitizedUrl"
                                                          trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                          matAutosizeMaxRows=5 matInput
                                                          formControlName="customField6"></textarea>

                                                      </mat-form-field>
                                                    </span>
                                                  </td>


                                                  <td fxFlex.xs="100" fxFlex="30" data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="100" appearance="outline">
                                                        <mat-label>Slide Description</mat-label>
                                                        <textarea
                                                          [attr.guide]="'template-sel-customfield7' + '__' + sanitizedUrl"
                                                          trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                          matAutosizeMaxRows=5 matInput
                                                          formControlName="customField7"></textarea>

                                                      </mat-form-field>
                                                    </span>
                                                  </td>

                                                  <td fxFlex.xs="100" fxFlex="30" data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <calsoft-image fxFlex="100" style="padding-bottom: 10px;"
                                                        (deleteResult)="updatesImageArray($event, i,'customField8',y)"
                                                        (fileUploadResult)="
                                  getResultArray($event, i,'customField8',y) " [index]="y"
                                                        [value]="ImageInfo.controls['customField8'].value">
                                                      </calsoft-image>
                                                    </span>
                                                  </td>


                                                  <td data-th="Action">
                                                    <span class="wordBreak">
                                                      <button [attr.guide]="'template-btn-22' + '__' + sanitizedUrl"
                                                        color="warn" mat-icon-button type="button"
                                                        (click)="deleteText(i,y)">
                                                        <mat-icon>remove_circle_outline
                                                        </mat-icon>
                                                      </button>
                                                    </span>
                                                  </td>
                                                </ng-container>
                                              </tr>
                                            </ng-container>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>



                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                                    <ng-container
                                      *ngIf="( comp.controls['type'].value == 'image')||( comp.controls['type'].value == 'brandsCarousel')||( comp.controls['type'].value == '360View')||( comp.controls['type'].value == 'storeLocations')
                                    ||( comp.controls['type'].value == 'mp4')||( comp.controls['type'].value == 'bannerTextWithButton') ||( comp.controls['type'].value == 'carouselwithProduct') ||( comp.controls['type'].value == 'customGroupLayout')
                                     || ( comp.controls['type'].value == 'categoryCarouselWithBanner')|| ( comp.controls['type'].value == 'tabLayout')
                                     || ( comp.controls['type'].value == 'faq')  || ( comp.controls['type'].value == 'scrolltextwithform') || ( comp.controls['type'].value == 'TypingWithBanner') 
                                     || ( comp.controls['type'].value == 'iconTextWithBackground') || ( comp.controls['type'].value == 'textWithImage')
                                     || ( comp.controls['type'].value == 'vedioBanner') || ( comp.controls['type'].value == 'sliderImageWithText') 
                                     || ( comp.controls['type'].value == 'partners') || ( comp.controls['type'].value == 'scrollableImageForm')
                                     || ( comp.controls['type'].value == 'livePrice')  || ( comp.controls['type'].value == 'TexthoverWithImage')">
                                      <mat-form-field
                                        *ngIf="comp.controls.customField23.value != 16 && comp.controls['type'].value == 'brandsCarousel' && layoutMainType !== 4  "
                                        fxFlex>
                                        <mat-label>Height</mat-label>
                                        <input [attr.guide]="'template-inp-height' + '__' + sanitizedUrl"
                                          (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                          formControlName="height" matInput />

                                      </mat-form-field>


                                      <mat-form-field
                                        *ngIf="comp.controls['type'].value != 'brandsCarousel'&& layoutMainType !== 4  "
                                        fxFlex>
                                        <mat-label>Height</mat-label>
                                        <input [attr.guide]="'template-inp-height' + '__' + sanitizedUrl"
                                          (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                          formControlName="height" matInput />

                                      </mat-form-field>



                                      <mat-form-field fxFlex
                                        *ngIf="( comp.controls['type'].value == 'customGroupLayout') ">
                                        <mat-label>Display View More Option</mat-label>
                                        <!-- <input [attr.guide]="'template-inp-customfield4' + '__' + sanitizedUrl" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        trim="blur" matInput formControlName="customField4"/> -->
                                        <mat-select formControlName="customField4" name="item">
                                          <mat-option *ngFor="let item of displayViewMore" [value]="item.value">
                                            {{item.viewValue}}
                                          </mat-option>
                                        </mat-select>

                                      </mat-form-field>

                                      <mat-form-field fxFlex
                                        *ngIf="( comp.controls['type'].value != 'image')&&( comp.controls['type'].value != '360View') 
                                      && ( comp.controls['type'].value != 'carouselwithProduct') && 
                                       ( comp.controls['type'].value != 'customGroupLayout') && 
                                       ( comp.controls['type'].value != 'tabLayout') && ( comp.controls['type'].value != 'faq') && layoutMainType !== 4  ">
                                        <mat-label>Alt Tag</mat-label>
                                        <input [attr.guide]="'template-inp-altimage' + '__' + sanitizedUrl"
                                          (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                          matInput formControlName="altImage" />

                                      </mat-form-field>

                                      <mat-form-field fxFlex
                                        *ngIf="comp.controls['type'].value === 'scrolltextwithform'">
                                        <mat-label>BackGround Image height</mat-label>
                                        <input [attr.guide]="'template-inp-customfield32' + '__' + sanitizedUrl"
                                          (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                          matInput formControlName="customField32" />

                                      </mat-form-field>


                                      <mat-form-field fxFlex *ngIf="comp.controls['type'].value == 'tabLayout'">
                                        <mat-label>Type</mat-label>
                                        <mat-select formControlName="customField11">
                                          <mat-option *ngFor="let item of tablayouttype" [value]="item.value">
                                            {{item.viewValue}}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>

                                      <mat-form-field fxFlex *ngIf="( comp.controls['type'].value == 'tabLayout')">
                                        <mat-label>Alignment</mat-label>
                                        <mat-select formControlName="customField5">
                                          <mat-option *ngFor="let item of position2" [value]="item.value">
                                            {{item.viewValue}}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>

                                      <mat-form-field fxFlex
                                        *ngIf="( comp.controls['type'].value != '360View' || comp.controls['type'].value == 'bannerTextWithButton'||  comp.controls['type'].value == 'categoryCarouselWithBanner'||  comp.controls['type'].value == 'tabLayout'
                                       ||  comp.controls['type'].value == 'image' || comp.controls['type'].value == 'carouselwithProduct'
                                       || comp.controls['type'].value == 'brandsCarousel'|| comp.controls['type'].value == 'partners' || comp.controls['type'].value != 'faq')">
                                        <mat-label>Gap Between Image</mat-label>
                                        <input [attr.guide]="'template-inp-gapbetweenimage' + '__' + sanitizedUrl"
                                          (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                          formControlName="gapBetweenImage" matInput />

                                      </mat-form-field>

                                      <mat-form-field fxFlex *ngIf="( comp.controls['type'].value == 'partners')">
                                        <mat-label>Carousel Speed</mat-label>
                                        <input [attr.guide]="'template-inp-customfield21' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField21" />
                                      </mat-form-field>

                                      <mat-form-field fxFlex
                                        *ngIf="( comp.controls['type'].value == 'TypingWithBanner') && ( comp.controls['type'].value != 'partners')">
                                        <mat-label>Type Speed</mat-label>
                                        <input [attr.guide]="'template-inp-customfield21' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField21" />
                                      </mat-form-field>


                                      <mat-form-field fxFlex
                                        *ngIf="( comp.controls['type'].value == 'brandsCarousel')  && comp.controls.customField23.value != 21 &&  comp.controls.customField23.value != 22 ">
                                        <mat-label>Carousel Speed</mat-label>
                                        <input [attr.guide]="'template-inp-customfield21' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField21" />
                                      </mat-form-field>

                                      <mat-form-field fxFlex
                                        *ngIf=" comp.controls['type'].value=='brandsCarousel' && comp.controls.customField23.value == 21  && comp.controls.customField23.value != 22 && layoutMainType !== 4 ">
                                        <mat-label>Paragraph</mat-label>
                                        <input [attr.guide]="'template-inp-customfield21' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField21" />
                                      </mat-form-field>

                                      <mat-form-field fxFlex
                                        *ngIf=" comp.controls['type'].value=='brandsCarousel' && comp.controls.customField23.value == 22  && layoutMainType !== 4 ">
                                        <mat-label> Sub Title</mat-label>
                                        <input [attr.guide]="'template-inp-customfield21' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField21" />
                                      </mat-form-field>



                                      <mat-form-field fxFlex
                                        *ngIf="( comp.controls['type'].value == 'sliderImageWithText') ">
                                        <mat-label>Button name</mat-label>
                                        <input [attr.guide]="'template-inp-customfield28' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField28" />
                                      </mat-form-field>

                                      <mat-form-field fxFlex
                                        *ngIf="comp.controls['type'].value=='brandsCarousel' && comp.controls.customField23.value != 21 && comp.controls.customField23.value != 22  && comp.controls.customField23.value != 2 && layoutMainType !== 4 ">
                                        <mat-label>width</mat-label>
                                        <input [attr.guide]="'template-inp-customfield25' + '__' + sanitizedUrl"
                                          (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                          formControlName="customField25" matInput />
                                      </mat-form-field>

                                      <mat-form-field fxFlex
                                        *ngIf="( comp.controls['type'].value == 'carouselwithProduct')">
                                        <mat-label>Font Color</mat-label>
                                        <input [attr.guide]="'template-inp-customfield22' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField22" />
                                      </mat-form-field>

                                      <mat-form-field fxFlex
                                        *ngIf="( comp.controls['type'].value == 'carouselwithProduct')">
                                        <mat-label>Align Type</mat-label>
                                        <mat-select formControlName="customField26">
                                          <mat-option *ngFor="let item of imageType" [value]="item.value">
                                            {{item.viewValue}}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>
                                      <mat-form-field fxFlex
                                        *ngIf="( comp.controls['type'].value == 'TypingWithBanner') && ( comp.controls['type'].value != 'carouselwithProduct')">
                                        <mat-label>Banner Type</mat-label>
                                        <mat-select formControlName="customField26">
                                          <mat-option *ngFor="let item of TypingbannerType" [value]="item.value">
                                            {{item.viewValue}}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>


                                      <mat-form-field fxFlex *ngIf="( comp.controls['type'].value == 'faq')">
                                        <mat-label>Display Title</mat-label>
                                        <mat-select formControlName="customField23">
                                          <mat-option *ngFor="let status of booleanFieldString1" [value]="status.value">
                                            {{status.viewValue}}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>

                                      <mat-form-field fxFlex
                                        *ngIf="( comp.controls['type'].value == 'scrolltextwithform')">
                                        <mat-label>Disable PopUp Button</mat-label>
                                        <mat-select formControlName="customField29">
                                          <mat-option *ngFor="let status of booleanFieldString2" [value]="status.value">
                                            {{status.viewValue}}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>



                                    </ng-container>
                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="( comp.controls['type'].value == 'partners') ">
                                    <mat-form-field fxFlex>
                                      <mat-label>Title Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield33' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField33" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Title Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield34' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField34" />
                                    </mat-form-field>



                                  </div>


                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px">
                                    <mat-form-field fxFlex
                                      *ngIf="( comp.controls['type'].value == 'mp4') || ( comp.controls['type'].value == 'iconTextWithBackground')">
                                      <mat-label>Width</mat-label>
                                      <input [attr.guide]="'template-inp-customfield33' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField33" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex
                                      *ngIf="( comp.controls['type'].value == 'mp4') || ( comp.controls['type'].value == 'iconTextWithBackground')">
                                      <mat-label>Mobile Width</mat-label>
                                      <input [attr.guide]="'template-inp-customfield28' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField28" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex
                                      *ngIf="( comp.controls['type'].value == 'mp4') || ( comp.controls['type'].value == 'iconTextWithBackground')">
                                      <mat-label>Title Web Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield31' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField31" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex
                                      *ngIf="( comp.controls['type'].value == 'mp4') || ( comp.controls['type'].value == 'iconTextWithBackground')">
                                      <mat-label>Title Mobile Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield32' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField32" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex
                                      *ngIf="comp.controls['type'].value == 'iconTextWithBackground' || comp.controls['type'].value =='image'">
                                      <mat-label>Alignment</mat-label>
                                      <mat-select formControlName="customField29">
                                        <mat-option *ngFor="let item of position2" [value]="item.value">
                                          {{item.viewValue}}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>

                                    <mat-form-field fxFlex *ngIf="comp.controls['type'].value =='image'">
                                      <mat-label>Top Title</mat-label>
                                      <textarea [attr.guide]="'template-sel-customfield5' + '__' + sanitizedUrl"
                                        trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5
                                        matInput formControlName="customField5"></textarea>
                                      <mat-icon class="clickable"
                                        (click)="openEditorText(comp.controls['customField5'].value,i,'customField5')"
                                        matSuffix>
                                        post_add
                                      </mat-icon>
                                    </mat-form-field>

                                    <mat-form-field fxFlex *ngIf="( comp.controls['type'].value == 'mp4')">
                                      <mat-label>Video Count</mat-label>
                                      <input [attr.guide]="'template-inp-customfield31' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField31" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex *ngIf="( comp.controls['type'].value == 'mp4')">
                                      <mat-label>Mobile Video Count</mat-label>
                                      <input [attr.guide]="'template-inp-customfield32' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField32" />
                                    </mat-form-field>
                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px">
                                    <mat-form-field fxFlex
                                      *ngIf="comp.controls['type'].value === 'TextAnimationwithtext'">
                                      <mat-label>TextanimationType</mat-label>
                                      <mat-select formControlName="customField17">
                                        <mat-option *ngFor="let item of TextanimationType" [value]="item.value">
                                          {{item.viewValue}}
                                        </mat-option>
                                      </mat-select>

                                    </mat-form-field>
                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px">
                                    <mat-form-field appearance="outline"
                                      *ngIf="comp.controls['type'].value=='brandsCarousel'  &&  comp.controls.customField23.value == 27"
                                      fxFlex>
                                      <mat-label>Sub Title</mat-label>
                                      <textarea [attr.guide]="'template-sel-customfield15' + '__' + sanitizedUrl"
                                        trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5
                                        matInput formControlName="customField15" matInput>
</textarea>
                                      <mat-icon class="clickable"
                                        (click)="openEditorText(comp.controls['customField15'].value,i,'customField15')"
                                        matSuffix>
                                        post_add
                                      </mat-icon>
                                    </mat-form-field>
                                    <mat-form-field fxFlex
                                      *ngIf="comp.controls['type'].value=='brandsCarousel'  &&  comp.controls.customField23.value == 27">
                                      <mat-label>Image Height </mat-label>
                                      <input [attr.guide]="'template-inp-customfield19' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" formControlName="customField19" matInput />
                                    </mat-form-field>
                                    <mat-form-field fxFlex
                                      *ngIf="comp.controls['type'].value=='brandsCarousel'  &&  comp.controls.customField23.value == 27">
                                      <mat-label>Sub Title Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield33' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" formControlName="customField33" matInput />
                                    </mat-form-field>
                                    <mat-form-field fxFlex
                                      *ngIf="comp.controls['type'].value=='brandsCarousel'  &&  comp.controls.customField23.value == 27">
                                      <mat-label>Sub Title Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield18' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" formControlName="customField18" matInput />
                                    </mat-form-field>
                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                                    <mat-form-field fxFlex
                                      *ngIf="comp.controls['type'].value=='brandsCarousel'  &&  comp.controls.customField23.value == 27">
                                      <mat-label>Sub Defintition Web font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield32' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" formControlName="customField32" matInput />
                                    </mat-form-field>
                                    <mat-form-field fxFlex
                                      *ngIf="comp.controls['type'].value=='brandsCarousel'  &&  comp.controls.customField23.value == 27">
                                      <mat-label>Sub Defintition Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield17' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" formControlName="customField17" matInput />
                                    </mat-form-field>
                                    <div fxFlex
                                      *ngIf="comp.controls['type'].value=='brandsCarousel'  &&  comp.controls.customField23.value == 27">
                                      <calsoft-image fxFlex="100" style="padding-bottom: 10px;"
                                        (deleteResult)="updatesIMage($event, i,'customField6')" (fileUploadResult)="
                                  getResultts($event, i,'customField6') " [index]="i"
                                        [value]="comp.controls['customField6'].value">
                                      </calsoft-image>
                                    </div>

                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px">
                                    <mat-form-field fxFlex
                                      *ngIf="comp.controls['type'].value === 'iconTextWithBackground'">
                                      <mat-label>Heading</mat-label>
                                      <input [attr.guide]="'template-inp-customfield7' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" formControlName="customField7" matInput />
                                    </mat-form-field>
                                    <mat-form-field fxFlex
                                      *ngIf="comp.controls['type'].value === 'iconTextWithBackground'">
                                      <mat-label>Heading Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield33' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" formControlName="customField33" matInput />
                                    </mat-form-field>
                                    <mat-form-field fxFlex
                                      *ngIf="comp.controls['type'].value === 'iconTextWithBackground'">
                                      <mat-label>Heading Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield34' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" formControlName="customField34" matInput />
                                    </mat-form-field>

                                    <mat-form-field fxFlex appearance="outline"
                                      *ngIf="comp.controls['type'].value === 'iconTextWithBackground'">
                                      <mat-label>Description</mat-label>
                                      <textarea [attr.guide]="'template-sel-customfield19' + '__' + sanitizedUrl"
                                        trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5
                                        matInput formControlName="customField19"></textarea>
                                      <mat-icon class="clickable"
                                        (click)="openEditorText(comp.controls['customField19'].value,i,'customField19')"
                                        matSuffix>
                                        post_add
                                      </mat-icon>
                                      <mat-hint fxHide.lt-md>Click on the icon to open editor</mat-hint>
                                    </mat-form-field>

                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px">
                                    <mat-form-field fxFlex
                                      *ngIf="comp.controls['type'].value === 'iconTextWithBackground'">
                                      <mat-label>Description Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield35' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" formControlName="customField35" matInput />
                                    </mat-form-field>
                                    <mat-form-field fxFlex
                                      *ngIf="comp.controls['type'].value === 'iconTextWithBackground'">
                                      <mat-label>Description Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield36' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" formControlName="customField36" matInput />
                                    </mat-form-field>
                                    <mat-form-field fxFlex
                                      *ngIf="comp.controls['type'].value === 'iconTextWithBackground'">
                                      <mat-label>Image Title Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield37' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" formControlName="customField37" matInput />
                                    </mat-form-field>
                                    <mat-form-field fxFlex
                                      *ngIf="comp.controls['type'].value === 'iconTextWithBackground'">
                                      <mat-label>Image Title Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield38' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" formControlName="customField38" matInput />
                                    </mat-form-field>


                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                                    <mat-form-field fxFlex
                                      *ngIf="comp.controls['type'].value === 'iconTextWithBackground'">
                                      <mat-label>Image Description Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield39' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" formControlName="customField39" matInput />
                                    </mat-form-field>
                                    <mat-form-field fxFlex
                                      *ngIf="comp.controls['type'].value === 'iconTextWithBackground'">
                                      <mat-label>Image Description Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield40' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" formControlName="customField40" matInput />
                                    </mat-form-field>


                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                                    <ng-container
                                      *ngIf="( comp.controls['type'].value == 'image')||( comp.controls['type'].value == 'brandsCarousel')||( comp.controls['type'].value == '360View')
                                    ||( comp.controls['type'].value == 'storeLocations') ||( comp.controls['type'].value == 'mp4') ||( comp.controls['type'].value == 'bannerTextWithButton')
                                    ||( comp.controls['type'].value == 'carouselwithProduct') ||( comp.controls['type'].value == 'customGroupLayout')
                                     || ( comp.controls['type'].value == 'categoryCarouselWithBanner') || ( comp.controls['type'].value == 'tabLayout') || ( comp.controls['type'].value == 'TypingWithBanner') 
                                     || ( comp.controls['type'].value == 'faq') || ( comp.controls['type'].value == 'scrolltextwithform') 
                                     || ( comp.controls['type'].value == 'iconTextWithBackground') || ( comp.controls['type'].value == 'textWithImage')  
                                     || ( comp.controls['type'].value == 'vedioBanner') || ( comp.controls['type'].value == 'sliderImageWithText')
                                     || ( comp.controls['type'].value == 'scrollableImageForm') || ( comp.controls['type'].value == 'livePrice')">
                                      <mat-form-field fxFlex
                                        *ngIf="comp.controls['type'].value != 'brandsCarousel' && layoutMainType !== 4 ">
                                        <mat-label>Mobile Height</mat-label>
                                        <input [attr.guide]="'template-inp-heightmob' + '__' + sanitizedUrl"
                                          (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                          formControlName="heightMob" matInput />

                                      </mat-form-field>

                                      <mat-form-field fxFlex
                                        *ngIf="comp.controls['type'].value === 'tabLayout' || (comp.controls['type'].value === 'vedioBanner')">
                                        <mat-label>Title Web Font Size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield18' + '__' + sanitizedUrl"
                                          (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                          formControlName="customField18" matInput />

                                      </mat-form-field>
                                      <mat-form-field fxFlex
                                        *ngIf="comp.controls['type'].value === 'tabLayout' || (comp.controls['type'].value === 'vedioBanner')">
                                        <mat-label>Title Mobile Font Size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield17' + '__' + sanitizedUrl"
                                          (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                          formControlName="customField17" matInput />

                                      </mat-form-field>


                                      <mat-form-field fxFlex *ngIf="comp.controls['type'].value === 'textWithImage'">
                                        <mat-label>Icon Name</mat-label>
                                        <input [attr.guide]="'template-inp-customfield4' + '__' + sanitizedUrl"
                                          (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                          formControlName="customField4" matInput />

                                      </mat-form-field>

                                      <mat-form-field fxFlex *ngIf="comp.controls['type'].value === 'vedioBanner'">
                                        <mat-label>Display Type</mat-label>
                                        <mat-select formControlName="customField25">
                                          <mat-option *ngFor="let item of vedioBannerType" [value]="item.value">
                                            {{item.viewValue}}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>

                                      <mat-form-field fxFlex
                                        *ngIf="comp.controls['type'].value === 'sliderImageWithText'">
                                        <mat-label>Layout Type</mat-label>
                                        <mat-select formControlName="customField25">
                                          <mat-option *ngFor="let item of sliderType" [value]="item.value">
                                            {{item.viewValue}}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>



                                      <mat-form-field fxFlex
                                        *ngIf="comp.controls['type'].value === 'sliderImageWithText' && comp.controls['customField25'].value == '2'">
                                        <mat-label>Image Side</mat-label>
                                        <mat-select formControlName="customField26">
                                          <mat-option *ngFor="let item of imageType" [value]="item.value">
                                            {{item.viewValue}}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>

                                      <mat-form-field fxFlex *ngIf="comp.controls['type'].value=='sliderImageWithText'">
                                        <mat-label>Button Color</mat-label>
                                        <input [attr.guide]="'template-inp-customfield27' + '__' + sanitizedUrl"
                                          (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                          formControlName="customField27" matInput />
                                      </mat-form-field>

                                      <mat-form-field fxFlex *ngIf="comp.controls['type'].value=='sliderImageWithText'">
                                        <mat-label>Button Link</mat-label>
                                        <input [attr.guide]="'template-inp-customfield29' + '__' + sanitizedUrl"
                                          (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                          formControlName="customField29" matInput />
                                      </mat-form-field>

                                      <mat-form-field fxFlex *ngIf="comp.controls['type'].value == 'customGroupLayout'">
                                        <mat-label>Auto Play</mat-label>
                                        <mat-select formControlName="customField33">
                                          <mat-option *ngFor="let status of autoplayString" [value]="status.value">
                                            {{status.viewValue}}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>

                                      <mat-form-field fxFlex *ngIf="comp.controls['type'].value == 'brandsCarousel'">
                                        <mat-label>Carousel type</mat-label>
                                        <mat-select formControlName="customField23">
                                          <mat-option *ngFor="let status of brand_type" [value]="status.viewValue">
                                            {{status.value}}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>

                                      <mat-form-field fxFlex
                                        *ngIf="comp.controls['type'].value=='brandsCarousel' && layoutMainType !== 4 ">
                                        <mat-label>Mobile width</mat-label>
                                        <input [attr.guide]="'template-inp-customfield26' + '__' + sanitizedUrl"
                                          (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                          formControlName="customField26" matInput />
                                      </mat-form-field>


                                      <mat-form-field appearance="outline"
                                        *ngIf="comp.controls['type'].value=='brandsCarousel' &&  comp.controls.customField23.value != 22 && layoutMainType !== 4  "
                                        fxFlex>
                                        <mat-label>Sub Defintition</mat-label>
                                        <textarea [attr.guide]="'template-sel-customfield7' + '__' + sanitizedUrl"
                                          trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5
                                          matInput formControlName="customField7" matInput>
                                  </textarea>
                                        <mat-icon class="clickable"
                                          (click)="openEditorText(comp.controls['customField7'].value,i,'customField7')"
                                          matSuffix>
                                          post_add
                                        </mat-icon>
                                      </mat-form-field>

                                      <mat-form-field appearance="outline"
                                        *ngIf="comp.controls['type'].value=='brandsCarousel'  && comp.controls.customField23.value == 22 && layoutMainType !== 4 "
                                        fxFlex>
                                        <mat-label>Sub Paragraph</mat-label>
                                        <textarea [attr.guide]="'template-sel-customfield7' + '__' + sanitizedUrl"
                                          trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5
                                          matInput formControlName="customField7" matInput>
   </textarea>
                                        <mat-icon class="clickable"
                                          (click)="openEditorText(comp.controls['customField7'].value,i,'customField7')"
                                          matSuffix>
                                          post_add
                                        </mat-icon>
                                      </mat-form-field>
                                      <mat-form-field appearance="outline"
                                        *ngIf="comp.controls['type'].value == 'TypingWithBanner'" fxFlex>
                                        <mat-label>Comma Separated Text</mat-label>

                                        <mat-label>Auto Play Seconds</mat-label>
                                        <mat-hint>Please Enter the Words with comma Seprated</mat-hint>
                                        <input [attr.guide]="'template-inp-customfield7' + '__' + sanitizedUrl"
                                          (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                          formControlName="customField7" matInput />
                                      </mat-form-field>

                                      <mat-form-field fxFlex
                                        *ngIf="comp.controls['type'].value === 'scrolltextwithform'">
                                        <mat-label>Alignment</mat-label>
                                        <mat-select formControlName="customField36">
                                          <mat-option *ngFor="let item of position2" [value]="item.value">
                                            {{item.viewValue}}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>

                                      <mat-form-field appearance="outline"
                                        *ngIf="comp.controls['type'].value=='scrolltextwithform' && comp.controls.layout.value == 0"
                                        fxFlex>
                                        <mat-label>Sub Title</mat-label>
                                        <textarea [attr.guide]="'template-sel-customfield4' + '__' + sanitizedUrl"
                                          trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5
                                          matInput formControlName="customField4" matInput>
                                  </textarea>
                                        <mat-icon class="clickable"
                                          (click)="openEditorText(comp.controls['customField4'].value,i,'customField4')"
                                          matSuffix>
                                          post_add
                                        </mat-icon>
                                      </mat-form-field>
                                      <mat-form-field appearance="outline"
                                        *ngIf="comp.controls['type'].value=='TypingWithBanner'" fxFlex>
                                        <mat-label>Sub Title</mat-label>
                                        <input [attr.guide]="'template-inp-customfield4' + '__' + sanitizedUrl"
                                          (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                          formControlName="customField4" matInput />
                                      </mat-form-field>

                                      <mat-form-field fxFlex
                                        *ngIf="comp.controls['type'].value == 'scrolltextwithform'">
                                        <mat-label>Display In</mat-label>
                                        <mat-select formControlName="customField23">
                                          <mat-option *ngFor="let status of displayInline" [value]="status.viewValue">
                                            {{status.value}}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>

                                      <mat-form-field fxFlex
                                        *ngIf="comp.controls['type'].value == 'iconTextWithBackground'">
                                        <mat-label>Type</mat-label>
                                        <mat-select formControlName="customField23">
                                          <mat-option *ngFor="let status of service_Layout" [value]="status.viewValue">
                                            {{status.value}}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>

                                      <mat-form-field fxFlex *ngIf="comp.controls['type'].value == 'customGroupLayout'">
                                        <mat-label>Auto Play Seconds</mat-label>
                                        <input [attr.guide]="'template-inp-customfield34' + '__' + sanitizedUrl"
                                          (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                          formControlName="customField34" matInput />

                                      </mat-form-field>

                                      <mat-form-field fxFlex
                                        *ngIf="comp.controls['type'].value == 'carouselwithProduct'">
                                        <mat-label>Layout</mat-label>
                                        <mat-select formControlName="layout" name="item">
                                          <mat-option *ngFor="
                                              let item of layout1;
                                              let i = index
                                            " [value]="item.type">
                                            {{ item.viewValue }} -
                                            {{ item.value }}
                                          </mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="
                                            comp.controls.layout.errors?.required
                                          ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>

                                      <mat-form-field fxFlex
                                        *ngIf="comp.controls['type'].value == 'carouselwithProduct'">
                                        <mat-label>Custom Product Scope</mat-label>
                                        <mat-select formControlName="value" [disableOptionCentering]="true"
                                          #singleSelect name="item">
                                          <mat-option>
                                            <ngx-mat-select-search name="Custom Product Scope Search" ngDefaultControl
                                              [formControl]="
                                            productScopeFilterControl
                                              " placeholderLabel="Product Scope Search" [preventHomeEndKeyPropagation]="
                                                true
                                              " noEntriesFoundLabel="No data found">
                                            </ngx-mat-select-search>
                                          </mat-option>
                                          <mat-option (onSelectionChange)="setProductScope($event,opt,'customField1',i)"
                                            *ngFor="let opt of filteredproductScopeTypeList;"
                                            [value]="opt.customProductScopeId">
                                            {{ opt.type }}
                                          </mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="
                                            comp.controls.value.errors?.required
                                          ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>

                                      <mat-form-field fxFlex
                                        *ngIf="(comp.controls['type'].value === 'image' && comp.controls['customField10'].value!=='Type 11') && layoutMainType !== 4 ">
                                        <mat-label>Mobile View Image Count</mat-label>
                                        <mat-select formControlName="displayMobileImage">

                                          <mat-option
                                            *ngFor="let item of imageCount.slice(0, comp.controls['layout'].value)"
                                            [value]="item.id">
                                            {{item.status}}
                                          </mat-option>

                                        </mat-select>
                                      </mat-form-field>

                                      <mat-form-field fxFlex *ngIf="comp.controls['type'].value =='faq'">
                                        <mat-label>Question Web Font Size </mat-label>
                                        <input [attr.guide]="'template-inp-customfield38' + '__' + sanitizedUrl"
                                          [autocomplete]="'off'" trim="blur" matInput formControlName="customField38" />
                                      </mat-form-field>

                                      <mat-form-field fxFlex *ngIf="comp.controls['type'].value =='faq'">
                                        <mat-label>Question Mobile Font Size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield15' + '__' + sanitizedUrl"
                                          [autocomplete]="'off'" trim="blur" matInput formControlName="customField15" />
                                      </mat-form-field>

                                      <mat-form-field fxFlex
                                        *ngIf="comp.controls['type'].value =='image' && comp.controls['customField10'].value=='Type 11' ">
                                        <mat-label>Width</mat-label>
                                        <input [attr.guide]="'template-inp-customfield2' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField2" />
                                      </mat-form-field>

                                      <mat-form-field fxFlex
                                        *ngIf="(comp.controls['type'].value === 'image' && comp.controls['customField10'].value!=='Type 11' ) && layoutMainType !== 4 ">
                                        <mat-label>Image Zoom</mat-label>
                                        <mat-select formControlName="customField9" name="item">
                                          <mat-option *ngFor="let item of boolean" [value]="item.value">
                                            {{item.viewValue}}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>

                                      <mat-form-field fxFlex
                                        *ngIf="comp.controls['type'].value =='image' && comp.controls['customField10'].value=='Type 11' ">
                                        <mat-label>Top Sub Title</mat-label>
                                        <textarea [attr.guide]="'template-sel-customfield29' + '__' + sanitizedUrl"
                                          trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5
                                          matInput formControlName="customField29"></textarea>
                                        <mat-icon class="clickable"
                                          (click)="openEditorText(comp.controls['customField29'].value,i,'customField29')"
                                          matSuffix>
                                          post_add
                                        </mat-icon>
                                      </mat-form-field>

                                      <mat-form-field fxFlex
                                        *ngIf="(comp.controls['type'].value === 'image' || comp.controls['type'].value === 'mp4' || comp.controls['type'].value === 'tabLayout' || comp.controls['type'].value === 'iconTextWithBackground') &&  layoutMainType !== 4 ">
                                        <mat-label>Mobile Gap Between Image</mat-label>
                                        <input [attr.guide]="'template-inp-mobilegapbetweenimage' + '__' + sanitizedUrl"
                                          (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                          formControlName="mobileGapBetweenImage" matInput />

                                      </mat-form-field>


                                      <mat-form-field fxFlex *ngIf="comp.controls['type'].value === 'mp4'">
                                        <mat-label>Video Type</mat-label>
                                        <mat-select formControlName="customField34">
                                          <mat-option *ngFor="let item of mp4VedioType" [value]="item.value">
                                            {{item.viewValue}}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>

                                    </ng-container>
                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="( comp.controls['type'].value == 'scrollableImageForm') ">
                                    <mat-form-field fxFlex>
                                      <mat-label>Title Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield39' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField39" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Title Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield40' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField40" />
                                    </mat-form-field>



                                  </div>

                                  <div *ngIf=" layoutMainType !== 4 " fxLayout.gt-md="row" fxLayout.lt-md="column"
                                    fxLayoutGap="10px">
                                    <mat-form-field fxFlex
                                      *ngIf="comp.controls['type'].value=='brandsCarousel' && comp.controls['customField23'].value=='24' ">
                                      <mat-label>Card Hover Color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield34' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField34" matInput />
                                    </mat-form-field>

                                    <mat-form-field fxFlex
                                      *ngIf="comp.controls['type'].value=='brandsCarousel' && comp.controls['customField23'].value=='24' ">
                                      <mat-label>Card Title Font Color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield26' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField26" matInput />
                                    </mat-form-field>
                                  </div>

                                  <div *ngIf=" layoutMainType !== 4 " fxLayout.gt-md="row" fxLayout.lt-md="column"
                                    fxLayoutGap="10px">

                                    <mat-form-field fxFlex *ngIf="comp.controls['type'].value=='brandsCarousel'">
                                      <mat-label>Display Count</mat-label>
                                      <input [attr.guide]="'template-inp-customfield14' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField14" matInput />
                                    </mat-form-field>

                                    <mat-form-field fxFlex *ngIf="comp.controls['type'].value=='brandsCarousel'">
                                      <mat-label>Display Count Mobile</mat-label>
                                      <input [attr.guide]="'template-inp-customfield33' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField33" matInput />
                                    </mat-form-field>

                                    <mat-form-field fxFlex
                                      *ngIf="comp.controls['type'].value == 'brandsCarousel' || comp.controls['type'].value == 'bannerTextWithButton' ">
                                      <mat-label>Font Family</mat-label>
                                      <input [attr.guide]="'template-inp-fontfamily' + '__' + sanitizedUrl" trim="blur"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" matInput
                                        formControlName="fontFamily" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex *ngIf="comp.controls['type'].value == 'brandsCarousel' ">
                                      <mat-label>Font Color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield5' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField5" />
                                    </mat-form-field>


                                    <mat-form-field fxFlex
                                      *ngIf="comp.controls['type'].value=='brandsCarousel' && comp.controls['customField23'].value=='7'">
                                      <mat-label>Button Link</mat-label>
                                      <input [attr.guide]="'template-inp-customfield3' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField3" matInput />
                                    </mat-form-field>
                                    <mat-form-field fxFlex
                                      *ngIf="comp.controls['type'].value=='brandsCarousel' && comp.controls['customField23'].value=='22' ">
                                      <mat-label>Card Height</mat-label>
                                      <input [attr.guide]="'template-inp-customfield3' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField3" matInput />
                                    </mat-form-field>



                                    <div fxFlex
                                      *ngIf="comp.controls['type'].value=='brandsCarousel' && comp.controls['customField23'].value=='13'|| comp.controls['customField23'].value=='24'  ">
                                      <calsoft-image fxFlex="100" style="padding-bottom: 10px;"
                                        (deleteResult)="updatesIMage($event, i,'customField6')" (fileUploadResult)="
                                  getResultts($event, i,'customField6') " [index]="i"
                                        [value]="comp.controls['customField6'].value">
                                      </calsoft-image>
                                    </div>


                                    <div fxFlex
                                      *ngIf="comp.controls['type'].value=='TypingWithBanner' || comp.controls['type'].value=='textWithImage'  ">

                                      <calsoft-image fxFlex="100" style="padding-bottom: 10px;"
                                        (deleteResult)="updatesIMage($event, i,'customField24')" (fileUploadResult)="
                                getResultts($event, i,'customField24') " [index]="i"
                                        [value]="comp.controls['customField24'].value">
                                      </calsoft-image>
                                    </div>
                                    <div fxFlex *ngIf="comp.controls['type'].value=='PyramidWithTextAndImage' ">

                                      <calsoft-image fxFlex="100" style="padding-bottom: 10px;"
                                        (deleteResult)="updatesIMage($event, i,'customField8')" (fileUploadResult)="
                              getResultts($event, i,'customField8') " [index]="i"
                                        [value]="comp.controls['customField8'].value">
                                      </calsoft-image>
                                    </div>

                                    <div fxFlex
                                      *ngIf="comp.controls['type'].value=='brandsCarousel'  && comp.controls['customField23'].value=='13' ">
                                      <calsoft-image fxFlex="100" style="padding-bottom: 10px;"
                                        (deleteResult)="updatesIMage($event, i,'customField7')" (fileUploadResult)="
                                  getResultts($event, i,'customField7') " [index]="i"
                                        [value]="comp.controls['customField7'].value">
                                      </calsoft-image>
                                    </div>

                                  </div>
                                  <div *ngIf=" layoutMainType !== 4 " fxLayout.gt-md="row" fxLayout.lt-md="column"
                                    fxLayoutGap="10px">




                                    <mat-form-field fxFlex *ngIf="comp.controls['type'].value == 'brandsCarousel' ">
                                      <mat-label>Web Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield34' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField34" />
                                    </mat-form-field>


                                    <mat-form-field fxFlex *ngIf="comp.controls['type'].value == 'brandsCarousel' ">
                                      <mat-label>Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield31' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField31" matInput />
                                    </mat-form-field>

                                    <mat-form-field fxFlex *ngIf="comp.controls['type'].value == 'brandsCarousel' ">
                                      <mat-label>Sub content height </mat-label>
                                      <input [attr.guide]="'template-inp-customfield37' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField37" />
                                    </mat-form-field>




                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="( comp.controls['type'].value == 'stepFlowLayout')">
                                    <calsoft-image fxFlex="40" style="padding-bottom: 10px;" required
                                      (deleteResult)="updatesIMage($event, i,'customField13')" (fileUploadResult)="
                                getResultts($event, i,'customField13') " [index]="i"
                                      [value]="comp.controls['customField13'].value">
                                    </calsoft-image>
                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf=" comp.controls['type'].value == 'textWithImage'&& comp.controls.customField20.value == 7">
                                    <calsoft-image fxFlex="40" style="padding-bottom: 10px;" required
                                      (deleteResult)="updatesIMage($event, i,'customField31')" (fileUploadResult)="
                                getResultts($event, i,'customField31') " [index]="i"
                                      [value]="comp.controls['customField31'].value">
                                    </calsoft-image>

                                    <calsoft-image fxFlex="40" style="padding-bottom: 10px;" required
                                      (deleteResult)="updatesIMage($event, i,'customField32')" (fileUploadResult)="
                                getResultts($event, i,'customField32') " [index]="i"
                                      [value]="comp.controls['customField32'].value">
                                    </calsoft-image>
                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px" *ngIf="( comp.controls['type'].value == 'image')
                                    ||( comp.controls['type'].value == 'textWithImage')
                                    ||(comp.controls['type'].value =='bannertextWithImage')
                                    ||(comp.controls['type'].value =='faq')
                                    ||( comp.controls['type'].value == 'freeText')
                                    ||(comp.controls['type'].value =='bannerTextWithButton')
                                    ||(comp.controls['type'].value =='scrollText')
                                    ||(comp.controls['type'].value =='CRMComparisonTable')
                                    ||(comp.controls['type'].value =='bannerVideo')
                                    ||( comp.controls['type'].value == 'categoryCarouselWithBanner')">
                                    <mat-form-field fxFlex *ngIf="layoutMainType !== 4 ">
                                      <mat-label>Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield17' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField17" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex appearance="outline"
                                      *ngIf="( comp.controls['type'].value == 'textWithImage')">
                                      <mat-label>Text Alignment</mat-label>
                                      <mat-select formControlName="customField30">
                                        <mat-option *ngFor="let item of textalignmenttype" [value]="item.value">
                                          {{item.viewValue}}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>

                                    <mat-form-field fxFlex *ngIf="( comp.controls['type'].value == 'textWithImage')">
                                      <mat-label>Background color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield27' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField27" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex *ngIf="( comp.controls['type'].value == 'textWithImage')">
                                      <mat-label>Content color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield28' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField28" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex
                                      *ngIf="comp.controls['type'].value =='image' && layoutMainType !== 4 ">
                                      <mat-label>Layout Top Gap</mat-label>
                                      <input [attr.guide]="'template-inp-customfield35' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField35" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex *ngIf="layoutMainType !== 4 ">
                                      <mat-label>Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield18' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField18" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex
                                      *ngIf="comp.controls['type'].value =='image' && comp.controls['customField10'].value=='Type 11' ">
                                      <mat-label>Button name1</mat-label>
                                      <input [attr.guide]="'template-inp-customfield12' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField12" matInput />
                                    </mat-form-field>

                                    <mat-form-field fxFlex *ngIf="( comp.controls['type'].value == 'freeText'  )">
                                      <mat-label>Title Type</mat-label>
                                      <mat-select formControlName="customField25">
                                        <mat-option *ngFor="let item of titleType" [value]="item.value">
                                          {{item.viewValue}}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>

                                    <mat-form-field fxFlex *ngIf="( comp.controls['type'].value == 'freeText')">
                                      <mat-label>Title Color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield26' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField26" />
                                    </mat-form-field>


                                    <mat-form-field fxFlex *ngIf="( comp.controls['type'].value == 'freeText')">
                                      <mat-label>Title AlignMent</mat-label>
                                      <mat-select formControlName="customField27" name="item">
                                        <mat-option *ngFor="
                                          let item of TitleAlignMent;
                                          let i = index
                                        " [value]="item.value">
                                          {{ item.viewValue }}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>

                                    <mat-form-field fxFlex *ngIf="( comp.controls['type'].value == 'faq')">
                                      <mat-label>Gap Between Faq</mat-label>
                                      <input [attr.guide]="'template-inp-gapbetweenimage' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="gapBetweenImage" matInput />

                                    </mat-form-field>

                                    <mat-form-field fxFlex
                                      *ngIf="( comp.controls['type'].value == 'bannerTextWithButton') || ( comp.controls['type'].value == 'categoryCarouselWithBanner') || ( comp.controls['type'].value == 'carouselwithProduct')">
                                      <mat-label>Font Color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield22' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField22" />
                                    </mat-form-field>

                                    <!-- <mat-form-field fxFlex
                                  *ngIf="( comp.controls['type'].value == 'bannerTextWithButton')">
                                  <mat-label>Sub Image Font Color</mat-label>
                                  <input [attr.guide]="'template-inp-customfield30' + '__' + sanitizedUrl" trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                    matInput formControlName="customField30" />
                                </mat-form-field> -->

                                    <mat-form-field fxFlex *ngIf="comp.controls['type'].value === 'faq'">
                                      <mat-label>Mobile Gap Between Faq</mat-label>
                                      <input [attr.guide]="'template-inp-mobilegapbetweenimage' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="mobileGapBetweenImage" matInput />

                                    </mat-form-field>

                                  </div>
                                  <div fxLayout.gt-md="column" fxLayout.lt-md="column" fxLayoutGap="10px">
                                    <div fxFlex *ngIf="( comp.controls['type'].value == 'ScrollWithAnimationUltimate')">
                                      <mat-form-field fxFlex>
                                        <mat-label>Main Heading One</mat-label>
                                        <input [attr.guide]="'template-inp-customfield15' + '__' + sanitizedUrl"
                                          (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                          formControlName="customField15" matInput />
                                        <mat-icon class="clickable"
                                          (click)="openEditorText(comp.controls['customField15'].value,i,'customField15')"
                                          matSuffix>
                                          post_add
                                        </mat-icon>

                                      </mat-form-field>

                                      <mat-form-field fxFlex>
                                        <mat-label>Main Heading Two</mat-label>
                                        <input [attr.guide]="'template-inp-customfield16' + '__' + sanitizedUrl"
                                          (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                          formControlName="customField16" matInput />
                                        <mat-icon class="clickable"
                                          (click)="openEditorText(comp.controls['customField16'].value,i,'customField16')"
                                          matSuffix>
                                          post_add
                                        </mat-icon>

                                      </mat-form-field>
                                      <mat-form-field fxFlex>
                                        <mat-label>Main Description One</mat-label>
                                        <input [attr.guide]="'template-inp-customfield17' + '__' + sanitizedUrl"
                                          (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                          formControlName="customField17" matInput />
                                        <mat-icon class="clickable"
                                          (click)="openEditorText(comp.controls['customField17'].value,i,'customField17')"
                                          matSuffix>
                                          post_add
                                        </mat-icon>

                                      </mat-form-field>

                                      <mat-form-field>
                                        <mat-label>Main Description Two</mat-label>
                                        <input [attr.guide]="'template-inp-customfield18' + '__' + sanitizedUrl"
                                          (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                          formControlName="customField18" matInput />
                                        <mat-icon class="clickable"
                                          (click)="openEditorText(comp.controls['customField18'].value,i,'customField18')"
                                          matSuffix>
                                          post_add
                                        </mat-icon>

                                      </mat-form-field>



                                    </div>
                                    <div fxFlex *ngIf="( comp.controls['type'].value == 'ScrollWithAnimationUltimate')">
                                      <mat-form-field fxFlex>
                                        <mat-label>Top Section Enable</mat-label>
                                        <mat-select formControlName="customField19">
                                          <mat-option *ngFor="let item of topsectionEnable" [value]="item.value">
                                            {{item.viewValue}}
                                          </mat-option>
                                        </mat-select>

                                      </mat-form-field>
                                      <mat-form-field fxFlex>
                                        <mat-label>Main Section Heading Size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield20' + '__' + sanitizedUrl"
                                          (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                          formControlName="customField20" matInput />

                                      </mat-form-field>
                                      <mat-form-field fxFlex>
                                        <mat-label>Main Section Description Size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield21' + '__' + sanitizedUrl"
                                          (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                          formControlName="customField21" matInput />

                                      </mat-form-field>
                                    </div>
                                    <div fxFlex *ngIf="( comp.controls['type'].value == 'ScrollWithAnimationUltimate')">

                                      <mat-form-field fxFlex>
                                        <mat-label>Secondary Section Heading Size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield22' + '__' + sanitizedUrl"
                                          (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                          formControlName="customField22" matInput />

                                      </mat-form-field>
                                      <mat-form-field fxFlex>
                                        <mat-label>Secondary Section Description Size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield23' + '__' + sanitizedUrl"
                                          (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                          formControlName="customField23" matInput />

                                      </mat-form-field>
                                      <mat-form-field fxFlex>
                                        <mat-label>Section Type</mat-label>
                                        <mat-select formControlName="customField25">
                                          <mat-option *ngFor="let item of SectionsChange" [value]="item.value">
                                            {{item.viewValue}}
                                          </mat-option>
                                        </mat-select>

                                      </mat-form-field>

                                    </div>

                                    <div *ngIf="(comp.controls['type'].value == 'ScrollWithAnimationUltimate')">

                                      <div class="editSets">
                                        <div class="title-head3" fxLayoutAlign="space-between center" color="primary">
                                          <span>Vertical Slider Information</span>

                                          <button [attr.guide]="'template-btn-23' + '__' + sanitizedUrl" class="create"
                                            (click)=" addFaq(i)" type="button" mat-mini-fab color="primary">
                                            <mat-icon>add</mat-icon>
                                          </button>
                                        </div>

                                        <div id="responsieTable" class="container">
                                          <table fxFlex="100">
                                            <tbody fxFlex="100">
                                              <ng-container formArrayName="images">
                                                <tr
                                                  *ngFor="let ImageInfo of comp.get('images')?.controls;; let y = index">
                                                  <ng-container [formGroupName]="y" fxLayout="column"
                                                    fxLayoutAlign="space-between center">
                                                    <div fxLayout="row" fxLayout.lt-md="column">
                                                      <td fxFlex data-th="Heading" fxLayoutGap="10px">
                                                        <span class="wordBreak">
                                                          <mat-form-field appearance="outline">
                                                            <mat-label>Heading</mat-label>
                                                            <textarea
                                                              [attr.guide]="'template-sel-customfield10' + '__' + sanitizedUrl"
                                                              trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                              matAutosizeMaxRows=5 matInput
                                                              formControlName="customField10"></textarea>
                                                            <mat-icon class="clickable"
                                                              (click)="openEditorTextForImageArray(ImageInfo.controls['customField10'].value,i,'customField10',y)"
                                                              matSuffix>
                                                              post_add
                                                            </mat-icon>
                                                          </mat-form-field>
                                                        </span>
                                                      </td>
                                                      <td fxFlex data-th="plan" fxLayoutGap="10px">
                                                        <span class="wordBreak">
                                                          <mat-form-field appearance="outline">
                                                            <mat-label>Description</mat-label>
                                                            <textarea
                                                              [attr.guide]="'template-sel-customfield11' + '__' + sanitizedUrl"
                                                              trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                              matAutosizeMaxRows=5 matInput
                                                              formControlName="customField11"></textarea>
                                                            <mat-icon class="clickable"
                                                              (click)="openEditorTextForImageArray(ImageInfo.controls['customField11'].value,i,'customField11',y)"
                                                              matSuffix>
                                                              post_add
                                                            </mat-icon>
                                                          </mat-form-field>
                                                        </span>
                                                      </td>

                                                      <td fxFlex data-th="logo" fxLayoutGap="10px">
                                                        <span class="wordBreak">

                                                          Image Upload
                                                          <calsoft-image style="padding-bottom: 10px;"
                                                            (deleteResult)="updatesImageArray($event, i,'customField13',y)"
                                                            (fileUploadResult)="
                                              getResultArray($event, i,'customField13',y) " [index]="y"
                                                            [value]="ImageInfo.controls['customField13'].value">
                                                          </calsoft-image>
                                                        </span>
                                                      </td>
                                                      <td fxFlex data-th="logo" fxLayoutGap="10px">
                                                        <span class="wordBreak">

                                                          Video Upload
                                                          <calsoft-video fxFlex="40" fxFlex.xs="100"
                                                            style="padding-bottom: 10px;"
                                                            (deleteResult)="updatesImageArray($event, i,'customField6',y)"
                                                            (fileUploadResult)="
                                                        getResultArray($event, i,'customField6',y) " [index]="i"
                                                            [value]="comp.controls['customField6'].value">
                                                          </calsoft-video>
                                                        </span>
                                                      </td>
                                                    </div>


                                                    <td data-th="Action">
                                                      <span class="wordBreak">
                                                        <button [attr.guide]="'template-btn-24' + '__' + sanitizedUrl"
                                                          color="warn" mat-icon-button type="button"
                                                          (click)="deleteText(i,y)">
                                                          <mat-icon>remove_circle_outline
                                                          </mat-icon>
                                                        </button>
                                                      </span>
                                                    </td>
                                                  </ng-container>
                                                </tr>
                                              </ng-container>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                    <!-- <div *ngIf="(comp.controls['type'].value == 'ScrollWithAnimationUltimate')">

                                    <div class="editSets">
                                      <div class="title-head3" fxLayoutAlign="space-between center"
                                        color="primary">
                                        <span>Horizontal Slider Information </span>
  
                                        <button [attr.guide]="'template-btn-25' + '__' + sanitizedUrl" class="create" (click)="addSub(i)" type="button"
                                          mat-mini-fab color="primary">
                                          <mat-icon>add</mat-icon>
                                        </button>
  
                                      </div>
                                      <div id="responsieTable" class="container">
                                        <table fxFlex="100" class="padding-10">
                                          <tbody fxFlex="100">
                          
                                            <ng-container formArrayName="layoutSub">
                                              <tr fxLayout.xs="column" fxLayout="row"
                                                *ngFor="let SubImageInfo of comp.get('layoutSub')?.controls; let y = index">
                                                <ng-container [formGroupName]="y">
  
                                                  <td fxFlex data-th="Heading" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <mat-form-field appearance="outline">
                                                        <mat-label>Heading</mat-label>
                                                        <textarea [attr.guide]="'template-sel-customfield10' + '__' + sanitizedUrl" trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                          matAutosizeMaxRows=5 matInput
                                                          formControlName="customField10"></textarea>
                                                        <mat-icon class="clickable"
                                                          (click)="openEditorTextForImageArray(SubImageInfo.controls['customField10'].value,i,'customField10',y)"
                                                          matSuffix>
                                                          post_add
                                                        </mat-icon>
                                                      </mat-form-field>
                                                    </span>
                                                  </td>
                                                  <td fxFlex data-th="plan" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <mat-form-field  appearance="outline">
                                                        <mat-label>Description</mat-label>
                                                        <textarea [attr.guide]="'template-sel-customfield11' + '__' + sanitizedUrl" trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                          matAutosizeMaxRows=5 matInput
                                                          formControlName="customField11"></textarea>
                                                        <mat-icon class="clickable"
                                                          (click)="openEditorTextForImageArray(SubImageInfo.controls['customField11'].value,i,'customField11',y)"
                                                          matSuffix>
                                                          post_add
                                                        </mat-icon>
                                                      </mat-form-field>
                                                    </span>
                                                  </td>

                                                  <td fxFlex data-th="logo" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      
                                                      Image Upload
                                                      <calsoft-image style="padding-bottom: 10px;"
                                                      (deleteResult)="updatesImageArray($event, i,'customField13',y)"
                                                      (fileUploadResult)="
                                            getResultArray($event, i,'customField13',y) " [index]="y"
                                                      [value]="SubImageInfo.controls['customField13'].value">
                                                    </calsoft-image>
                                                    </span>
                                                  </td>
                                                  <td fxFlex data-th="logo" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      
                                                       Video Upload
                                                      <calsoft-video fxFlex="40" fxFlex.xs="100" style="padding-bottom: 10px;"
                                                      (deleteResult)="updatesImageArray($event, i,'customField6',y)" (fileUploadResult)="
                                                      getResultArray($event, i,'customField6',y) " [index]="i"
                                                      [value]="comp.controls['customField6'].value">
                                                    </calsoft-video>
                                                    </span>
                                                  </td>
  
  
                                              
  
                                                  <td data-th="Action">
                                                    <button [attr.guide]="'template-btn-26' + '__' + sanitizedUrl" color="warn" mat-icon-button type="button"
                                                      (click)="deleteLayoutSub(i,y)">
                                                      <mat-icon>remove_circle_outline
                                                      </mat-icon>
                                                    </button>
                                                  </td>
                                                </ng-container>
                                              </tr>
                                            </ng-container>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div> -->

                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px">
                                    <mat-form-field fxFlex appearance="outline"
                                      *ngIf="( comp.controls['type'].value == 'textwithform')">
                                      <mat-label>Form Alignment</mat-label>
                                      <mat-select formControlName="customField33">
                                        <mat-option *ngFor="let item of textalignmenttype" [value]="item.value">
                                          {{item.viewValue}}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>

                                    <div fxFlex *ngIf="( comp.controls['type'].value == 'CRMComparisonTable')">

                                      <calsoft-image style="padding-bottom: 10px;"
                                        (deleteResult)="updatesIMage($event, i,'customField24')" (fileUploadResult)="
                                getResultts($event, i,'customField24') " [index]="i"
                                        [value]="comp.controls['customField24'].value">
                                      </calsoft-image>
                                    </div>

                                    <mat-form-field fxFlex
                                      *ngIf="( comp.controls['type'].value =='CRMComparisonTable')">
                                      <mat-label>Background Color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield38' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField38" matInput />

                                    </mat-form-field>
                                    <mat-form-field fxFlex
                                      *ngIf="( comp.controls['type'].value =='CRMComparisonTable')">
                                      <mat-label>Primary Color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield39' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField39" matInput />

                                    </mat-form-field>
                                    <mat-form-field fxFlex
                                      *ngIf="( comp.controls['type'].value =='CRMComparisonTable')">
                                      <mat-label>Secondary Color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield40' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField40" matInput />

                                    </mat-form-field>


                                    <mat-form-field fxFlex *ngIf="( comp.controls['type'].value == 'textwithform')">
                                      <mat-label>Height</mat-label>
                                      <input [attr.guide]="'template-inp-customfield38' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField38" matInput />

                                    </mat-form-field>

                                    <mat-form-field fxFlex *ngIf="( comp.controls['type'].value == 'textwithform')">
                                      <mat-label>Background color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield37' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField37" />
                                    </mat-form-field>

                                    <div fxFlex *ngIf="( comp.controls['type'].value == 'textwithform')">

                                      <calsoft-image style="padding-bottom: 10px;"
                                        (deleteResult)="updatesIMage($event, i,'customField24')" (fileUploadResult)="
                                getResultts($event, i,'customField24') " [index]="i"
                                        [value]="comp.controls['customField24'].value">
                                      </calsoft-image>
                                    </div>

                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px">
                                    <mat-form-field fxFlex
                                      *ngIf="( comp.controls['type'].value == 'otherCustomization')">
                                      <mat-label>Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield39' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField39" matInput />

                                    </mat-form-field>
                                    <mat-form-field fxFlex
                                      *ngIf="( comp.controls['type'].value == 'otherCustomization')">
                                      <mat-label>Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield40' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField40" matInput />

                                    </mat-form-field>
                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="( comp.controls['type'].value == 'bannerTextWithButton' || comp.controls['type'].value == 'image' || comp.controls['type'].value == 'categoryCarouselWithBanner') && layoutMainType != 4">
                                    <mat-form-field fxFlex>
                                      <mat-label>Button Color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield33' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField33" matInput />
                                    </mat-form-field>

                                    <mat-form-field fxFlex
                                      *ngIf="comp.controls['type'].value =='image' && comp.controls['customField10'].value!=='Type 11' ">
                                      <mat-label>Button radiuscolor</mat-label>
                                      <input [attr.guide]="'template-inp-customfield34' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField34" matInput />
                                    </mat-form-field>

                                    <mat-form-field fxFlex
                                      *ngIf="comp.controls['type'].value =='image' && comp.controls['customField10'].value=='Type 11' ">
                                      <mat-label>Button 2 name</mat-label>
                                      <input [attr.guide]="'template-inp-customfield34' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField34" matInput />
                                    </mat-form-field>


                                    <mat-form-field fxFlex
                                      *ngIf="( comp.controls['type'].value == 'image' && comp.controls['customField10'].value!=='Type 11')">
                                      <mat-label>Font Color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield21' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField21" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex
                                      *ngIf="( comp.controls['type'].value == 'image' && comp.controls['customField10'].value=='Type 11')">
                                      <mat-label>Button 2 Color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield22' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField22" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex *ngIf="( comp.controls['type'].value == 'image')">
                                      <mat-label>Alt Tag</mat-label>
                                      <input [attr.guide]="'template-inp-altimage' + '__' + sanitizedUrl" trim="blur"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" matInput
                                        formControlName="altImage" />
                                    </mat-form-field>
                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="layoutMainType != 4">
                                    <mat-form-field fxFlex
                                      *ngIf="( comp.controls['type'].value == 'bannerTextWithButton')  || comp.controls['type'].value == 'categoryCarouselWithBanner'">
                                      <mat-label>Sub Image Height</mat-label>
                                      <input [attr.guide]="'template-inp-customfield25' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField25" matInput />

                                    </mat-form-field>

                                    <mat-form-field fxFlex
                                      *ngIf="( comp.controls['type'].value == 'productScope') || comp.controls['type'].value == 'category' || comp.controls['type'].value == 'otherCustomization'">
                                      <mat-label>Header Color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield25' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField25" matInput />

                                    </mat-form-field>

                                    <mat-form-field fxFlex
                                      *ngIf="( comp.controls['type'].value == 'productScope') || comp.controls['type'].value == 'category' || comp.controls['type'].value == 'otherCustomization'">
                                      <mat-label>Button Text</mat-label>
                                      <input [attr.guide]="'template-inp-customfield26' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField26" matInput />
                                    </mat-form-field>

                                    <mat-form-field fxFlex
                                      *ngIf="( comp.controls['type'].value == 'productScope') || comp.controls['type'].value == 'category' || comp.controls['type'].value == 'otherCustomization'">
                                      <mat-label>Layout Width</mat-label>
                                      <input [attr.guide]="'template-inp-customfield27' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField27" matInput />
                                      <mat-hint>Only For Product Carousel</mat-hint>
                                    </mat-form-field>

                                    <mat-form-field fxFlex
                                      *ngIf="( comp.controls['type'].value == 'productScope') || comp.controls['type'].value == 'category' || comp.controls['type'].value == 'otherCustomization'">
                                      <mat-label>Layout Width Mobile</mat-label>
                                      <input [attr.guide]="'template-inp-customfield28' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField28" matInput />
                                      <mat-hint>Only For Product Carousel</mat-hint>
                                    </mat-form-field>

                                    <mat-form-field fxFlex
                                      *ngIf="comp.controls['type'].value == 'slideBanner'|| comp.controls['type'].value == 'TexthoverWithImage'">
                                      <mat-label>Image Height</mat-label>
                                      <input [attr.guide]="'template-inp-customfield25' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField25" matInput />

                                    </mat-form-field>
                                    <mat-form-field fxFlex *ngIf=" comp.controls['type'].value == 'TexthoverWithImage'">
                                      <mat-label>Font Color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield5' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField5" />
                                    </mat-form-field>


                                    <mat-form-field fxFlex *ngIf="comp.controls['type'].value == 'slideBanner' ">
                                      <mat-label>Image Width</mat-label>
                                      <input [attr.guide]="'template-inp-customfield27' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField27" matInput />

                                    </mat-form-field>

                                    <mat-form-field fxFlex *ngIf="comp.controls['type'].value == 'slideBanner' ">
                                      <mat-label>Image Height Mobile</mat-label>
                                      <input [attr.guide]="'template-inp-customfield26' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField26" matInput />

                                    </mat-form-field>

                                    <mat-form-field fxFlex *ngIf="comp.controls['type'].value == 'slideBanner' ">
                                      <mat-label>Image Width Mobile</mat-label>
                                      <input [attr.guide]="'template-inp-customfield28' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField28" matInput />

                                    </mat-form-field>

                                    <mat-form-field fxFlex appearance="outline"
                                      *ngIf="( comp.controls['type'].value == 'bannerTextWithButton')">
                                      <mat-label>Content Gap</mat-label>
                                      <input [attr.guide]="'template-inp-customfield34' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        matInput formControlName="customField34" />

                                    </mat-form-field>

                                    <mat-form-field fxFlex
                                      *ngIf="( comp.controls['type'].value == 'bannerTextWithButton')  || comp.controls['type'].value == 'categoryCarouselWithBanner' ">
                                      <mat-label>Sub Image Height Mobile</mat-label>
                                      <input [attr.guide]="'template-inp-customfield26' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField26" matInput />

                                    </mat-form-field>

                                    <!-- <mat-form-field fxFlex *ngIf="comp.controls['type'].value == 'image' ">
                                    <mat-label>Sub Image Width</mat-label>
                                    <input [attr.guide]="'template-inp-customfield27' + '__' + sanitizedUrl" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                      formControlName="customField27" matInput/>

                                  </mat-form-field>


                                  <mat-form-field fxFlex *ngIf="comp.controls['type'].value == 'image' ">
                                    <mat-label>Sub Image Width Mobile</mat-label>
                                    <input [attr.guide]="'template-inp-customfield28' + '__' + sanitizedUrl" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                      formControlName="customField28" matInput/>

                                  </mat-form-field> -->
                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="(comp.controls['type'].value == 'category' || comp.controls['type'].value == 'tabLayout' || comp.controls['type'].value == 'productScope')  && layoutMainType != 4">
                                    <mat-form-field fxFlex>
                                      <mat-label> Product Count</mat-label>
                                      <input [attr.guide]="'template-inp-customfield29' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField29" matInput />

                                    </mat-form-field>

                                    <mat-form-field fxFlex>
                                      <mat-label>Mobile Product Count</mat-label>
                                      <input [attr.guide]="'template-inp-customfield30' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField30" matInput />

                                    </mat-form-field>

                                    <!-- <mat-form-field fxFlex>
                                      <mat-label> Product Timing</mat-label>
                                      <input [attr.guide]="'template-inp-customfield31' + '__' + sanitizedUrl" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        trim="blur" formControlName="customField31" matInput/>

                                    </mat-form-field> -->

                                    <mat-form-field fxFlex>
                                      <mat-label>Date</mat-label>
                                      <input [attr.guide]="'template-inp-customfield31' + '__' + sanitizedUrl"
                                        [matDatepicker]="followUp" formControlName="customField31" matInput />
                                      <mat-datepicker-toggle [for]="followUp" matSuffix></mat-datepicker-toggle>
                                      <mat-datepicker #followUp></mat-datepicker>

                                    </mat-form-field>


                                    <mat-form-field fxFlex>
                                      <mat-label>Product Timing</mat-label>
                                      <input [attr.guide]="'template-inp-customfield33' + '__' + sanitizedUrl"
                                        type="time" formControlName="customField33" matInput />
                                    </mat-form-field>

                                    <mat-form-field fxFlex>
                                      <mat-label>Product Layout Type</mat-label>
                                      <mat-select formControlName="customField32">
                                        <mat-option *ngFor="let item of productlayouttype" [value]="item.viewValue">
                                          {{item.value}}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>
                                  </div>

                                  <div fxLayout.gt-md="row" *ngIf="comp.controls['type'].value == 'image'"
                                    fxLayout.lt-md="column" fxLayoutGap="10px">
                                    <mat-form-field fxFlex *ngIf="comp.controls['customField10'].value == 'Type 9'">
                                      <mat-label>Sub Description</mat-label>
                                      <input [attr.guide]="'template-inp-customfield7' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField7" matInput />
                                      <mat-icon class="clickable"
                                        (click)="openEditorText(comp.controls['customField7'].value,i,'customField7')"
                                        matSuffix>
                                        post_add
                                      </mat-icon>

                                    </mat-form-field>

                                    <mat-form-field fxFlex *ngIf="comp.controls['customField10'].value == 'Type 9'">
                                      <mat-label>Sub Paragraph</mat-label>
                                      <input [attr.guide]="'template-inp-customfield11' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField11" matInput />
                                      <mat-icon class="clickable"
                                        (click)="openEditorText(comp.controls['customField11'].value,i,'customField11')"
                                        matSuffix>
                                        post_add
                                      </mat-icon>
                                    </mat-form-field>

                                    <mat-form-field fxFlex *ngIf="comp.controls['customField10'].value == 'Type 9'">
                                      <mat-label>Sub Paragraph 2</mat-label>
                                      <input [attr.guide]="'template-inp-customfield12' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField12" matInput />
                                      <mat-icon class="clickable"
                                        (click)="openEditorText(comp.controls['customField12'].value,i,'customField12')"
                                        matSuffix>
                                        post_add
                                      </mat-icon>

                                    </mat-form-field>
                                  </div>


                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                                    <ng-container>
                                      <mat-form-field fxFlex *ngIf="layoutMainType !== 4">
                                        <mat-label>Position</mat-label>
                                        <input [attr.guide]="'template-inp-position' + '__' + sanitizedUrl" trim="blur"
                                          (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" required
                                          numbersOnly matInput formControlName="position" />
                                        <mat-error *ngIf="
                                            comp.controls.position.errors
                                              ?.required
                                          ">
                                          Please fill out this field.
                                        </mat-error>
                                      </mat-form-field>



                                      <mat-form-field fxFlex *ngIf="comp.controls['type'].value === 'stepFlowLayout'">
                                        <mat-label>Types</mat-label>
                                        <mat-select formControlName="customField25">
                                          <mat-option *ngFor="let item of stepFlowLayout" [value]="item.value">
                                            {{item.viewValue}}
                                          </mat-option>
                                        </mat-select>

                                      </mat-form-field>

                                      <mat-form-field fxFlex *ngIf="comp.controls['type'].value === 'emiCalculator'">
                                        <mat-label>Types</mat-label>
                                        <mat-select formControlName="customField23">
                                          <mat-option *ngFor="let item of emiCalculatorLayout" [value]="item.value">
                                            {{item.viewValue}}
                                          </mat-option>
                                        </mat-select>

                                      </mat-form-field>

                                      <mat-form-field fxFlex appearance="outline"
                                        *ngIf="comp.controls['type'].value === 'emiCalculator'&&  comp.controls.customField23.value ==1">
                                        <mat-label>Description</mat-label>
                                        <textarea [attr.guide]="'template-sel-customfield19' + '__' + sanitizedUrl"
                                          trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5
                                          matInput formControlName="customField19"></textarea>
                                        <mat-icon class="clickable"
                                          (click)="openEditorText(comp.controls['customField19'].value,i,'customField19')"
                                          matSuffix>
                                          post_add
                                        </mat-icon>
                                        <mat-hint fxHide.lt-md>Click on the icon to open editor</mat-hint>
                                      </mat-form-field>

                                      <mat-form-field fxFlex *ngIf="comp.controls['type'].value == 'faq' ">
                                        <mat-label>Header color</mat-label>
                                        <input [attr.guide]="'template-inp-customfield26' + '__' + sanitizedUrl"
                                          (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                          formControlName="customField26" matInput />

                                      </mat-form-field>

                                      <mat-form-field fxFlex *ngIf="comp.controls['type'].value === 'faq'">
                                        <mat-label>Types</mat-label>
                                        <mat-select formControlName="customField25">
                                          <mat-option *ngFor="let item of faqtypes" [value]="item.value">
                                            {{item.viewValue}}
                                          </mat-option>
                                        </mat-select>

                                      </mat-form-field>

                                      <mat-form-field fxFlex
                                        *ngIf="comp.controls['type'].value === 'imageContainerWithText'">
                                        <mat-label>Image Side</mat-label>
                                        <mat-select formControlName="customField25">
                                          <mat-option *ngFor="let item of imageType" [value]="item.value">
                                            {{item.viewValue}}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>

                                      <mat-form-field fxFlex
                                        *ngIf="comp.controls['type'].value === 'imageContainerWithText'">
                                        <mat-label>Button Name</mat-label>
                                        <input [attr.guide]="'template-inp-customfield12' + '__' + sanitizedUrl"
                                          [autocomplete]="'off'" trim="blur" matInput formControlName="customField12" />

                                      </mat-form-field>

                                      <mat-form-field fxFlex
                                        *ngIf="comp.controls['type'].value === 'imageContainerWithText'||comp.controls['type'].value === 'emiCalculator'">
                                        <mat-label>Background Color</mat-label>
                                        <input [attr.guide]="'template-inp-customfield20' + '__' + sanitizedUrl"
                                          [autocomplete]="'off'" trim="blur" matInput formControlName="customField20" />
                                      </mat-form-field>

                                      <mat-form-field fxFlex
                                        *ngIf="comp.controls['type'].value === 'imageContainerWithText'">
                                        <mat-label>Navigation Link</mat-label>
                                        <input [attr.guide]="'template-inp-customfield18' + '__' + sanitizedUrl"
                                          [autocomplete]="'off'" trim="blur" matInput formControlName="customField18" />

                                      </mat-form-field>

                                      <mat-form-field fxFlex
                                        *ngIf="comp.controls['type'].value === 'faq' && comp.controls.customField25.value == 2">
                                        <mat-label>Alt Tag</mat-label>
                                        <input [attr.guide]="'template-inp-altimage' + '__' + sanitizedUrl"
                                          (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                          formControlName="altImage" matInput />
                                      </mat-form-field>

                                      <mat-form-field fxFlex *ngIf="comp.controls['type'].value === 'vedioBanner'">
                                        <mat-label>Video Title</mat-label>
                                        <input [attr.guide]="'template-inp-customfield4' + '__' + sanitizedUrl"
                                          (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                          formControlName="customField4" matInput />
                                        <mat-icon class="clickable"
                                          (click)="openEditorText(comp.controls['customField4'].value,i,'customField4')"
                                          matSuffix>
                                          post_add
                                        </mat-icon>
                                      </mat-form-field>
                                      <mat-form-field fxFlex *ngIf="comp.controls['type'].value === 'vedioBanner'">
                                        <mat-label>Video Title AlignMent</mat-label>
                                        <mat-select formControlName="customField31" name="item">
                                          <mat-option *ngFor="
                                            let item of VideoTitleAlignMent;
                                            let i = index
                                          " [value]="item.value">
                                            {{ item.viewValue }}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>

                                      <mat-form-field fxFlex *ngIf="comp.controls['type'].value === 'vedioBanner'">
                                        <mat-label>Video Description</mat-label>
                                        <input [attr.guide]="'template-inp-customfield5' + '__' + sanitizedUrl"
                                          (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                          formControlName="customField5" matInput />
                                        <mat-icon class="clickable"
                                          (click)="openEditorText(comp.controls['customField5'].value,i,'customField5')"
                                          matSuffix>
                                          post_add
                                        </mat-icon>
                                      </mat-form-field>

                                      <mat-form-field fxFlex *ngIf="comp.controls['type'].value=='vedioBanner'">
                                        <mat-label>Form Type</mat-label>
                                        <mat-select formControlName="customField30">
                                          <mat-option *ngFor="let item of formType" [value]="item.value">
                                            {{item.viewValue}}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>


                                      <mat-form-field fxFlex *ngIf="comp.controls['type'].value === 'buttonType'">
                                        <mat-label>Button type</mat-label>
                                        <mat-select formControlName="customField15">
                                          <mat-option *ngFor="let item of buttonTypes" [value]="item.value">
                                            {{item.viewValue}}
                                          </mat-option>
                                        </mat-select>

                                      </mat-form-field>

                                      <mat-form-field fxFlex
                                        *ngIf="comp.controls['type'].value === 'buttonType'|| comp.controls['type'].value === 'slideBanner' ||comp.controls['type'].value === 'stepFlowLayout'">
                                        <mat-label>Font Size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield22' + '__' + sanitizedUrl"
                                          [autocomplete]="'off'" trim="blur" matInput formControlName="customField22" />
                                      </mat-form-field>

                                      <mat-form-field fxFlex
                                        *ngIf="comp.controls['type'].value === 'buttonType'|| comp.controls['type'].value === 'slideBanner'|| comp.controls['type'].value === 'stepFlowLayout'">
                                        <mat-label>Mobile Font Size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield23' + '__' + sanitizedUrl"
                                          [autocomplete]="'off'" trim="blur" matInput formControlName="customField23" />
                                      </mat-form-field>


                                      <mat-form-field fxFlex *ngIf="comp.controls['type'].value === 'buttonType'">
                                        <mat-label>Alignment</mat-label>
                                        <mat-select formControlName="customField28">
                                          <mat-option *ngFor="let item of position2" [value]="item.value">
                                            {{item.viewValue}}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>

                                      <mat-form-field fxFlex *ngIf="comp.controls['type'].value === 'buttonType'">
                                        <mat-label>Navigation Type</mat-label>
                                        <mat-select formControlName="customField6">
                                          <mat-option *ngFor="let item of navigationType" [value]="item.value">
                                            {{item.viewValue}}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>

                                      <mat-form-field fxFlex
                                        *ngIf="comp.controls['type'].value === 'buttonType' && comp.controls['customField6'].value==0">
                                        <mat-label>Link</mat-label>
                                        <input [attr.guide]="'template-inp-customfield11' + '__' + sanitizedUrl"
                                          [autocomplete]="'off'" trim="blur" matInput formControlName="customField11" />

                                      </mat-form-field>


                                      <mat-form-field fxFlex
                                        *ngIf="comp.controls['type'].value === 'buttonType' && comp.controls['customField6'].value==1">
                                        <mat-label>Form</mat-label>
                                        <mat-select formControlName="customField5" [disableOptionCentering]="true"
                                          #singleSelect name="item">
                                          <mat-option>
                                            <ngx-mat-select-search name="Form Search" ngDefaultControl [formControl]="
                              dynamicFormFilterControl
                                " placeholderLabel="Form Search" [preventHomeEndKeyPropagation]="
                                  true
                                " noEntriesFoundLabel="No data found">
                                            </ngx-mat-select-search>
                                          </mat-option>
                                          <mat-option *ngFor="let opt of filtereddynamicFormTypeList;"
                                            [value]="opt.formGroupId">
                                            {{ opt.name }}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>




                                      <mat-form-field fxFlex
                                        *ngIf="(comp.controls['type'].value === 'brandsCarousel'||comp.controls['type'].value === 'mp4')&& layoutMainType !== 4 ">
                                        <mat-label>Radius</mat-label>
                                        <input [attr.guide]="'template-inp-customfield11' + '__' + sanitizedUrl"
                                          [autocomplete]="'off'" trim="blur" matInput formControlName="customField11" />

                                      </mat-form-field>

                                      <mat-form-field fxFlex *ngIf="comp.controls['type'].value === 'typeForm'">
                                        <mat-label>Type Form Id </mat-label>
                                        <input [attr.guide]="'template-inp-customfield11' + '__' + sanitizedUrl"
                                          [autocomplete]="'off'" trim="blur" matInput formControlName="customField11" />

                                      </mat-form-field>


                                      <mat-form-field fxFlex *ngIf="comp.controls['type'].value === 'subscription' ">
                                        <mat-label>Enable ToTal Payment</mat-label>
                                        <mat-select formControlName="customField13">
                                          <mat-option *ngFor="let item of enablePayment" [value]="item.value">
                                            {{item.viewValue}}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>


                                      <mat-form-field fxFlex
                                        *ngIf="(comp.controls['type'].value === 'brandsCarousel' ||comp.controls['type'].value === 'mp4') && layoutMainType !== 4">
                                        <mat-label>Alignment</mat-label>
                                        <mat-select formControlName="customField13">
                                          <mat-option *ngFor="let item of position" [value]="item.value">
                                            {{item.viewValue}}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>

                                      <mat-form-field fxFlex
                                        *ngIf="( comp.controls['type'].value == 'categoryCarouselWithBanner')">
                                        <mat-label>Alignment</mat-label>
                                        <mat-select formControlName="customField13">
                                          <mat-option *ngFor="let item of position1" [value]="item.value">
                                            {{item.viewValue}}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>


                                      <mat-form-field fxFlex
                                        *ngIf="(comp.controls['type'].value === 'brandsCarousel' || comp.controls['type'].value === 'mp4' || comp.controls['type'].value === 'TypingWithBanner') && layoutMainType !== 4 ">
                                        <mat-label>Button Name</mat-label>
                                        <input [attr.guide]="'template-inp-customfield12' + '__' + sanitizedUrl"
                                          (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                          matInput formControlName="customField12" />

                                      </mat-form-field>
                                      <!-- <mat-form-field fxFlex
                                      *ngIf="comp.controls['type'].value != 'brandsCarousel' && comp.controls['type'].value != 'mp4' && comp.controls['type'].value != 'TypingWithBanner'">
                                      <mat-label>Button Name</mat-label>
                                      <input [attr.guide]="'template-inp-customfield12' + '__' + sanitizedUrl" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        trim="blur" matInput formControlName="customField12"/>

                                    </mat-form-field> -->


                                      <mat-form-field fxFlex *ngIf=" comp.controls['type'].value == 'textWithImage'">
                                        <mat-label>Title 2</mat-label>
                                        <input [attr.guide]="'template-inp-customfield19' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField19" />
                                        <mat-icon class="clickable"
                                          (click)="openEditorText(comp.controls['customField19'].value,i,'customField19')"
                                          matSuffix>
                                          post_add
                                        </mat-icon>
                                      </mat-form-field>

                                      <mat-form-field fxFlex
                                        *ngIf=" comp.controls['type'].value == 'textWithImage' || comp.controls['type'].value == 'typeForm'">
                                        <mat-label>Type</mat-label>
                                        <mat-select formControlName="customField20">
                                          <mat-option *ngFor="let item of layoutType2" [value]="item.id">
                                            {{item.status}}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>

                                      <mat-form-field fxFlex *ngIf="comp.controls['type'].value == 'categoryCarousel'">
                                        <mat-label>Type</mat-label>
                                        <mat-select formControlName="customField20">
                                          <mat-option *ngFor="let item of categoryCarouselType" [value]="item.id">
                                            {{item.status}}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>

                                      <mat-form-field fxFlex *ngIf=" comp.controls['type'].value == 'categoryCarousel'">
                                        <mat-label>Display Category Name</mat-label>
                                        <mat-select formControlName="categoryId7">
                                          <mat-option *ngFor="let item of booleanFieldNumber1" [value]="item.value">
                                            {{item.viewValue}}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>




                                      <mat-form-field fxFlex
                                        *ngIf=" (comp.controls['type'].value == 'freeText' || comp.controls['type'].value == 'scrollText'  || comp.controls['type'].value == 'textWithText') && layoutMainType !== 4">
                                        <mat-label>Font Family</mat-label>
                                        <input [attr.guide]="'template-inp-fontfamily' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="fontFamily" />
                                      </mat-form-field>

                                      <mat-form-field fxFlex *ngIf=" comp.controls['type'].value == 'textWithText'">
                                        <mat-label>Title Font Size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield19' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField19" />
                                      </mat-form-field>

                                      <mat-form-field fxFlex *ngIf=" comp.controls['type'].value == 'textWithText'">
                                        <mat-label>Title Mobile Font Size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield20' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField20" />
                                      </mat-form-field>

                                      <mat-form-field fxFlex
                                        *ngIf=" (comp.controls['type'].value == 'freeText' || comp.controls['type'].value == 'scrollText' || comp.controls['type'].value == 'bannerTextWithButton'|| comp.controls['type'].value == 'categoryCarouselWithBanner') && layoutMainType !== 4">
                                        <mat-label>Show Animation </mat-label>
                                        <mat-select formControlName="customField7">
                                          <mat-option *ngFor="let status of ShowAnimation" [value]="status.value">
                                            {{status.viewValue}}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>

                                      <mat-form-field fxFlex *ngIf="comp.controls['type'].value == 'DoubleImagescroll'">
                                        <mat-label>Gap Between Image</mat-label>
                                        <input [attr.guide]="'template-inp-gapbetweenimage' + '__' + sanitizedUrl"
                                          (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                          formControlName="gapBetweenImage" matInput />

                                      </mat-form-field>


                                      <mat-form-field fxFlex
                                        *ngIf="( comp.controls['type'].value === 'category' || comp.controls['type'].value === 'productScope') && layoutMainType !== 4">
                                        <mat-label>Deals Name</mat-label>
                                        <input [attr.guide]="'template-inp-customfield25' + '__' + sanitizedUrl"
                                          (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                          matInput formControlName="customField25" />
                                      </mat-form-field>

                                    </ng-container>

                                    <ng-container *ngIf=" comp.controls['type'].value == 'bannertextWithImage'">
                                      <mat-form-field fxFlex>
                                        <mat-label>Banner Title</mat-label>
                                        <input [attr.guide]="'template-inp-customfield1' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField1" />

                                      </mat-form-field>

                                      <calsoft-image fxFlex="50" style="padding-bottom: 10px;" required
                                        (deleteResult)="updatesIMage($event, i,'customField13')" (fileUploadResult)="
                                    getResultts($event, i,'customField13') " [index]="i"
                                        [value]="comp.controls['customField13'].value">
                                      </calsoft-image>


                                      <!-- <mat-form-field fxFlex>
                                      <mat-label>Banner Title1</mat-label>
                                      <input [attr.guide]="'template-inp-customfield4' + '__' + sanitizedUrl" trim="blur" (keydown.enter)="$event.preventDefault()"
                                        [autocomplete]="'off'"  matInput formControlName="customField4" />
                                    
                                    </mat-form-field> -->

                                    </ng-container>


                                    <ng-container *ngIf="(comp.controls['type'].value === 'banner' || comp.controls['type'].value === 'image' 
                                    || comp.controls['type'].value === 'category' || comp.controls['type'].value === 'productScope' 
                                    || comp.controls['type'].value === 'otherCustomization' 
                                    || comp.controls['type'].value === 'contactForm'
                                    || comp.controls['type'].value === 'categoryCarousel'
                                    || comp.controls['type'].value === 'bannerTextWithButton' 
                                    || comp.controls['type'].value === 'freeText'
                                    || comp.controls['type'].value === 'serviceLayout' 
                                    || comp.controls['type'].value === 'textWithText'       
                                    || comp.controls['type'].value === 'serviceContactButton' 
                                    || comp.controls['type'].value === 'tabLayout'     
                                    || comp.controls['type'].value === 'brandsCarousel' 
                                    || comp.controls['type'].value === 'scrolltextwithform'  
                                    || comp.controls['type'].value === 'footer'     
                                    || comp.controls['type'].value === 'livePrice'  
                                    || comp.controls['type'].value === 'OrderSuccess'                        
                                    )&&  layoutMainType !== 4">
                                      <mat-form-field fxFlex>
                                        <mat-label>BackGround Color</mat-label>
                                        <input [attr.guide]="'template-inp-customfield8' + '__' + sanitizedUrl"
                                          (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                          matInput formControlName="customField8" />
                                      </mat-form-field>

                                      <mat-form-field fxFlex *ngIf="comp.controls['type'].value === 'footer'">
                                        <mat-label> Footer BackGround Color</mat-label>
                                        <input [attr.guide]="'template-inp-customfield10' + '__' + sanitizedUrl"
                                          (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                          matInput formControlName="customField10" />
                                      </mat-form-field>
                                      <mat-form-field fxFlex
                                        *ngIf="comp.controls['type'].value === 'tabLayout' || comp.controls['type'].value === 'OrderSuccess'">
                                        <mat-label> Button Color</mat-label>
                                        <input [attr.guide]="'template-inp-customfield10' + '__' + sanitizedUrl"
                                          (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                          matInput formControlName="customField10" />
                                      </mat-form-field>


                                      <mat-form-field fxFlex *ngIf="comp.controls['type'].value=='footer'">
                                        <mat-label>Footer Font Color</mat-label>
                                        <input [attr.guide]="'template-inp-customfield11' + '__' + sanitizedUrl"
                                          [autocomplete]="'off'" trim="blur" matInput formControlName="customField11" />
                                      </mat-form-field>

                                      <mat-form-field fxFlex *ngIf="comp.controls['type'].value=='livePrice'">
                                        <mat-label>Image Count</mat-label>
                                        <mat-select formControlName="layout" name="item">
                                          <mat-option *ngFor="let item of [1, 2, 3, 4]" [value]="item">
                                            {{ item }}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>


                                      <mat-form-field fxFlex
                                        *ngIf="comp.controls['type'].value === 'banner'&&  layoutMainType !== 4">
                                        <mat-label>Alt Tag</mat-label>
                                        <input [attr.guide]="'template-inp-altimage' + '__' + sanitizedUrl"
                                          (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                          matInput formControlName="altImage" />
                                      </mat-form-field>

                                      <mat-form-field fxFlex appearance="outline"
                                        *ngIf=" comp.controls['type'].value == 'banner'&& comp.controls.customField1.value === 'type16'&& layoutMainType !== 4">
                                        <mat-label>Display Login</mat-label>
                                        <mat-select formControlName="customField25">
                                          <mat-option *ngFor="let item of displaylogin" [value]="item.value">
                                            {{item.viewValue}}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>


                                      <mat-form-field fxFlex
                                        *ngIf="comp.controls['type'].value === 'scrolltextwithform'">
                                        <mat-label>Form BackGround Color</mat-label>
                                        <input [attr.guide]="'template-inp-customfield15' + '__' + sanitizedUrl"
                                          [autocomplete]="'off'" trim="blur" formControlName="customField15" matInput />
                                      </mat-form-field>

                                      <mat-form-field fxFlex *ngIf="comp.controls['type'].value === 'image'">
                                        <mat-label>Sub BackGround Color</mat-label>
                                        <input [attr.guide]="'template-inp-customfield7' + '__' + sanitizedUrl"
                                          [autocomplete]="'off'" trim="blur" formControlName="customField7" matInput />
                                      </mat-form-field>

                                      <mat-form-field fxFlex *ngIf="comp.controls['type'].value === 'image'">
                                        <mat-label>Card Height</mat-label>
                                        <input [attr.guide]="'template-inp-customfield11' + '__' + sanitizedUrl"
                                          (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                          matInput formControlName="customField11" />
                                      </mat-form-field>

                                    </ng-container>



                                    <ng-container *ngIf="(comp.controls['type'].value === 'banner' || comp.controls['type'].value === 'image'
                                     || comp.controls['type'].value === 'slideBanner' 
                                     ||comp.controls['type'].value === '360View'
                                      || comp.controls['type'].value === 'bannerVideo' 
                                      || comp.controls['type'].value === 'bannerTextWithButton'
                                      || comp.controls['type'].value === 'category'
                                       || comp.controls['type'].value === 'productScope' 
                                       || comp.controls['type'].value === 'contactForm'
                                       || comp.controls['type'].value === 'freeText' 
                                       || comp.controls['type'].value === 'serviceLayout' 
                                       || comp.controls['type'].value === 'serviceContactButton'
                                       || comp.controls['type'].value === 'otherCustomization'
                                       || comp.controls['type'].value === 'iconTextWithBackground'
                                       || comp.controls['type'].value === 'tabLayout'
                                       || comp.controls['type'].value === 'servicePlan' 
                                       || comp.controls['type'].value === 'dragdrop'
                                       || comp.controls['type'].value === 'footer'
                                       || comp.controls['type'].value === 'brandsCarousel'
                                       || comp.controls['type'].value === 'OrderSuccess'
                                        ) &&  layoutMainType !== 4">

                                      <calsoft-image fxFlex="40" style="padding-bottom: 10px;"
                                        (deleteResult)="updatesIMage($event, i,'customField6')" (fileUploadResult)="
                                    getResultts($event, i,'customField6') " [index]="i"
                                        [value]="comp.controls['customField6'].value">
                                      </calsoft-image>


                                    </ng-container>

                                    <ng-container *ngIf="comp.controls['type'].value === 'scrolltextwithform'">
                                      <calsoft-image fxFlex="40" style="padding-bottom: 10px;"
                                        (deleteResult)="updatesIMage($event, i,'customField9')" (fileUploadResult)="
                                  getResultts($event, i,'customField9') " [index]="i"
                                        [value]="comp.controls['customField9'].value">
                                      </calsoft-image>
                                    </ng-container>



                                    <ng-container *ngIf="comp.controls['type'].value=='serviceLayout'">
                                      <mat-form-field fxFlex>
                                        <mat-label>Layout Type</mat-label>
                                        <mat-select formControlName="customField7">
                                          <mat-option *ngFor="let item of service_Layout" [value]="item.viewValue">
                                            {{item.value}}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container *ngIf="comp.controls['type'].value=='textwithform' ">

                                      <mat-form-field fxFlex>
                                        <mat-label>Image Title font size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield25' + '__' + sanitizedUrl"
                                          [autocomplete]="'off'" trim="blur" matInput formControlName="customField25" />
                                      </mat-form-field>

                                    </ng-container>

                                    <ng-container
                                      *ngIf="comp.controls['type'].value=='textwithform' || comp.controls['type'].value=='scrolltextwithform' || comp.controls['type'].value=='scrollableImageForm' || comp.controls['type'].value=='DoubleImagescroll'">
                                      <mat-form-field fxFlex>
                                        <mat-label>Form Type</mat-label>
                                        <mat-select formControlName="customField30">
                                          <mat-option *ngFor="let item of formType" [value]="item.value">
                                            {{item.viewValue}}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container *ngIf="comp.controls['type'].value=='textwithform'">
                                      <mat-form-field fxFlex>
                                        <mat-label>SubTitle Font Size </mat-label>
                                        <input [attr.guide]="'template-inp-customfield22' + '__' + sanitizedUrl"
                                          [autocomplete]="'off'" trim="blur" matInput formControlName="customField22" />
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container
                                      *ngIf="comp.controls['type'].value=='maps'
                                    ||comp.controls['type'].value=='contactForm' || comp.controls['type'].value=='mapsWithContactForm' ">
                                      <mat-form-field fxFlex>
                                        <mat-label>Layout</mat-label>
                                        <mat-select [disabled]="
                                          comp.controls['layout'].value != ''
                                        " required formControlName="layout" name="item">
                                          <mat-option *ngFor="let item of [1, 2]" [value]="item">
                                            {{ item }}
                                          </mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="
                                      comp.controls.layout.errors?.required
                                    ">
                                          Please fill out this field.
                                        </mat-error>
                                        <mat-error *ngIf="
                                      comp.controls['type'].value == 'image' &&
                                      comp.controls['value'].value == ''
                                    ">
                                          Please fill out this field.
                                        </mat-error>

                                      </mat-form-field>

                                      <mat-form-field fxFlex *ngIf="comp.controls['type'].value=='maps'">
                                        <mat-label>Multiple location</mat-label>
                                        <mat-select formControlName="customField30">
                                          <mat-option *ngFor="let item of mapview" [value]="item.value">
                                            {{item.viewValue}}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>

                                      <mat-form-field fxFlex
                                        *ngIf="comp.controls['type'].value=='contactForm' || comp.controls['type'].value=='mapsWithContactForm'">
                                        <mat-label>Form Type</mat-label>
                                        <mat-select formControlName="customField30">
                                          <mat-option *ngFor="let item of formType" [value]="item.value">
                                            {{item.viewValue}}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>

                                      <mat-form-field fxFlex *ngIf="comp.controls['type'].value=='buttonType'">
                                        <mat-label>Button Name </mat-label>
                                        <input [attr.guide]="'template-inp-customfield30' + '__' + sanitizedUrl"
                                          [autocomplete]="'off'" trim="blur" matInput formControlName="customField30" />
                                      </mat-form-field>

                                    </ng-container>
                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value=='OrderSuccess'">

                                    <mat-form-field fxFlex>
                                      <mat-label> End Title </mat-label>
                                      <input [attr.guide]="'template-inp-customfield23' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField23" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex>
                                      <mat-label> Button Name </mat-label>
                                      <input [attr.guide]="'template-inp-customfield24' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField24" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex>
                                      <mat-label>Height</mat-label>
                                      <input [attr.guide]="'template-inp-customfield25' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField25" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex>
                                      <mat-label>Mobile Height</mat-label>
                                      <input [attr.guide]="'template-inp-customfield26' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField26" />
                                    </mat-form-field>

                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value=='OrderSuccess'">

                                    <mat-form-field fxFlex>
                                      <mat-label>End Title Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield27' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField27" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex>
                                      <mat-label>End Title Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield28' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField28" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex>
                                      <mat-label>Button Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield29' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField29" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex>
                                      <mat-label>Button Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield30' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField30" />
                                    </mat-form-field>

                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value=='OrderSuccess'">

                                    <mat-form-field fxFlex>
                                      <mat-label>Font color </mat-label>
                                      <input [attr.guide]="'template-inp-customfield35' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField35" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex>
                                      <mat-label> Button Font color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield36' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField36" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex>
                                      <mat-label>Width</mat-label>
                                      <input [attr.guide]="'template-inp-customfield37' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField37" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex>
                                      <mat-label> Mobile Width</mat-label>
                                      <input [attr.guide]="'template-inp-customfield38' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField38" />
                                    </mat-form-field>

                                  </div>


                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value=='footer'">
                                    <mat-form-field fxFlex="30">
                                      <mat-label>Mobile Width</mat-label>
                                      <input [attr.guide]="'template-inp-customfield7' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField7" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex="30" appearance="outline">
                                      <mat-label>Display Contact Information</mat-label>
                                      <mat-select formControlName="customField13">
                                        <mat-option *ngFor="let item of displaycontact" [value]="item.value">
                                          {{item.viewValue}}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>

                                    <mat-form-field fxFlex="30" appearance="outline">
                                      <mat-label>Subscriber Button Type</mat-label>
                                      <mat-select formControlName="customField14">
                                        <mat-option *ngFor="let item of SubscriberButtontype" [value]="item.value">
                                          {{item.viewValue}}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>

                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value=='footer'">
                                    <mat-form-field fxFlex="30">
                                      <mat-label> Title Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield15' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField15" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex="30">
                                      <mat-label> Title Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield16' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField16" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex="30">
                                      <mat-label> Title Font Color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield17' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField17" />
                                    </mat-form-field>

                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value=='footer'">
                                    <mat-form-field fxFlex="30">
                                      <mat-label> content Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield18' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField18" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex="30">
                                      <mat-label> content Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield19' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField19" />
                                    </mat-form-field>


                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="(comp.controls['type'].value == 'tabLayout')">
                                    <mat-form-field fxFlex>
                                      <mat-label> Text with Image Title Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield37' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField37" matInput />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label> Text with Image Title Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield38' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField38" matInput />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label> Tab Title Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield39' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField39" matInput />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label> Tab Title Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield40' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField40" matInput />
                                    </mat-form-field>
                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="(comp.controls['type'].value == 'tabLayout')">
                                    <mat-form-field fxFlex>
                                      <mat-label> Title1 Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield33' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField33" matInput />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label> Title1 Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield34' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField34" matInput />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label> Description 1 Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield32' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField32" matInput />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label> Description 1 Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield36' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField36" matInput />
                                    </mat-form-field>
                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="(comp.controls['type'].value == 'banner' && layoutMainType !== 4)">
                                    <mat-form-field fxFlex>
                                      <mat-label>Title Web Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield34' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField34" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label> Title Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield35' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField35" matInput />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label> Sub Title Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield36' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField36" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label> Sub Title Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield37' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField37" matInput />
                                    </mat-form-field>
                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="(comp.controls['type'].value == 'slideBanner')">
                                    <mat-form-field fxFlex>
                                      <mat-label>Banner Web Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield34' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField34" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label> Banner Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield35' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField35" matInput />
                                    </mat-form-field>
                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="(comp.controls['type'].value == 'slideBanner')">
                                    <mat-form-field fxFlex>
                                      <mat-label> Banner1 Web Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield37' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField37" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Banner1 Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield38' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField38" matInput />
                                    </mat-form-field>
                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="(comp.controls['type'].value == 'slideBanner')">
                                    <mat-form-field fxFlex>
                                      <mat-label>Banner2 Web Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield39' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField39" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Banner2 Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield40' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField40" matInput />
                                    </mat-form-field>
                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="(comp.controls['type'].value == 'bannerVideo')">
                                    <mat-form-field fxFlex>
                                      <mat-label>Content Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield21' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField21" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Content Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield22' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField22" matInput />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Content1 Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield23' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField23" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Content1 Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield24' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField24" matInput />
                                    </mat-form-field>
                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="layoutMainType !== 4">
                                    <mat-form-field fxFlex="30" fxFlex.xs="100"
                                      *ngIf="comp.controls['type'].value!='freeText'&& comp.controls['type'].value!='table'">
                                      <mat-label>Show Animation </mat-label>
                                      <mat-select formControlName="customField36">
                                        <mat-option *ngFor="let status of ShowAnimation" [value]="status.value">
                                          {{status.viewValue}}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>

                                    <mat-form-field fxFlex="40"
                                      *ngIf="comp.controls['type'].value=='scrolltextwithform'" appearance="outline">
                                      <mat-label>Button Name</mat-label>
                                      <input [attr.guide]="'template-inp-customfield14' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        matInput formControlName="customField14" />

                                    </mat-form-field>
                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value=='serviceLayout'">
                                    <mat-form-field fxFlex="50">
                                      <mat-label>Layout Search Type</mat-label>
                                      <mat-select formControlName="customField25">
                                        <mat-option *ngFor="let item of searchlayout" [value]="item.viewValue">
                                          {{item.value}}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>
                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value=='serviceLayout'">
                                    <mat-form-field fxFlex>
                                      <mat-label>Subtitle</mat-label>
                                      <input [attr.guide]="'template-inp-customfield17' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        matInput formControlName="customField17" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield23' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField23" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield24' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField24" matInput />
                                    </mat-form-field>
                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value=='TypingWithBanner' && comp.controls['type'].value !='serviceLayout'">
                                    <mat-form-field fxFlex>
                                      <mat-label>Button Navigation Link</mat-label>
                                      <input [attr.guide]="'template-inp-customfield17' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        matInput formControlName="customField17" />
                                    </mat-form-field>
                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value=='TypingWithBanner'">
                                    <mat-form-field fxFlex>
                                      <mat-label>Banner Height</mat-label>
                                      <input [attr.guide]="'template-inp-customfield29' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        matInput formControlName="customField29" />
                                    </mat-form-field>
                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value=='TypingWithBanner'">
                                    <mat-form-field fxFlex>
                                      <mat-label>Font Color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield1' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        matInput formControlName="customField1" />
                                    </mat-form-field>
                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value=='buttonType' &&  comp.controls.customField15.value === '4'">
                                    <mat-form-field fxFlex>
                                      <mat-label>Background Color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield16' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        matInput formControlName="customField16" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex>
                                      <mat-label>text Color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield17' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        matInput formControlName="customField17" />
                                    </mat-form-field>


                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value=='TypingWithBanner'">
                                    <mat-form-field fxFlex>
                                      <mat-label>Background Color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield16' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        matInput formControlName="customField16" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex>
                                      <mat-label>Paragraph</mat-label>
                                      <input [attr.guide]="'template-inp-customfield30' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        matInput formControlName="customField30" />
                                    </mat-form-field>


                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls.customField25.value === '2'">
                                    <calsoft-image fxFlex="40" style="padding-bottom: 10px;"
                                      (deleteResult)="updatesIMage($event, i,'customField6')" (fileUploadResult)="
                                getResultts($event, i,'customField6') " [index]="i"
                                      [value]="comp.controls['customField6'].value">
                                    </calsoft-image>
                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value=='TypingWithBanner' ">
                                    <calsoft-image fxFlex="40" style="padding-bottom: 10px;"
                                      (deleteResult)="updatesIMage($event, i,'customField6')" (fileUploadResult)="
                                getResultts($event, i,'customField6') " [index]="i"
                                      [value]="comp.controls['customField6'].value">
                                    </calsoft-image>
                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="(comp.controls['type'].value === 'bannerTextWithButton'||comp.controls['type'].value === 'categoryCarouselWithBanner')">
                                    <mat-form-field fxFlex>
                                      <mat-label>Title Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield31' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField31" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label> Title Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield32' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField32" matInput />
                                    </mat-form-field>
                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="(comp.controls['type'].value == 'serviceLayout'|| comp.controls['type'].value === 'stepFlowLayout')">
                                    <mat-form-field fxFlex>
                                      <mat-label>Title Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield34' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField34" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label> Title Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield31' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField31" matInput />
                                    </mat-form-field>
                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px" *ngIf="(comp.controls['type'].value == 'serviceLayout'||comp.controls['type'].value === 'bannerTextWithButton'
                                ||comp.controls['type'].value === 'categoryCarouselWithBanner')">
                                    <mat-form-field fxFlex>
                                      <mat-label>SubTitle Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield37' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField37" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>SubTitle Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield38' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField38" matInput />
                                    </mat-form-field>
                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="(comp.controls['type'].value == 'serviceLayout'|| comp.controls['type'].value === 'stepFlowLayout'
                                ||comp.controls['type'].value === 'bannerTextWithButton'||comp.controls['type'].value === 'categoryCarouselWithBanner')">
                                    <mat-form-field fxFlex>
                                      <mat-label>Description Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield39' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField39" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Description Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield40' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField40" matInput />
                                    </mat-form-field>
                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="(comp.controls['type'].value === 'categoryCarouselWithBanner')">
                                    <mat-form-field fxFlex>
                                      <mat-label>Sub Description Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield24' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField24" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label> Sub Description Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield25' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField25" matInput />
                                    </mat-form-field>
                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="(comp.controls['type'].value === 'bannerTextWithButton')">
                                    <mat-form-field fxFlex>
                                      <mat-label>Sub Description Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield27' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField27" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label> Sub Description Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield28' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField28" matInput />
                                    </mat-form-field>
                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="(comp.controls['type'].value === 'bannerTextWithButton'||comp.controls['type'].value === 'categoryCarouselWithBanner')">
                                    <mat-form-field fxFlex>
                                      <mat-label>Special Description Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield29' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField29" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label> Special Description Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield30' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField30" matInput />
                                    </mat-form-field>
                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="layoutMainType !== 4">

                                    <mat-form-field fxFlex
                                      *ngIf=" comp.controls['type'].value == 'category'||comp.controls['type'].value == 'productScope'||comp.controls['type'].value == 'otherCustomization' ||comp.controls['type'].value == 'tabLayout'">
                                      <mat-label>Header Type</mat-label>
                                      <mat-select formControlName="categoryId5">
                                        <mat-option *ngFor="let item of headerType" [value]="item.value">
                                          {{item.viewValue}}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>


                                    <mat-form-field fxFlex
                                      *ngIf=" comp.controls['type'].value == 'category'||comp.controls['type'].value == 'productScope'||comp.controls['type'].value == 'otherCustomization' ||comp.controls['type'].value == 'tabLayout' ">
                                      <mat-label>Border</mat-label>
                                      <mat-select formControlName="categoryId4">
                                        <mat-option *ngFor="let item of booleanFieldNumber" [value]="item.value">
                                          {{item.viewValue}}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>

                                    <mat-form-field fxFlex
                                      *ngIf=" (comp.controls['type'].value == 'category'||comp.controls['type'].value == 'productScope')  && layoutMainType != 4">
                                      <mat-label>Title Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield39' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        matInput formControlName="customField39" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex
                                      *ngIf="(comp.controls['type'].value == 'category'||comp.controls['type'].value == 'productScope')  && layoutMainType != 4">
                                      <mat-label>Title Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield40' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        matInput formControlName="customField40" />
                                    </mat-form-field>


                                    <mat-form-field fxFlex *ngIf="comp.controls['type'].value === 'tabLayout' ">
                                      <mat-label>Type</mat-label>
                                      <mat-select formControlName="customField13">
                                        <mat-option *ngFor="let item of tabLayout" [value]="item.value">
                                          {{item.viewValue}}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>

                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value === 'buttonType'">

                                    <mat-form-field fxFlex
                                      *ngIf="comp.controls.customField15.value === '1' || comp.controls.customField15.value === '3' || comp.controls.customField15.value === '5' ||  comp.controls.customField15.value === '8'">
                                      <mat-label>Content Title</mat-label>
                                      <input [attr.guide]="'template-inp-customfield16' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        matInput formControlName="customField16" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex *ngIf="comp.controls.customField15.value === '7'">
                                      <mat-label>Content Title</mat-label>
                                      <textarea [attr.guide]="'template-sel-customfield16' + '__' + sanitizedUrl"
                                        trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5
                                        matInput formControlName="customField16" matInput>
                                  </textarea>
                                      <mat-icon class="clickable"
                                        (click)="openEditorText(comp.controls['customField16'].value,i,'customField16')"
                                        matSuffix>
                                        post_add
                                      </mat-icon>
                                    </mat-form-field>

                                    <mat-form-field fxFlex
                                      *ngIf="comp.controls.customField15.value === '3' || comp.controls.customField15.value === '8'">
                                      <mat-label>Inner Text as</mat-label>
                                      <textarea [attr.guide]="'template-sel-customfield19' + '__' + sanitizedUrl"
                                        trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5
                                        matInput formControlName="customField19" require d></textarea>
                                      <mat-icon class="clickable"
                                        (click)="openEditorText(comp.controls['customField19'].value,i,'customField19')"
                                        matSuffix>
                                        post_add
                                      </mat-icon>
                                      <mat-hint fxHide.lt-md>Click on the icon to open editor</mat-hint>
                                    </mat-form-field>
                                    <!-- <mat-form-field fxFlex *ngIf="comp.controls['type'].value=='TypingWithBanner'">
                                    <mat-label>Paragraph</mat-label>
                                    <textarea [attr.guide]="'template-sel-customfield19' + '__' + sanitizedUrl" trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5
                                      matInput formControlName="customField19" require d></textarea>
                                    <mat-icon class="clickable"
                                      (click)="openEditorText(comp.controls['customField19'].value,i,'customField19')"
                                      matSuffix>
                                      post_add
                                    </mat-icon>
                                    <mat-hint fxHide.lt-md>Click on the icon to open editor</mat-hint>
                                  </mat-form-field> -->

                                    <mat-form-field fxFlex
                                      *ngIf="comp.controls.customField15.value === '3' ||  comp.controls.customField15.value === '8'">
                                      <mat-label>Inner text fontsize</mat-label>
                                      <input [attr.guide]="'template-inp-customfield30' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        matInput formControlName="customField30" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex
                                      *ngIf="comp.controls.customField15.value === '3' ||  comp.controls.customField15.value === '8'">
                                      <mat-label>Inner text Mob fontsize</mat-label>
                                      <input [attr.guide]="'template-inp-customfield31' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        matInput formControlName="customField31" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex
                                      *ngIf="comp.controls.customField15.value === '1' || comp.controls.customField15.value === '3' || comp.controls.customField15.value === '5' || comp.controls.customField15.value === '7' ||  comp.controls.customField15.value === '8'">
                                      <mat-label>BackGround Color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield17' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        matInput formControlName="customField17" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex
                                      *ngIf="comp.controls.customField15.value === '1' || comp.controls.customField15.value === '3' ||  comp.controls.customField15.value === '8'">
                                      <mat-label>Button Icon Name</mat-label>
                                      <input [attr.guide]="'template-inp-customfield18' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        matInput formControlName="customField18" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex *ngIf="comp.controls.customField15.value === '2'">
                                      <mat-label>Button name2</mat-label>
                                      <input [attr.guide]="'template-inp-customfield16' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        matInput formControlName="customField16" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex *ngIf="comp.controls.customField15.value === '2'">
                                      <mat-label>Navigation Link2</mat-label>
                                      <input [attr.guide]="'template-inp-customfield17' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        matInput formControlName="customField17" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex *ngIf="comp.controls.customField15.value === '2' ">
                                      <mat-label>Button Color1</mat-label>
                                      <input [attr.guide]="'template-inp-customfield18' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        matInput formControlName="customField18" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex *ngIf="comp.controls.customField15.value === '2'">
                                      <mat-label>Button Color2</mat-label>
                                      <input [attr.guide]="'template-inp-customfield19' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        matInput formControlName="customField19" />
                                    </mat-form-field>

                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value === 'buttonType'">

                                    <mat-form-field fxFlex
                                      *ngIf="comp.controls.customField15.value === '3' ||  comp.controls.customField15.value === '8'">
                                      <mat-label>Content Color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield20' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        matInput formControlName="customField20" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex
                                      *ngIf="comp.controls.customField15.value === '3' || comp.controls.customField15.value === '7' ||  comp.controls.customField15.value === '8'">
                                      <mat-label>Button color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield21' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        matInput formControlName="customField21" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex
                                      *ngIf="comp.controls.customField15.value === '3' || comp.controls.customField15.value === '1' || comp.controls.customField15.value === '5' || comp.controls.customField15.value === '7' ||  comp.controls.customField15.value === '8'">
                                      <mat-label>title fontsize</mat-label>
                                      <input [attr.guide]="'template-inp-customfield27' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        matInput formControlName="customField27" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex
                                      *ngIf="comp.controls.customField15.value === '3' || comp.controls.customField15.value === '1' || comp.controls.customField15.value === '5' || comp.controls.customField15.value === '7' ||  comp.controls.customField15.value === '8'">
                                      <mat-label>title Mobile fontsize</mat-label>
                                      <input [attr.guide]="'template-inp-customfield29' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        matInput formControlName="customField29" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex *ngIf="comp.controls.customField15.value === '5'">
                                      <mat-label>Button name2</mat-label>
                                      <input [attr.guide]="'template-inp-customfield23' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        matInput formControlName="customField23" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex *ngIf="comp.controls.customField15.value === '5'">
                                      <mat-label>Button color1</mat-label>
                                      <input [attr.guide]="'template-inp-customfield24' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        matInput formControlName="customField24" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex *ngIf="comp.controls.customField15.value === '5'">
                                      <mat-label>Button color2</mat-label>
                                      <input [attr.guide]="'template-inp-customfield25' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        matInput formControlName="customField25" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex *ngIf="comp.controls.customField15.value === '5'">
                                      <mat-label>Navigation Link</mat-label>
                                      <input [attr.guide]="'template-inp-customfield26' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        matInput formControlName="customField26" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex *ngIf="comp.controls.customField15.value === '8'">
                                      <mat-label>Button Content Color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield37' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        matInput formControlName="customField37" />
                                    </mat-form-field>

                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value === 'freeText' && layoutMainType != 4">

                                    <mat-form-field fxFlex *ngIf="layoutMainType != 4">
                                      <mat-label>Font weight</mat-label>
                                      <input [attr.guide]="'template-inp-customfield29' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        matInput formControlName="customField29" />
                                    </mat-form-field>


                                    <mat-form-field fxFlex>
                                      <mat-label>Button Name </mat-label>
                                      <input [attr.guide]="'template-inp-customfield30' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField30" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Button Color </mat-label>
                                      <input [attr.guide]="'template-inp-customfield31' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField31" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Link </mat-label>
                                      <input [attr.guide]="'template-inp-customfield32' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField32" />
                                    </mat-form-field>


                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value === 'freeText' && layoutMainType != 4">

                                    <mat-form-field fxFlex>
                                      <mat-label>Inner Text Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield39' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        matInput formControlName="customField39" />
                                    </mat-form-field>


                                    <mat-form-field fxFlex>
                                      <mat-label>Inner Text Mobile Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield40' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField40" />
                                    </mat-form-field>



                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value === 'freeText' && layoutMainType != 4">

                                    <mat-form-field fxFlex>
                                      <mat-label>Content Width</mat-label>
                                      <input [attr.guide]="'template-inp-customfield23' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField23" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex>
                                      <mat-label>Button Icon name </mat-label>
                                      <input [attr.guide]="'template-inp-customfield33' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField33" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex>
                                      <mat-label>Mobile ContentWidth </mat-label>
                                      <input [attr.guide]="'template-inp-customfield28' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField28" />
                                    </mat-form-field>
                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value=='DoubleImagescroll'">
                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>Inner Title</mat-label>
                                      <textarea [attr.guide]="'template-sel-customfield6' + '__' + sanitizedUrl"
                                        trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5
                                        matInput formControlName="customField6" matInput>
                                  </textarea>
                                      <mat-icon class="clickable"
                                        (click)="openEditorText(comp.controls['customField6'].value,i,'customField6')"
                                        matSuffix>
                                        post_add
                                      </mat-icon>
                                    </mat-form-field>

                                    <!-- <mat-form-field fxFlex>
                                  <mat-label>Inner Title</mat-label>
                                  <input [attr.guide]="'template-inp-customfield6' + '__' + sanitizedUrl" [autocomplete]="'off'" trim="blur" matInput formControlName="customField6"/>
                                </mat-form-field> -->
                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>Inner Description</mat-label>
                                      <textarea [attr.guide]="'template-sel-customfield21' + '__' + sanitizedUrl"
                                        trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5
                                        matInput formControlName="customField21" matInput>
                                  </textarea>
                                      <mat-icon class="clickable"
                                        (click)="openEditorText(comp.controls['customField21'].value,i,'customField21')"
                                        matSuffix>
                                        post_add
                                      </mat-icon>
                                    </mat-form-field>
                                    <!-- <mat-form-field fxFlex>
                                  <mat-label>Inner Description</mat-label>
                                  <input [attr.guide]="'template-inp-customfield7' + '__' + sanitizedUrl" [autocomplete]="'off'" trim="blur" matInput formControlName="customField7"/>
                                </mat-form-field> -->

                                    <calsoft-image fxFlex="50" style="padding-bottom: 10px;" required
                                      (deleteResult)="updatesIMage($event, i,'customField22')" (fileUploadResult)="
                                  getResultts($event, i,'customField22') " [index]="i"
                                      [value]="comp.controls['customField22'].value">
                                    </calsoft-image>


                                    <calsoft-image fxFlex="50" style="padding-bottom: 10px;" required
                                      (deleteResult)="updatesIMage($event, i,'customField23')" (fileUploadResult)="
                                    getResultts($event, i,'customField23') " [index]="i"
                                      [value]="comp.controls['customField23'].value">
                                    </calsoft-image>


                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value=='DoubleImagescroll'">

                                    <mat-form-field fxFlex>
                                      <mat-label>Top Color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield24' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField24" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Bottom Color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield25' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField25" />
                                    </mat-form-field>

                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value=='DoubleImagescroll'">
                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>Inner Title 2</mat-label>
                                      <textarea [attr.guide]="'template-sel-customfield14' + '__' + sanitizedUrl"
                                        trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5
                                        matInput formControlName="customField14" matInput>
                                </textarea>
                                      <mat-icon class="clickable"
                                        (click)="openEditorText(comp.controls['customField14'].value,i,'customField14')"
                                        matSuffix>
                                        post_add
                                      </mat-icon>
                                    </mat-form-field>

                                    <!-- <mat-form-field fxFlex>
                                <mat-label>Inner Title 2</mat-label>
                                <input [attr.guide]="'template-inp-customfield14' + '__' + sanitizedUrl" [autocomplete]="'off'" trim="blur" matInput formControlName="customField14"/>
                              </mat-form-field>
                              <mat-form-field fxFlex> -->
                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>Inner Description 2</mat-label>
                                      <textarea [attr.guide]="'template-sel-customfield15' + '__' + sanitizedUrl"
                                        trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5
                                        matInput formControlName="customField15" matInput>
                                  </textarea>
                                      <mat-icon class="clickable"
                                        (click)="openEditorText(comp.controls['customField15'].value,i,'customField15')"
                                        matSuffix>
                                        post_add
                                      </mat-icon>
                                    </mat-form-field>

                                    <!-- <mat-label>Inner Description 2</mat-label>
                                <input [attr.guide]="'template-inp-customfield15' + '__' + sanitizedUrl" [autocomplete]="'off'" trim="blur" matInput formControlName="customField15"/>
                              </mat-form-field> -->


                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value=='DoubleImagescroll'">

                                    <mat-form-field fxFlex>
                                      <mat-label>Inner Title 1 Color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield17' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField17" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Inner Description 1 color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield18' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField18" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Inner Title 2 Color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield19' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField19" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Inner Description 2 color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield20' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField20" />
                                    </mat-form-field>


                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px" *ngIf="comp.controls['type'].value=='contactForm'|| comp.controls['type'].value=='vedioBanner' ||
                                  comp.controls['type'].value=='mapsWithContactForm' || 
                                  comp.controls['type'].value=='textwithform' ||
                                  comp.controls['type'].value=='scrollableImageForm' ||
                                  comp.controls['type'].value=='scrolltextwithform' || 
                                  comp.controls['type'].value=='DoubleImagescroll'">

                                    <mat-form-field fxFlex *ngIf="comp.controls['customField30'].value == '1'">
                                      <mat-label>Dynamic Form</mat-label>
                                      <mat-select formControlName="value" [disableOptionCentering]="true" #singleSelect
                                        name="item">
                                        <mat-option>
                                          <ngx-mat-select-search name="Dynamic Form Search" ngDefaultControl
                                            [formControl]="
                                          dynamicFormFilterControl
                                            " placeholderLabel="Dynamic Form Search" [preventHomeEndKeyPropagation]="
                                              true
                                            " noEntriesFoundLabel="No data found">
                                          </ngx-mat-select-search>
                                        </mat-option>
                                        <mat-option (onSelectionChange)="setDynamicForm($event,opt,'customField1',i)"
                                          *ngFor="let opt of filtereddynamicFormTypeList;" [value]="opt.formGroupId">
                                          {{ opt.name }}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>

                                    <mat-form-field fxFlex="50" *ngIf="comp.controls['customField13'].value == '1'">
                                      <mat-label>Dynamic Form 1</mat-label>
                                      <mat-select formControlName="customField7" [disableOptionCentering]="true"
                                        #singleSelect name="item">
                                        <mat-option>
                                          <ngx-mat-select-search name="Dynamic Form Search" ngDefaultControl
                                            [formControl]="
                                          dynamicFormFilterControl
                                            " placeholderLabel="Dynamic Form Search" [preventHomeEndKeyPropagation]="
                                              true
                                            " noEntriesFoundLabel="No data found">
                                          </ngx-mat-select-search>
                                        </mat-option>
                                        <mat-option (onSelectionChange)="setDynamicForm($event,opt,'customField8',i)"
                                          *ngFor="let opt of filtereddynamicFormTypeList;" [value]="opt.formGroupId">
                                          {{ opt.name }}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>

                                    <mat-form-field fxFlex>
                                      <mat-label>Enable ToTal Payment</mat-label>
                                      <mat-select formControlName="customField5">
                                        <mat-option *ngFor="let item of enablePayment" [value]="item.value">
                                          {{item.viewValue}}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>

                                    <mat-form-field fxFlex *ngIf="comp.controls['customField30'].value == '1'"
                                      appearance="outline">
                                      <mat-label>Form Type</mat-label>
                                      <mat-select formControlName="customField13">
                                        <mat-option *ngFor="let status of Formtype" [value]="status.value">
                                          {{status.viewValue}}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>

                                    <mat-form-field fxFlex *ngIf="comp.controls['customField30'].value == '1'"
                                      appearance="outline">
                                      <mat-label>Submit Type</mat-label>
                                      <mat-select formControlName="customField31">
                                        <mat-option *ngFor="let status of submittype" [value]="status.value">
                                          {{status.viewValue}}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>

                                    <mat-form-field fxFlex *ngIf="comp.controls['type'].value=='textwithform'">
                                      <mat-label>Mob Title font size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield31' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField31" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex *ngIf="comp.controls['type'].value=='textwithform'">
                                      <mat-label>Mob subtitle font size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield32' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField32" />
                                    </mat-form-field>

                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value=='textwithform' || comp.controls['type'].value=='scrolltextwithform' || comp.controls['type'].value=='tabLayout'">
                                    <mat-form-field appearance="outline" fxFlex="50">
                                      <mat-label>Text With Image Title</mat-label>
                                      <textarea [attr.guide]="'template-sel-customfield6' + '__' + sanitizedUrl"
                                        trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5
                                        matInput formControlName="customField6" matInput>
                                  </textarea>
                                      <mat-icon class="clickable"
                                        (click)="openEditorText(comp.controls['customField6'].value,i,'customField6')"
                                        matSuffix>
                                        post_add
                                      </mat-icon>
                                    </mat-form-field>

                                    <calsoft-image *ngIf="comp.controls['type'].value=='tabLayout' " fxFlex="100"
                                      style="padding-bottom: 10px;"
                                      (deleteResult)="updatesIMage($event, i,'customField8')" (fileUploadResult)="
                              getResultts($event, i,'customField8') " [index]="i"
                                      [value]="comp.controls['customField8'].value">
                                    </calsoft-image>

                                    <mat-form-field fxFlex *ngIf="comp.controls['type'].value=='scrolltextwithform' ">
                                      <mat-label>Split Screen Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield2' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField2" />
                                    </mat-form-field>

                                    <mat-form-field appearance="outline"
                                      *ngIf="comp.controls['type'].value=='textwithform' || comp.controls['type'].value=='scrolltextwithform'"
                                      fxFlex>
                                      <mat-label>Sub Defintition</mat-label>
                                      <textarea [attr.guide]="'template-sel-customfield7' + '__' + sanitizedUrl"
                                        trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5
                                        matInput formControlName="customField7" matInput>
                                  </textarea>
                                      <mat-icon class="clickable"
                                        (click)="openEditorText(comp.controls['customField7'].value,i,'customField7')"
                                        matSuffix>
                                        post_add
                                      </mat-icon>
                                    </mat-form-field>


                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px" *ngIf="comp.controls['type'].value=='contactForm'
                                  ||comp.controls['type'].value=='TexthoverWithImage' ">

                                    <mat-form-field fxFlex
                                      *ngIf="comp.controls['type'].value !=='contactForm'|| comp.controls['type'].value !=='TexthoverWithImage'  ">
                                      <mat-label>Title Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield11' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField11" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Title align </mat-label>
                                      <mat-select formControlName="customField12">
                                        <mat-option *ngFor="let status of Title_view" [value]="status.value">
                                          {{status.value}}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Title Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield39' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField39" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Title Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield40' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField40" />
                                    </mat-form-field>

                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value=='storeLocations' ">

                                    <mat-form-field fxFlex>
                                      <mat-label>City Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield16' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField16" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>City Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield17' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField17" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Address Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield18' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField18" />
                                    </mat-form-field>
                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value=='storeLocations' ">
                                    <mat-form-field fxFlex>
                                      <mat-label>Address Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield19' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField19" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Phone Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield20' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField20" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Phone Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield21' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField21" />
                                    </mat-form-field>
                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px" *ngIf="comp.controls['type'].value=='contactForm'
                                   || comp.controls['type'].value=='mapsWithContactForm'
                                   || comp.controls['type'].value=='textwithform'
                                   || comp.controls['type'].value=='scrolltextwithform'
                                   || comp.controls['type'].value=='stepperform'
                                    || comp.controls['type'].value=='scrollableImageForm' 
                                    || comp.controls['type'].value == 'vedioBanner'
                                    ||  comp.controls['type'].value=='DoubleImagescroll'  ">

                                    <mat-form-field fxFlex>
                                      <mat-label>No of Fields To be displayed in Web </mat-label>
                                      <input [attr.guide]="'template-inp-customfield26' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField26" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>No of Fields To be displayed in Mobile</mat-label>
                                      <input [attr.guide]="'template-inp-customfield27' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField27" />
                                    </mat-form-field>

                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px" *ngIf="
                                  comp.controls['type'].value=='scrolltextwithform'
                                ">

                                    <mat-form-field fxFlex>
                                      <mat-label>Enable Privacy Policy Button</mat-label>
                                      <mat-select formControlName="customField32">
                                        <mat-option *ngFor="let item of enablePrivacypolicy" [value]="item.value">
                                          {{item.viewValue}}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Enable Broucher Button</mat-label>
                                      <mat-select formControlName="customField33">
                                        <mat-option *ngFor="let item of enablebroucherbutton" [value]="item.value">
                                          {{item.viewValue}}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>


                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px" *ngIf="
                                comp.controls['type'].value=='scrolltextwithform'
                              ">

                                    <mat-form-field fxFlex>
                                      <mat-label>Enter Description For Privacy Policy </mat-label>
                                      <input [attr.guide]="'template-inp-customfield40' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField40" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield40' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField40" />
                                    </mat-form-field>


                                  </div>
                                  <!-- <calsoft-pdf fxFlex="40" style="padding-bottom: 10px;"
                                      (deleteResult)="updatesIMage($event, i,'customField6')" (fileUploadResult)="
                                    getResultts($event, i,'customField6') " [index]="i"
                                      [value]="comp.controls['customField6'].value">
                                    </calsoft-pdf> -->
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value=='scrolltextwithform'">

                                    <mat-form-field appearance="outline" *ngIf="enablePrivacypolicy.value == '1'"
                                      fxFlex>
                                      <mat-label>Enter Privacy Policy</mat-label>
                                      <textarea [attr.guide]="'template-sel-customfield30' + '__' + sanitizedUrl"
                                        trim="blur" matTextareaAutosize matAutosizeMinRows="1" matAutosizeMaxRows="5"
                                        matInput formControlName="customField30">
                                   </textarea>
                                      <mat-icon class="clickable"
                                        (click)="openEditorText(comp.controls['customField30'].value, i, 'customField30')"
                                        matSuffix>
                                        post_add
                                      </mat-icon>
                                      <div *ngIf="enablebroucherbutton.value == '1'">
                                        <calsoft-pdf fxFlex="40" style="padding-bottom: 10px;"
                                          (deleteResult)="updatesIMage($event, i, 'customField29')"
                                          (fileUploadResult)="getResultts($event, i, 'customField29')" [index]="i"
                                          [value]="comp.controls['customField29'].value">
                                        </calsoft-pdf>
                                      </div>
                                    </mat-form-field>

                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value=='scrolltextwithform'">

                                    <mat-form-field fxFlex>
                                      <mat-label>Text with Image Titile Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield37' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField37" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Text with Image Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield38' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField38" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Sub Defintition Titile Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield31' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField31" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Sub Defintition Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield34' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField34" />
                                    </mat-form-field>

                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value=='DoubleImagescroll'">

                                    <mat-form-field fxFlex>
                                      <mat-label>Inner Title Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield37' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField37" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Inner Title Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield38' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField38" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Inner Description Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield31' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField31" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Inner Description Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield34' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField34" />
                                    </mat-form-field>

                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="( comp.controls['type'].value == 'stepperform') ">
                                    <mat-form-field fxFlex>
                                      <mat-label>Title Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield33' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField33" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Title Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield34' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField34" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Step-From Title Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield35' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField35" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Step-Form Title Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield36' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField36" />
                                    </mat-form-field>



                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value=='contactForm'">

                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>Show White Theme Field</mat-label>
                                      <mat-select formControlName="customField38">
                                        <mat-option *ngFor="let status of whitethemetypes" [value]="status.value">
                                          {{status.viewValue}}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>
                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px" *ngIf="comp.controls['type'].value=='contactForm' 
                                  || comp.controls['type'].value == 'vedioBanner'
                                  || comp.controls['type'].value=='mapsWithContactForm'
                                  || comp.controls['type'].value=='textwithform'
                                  || comp.controls['type'].value=='scrolltextwithform'
                                  || comp.controls['type'].value=='stepperform'
                                  || comp.controls['type'].value=='scrollableImageForm'
                                  || comp.controls['type'].value=='DoubleImagescroll'">

                                    <mat-form-field fxFlex>
                                      <mat-label>Success Message</mat-label>
                                      <input [attr.guide]="'template-inp-customfield28' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField28" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Failer Message</mat-label>
                                      <input [attr.guide]="'template-inp-customfield29' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField29" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex *ngIf="comp.controls['type'].value!=='vedioBanner'">
                                      <mat-label>Redirect Link</mat-label>
                                      <input [attr.guide]="'template-inp-customfield10' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField10" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex *ngIf="comp.controls['type'].value=='vedioBanner'">
                                      <mat-label>Redirect Link</mat-label>
                                      <input [attr.guide]="'template-inp-customfield11' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField11" />
                                    </mat-form-field>

                                  </div>




                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value=='textwithform' || comp.controls['type'].value=='scrolltextwithform'">

                                    <calsoft-image fxFlex="50" style="padding-bottom: 10px;" required
                                      (deleteResult)="updatesIMage($event, i,'customField21')" (fileUploadResult)="
                                    getResultts($event, i,'customField21') " [index]="i"
                                      [value]="comp.controls['customField21'].value">
                                    </calsoft-image>

                                    <mat-form-field fxFlex *ngIf="comp.controls['type'].value=='scrolltextwithform'">
                                      <mat-label>Sub Image height</mat-label>
                                      <input [attr.guide]="'template-inp-customfield11' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField11" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex *ngIf="comp.controls['type'].value=='scrolltextwithform'">
                                      <mat-label>Sub Image Mob height</mat-label>
                                      <input [attr.guide]="'template-inp-customfield12' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField12" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex *ngIf="comp.controls['type'].value=='scrolltextwithform'">
                                      <mat-label>Font Color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield33' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField33" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex *ngIf="comp.controls['type'].value=='textwithform'">
                                      <mat-label>Alt Tag </mat-label>
                                      <input [attr.guide]="'template-inp-altimage' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="altImage" />
                                    </mat-form-field>

                                    <mat-form-field appearance="outline"
                                      *ngIf="comp.controls['type'].value=='textwithform'" fxFlex>
                                      <mat-label>Describe About</mat-label>
                                      <textarea [attr.guide]="'template-sel-customfield8' + '__' + sanitizedUrl"
                                        trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5
                                        matInput formControlName="customField8" matInput>
                                    </textarea>
                                      <mat-icon class="clickable"
                                        (click)="openEditorText(comp.controls['customField8'].value,i,'customField8')"
                                        matSuffix>
                                        post_add
                                      </mat-icon>
                                    </mat-form-field>

                                    <ng-container *ngIf="comp.controls['type'].value=='textwithform'">
                                      <mat-form-field fxFlex>
                                        <mat-label>Describe Font Size </mat-label>
                                        <input [attr.guide]="'template-inp-customfield26' + '__' + sanitizedUrl"
                                          [autocomplete]="'off'" trim="blur" matInput formControlName="customField26" />
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-container *ngIf="comp.controls['type'].value=='textwithform'">
                                      <mat-form-field fxFlex>
                                        <mat-label>Describe Mob Font Size </mat-label>
                                        <input [attr.guide]="'template-inp-customfield35' + '__' + sanitizedUrl"
                                          [autocomplete]="'off'" trim="blur" matInput formControlName="customField35" />
                                      </mat-form-field>
                                    </ng-container>


                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value=='textWithText' || comp.controls['type'].value=='TexthoverWithImage'">

                                    <mat-form-field fxFlex>
                                      <mat-label>Describe font size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield21' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField21" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Describe Mobile font size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield22' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField22" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex
                                      *ngIf="( comp.controls['type'].value != 'TexthoverWithImage')">
                                      <mat-label>Button Name</mat-label>
                                      <input [attr.guide]="'template-inp-customfield3' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField3" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex
                                      *ngIf="( comp.controls['type'].value != 'TexthoverWithImage')">
                                      <mat-label>Types </mat-label>
                                      <mat-select formControlName="customField5">
                                        <mat-option *ngFor="let status of textwithtexttype" [value]="status.viewValue">
                                          {{status.value}}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>

                                    <mat-form-field fxFlex
                                      *ngIf="( comp.controls['type'].value == 'TexthoverWithImage')">
                                      <mat-label>Background color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield27' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField27" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex
                                      *ngIf="( comp.controls['type'].value == 'TexthoverWithImage')">
                                      <mat-label>Text Background color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield28' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField28" />
                                    </mat-form-field>

                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value=='textWithText'">

                                    <mat-form-field fxFlex>
                                      <mat-label>Gap Betwen Container</mat-label>
                                      <input [attr.guide]="'template-inp-customfield35' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField35" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex>
                                      <mat-label>Title align </mat-label>
                                      <mat-select formControlName="customField39">
                                        <mat-option *ngFor="let status of Title_view" [value]="status.viewValue">
                                          {{status.value}}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>

                                    <calsoft-image fxFlex style="padding-bottom: 10px;" required
                                      (deleteResult)="updatesIMage($event, i,'customField37')" (fileUploadResult)="
                              getResultts($event, i,'customField37') " [index]="i"
                                      [value]="comp.controls['customField37'].value">
                                    </calsoft-image>
                                    <calsoft-image fxFlex style="padding-bottom: 10px;" required
                                      (deleteResult)="updatesIMage($event, i,'customField38')" (fileUploadResult)="
                              getResultts($event, i,'customField38') " [index]="i"
                                      [value]="comp.controls['customField38'].value">
                                    </calsoft-image>
                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value=='textWithText'">

                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>Title Left</mat-label>
                                      <input [attr.guide]="'template-inp-customfield7' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField7" />
                                      <mat-icon class="clickable"
                                        (click)="openEditorText(comp.controls['customField7'].value,i,'customField7')"
                                        matSuffix>
                                        post_add
                                      </mat-icon>
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>Description</mat-label>
                                      <textarea [attr.guide]="'template-sel-customfield14' + '__' + sanitizedUrl"
                                        trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5
                                        matInput formControlName="customField14" matInput>
                                    </textarea>
                                      <mat-icon class="clickable"
                                        (click)="openEditorText(comp.controls['customField14'].value,i,'customField14')"
                                        matSuffix>
                                        post_add
                                      </mat-icon>
                                    </mat-form-field>

                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value=='textWithText'">

                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>Title Right</mat-label>
                                      <input [attr.guide]="'template-inp-customfield11' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField11" />
                                      <mat-icon class="clickable"
                                        (click)="openEditorText(comp.controls['customField11'].value,i,'customField11')"
                                        matSuffix>
                                        post_add
                                      </mat-icon>
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>Description</mat-label>
                                      <textarea [attr.guide]="'template-sel-customfield10' + '__' + sanitizedUrl"
                                        trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5
                                        matInput formControlName="customField10" matInput>
                                  </textarea>
                                      <mat-icon class="clickable"
                                        (click)="openEditorText(comp.controls['customField10'].value,i,'customField10')"
                                        matSuffix>
                                        post_add
                                      </mat-icon>
                                    </mat-form-field>

                                    <mat-form-field fxFlex>
                                      <mat-label>Background Color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield4' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField4" />
                                    </mat-form-field>

                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value=='serviceContactButton'">

                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>Title Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield37' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField37" />
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>Title Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield38' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField38" />
                                    </mat-form-field>
                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>Content Option Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield39' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField39" />
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>Content Option Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield40' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField40" />
                                    </mat-form-field>


                                  </div>


                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value=='serviceContactButton'">

                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>Call Us Button Name</mat-label>
                                      <input [attr.guide]="'template-inp-customfield7' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField7" />
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>Call Us Number</mat-label>
                                      <input [attr.guide]="'template-inp-customfield15' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField15" />
                                    </mat-form-field>


                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value=='serviceContactButton'">

                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>Email Button Name</mat-label>
                                      <input [attr.guide]="'template-inp-customfield10' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField10" />
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>Email Id</mat-label>
                                      <input [attr.guide]="'template-inp-customfield11' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField11" />
                                    </mat-form-field>


                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value=='serviceContactButton'">

                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>Whatsapp Button Name</mat-label>
                                      <input [attr.guide]="'template-inp-customfield12' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField12" />
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>Whatsapp Number</mat-label>
                                      <input [attr.guide]="'template-inp-customfield14' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField14" />
                                    </mat-form-field>


                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value=='NumberCount'">

                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>Title Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield11' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField11" />
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>Title Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield12' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField12" />
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>Number Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield14' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField14" />
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>Number Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield15' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField15" />
                                    </mat-form-field>


                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value=='NumberCount'">

                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>Font color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield16' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField16" />
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label> Hover color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield17' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField17" />
                                    </mat-form-field>




                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value=='textWithImage'">
                                    <mat-form-field fxFlex>
                                      <mat-label>Button Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield25' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField25" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex>
                                      <mat-label>Button Mobile font size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield26' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField26" />
                                    </mat-form-field>

                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value=='imageContainerWithText'">

                                    <mat-form-field fxFlex>
                                      <mat-label>Button Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield26' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField26" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex>
                                      <mat-label>Button Mobile font size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield27' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField27" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex>
                                      <mat-label>Image height</mat-label>
                                      <input [attr.guide]="'template-inp-customfield28' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField28" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex>
                                      <mat-label>Image Mobile height</mat-label>
                                      <input [attr.guide]="'template-inp-customfield29' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField29" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex>
                                      <mat-label>font size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield30' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField30" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex>
                                      <mat-label>Mobile font size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield31' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField31" />
                                    </mat-form-field>

                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value=='imageContainerWithText'">

                                    <calsoft-image fxFlex="50" style="padding-bottom: 10px;" required
                                      (deleteResult)="updatesIMage($event, i,'customField21')" (fileUploadResult)="
                              getResultts($event, i,'customField21') " [index]="i"
                                      [value]="comp.controls['customField21'].value">
                                    </calsoft-image>

                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>Alt Tag</mat-label>
                                      <input [attr.guide]="'template-inp-altimage' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="altImage" />
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>Title</mat-label>
                                      <input [attr.guide]="'template-inp-customfield7' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField7" />
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>content 1</mat-label>
                                      <textarea [attr.guide]="'template-sel-customfield14' + '__' + sanitizedUrl"
                                        trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5
                                        matInput formControlName="customField14" matInput>
                                </textarea>
                                      <mat-icon class="clickable"
                                        (click)="openEditorText(comp.controls['customField14'].value,i,'customField14')"
                                        matSuffix>
                                        post_add
                                      </mat-icon>
                                    </mat-form-field>

                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value=='imageContainerWithText'">

                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>Middle Title</mat-label>
                                      <input [attr.guide]="'template-inp-customfield11' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField11" />
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>Sub Title font size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield32' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField32" />
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>Sub Title Mob font size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield33' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField33" />
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>background type</mat-label>
                                      <mat-select formControlName="autoplay" formControlName="customField18">
                                        <mat-option *ngFor="let status of backType" [value]="status.value">
                                          {{status.viewValue}}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>content 2</mat-label>
                                      <textarea [attr.guide]="'template-sel-customfield10' + '__' + sanitizedUrl"
                                        trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5
                                        matInput formControlName="customField10" matInput>
                              </textarea>
                                      <mat-icon class="clickable"
                                        (click)="openEditorText(comp.controls['customField10'].value,i,'customField10')"
                                        matSuffix>
                                        post_add
                                      </mat-icon>
                                    </mat-form-field>

                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="comp.controls['type'].value=='imageContainerWithText'">
                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>content 1 font size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield35' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField35" />
                                    </mat-form-field>
                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>content 2 font size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield36' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField36" />
                                    </mat-form-field>
                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>content 1 Mobile font size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield37' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField37" />
                                    </mat-form-field>
                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>content 2 Mobile font size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield38' + '__' + sanitizedUrl"
                                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField38" />
                                    </mat-form-field>

                                  </div>


                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf=" comp.controls['type'].value == 'bannertextWithImage'">
                                    <mat-form-field fxFlex="50" appearance="outline">
                                      <mat-label>Banner Description</mat-label>
                                      <textarea [attr.guide]="'template-sel-customfield14' + '__' + sanitizedUrl"
                                        trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5
                                        matInput formControlName="customField14"></textarea>
                                      <mat-icon class="clickable"
                                        (click)="openEditorText(comp.controls['customField14'].value,i,'customField14')"
                                        matSuffix>
                                        post_add
                                      </mat-icon>
                                      <mat-hint fxHide.lt-md>Click on the icon to open editor</mat-hint>
                                    </mat-form-field>


                                    <mat-form-field fxFlex fxLayoutGap="10px">
                                      <mat-label>Banner Description Color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield8' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        matInput formControlName="customField8" />
                                    </mat-form-field>


                                    <mat-form-field fxFlex>
                                      <mat-label>Font Family</mat-label>
                                      <input [attr.guide]="'template-inp-fontfamily' + '__' + sanitizedUrl" trim="blur"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" matInput
                                        formControlName="fontFamily" />
                                    </mat-form-field>

                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf=" comp.controls['type'].value == 'bannertextWithImage' || comp.controls['type'].value == 'slideBanner'">

                                    <calsoft-image fxFlex="50" style="padding-bottom: 10px;" required
                                      (deleteResult)="updatesIMage($event, i,'customField21')" (fileUploadResult)="
                                    getResultts($event, i,'customField21') " [index]="i"
                                      [value]="comp.controls['customField21'].value">
                                    </calsoft-image>



                                    <!-- <mat-form-field fxFlex>
                                    <mat-label>Font Family</mat-label>
                                    <input [attr.guide]="'template-inp-fontfamily' + '__' + sanitizedUrl" trim="blur" [autocomplete]="'off'"  matInput formControlName="fontFamily" />                                    
                                  </mat-form-field> -->

                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf=" comp.controls['type'].value == 'bannertextWithImage'">

                                    <mat-form-field fxFlex>
                                      <mat-label>Description Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield35' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField35" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex>
                                      <mat-label>Description Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield36' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField36" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Image Title Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield33' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField33" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex>
                                      <mat-label>Image Title Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield34' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField34" />
                                    </mat-form-field>




                                    <!-- <mat-form-field fxFlex>
                                  <mat-label>Font Family</mat-label>
                                  <input [attr.guide]="'template-inp-fontfamily' + '__' + sanitizedUrl" trim="blur" [autocomplete]="'off'"  matInput formControlName="fontFamily" />                                    
                                </mat-form-field> -->

                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf=" comp.controls['type'].value == 'bannertextWithImage'">


                                    <mat-form-field fxFlex>
                                      <mat-label>Image Title 1 Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield31' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField31" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex>
                                      <mat-label>Image Title 1 Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield32' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField32" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Image Content Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield29' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField29" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex>
                                      <mat-label>Image Content Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield30' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField30" />
                                    </mat-form-field>




                                    <!-- <mat-form-field fxFlex>
                                 <mat-label>Font Family</mat-label>
                                 <input [attr.guide]="'template-inp-fontfamily' + '__' + sanitizedUrl" trim="blur" [autocomplete]="'off'"  matInput formControlName="fontFamily" />                                    
                               </mat-form-field> -->

                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf=" comp.controls['type'].value == 'bannertextWithImage'">



                                    <mat-form-field fxFlex>
                                      <mat-label>Image Content 1 Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield37' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField37" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex>
                                      <mat-label>Image Content 1 Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield38' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField38" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex>
                                      <mat-label>Image Content 2 Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield39' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField39" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex>
                                      <mat-label>Image Content 2 Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield40' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField40" />
                                    </mat-form-field>




                                    <!-- <mat-form-field fxFlex>
                                <mat-label>Font Family</mat-label>
                                <input [attr.guide]="'template-inp-fontfamily' + '__' + sanitizedUrl" trim="blur" [autocomplete]="'off'"  matInput formControlName="fontFamily" />                                    
                              </mat-form-field> -->

                                  </div>




                                  <div formArrayName="images" *ngIf="(comp.controls['type'].value == 'image')|| 
                                    (comp.controls['type'].value == 'textWithImage')  ">


                                    <div *ngFor="
                                        let skill of comp.get('images')?.controls;
                                        let j = index
                                      ">
                                      <div [formGroupName]="j" fxLayout="column" fxLayoutGap="10px">
                                        <!-- <mat-form-field>
                                             <input [attr.guide]="'template-inp-img' + '__' + sanitizedUrl" [autocomplete]="'off'"matInput formControlName="img" placeholder="label" value="value"/>
                                            </mat-form-field> -->
                                        <div fxLayout.gt-md="row" fxLayout.lt-md="column">
                                          <ng-container
                                            *ngIf="skill.controls['type'].value==1 || skill.controls['type'].value==4  || skill.controls['type'].value==5 || skill.controls['type'].value==6 || skill.controls['type'].value==7 || skill.controls['type'].value==8 || skill.controls['type'].value==10|| skill.controls['type'].value==12">
                                            <calsoft-image fxFlex="50" [type]="skill.controls['type'].value"
                                              (deleteResult)="update($event, j)" (fileUploadResult)="
                                          getResult($event, i, j)  
                                        " (imageUrlReturn)="getImageUrl($event,comp.controls['height'].value,comp.controls['heightMob'].value,i,j) "
                                              [index]="i" [childeIndex]="j" [value]="skill.controls['img'].value">
                                            </calsoft-image>
                                          </ng-container>


                                          <ng-container
                                            *ngIf="skill.controls['type'].value==3 || skill.controls['type'].value==13">

                                            <calsoft-video fxFlex="50" (deleteResult)="update($event, j)"
                                              (fileUploadResult)="
                                          getResult($event, i, j)
                                        " [index]="i" [childeIndex]="j" [value]="skill.controls['img'].value">
                                            </calsoft-video>

                                          </ng-container>

                                          <div fxLayout="column" fxFlex="100">
                                            <div fxFlex="100" fxLayout.gt-md="row" fxLayout.lt-md="column"
                                              fxLayoutGap="10px"> <ng-container
                                                *ngIf="skill.controls['type'].value==2 && _form.value.conditions[i].images[0].type !==3 ">
                                                <mat-form-field fxFlex="50" appearance="outline">
                                                  <mat-label>Video Id</mat-label>
                                                  <input [attr.guide]="'template-inp-img' + '__' + sanitizedUrl"
                                                    (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                    trim="blur" matInput formControlName="img" required />
                                                  <mat-error *ngIf="
                                           skill.controls.img.errors?.required
                                         ">
                                                    Please fill out this field.
                                                  </mat-error>
                                                </mat-form-field>

                                                <mat-form-field fxFlex>
                                                  <mat-label>Auto Play</mat-label>
                                                  <mat-select formControlName="autoplay">
                                                    <mat-option *ngFor="let status of autoplay" [value]="status.value">
                                                      {{status.viewValue}}
                                                    </mat-option>
                                                  </mat-select>
                                                </mat-form-field>

                                              </ng-container>

                                              <ng-container *ngIf="skill.controls['type'].value==9">
                                                <mat-form-field fxFlex="50" appearance="outline">
                                                  <mat-label>Image Icon</mat-label>
                                                  <input [attr.guide]="'template-inp-img' + '__' + sanitizedUrl"
                                                    (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                    trim="blur" matInput formControlName="img" required />
                                                  <mat-error *ngIf="
                                           skill.controls.img.errors?.required
                                         ">
                                                    Please fill out this field.
                                                  </mat-error>
                                                </mat-form-field>
                                              </ng-container>

                                              <ng-container>
                                                <mat-form-field fxFlex *ngIf="(comp.controls['type'].value == 'image')|| 
                                              (comp.controls['type'].value != 'textWithImage')  ">
                                                  <mat-label>Types</mat-label>

                                                  <mat-select required formControlName="type" name="item">

                                                    <mat-option (onSelectionChange)="onChangeSubChild
                                                ($event,i,j)" *ngFor="
                                                  let item of dataType;
                                                  let i = index
                                                " [value]="item.value">
                                                      {{ item.viewValue }}
                                                    </mat-option>
                                                  </mat-select>
                                                </mat-form-field>

                                                <mat-form-field fxFlex
                                                  *ngIf="comp.controls['type'].value === 'textWithImage'">
                                                  <mat-label>Types</mat-label>

                                                  <mat-select required formControlName="type" name="item">

                                                    <mat-option (onSelectionChange)="onChangeSubChild
                                                ($event,i,j)" *ngFor="
                                                  let item of textWithImageType;
                                                  let i = index
                                                " [value]="item.value">
                                                      {{ item.viewValue }}
                                                    </mat-option>
                                                  </mat-select>
                                                </mat-form-field>

                                                <mat-form-field fxFlex
                                                  *ngIf="skill.controls['type'].value==6 && skill.controls['customField33'].value==1">
                                                  <mat-label>Sub Image content width</mat-label>
                                                  <input
                                                    [attr.guide]="'template-inp-customfield31' + '__' + sanitizedUrl"
                                                    (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                    trim="blur" formControlName="customField31" matInput />
                                                </mat-form-field>

                                              </ng-container>

                                              <ng-container>
                                                <mat-form-field fxFlex *ngIf="skill.controls['type'].value!=6">
                                                  <mat-label>Navigation</mat-label>
                                                  <mat-select required
                                                    (selectionChange)="doSomething1($event,i,j,'catId')"
                                                    formControlName="navigation" name="item">
                                                    <mat-option *ngFor="
                                                  let item of navigation;
                                                  let i = index
                                                " [value]="item.value">
                                                      {{ item.viewValue }}
                                                    </mat-option>
                                                  </mat-select>
                                                </mat-form-field>
                                              </ng-container>
                                              <span *ngIf="skill.controls['navigation'].value!=3">
                                                <mat-form-field fxFlex *ngIf="skill.controls['type'].value!=6">

                                                  <mat-label>
                                                    {{ skill.controls['navigation'].value === 0 ? 'Category' :
                                                    (skill.controls['navigation'].value === 1 ? 'Url' : 'Form') }}
                                                  </mat-label>


                                                  <mat-select *ngIf="skill.controls['navigation'].value==0" required
                                                    formControlName="catId" [disableOptionCentering]="true"
                                                    #singleSelect name="item">
                                                    <mat-option>
                                                      <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                        [formControl]="
                                                  categoryFilterControl
                                                " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                  true
                                                " noEntriesFoundLabel="No data found">
                                                      </ngx-mat-select-search>
                                                    </mat-option>
                                                    <mat-option *ngFor="
                                                let opt of filteredCategoryTypeList
                                              " [value]="opt.categoryId">
                                                      {{ opt.categoryName }}
                                                    </mat-option>
                                                  </mat-select>

                                                  <mat-select *ngIf="skill.controls['navigation'].value==2"
                                                    formControlName="catId" [disableOptionCentering]="true"
                                                    #singleSelect name="item">
                                                    <mat-option>
                                                      <ngx-mat-select-search name="Dynamic Form Search" ngDefaultControl
                                                        [formControl]="
                                            dynamicFormFilterControl
                                              " placeholderLabel="Dynamic Form Search" [preventHomeEndKeyPropagation]="
                                                true
                                              " noEntriesFoundLabel="No data found">
                                                      </ngx-mat-select-search>
                                                    </mat-option>
                                                    <mat-option *ngFor="let opt of filtereddynamicFormTypeList;"
                                                      [value]="opt.formGroupId">
                                                      {{ opt.name }}
                                                    </mat-option>
                                                  </mat-select>


                                                  <input
                                                    [attr.guide]="'template-inp-navigatedurl' + '__' + sanitizedUrl"
                                                    *ngIf="skill.controls['navigation'].value==1" trim="blur"
                                                    (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                    matInput formControlName="navigatedUrl" />


                                                </mat-form-field>
                                              </span>

                                            </div>
                                            <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                              *ngIf="comp.controls['type'].value === 'image'">

                                              <mat-form-field fxFlex
                                                *ngIf="skill.controls['type'].value==8 && (skill.controls['customField33'].value==14 || skill.controls['customField33'].value==15 )"
                                                fxFlex="30">
                                                <mat-label>Enable Background Image </mat-label>
                                                <mat-select formControlName="customField36">
                                                  <mat-option *ngFor="let status of Image_icon_type"
                                                    [value]="status.value">
                                                    {{status.viewValue}}
                                                  </mat-option>
                                                </mat-select>

                                              </mat-form-field>
                                              <div fxFlex="30"
                                                *ngIf="skill.controls['type'].value==8 && (skill.controls['customField33'].value==14 || skill.controls['customField33'].value==15 )">
                                                <calsoft-image fxFlex
                                                  (deleteResult)="updatesIMage($event, i,'customField35')"
                                                  (fileUploadResult)="
                                          getResultts($event, i,'customField37') " [index]="i"
                                                  [value]="comp.controls['customField37'].value">
                                                </calsoft-image>
                                              </div>
                                              <mat-form-field fxFlex="30"
                                                *ngIf="skill.controls['type'].value==8 && (skill.controls['customField33'].value==14 || skill.controls['customField33'].value==15 )">
                                                <mat-label>Backgroundcolor</mat-label>
                                                <input [attr.guide]="'template-inp-customfield35' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField35" />
                                              </mat-form-field>

                                            </div>
                                            <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                              *ngIf="comp.controls['type'].value === 'image'">

                                              <mat-form-field fxFlex="30"
                                                *ngIf="skill.controls['type'].value==8 && (skill.controls['customField33'].value==14 || skill.controls['customField33'].value==15 )">
                                                <mat-label>Secondary Text Web Font Size</mat-label>
                                                <input [attr.guide]="'template-inp-customfield38' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField38" />
                                              </mat-form-field>
                                              <mat-form-field fxFlex="30"
                                                *ngIf="skill.controls['type'].value==8 && (skill.controls['customField33'].value==14 || skill.controls['customField33'].value==15 )">
                                                <mat-label>Secondary Text Mobile Font Size</mat-label>
                                                <input [attr.guide]="'template-inp-customfield39' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField39" />
                                              </mat-form-field>
                                              <mat-form-field fxFlex="30"
                                                *ngIf="skill.controls['type'].value==8 && (skill.controls['customField33'].value==14 || skill.controls['customField33'].value==15 )">
                                                <mat-label>Padding Between The image And Type</mat-label>
                                                <input [attr.guide]="'template-inp-customfield40' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField40" />
                                              </mat-form-field>


                                            </div>
                                            <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                              *ngIf="comp.controls['type'].value === 'image'">

                                              <mat-form-field fxFlex="20"
                                                *ngIf="skill.controls['type'].value==8 && (skill.controls['customField33'].value==14 || skill.controls['customField33'].value==15 )">
                                                <mat-label>Border Radius</mat-label>
                                                <input [attr.guide]="'template-inp-customfield32' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField32" />
                                              </mat-form-field>
                                              <mat-form-field fxFlex="20"
                                                *ngIf="skill.controls['type'].value==8 && (skill.controls['customField33'].value==14 || skill.controls['customField33'].value==15 )">
                                                <mat-label>Box Width for Web </mat-label>
                                                <input [attr.guide]="'template-inp-customfield30' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField30" />
                                              </mat-form-field>
                                              <mat-form-field fxFlex="20"
                                                *ngIf="skill.controls['type'].value==8 && (skill.controls['customField33'].value==14 || skill.controls['customField33'].value==15 )">
                                                <mat-label>Box Width for Mobile </mat-label>
                                                <input [attr.guide]="'template-inp-customfield34' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField34" />
                                              </mat-form-field>





                                            </div>
                                            <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                              *ngIf="comp.controls['type'].value === 'image'">

                                              <mat-form-field fxFlex="20"
                                                *ngIf="skill.controls['type'].value==8 && skill.controls['customField33'].value==15 ">
                                                <mat-label>Outline Breadth</mat-label>
                                                <input [attr.guide]="'template-inp-customfield28' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField28" />
                                              </mat-form-field>
                                              <mat-form-field fxFlex="20"
                                                *ngIf="skill.controls['type'].value==8 &&  skill.controls['customField33'].value==15 ">
                                                <mat-label>Outline Color</mat-label>
                                                <input [attr.guide]="'template-inp-customfield29' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField29" />
                                              </mat-form-field>






                                            </div>
                                            <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                              *ngIf="comp.controls['type'].value === 'image'">

                                              <mat-form-field fxFlex="20"
                                                *ngIf="skill.controls['type'].value==8 && (skill.controls['customField33'].value==14 || skill.controls['customField33'].value==15 ) ">
                                                <mat-label>Container web Height</mat-label>
                                                <input [attr.guide]="'template-inp-customfield26' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField26" />
                                              </mat-form-field>
                                              <mat-form-field fxFlex="20"
                                                *ngIf="skill.controls['type'].value==8 && (skill.controls['customField33'].value==14 || skill.controls['customField33'].value==15 ) ">
                                                <mat-label>Container Mobile Height</mat-label>
                                                <input [attr.guide]="'template-inp-customfield27' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField27" />
                                              </mat-form-field>






                                            </div>




                                            <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                              *ngIf="comp.controls['type'].value === 'image'">
                                              <mat-form-field fxFlex
                                                *ngIf="skill.controls['type'].value!=6 && skill.controls['type'].value!=7 && skill.controls['type'].value!=8 && skill.controls['type'].value!=9  && skill.controls['type'].value!=10  && skill.controls['type'].value!=13 && layoutMainType !==4">
                                                <mat-label>Label</mat-label>
                                                <input [attr.guide]="'template-inp-customfield1' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField1" />

                                              </mat-form-field>

                                              <mat-form-field fxFlex="50" appearance="outline"
                                                *ngIf="skill.controls['type'].value==2">
                                                <mat-label>SubTitle</mat-label>
                                                <textarea
                                                  [attr.guide]="'template-sel-customfield21' + '__' + sanitizedUrl"
                                                  trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                  matAutosizeMaxRows=5 matInput
                                                  formControlName="customField21"></textarea>
                                                <mat-icon class="clickable"
                                                  (click)="openEditorTextForImageArray(skill.controls['customField21'].value,i,'customField21', j)"
                                                  matSuffix>
                                                  post_add
                                                </mat-icon>
                                                <mat-hint fxHide.lt-md>Click on the icon to open editor</mat-hint>
                                              </mat-form-field>


                                              <mat-form-field fxFlex.xs="100" fxFlex *ngIf="layoutMainType !==4">
                                                <mat-label>Show Animation </mat-label>
                                                <mat-select formControlName="customField36">
                                                  <mat-option *ngFor="let status of ShowAnimation"
                                                    [value]="status.value">
                                                    {{status.viewValue}}
                                                  </mat-option>
                                                </mat-select>
                                              </mat-form-field>


                                              <mat-form-field fxFlex
                                                *ngIf="skill.controls['type'].value==7 || skill.controls['type'].value==10 || skill.controls['type'].value==13">
                                                <mat-label>Title</mat-label>
                                                <input [attr.guide]="'template-inp-customfield1' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField1" />

                                              </mat-form-field>


                                              <mat-form-field fxFlex *ngIf="skill.controls['type'].value==8">
                                                <mat-label>Primary Text</mat-label>
                                                <input [attr.guide]="'template-inp-customfield1' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField1" />
                                                <mat-icon class="clickable"
                                                  (click)="openEditorTextForImageArray(skill.controls['customField1'].value,i,'customField1', j)"
                                                  matSuffix>
                                                  post_add
                                                </mat-icon>
                                              </mat-form-field>

                                              <mat-form-field fxFlex *ngIf="skill.controls['type'].value==9">
                                                <mat-label>Primary Text</mat-label>
                                                <input [attr.guide]="'template-inp-customfield1' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField1" />
                                              </mat-form-field>

                                              <mat-form-field fxFlex
                                                *ngIf="skill.controls['type'].value==8 || skill.controls['type'].value==9">
                                                <mat-label>Font Color</mat-label>
                                                <input [attr.guide]="'template-inp-customfield10' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField10" />
                                              </mat-form-field>

                                              <mat-form-field fxFlex *ngIf="skill.controls['type'].value==11">
                                                <mat-label>Title Color</mat-label>
                                                <input [attr.guide]="'template-inp-customfield10' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField10" />
                                              </mat-form-field>

                                              <mat-form-field fxFlex
                                                *ngIf="skill.controls['type'].value==8 || skill.controls['type'].value==9">
                                                <mat-label>Font Family</mat-label>
                                                <input [attr.guide]="'template-inp-customfield11' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField11" />
                                              </mat-form-field>

                                              <mat-form-field fxFlex
                                                *ngIf="skill.controls['type'].value!=9 && skill.controls['type'].value!=11 && layoutMainType !==4">
                                                <mat-label>Alt Tag</mat-label>
                                                <input [attr.guide]="'template-inp-altimage' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="altImage" />

                                              </mat-form-field>

                                              <mat-form-field fxFlex="50" appearance="outline"
                                                *ngIf="skill.controls['type'].value==4 || skill.controls['type'].value==5 || skill.controls['type'].value==7 || skill.controls['type'].value==10 || skill.controls['type'].value==11  && skill.controls['type'].value!=8">
                                                <mat-label>Description</mat-label>
                                                <textarea
                                                  [attr.guide]="'template-sel-customfield21' + '__' + sanitizedUrl"
                                                  trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                  matAutosizeMaxRows=5 matInput
                                                  formControlName="customField21"></textarea>
                                                <mat-icon class="clickable"
                                                  (click)="openEditorTextForImageArray(skill.controls['customField21'].value,i,'customField21', j)"
                                                  matSuffix>
                                                  post_add
                                                </mat-icon>
                                                <mat-hint fxHide.lt-md>Click on the icon to open editor</mat-hint>
                                              </mat-form-field>


                                              <mat-form-field fxFlex *ngIf="skill.controls['type'].value==11">
                                                <mat-label>Background Color</mat-label>
                                                <input [attr.guide]="'template-inp-customfield5' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField5" />

                                              </mat-form-field>

                                              <mat-form-field fxFlex *ngIf="skill.controls['type'].value==7">
                                                <mat-label>Description</mat-label>
                                                <input [attr.guide]="'template-inp-altimage' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="altImage" />

                                              </mat-form-field>

                                              <mat-form-field fxFlex *ngIf="skill.controls['type'].value==3">
                                                <mat-label>Video Type</mat-label>
                                                <mat-select formControlName="autoplay">
                                                  <mat-option *ngFor="let status of videotype" [value]="status.value">
                                                    {{status.viewValue}}
                                                  </mat-option>
                                                </mat-select>
                                              </mat-form-field>

                                              <mat-form-field fxFlex *ngIf="skill.controls['type'].value==6">
                                                <mat-label>Type</mat-label>
                                                <mat-select formControlName="customField33">
                                                  <mat-option *ngFor="let item of lookbacktype" [value]="item.id">
                                                    {{item.status}}
                                                  </mat-option>
                                                </mat-select>
                                              </mat-form-field>


                                              <mat-form-field fxFlex
                                                *ngIf="skill.controls['type'].value==6 && _form.value.conditions[i].customField10!=='Type 11' ">
                                                <mat-label>Display Description</mat-label>
                                                <mat-select formControlName="customField32">
                                                  <mat-option *ngFor="let status of booleanVariable1"
                                                    [value]="status.value">
                                                    {{status.viewValue}}
                                                  </mat-option>
                                                </mat-select>
                                              </mat-form-field>

                                              <!-- <mat-form-field fxFlex *ngIf="skill.controls['type'].value!=3 && skill.controls['type'].value!=4 && skill.controls['type'].value!=5 && 
                                              skill.controls['type'].value!=6 && skill.controls['type'].value!=8 && skill.controls['type'].value!=9 
                                              && skill.controls['type'].value!=10 && skill.controls['type'].value!=11">
                                              <mat-label>Show Animation </mat-label>
                                              <mat-select formControlName="customField7">
                                                <mat-option *ngFor="let status of ShowAnimation" [value]="status.value">
                                                  {{status.viewValue}}
                                                </mat-option>
                                              </mat-select>
                                            </mat-form-field> -->



                                              <!-- <mat-form-field fxFlex>
                                            <mat-label>Button Name</mat-label>
                                            <input [attr.guide]="'template-inp-customfield12' + '__' + sanitizedUrl" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                              matInput formControlName="customField12"/>
                                           
                                          </mat-form-field> -->

                                            </div>
                                            <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                              *ngIf="skill.controls['type'].value!=6 && skill.controls['type'].value!=7 && skill.controls['type'].value!=8  && skill.controls['type'].value!=9 && skill.controls['type'].value!=10">
                                              <mat-form-field fxFlex *ngIf="comp.controls['type'].value === 'image'">
                                                <mat-label>Radius</mat-label>
                                                <input [attr.guide]="'template-inp-customfield11' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField11" />

                                              </mat-form-field>


                                              <mat-form-field fxFlex
                                                *ngIf="comp.controls['type'].value === 'image' && skill.controls['type'].value!=11">
                                                <mat-label>Alignment</mat-label>
                                                <mat-select formControlName="customField13">
                                                  <mat-option *ngFor="let item of position" [value]="item.value">
                                                    {{item.viewValue}}
                                                  </mat-option>
                                                </mat-select>
                                              </mat-form-field>

                                              <mat-form-field fxFlex *ngIf="comp.controls['type'].value === 'image'">
                                                <mat-label>Button Name</mat-label>
                                                <input [attr.guide]="'template-inp-customfield12' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField12" />

                                              </mat-form-field>

                                            </div>
                                            <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                              *ngIf="skill.controls['type'].value==7">

                                              <mat-form-field fxFlex *ngIf="comp.controls['type'].value === 'image'">
                                                <mat-label>Button</mat-label>
                                                <input [attr.guide]="'template-inp-customfield12' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField12" />

                                              </mat-form-field>

                                              <mat-form-field fxFlex *ngIf="comp.controls['type'].value === 'image'">
                                                <mat-label>Alignment</mat-label>
                                                <mat-select formControlName="customField28">
                                                  <mat-option *ngFor="let item of position2" [value]="item.value">
                                                    {{item.viewValue}}
                                                  </mat-option>
                                                </mat-select>
                                              </mat-form-field>

                                              <mat-form-field fxFlex *ngIf="comp.controls['type'].value === 'image'">
                                                <mat-label>Button Type</mat-label>
                                                <mat-select formControlName="customField30">
                                                  <mat-option *ngFor="let item of buttonType" [value]="item.value">
                                                    {{item.viewValue}}
                                                  </mat-option>
                                                </mat-select>
                                              </mat-form-field>


                                            </div>

                                            <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                              *ngIf="skill.controls['type'].value==2">

                                              <mat-form-field fxFlex *ngIf="comp.controls['type'].value === 'image'">
                                                <mat-label>Web Width</mat-label>
                                                <input [attr.guide]="'template-inp-customfield22' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField22" />

                                              </mat-form-field>

                                              <mat-form-field fxFlex *ngIf="comp.controls['type'].value === 'image'">
                                                <mat-label>Mobile Width</mat-label>
                                                <input [attr.guide]="'template-inp-customfield24' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField24" />

                                              </mat-form-field>
                                            </div>

                                            <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                              *ngIf="skill.controls['type'].value==12">

                                              <mat-form-field fxFlex *ngIf="comp.controls['type'].value === 'image'">
                                                <mat-label>Table Header</mat-label>
                                                <input [attr.guide]="'template-inp-customfield22' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField22" />

                                              </mat-form-field>

                                              <mat-form-field fxFlex *ngIf="comp.controls['type'].value === 'image'">
                                                <mat-label>Table Column</mat-label>
                                                <input [attr.guide]="'template-inp-customfield24' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField24" />

                                              </mat-form-field>
                                            </div>

                                            <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                              *ngIf="comp.controls['type'].value === 'textWithImage'">

                                              <mat-form-field fxFlex>
                                                <mat-label>Table Header</mat-label>
                                                <input [attr.guide]="'template-inp-customfield22' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField22" />

                                              </mat-form-field>

                                              <mat-form-field fxFlex>
                                                <mat-label>Table Column</mat-label>
                                                <input [attr.guide]="'template-inp-customfield24' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField24" />

                                              </mat-form-field>
                                              <mat-form-field fxFlex
                                                *ngIf="comp.controls['type'].value === 'textWithImage' && _form.value.conditions[i].images[0].type ==3 ">
                                                <mat-label>Video Type</mat-label>
                                                <mat-select formControlName="autoplay">
                                                  <mat-option *ngFor="let status of videotype" [value]="status.value">
                                                    {{status.viewValue}}
                                                  </mat-option>
                                                </mat-select>
                                              </mat-form-field>

                                            </div>

                                            <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                              *ngIf="comp.controls['type'].value === 'textWithImage'">

                                              <mat-form-field fxFlex>
                                                <mat-label>Boxshadow Visible</mat-label>
                                                <mat-select formControlName="customField20" name="item">
                                                  <mat-option *ngFor="let item of boxshadow" [value]="item.value">
                                                    {{item.viewValue}}
                                                  </mat-option>
                                                </mat-select>
                                              </mat-form-field>

                                              <mat-form-field fxFlex>
                                                <mat-label>Padding</mat-label>
                                                <input [attr.guide]="'template-inp-customfield21' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField21" />

                                              </mat-form-field>


                                            </div>

                                            <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                                              <mat-form-field fxFlex appearance="outline"
                                                *ngIf="skill.controls['type'].value==8 || skill.controls['type'].value==9">
                                                <mat-label>Secondary text</mat-label>
                                                <textarea
                                                  [attr.guide]="'template-sel-customfield14' + '__' + sanitizedUrl"
                                                  trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                  matAutosizeMaxRows=5 matInput
                                                  formControlName="customField14"></textarea>
                                                <mat-icon class="clickable"
                                                  (click)="openEditorTextForImageArray(skill.controls['customField14'].value,i,'customField14', j)"
                                                  matSuffix>
                                                  post_add
                                                </mat-icon>
                                                <mat-hint fxHide.lt-md>Click on the icon to open editor</mat-hint>
                                              </mat-form-field>


                                              <mat-form-field fxFlex
                                                *ngIf="skill.controls['type'].value==8 || skill.controls['type'].value==9">
                                                <mat-label>Font Color</mat-label>
                                                <input [attr.guide]="'template-inp-customfield15' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField15" />
                                              </mat-form-field>

                                              <mat-form-field fxFlex
                                                *ngIf="skill.controls['type'].value==8 || skill.controls['type'].value==9">
                                                <mat-label>Card Background Color</mat-label>
                                                <input [attr.guide]="'template-inp-customfield16' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField16" />
                                              </mat-form-field>

                                            </div>

                                            <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px">


                                              <mat-form-field fxFlex
                                                *ngIf="skill.controls['type'].value==8 || skill.controls['type'].value==9">
                                                <mat-label>Font Family</mat-label>
                                                <input [attr.guide]="'template-inp-customfield16' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField16" />
                                              </mat-form-field>


                                              <mat-form-field fxFlex
                                                *ngIf="skill.controls['type'].value!=10 && _form.value.conditions[i].customField10 !== 'Type 11' && layoutMainType !==4">
                                                <mat-label>Display Read More</mat-label>
                                                <mat-select formControlName="customField34">
                                                  <mat-option *ngFor="let item of booleanFieldString1"
                                                    [value]="item.value">
                                                    {{item.viewValue}}
                                                  </mat-option>
                                                </mat-select>
                                              </mat-form-field>

                                              <!-- <mat-form-field fxFlex *ngIf="skill.controls['type'].value==13">
                                                <mat-label>Description</mat-label>
                                                <input [attr.guide]="'template-inp-customfield4' + '__' + sanitizedUrl" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField4"/>

                                              </mat-form-field> -->

                                              <mat-form-field fxFlex appearance="outline"
                                                *ngIf="skill.controls['type'].value==13">
                                                <mat-label>Description</mat-label>
                                                <textarea
                                                  [attr.guide]="'template-sel-customfield4' + '__' + sanitizedUrl"
                                                  trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                  matAutosizeMaxRows=5 matInput
                                                  formControlName="customField4"></textarea>
                                                <mat-icon class="clickable"
                                                  (click)="openEditorTextForImageArray(skill.controls['customField4'].value,i,'customField4', j)"
                                                  matSuffix>
                                                  post_add
                                                </mat-icon>
                                                <mat-hint fxHide.lt-md>Click on the icon to open editor</mat-hint>
                                              </mat-form-field>

                                              <mat-form-field fxFlex
                                                *ngIf="_form.value.conditions[i].customField10 == 'Type 11' ">
                                                <mat-label>Button 1 Link</mat-label>
                                                <input [attr.guide]="'template-inp-customfield4' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField4" />
                                              </mat-form-field>

                                              <mat-form-field fxFlex
                                                *ngIf="_form.value.conditions[i].customField10 == 'Type 11' ">
                                                <mat-label>Button 2 Link</mat-label>
                                                <input [attr.guide]="'template-inp-customfield5' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField5" />
                                              </mat-form-field>

                                              <mat-form-field fxFlex
                                                *ngIf="comp.controls['type'].value === 'textWithImage'">
                                                <mat-label>Enable Table</mat-label>
                                                <mat-select formControlName="customField26">
                                                  <mat-option *ngFor="let item of Enabletable" [value]="item.value">
                                                    {{item.viewValue}}
                                                  </mat-option>
                                                </mat-select>
                                              </mat-form-field>

                                            </div>

                                            <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                                              <mat-form-field fxFlex
                                                *ngIf="skill.controls.customField33.value == 17 || skill.controls.customField33.value == 18 || skill.controls.customField33.value == 20 || skill.controls.customField33.value == 21">
                                                <mat-label>Sub Text Web Font Size </mat-label>
                                                <input [attr.guide]="'template-inp-customfield20' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField20" />
                                              </mat-form-field>

                                              <mat-form-field fxFlex
                                                *ngIf="skill.controls.customField33.value == 17 || skill.controls.customField33.value == 18 || skill.controls.customField33.value == 20 || skill.controls.customField33.value == 21">
                                                <mat-label>Sub Text Mobile Font Size</mat-label>
                                                <input [attr.guide]="'template-inp-customfield21' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField21" />
                                              </mat-form-field>

                                              <mat-form-field fxFlex
                                                *ngIf="skill.controls.customField33.value == 17 || skill.controls.customField33.value == 18 || skill.controls.customField33.value == 20 || skill.controls.customField33.value == 21">
                                                <mat-label>Height Web</mat-label>
                                                <input [attr.guide]="'template-inp-customfield22' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField22" />
                                              </mat-form-field>

                                              <mat-form-field fxFlex
                                                *ngIf="skill.controls.customField33.value == 17 || skill.controls.customField33.value == 18 || skill.controls.customField33.value == 20 || skill.controls.customField33.value == 21">
                                                <mat-label>Height Mobile</mat-label>
                                                <input [attr.guide]="'template-inp-customfield23' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField23" />
                                              </mat-form-field>
                                            </div>

                                            <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                                              <mat-form-field fxFlex *ngIf="skill.controls['type'].value!=10 ">
                                                <mat-label>Type Display</mat-label>
                                                <mat-select formControlName="customField33">
                                                  <mat-option *ngFor="let item of imageType2" [value]="item.id">
                                                    {{item.status}}
                                                  </mat-option>
                                                </mat-select>
                                              </mat-form-field>

                                              <mat-form-field fxFlex
                                                *ngIf="_form.value.conditions[i].customField10 == 'Type 11' ">
                                                <mat-label>Button font size</mat-label>
                                                <input [attr.guide]="'template-inp-customfield7' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField7" />
                                              </mat-form-field>

                                              <mat-form-field fxFlex
                                                *ngIf="_form.value.conditions[i].customField10 == 'Type 11' ">
                                                <mat-label>Button Padding</mat-label>
                                                <input [attr.guide]="'template-inp-customfield8' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField8" />
                                              </mat-form-field>

                                              <mat-form-field fxFlex
                                                *ngIf="comp.controls['type'].value === 'textWithImage'">
                                                <mat-label>Image Zoom</mat-label>

                                                <mat-select formControlName="customField9" name="item">
                                                  <mat-option *ngFor="let item of boolean" [value]="item.value">
                                                    {{item.viewValue}}
                                                  </mat-option>

                                                </mat-select>

                                              </mat-form-field>

                                              <mat-form-field fxFlex
                                                *ngIf="comp.controls['type'].value === 'textWithImage'">
                                                <mat-label>Show Sub Content </mat-label>

                                                <mat-select formControlName="customField10" name="item">
                                                  <mat-option *ngFor="let item of subcontent" [value]="item.value">
                                                    {{item.viewValue}}
                                                  </mat-option>

                                                </mat-select>

                                              </mat-form-field>

                                              <mat-form-field fxFlex
                                                *ngIf="skill.controls.customField33.value == 3 || skill.controls.customField33.value == 1">
                                                <mat-label>Link</mat-label>
                                                <input [attr.guide]="'template-inp-customfield7' + '__' + sanitizedUrl"
                                                  [autocomplete]="'off'" trim="blur" formControlName="customField7"
                                                  matInput />
                                              </mat-form-field>

                                              <mat-form-field fxFlex
                                                *ngIf="comp.controls['type'].value === 'textWithImage' && skill.controls.customField33.value == 1 ">
                                                <mat-label>Button name2</mat-label>
                                                <input [attr.guide]="'template-inp-customfield16' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField16" />
                                              </mat-form-field>

                                              <mat-form-field fxFlex
                                                *ngIf="skill.controls.customField33.value == 12||skill.controls.customField33.value == 5 ||skill.controls.customField33.value == 16 ||skill.controls.customField33.value == 22 ">
                                                <mat-label>Button name2</mat-label>
                                                <input [attr.guide]="'template-inp-customfield25' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField25" />
                                              </mat-form-field>

                                              <!-- <mat-form-field fxFlex *ngIf="comp.controls['type'].value === 'textWithImage' && skill.controls.customField33.value == 1 ">
                                              <mat-label>Button height</mat-label>
                                              <input [attr.guide]="'template-inp-customfield17' + '__' + sanitizedUrl" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                trim="blur" matInput formControlName="customField17"/>
                                            </mat-form-field>    -->

                                            </div>

                                            <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                              *ngIf="comp.controls['type'].value === 'textWithImage'&& skill.controls.customField10.value == 1">

                                              <mat-form-field fxFlex appearance="outline">
                                                <mat-label>Sub Icon1</mat-label>
                                                <input [attr.guide]="'template-inp-customfield14' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField14" />

                                              </mat-form-field>

                                              <mat-form-field fxFlex appearance="outline">
                                                <mat-label>Sub Title1</mat-label>
                                                <input [attr.guide]="'template-inp-customfield15' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField15" />

                                              </mat-form-field>


                                              <mat-form-field fxFlex appearance="outline">
                                                <mat-label>Sub Description1</mat-label>
                                                <input [attr.guide]="'template-inp-customfield16' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField16" />

                                              </mat-form-field>



                                            </div>

                                            <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                              *ngIf="comp.controls['type'].value === 'textWithImage' && skill.controls.customField10.value == 1">

                                              <mat-form-field fxFlex appearance="outline">
                                                <mat-label>Sub Icon2</mat-label>
                                                <input [attr.guide]="'template-inp-customfield17' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField17" />

                                              </mat-form-field>

                                              <mat-form-field fxFlex appearance="outline">
                                                <mat-label>Sub Title2</mat-label>
                                                <input [attr.guide]="'template-inp-customfield18' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField18" />

                                              </mat-form-field>


                                              <mat-form-field fxFlex appearance="outline">
                                                <mat-label>Sub Description2</mat-label>
                                                <input [attr.guide]="'template-inp-customfield19' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField19" />

                                              </mat-form-field>



                                            </div>

                                            <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                              *ngIf="comp.controls['type'].value === 'textWithImage' && skill.controls.customField10.value == 1">

                                              <mat-form-field fxFlex appearance="outline">
                                                <mat-label>Sub Icon3</mat-label>
                                                <input [attr.guide]="'template-inp-customfield20' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField20" />

                                              </mat-form-field>

                                              <mat-form-field fxFlex appearance="outline">
                                                <mat-label>Sub Title3</mat-label>
                                                <input [attr.guide]="'template-inp-customfield21' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField21" />

                                              </mat-form-field>


                                              <mat-form-field fxFlex appearance="outline">
                                                <mat-label>Sub Description3</mat-label>
                                                <input [attr.guide]="'template-inp-customfield23' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField23" />

                                              </mat-form-field>



                                            </div>

                                            <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                              *ngIf="(comp.controls['type'].value === 'image' && (skill.controls.customField33.value == 16 || skill.controls.customField33.value == 19 ||skill.controls.customField33.value == 22))">

                                              <mat-form-field fxFlex>
                                                <mat-label>Image Height</mat-label>
                                                <input [attr.guide]="'template-inp-customfield26' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" formControlName="customField26" matInput />

                                              </mat-form-field>

                                              <mat-form-field fxFlex>
                                                <mat-label>Image Width</mat-label>
                                                <input [attr.guide]="'template-inp-customfield27' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" formControlName="customField27" matInput />

                                              </mat-form-field>
                                            </div>
                                            <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                              *ngIf="comp.controls['type'].value === 'textWithImage' && skill.controls.customField33.value == 1 ">
                                              <mat-form-field fxFlex>
                                                <mat-label>Button 1 color</mat-label>
                                                <input [attr.guide]="'template-inp-customfield18' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField18" />
                                              </mat-form-field>

                                              <mat-form-field fxFlex>
                                                <mat-label>Button 2 color</mat-label>
                                                <input [attr.guide]="'template-inp-customfield19' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField19" />
                                              </mat-form-field>

                                              <mat-form-field fxFlex>
                                                <mat-label>Buttons Width</mat-label>
                                                <input [attr.guide]="'template-inp-customfield20' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField20" />
                                              </mat-form-field>
                                            </div>

                                            <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                              *ngIf="comp.controls['type'].value === 'textWithImage' && skill.controls.customField33.value == 1 ">
                                              <!-- <mat-form-field fxFlex>
                                              <mat-label>Button 1 link</mat-label>
                                              <input [attr.guide]="'template-inp-customfield21' + '__' + sanitizedUrl" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                trim="blur" matInput formControlName="customField21"/>
                                            </mat-form-field> -->

                                              <mat-form-field fxFlex>
                                                <mat-label>Button 2 link</mat-label>
                                                <input [attr.guide]="'template-inp-customfield22' + '__' + sanitizedUrl"
                                                  (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                  trim="blur" matInput formControlName="customField22" />
                                              </mat-form-field>

                                            </div>

                                          </div>
                                        </div>

                                        <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                          *ngIf="comp.controls['type'].value === 'image'" style="overflow: scroll">
                                          <tr fxFlex="100" fxLayout="row">
                                            <td fxFlex="100" *ngIf="skill.controls['type'].value==6">
                                              <div fxFlex class="editSets">
                                                <div class="title-head3" color="primary">
                                                  <span>Image</span>
                                                </div>
                                                <div id="responsieTable" class="container">
                                                  <table class="rwd-table">
                                                    <tbody>
                                                      <tr>
                                                        <th>S.No</th>
                                                        <!-- <th>Position</th> -->
                                                        <th>Top</th>
                                                        <th>Left</th>
                                                        <th>Height</th>
                                                        <th>Mobile Height</th>
                                                        <th
                                                          *ngIf="_form.value.conditions[i].images[j].customField33==2">
                                                          Text Field</th>
                                                        <th
                                                          *ngIf="_form.value.conditions[i].images[j].customField33==2">
                                                          Icon Name</th>
                                                        <th
                                                          *ngIf="_form.value.conditions[i].images[j].customField33==2">
                                                          BackGround color </th>
                                                        <th
                                                          *ngIf="_form.value.conditions[i].images[j].customField33==2">
                                                          text color </th>
                                                        <th
                                                          *ngIf="_form.value.conditions[i].images[j].customField33==2">
                                                          Animation </th>

                                                        <th
                                                          *ngIf="_form.value.conditions[i].images[j].customField33!=2">
                                                          Product Name</th>
                                                        <th
                                                          *ngIf="_form.value.conditions[i].images[j].customField33==1">
                                                          View position</th>
                                                        <th>Action</th>
                                                      </tr>

                                                      <ng-container
                                                        *ngIf="_form.value.conditions[i].images[j].subChild.length>0">
                                                        <ng-container formArrayName="subChild">
                                                          <tr fxLayout.xs="column" *ngFor="let subChildImageInfo of skill.get('subChild')?.controls;
                                                       let k = index">
                                                            <ng-container [formGroupName]="k">
                                                              <td data-th="Image">
                                                                {{k+1}}
                                                              </td>
                                                              <!-- <td data-th="Position" style="width: 30%;">
                                                            <span class="wordBreak">
                                                              <mat-form-field fxFlex>
                                                                <mat-label>Position</mat-label>
                                                                <input [attr.guide]="'template-inp-customfield5' + '__' + sanitizedUrl" trim="blur" (keydown.enter)="$event.preventDefault()"
                                                                  [autocomplete]="'off'" required numbersOnly matInput
                                                                  formControlName="customField5" />                                                                
                                                              </mat-form-field>
                                                            </span>
                                                          </td> -->
                                                              <td data-th="Top" class="mobilewidth" style="width: 20%;">
                                                                <span class="wordBreak">
                                                                  <mat-form-field fxFlex>
                                                                    <mat-label>Top Percentage</mat-label>
                                                                    <input
                                                                      [attr.guide]="'template-inp-customfield3' + '__' + sanitizedUrl"
                                                                      trim="blur"
                                                                      (keydown.enter)="$event.preventDefault()"
                                                                      [autocomplete]="'off'" matInput
                                                                      formControlName="customField3" />
                                                                  </mat-form-field>
                                                                </span>
                                                              </td>

                                                              <td data-th="Left" class="mobilewidth"
                                                                style="width: 20%;">
                                                                <span class="wordBreak">
                                                                  <mat-form-field fxFlex>
                                                                    <mat-label>Left Percentage</mat-label>
                                                                    <input
                                                                      [attr.guide]="'template-inp-customfield4' + '__' + sanitizedUrl"
                                                                      trim="blur"
                                                                      (keydown.enter)="$event.preventDefault()"
                                                                      [autocomplete]="'off'" matInput
                                                                      formControlName="customField4" />
                                                                  </mat-form-field>
                                                                </span>
                                                              </td>

                                                              <td data-th="Height" class="mobilewidth"
                                                                style="width: 20%;">
                                                                <span class="wordBreak">
                                                                  <mat-form-field fxFlex>
                                                                    <mat-label>Height</mat-label>
                                                                    <input
                                                                      [attr.guide]="'template-inp-customfield25' + '__' + sanitizedUrl"
                                                                      trim="blur"
                                                                      (keydown.enter)="$event.preventDefault()"
                                                                      [autocomplete]="'off'" matInput
                                                                      formControlName="customField25" />
                                                                  </mat-form-field>
                                                                </span>
                                                              </td>

                                                              <td data-th="Mobile Height" class="mobilewidth"
                                                                style="width: 20%;">
                                                                <span class="wordBreak">
                                                                  <mat-form-field fxFlex>
                                                                    <mat-label>Mobile Height</mat-label>
                                                                    <input
                                                                      [attr.guide]="'template-inp-customfield26' + '__' + sanitizedUrl"
                                                                      trim="blur"
                                                                      (keydown.enter)="$event.preventDefault()"
                                                                      [autocomplete]="'off'" matInput
                                                                      formControlName="customField26" />
                                                                  </mat-form-field>
                                                                </span>
                                                              </td>

                                                              <td data-th="Left" class="mobilewidth" style="width: 20%;"
                                                                *ngIf="_form.value.conditions[i].images[j].customField33==2">
                                                                <span class="wordBreak">
                                                                  <mat-form-field fxFlex>
                                                                    <mat-label>Text field</mat-label>
                                                                    <input
                                                                      [attr.guide]="'template-inp-customfield11' + '__' + sanitizedUrl"
                                                                      trim="blur"
                                                                      (keydown.enter)="$event.preventDefault()"
                                                                      [autocomplete]="'off'" matInput
                                                                      formControlName="customField11" />
                                                                  </mat-form-field>
                                                                </span>
                                                              </td>

                                                              <td data-th="Left" class="mobilewidth" style="width: 20%;"
                                                                *ngIf="_form.value.conditions[i].images[j].customField33==2">
                                                                <span class="wordBreak">
                                                                  <mat-form-field fxFlex>
                                                                    <mat-label>Icon Name</mat-label>
                                                                    <input
                                                                      [attr.guide]="'template-inp-customfield12' + '__' + sanitizedUrl"
                                                                      trim="blur"
                                                                      (keydown.enter)="$event.preventDefault()"
                                                                      [autocomplete]="'off'" matInput
                                                                      formControlName="customField12" />
                                                                  </mat-form-field>
                                                                </span>
                                                              </td>
                                                              <td data-th="Left" class="mobilewidth" style="width: 20%;"
                                                                *ngIf="_form.value.conditions[i].images[j].customField33==2">
                                                                <span class="wordBreak">
                                                                  <mat-form-field fxFlex>
                                                                    <mat-label>Background Color</mat-label>
                                                                    <input
                                                                      [attr.guide]="'template-inp-customfield13' + '__' + sanitizedUrl"
                                                                      trim="blur"
                                                                      (keydown.enter)="$event.preventDefault()"
                                                                      [autocomplete]="'off'" matInput
                                                                      formControlName="customField13" />
                                                                  </mat-form-field>
                                                                </span>
                                                              </td>

                                                              <td data-th="Left" class="mobilewidth" style="width: 20%;"
                                                                *ngIf="_form.value.conditions[i].images[j].customField33==2">
                                                                <span class="wordBreak">
                                                                  <mat-form-field fxFlex>
                                                                    <mat-label>Text color</mat-label>
                                                                    <input
                                                                      [attr.guide]="'template-inp-customfield14' + '__' + sanitizedUrl"
                                                                      trim="blur"
                                                                      (keydown.enter)="$event.preventDefault()"
                                                                      [autocomplete]="'off'" matInput
                                                                      formControlName="customField14" />
                                                                  </mat-form-field>
                                                                </span>
                                                              </td>

                                                              <td fxLayout.xs="column" data-th="Left"
                                                                class="mobilewidth" style="width: 20%;"
                                                                *ngIf="_form.value.conditions[i].images[j].customField33==2">
                                                                <span class="wordBreak">
                                                                  <mat-form-field fxFlex>
                                                                    <mat-label>Animation</mat-label>
                                                                    <mat-select formControlName="customField16">
                                                                      <mat-option *ngFor="let status of ShowAnimation"
                                                                        [value]="status.value">
                                                                        {{status.viewValue}}
                                                                      </mat-option>
                                                                    </mat-select>
                                                                  </mat-form-field>
                                                                </span>
                                                              </td>

                                                              <td data-th="Left" class="mobilewidth" style="width: 40%;"
                                                                *ngIf="_form.value.conditions[i].images[j].customField33!=2">
                                                                <mat-form-field>
                                                                  <input
                                                                    [attr.guide]="'template-inp-customfield14' + '__' + sanitizedUrl"
                                                                    matAutocompletePosition="below"
                                                                    [autocomplete]="'off'" #input1 calsoftBarCodePut
                                                                    matInput type="search" spellcheck="false"
                                                                    class="search-input text-muted" [debounce]="600"
                                                                    (onDetected)="onDetected($event)"
                                                                    formControlName="customField14"
                                                                    (keydown.enter)="$event.preventDefault()"
                                                                    (focus)="openDropdown()" placeholder="Search..."
                                                                    #inputElem [matAutocomplete]="auto" />

                                                                  <button
                                                                    [attr.guide]="'template-btn-clear' + '__' + sanitizedUrl"
                                                                    mat-button matSuffix mat-icon-button
                                                                    aria-label="Clear" (click)="clearInput(i,j,k)">
                                                                    <mat-icon>clear</mat-icon>
                                                                  </button>
                                                                  <mat-autocomplete class="mat-elevation-z2 autocmp"
                                                                    #auto="matAutocomplete">
                                                                    <mat-option *ngFor="let filter of filteredOptions"
                                                                      (click)="getProducts(filter,i,j,k)"
                                                                      [value]="filter.name">
                                                                      <mat-icon>search</mat-icon>
                                                                      <span>{{ filter.name }}</span>
                                                                    </mat-option>
                                                                  </mat-autocomplete>
                                                                </mat-form-field>
                                                              </td>

                                                              <td fxLayout.xs="column" style="width: 100%;"
                                                                data-th="Position"
                                                                *ngIf="_form.value.conditions[i].images[j].customField33==1">
                                                                <mat-form-field fxFlex>
                                                                  <mat-label>View Position</mat-label>
                                                                  <mat-select formControlName="customField29"
                                                                    name="item">
                                                                    <mat-option *ngFor="
                                                                  let item of viewposition;
                                                                  let i = index
                                                                " [value]="item.value">
                                                                      {{ item.viewValue }}
                                                                    </mat-option>
                                                                  </mat-select>
                                                                </mat-form-field>
                                                              </td>


                                                              <td data-th="Action">
                                                                <button
                                                                  [attr.guide]="'template-btn-27' + '__' + sanitizedUrl"
                                                                  color="warn" mat-icon-button type="button"
                                                                  (click)="removeArray(i,j,k)">
                                                                  <mat-icon>remove_circle_outline
                                                                  </mat-icon>
                                                                </button>
                                                              </td>
                                                            </ng-container>
                                                          </tr>
                                                        </ng-container>
                                                      </ng-container>
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </div>

                                            </td>
                                          </tr>
                                        </div>

                                      </div>
                                    </div>

                                  </div>


                                  <!-- bannertextWithImage -->

                                  <div *ngIf="(comp.controls['type'].value == 'bannertextWithImage')">

                                    <div class="editSets">
                                      <div class="title-head3" fxLayoutAlign="space-between center" color="primary">
                                        <span>Scrollable Text</span>

                                        <button [attr.guide]="'template-btn-28' + '__' + sanitizedUrl" class="create"
                                          (click)=" addImages(i)" type="button" mat-mini-fab color="primary">
                                          <mat-icon>add</mat-icon>
                                        </button>
                                      </div>
                                      <div id="responsieTable" class="container">
                                        <table fxFlex="100" class="rwd-table">
                                          <tbody fxFlex="100">
                                            <tr>
                                              <th fxFlex="15">Image Title</th>
                                              <th fxFlex="15">Image Title1</th>
                                              <th fxFlex="20">Image Content</th>
                                              <th fxFlex="20">Image Content1</th>
                                              <th fxFlex="20">Image Content 2</th>
                                              <th>Action</th>
                                            </tr>
                                            <ng-container formArrayName="images">
                                              <tr fxLayout.xs="column"
                                                *ngFor="let ImageInfo of comp.get('images')?.controls;; let y = index">
                                                <ng-container [formGroupName]="y">

                                                  <td fxFlex="15" fxFlex.xs="100" data-th="Filename">
                                                    <span class="wordBreak">

                                                      <mat-form-field fxFlex="100">
                                                        <mat-label>Image Title</mat-label>
                                                        <input
                                                          [attr.guide]="'template-inp-customfield11' + '__' + sanitizedUrl"
                                                          trim="blur" (keydown.enter)="$event.preventDefault()"
                                                          [autocomplete]="'off'" matInput
                                                          formControlName="customField11" />

                                                      </mat-form-field>

                                                    </span>
                                                  </td>
                                                  <td fxFlex="15" fxFlex.xs="100" data-th="Filename">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="100">
                                                        <mat-label>Image Title1</mat-label>
                                                        <input
                                                          [attr.guide]="'template-inp-customfield12' + '__' + sanitizedUrl"
                                                          trim="blur" (keydown.enter)="$event.preventDefault()"
                                                          [autocomplete]="'off'" matInput
                                                          formControlName="customField12" />

                                                      </mat-form-field>
                                                    </span>
                                                  </td>
                                                  <td fxFlex="20" fxFlex.xs="100" data-th="Filename">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="100" appearance="outline">
                                                        <mat-label>Image Content</mat-label>
                                                        <textarea
                                                          [attr.guide]="'template-sel-customfield15' + '__' + sanitizedUrl"
                                                          trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                          matAutosizeMaxRows=5 matInput
                                                          formControlName="customField15"></textarea>
                                                        <mat-icon class="clickable"
                                                          (click)="openEditorTextForImageArray(ImageInfo.controls['customField15'].value,i,'customField15',y)"
                                                          matSuffix>
                                                          post_add
                                                        </mat-icon>
                                                        <!-- <mat-hint fxHide.lt-md>Click on the icon to open editor</mat-hint> -->
                                                      </mat-form-field>

                                                    </span>
                                                  </td>
                                                  <!-- <td data-th="Navigation" style="width: 90%;">
                                                
    
                                              </td> -->
                                                  <td fxFlex="20" fxFlex.xs="100" data-th="Filename">
                                                    <span class="wordBreak">

                                                      <mat-form-field fxFlex="100" appearance="outline">
                                                        <mat-label>Image Content1</mat-label>
                                                        <textarea
                                                          [attr.guide]="'template-sel-customfield16' + '__' + sanitizedUrl"
                                                          trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                          matAutosizeMaxRows=5 matInput
                                                          formControlName="customField16"></textarea>
                                                        <mat-icon class="clickable"
                                                          (click)="openEditorTextForImageArray(ImageInfo.controls['customField16'].value,i,'customField16',y)"
                                                          matSuffix>
                                                          post_add
                                                        </mat-icon>
                                                        <!-- <mat-hint fxHide.lt-md>Click on the icon to open editor</mat-hint> -->
                                                      </mat-form-field>

                                                    </span>
                                                  </td>

                                                  <td fxFlex="20" fxFlex.xs="100" data-th="Filename">
                                                    <span class="wordBreak">

                                                      <mat-form-field fxFlex="100" appearance="outline">
                                                        <mat-label>Image Content2</mat-label>
                                                        <textarea
                                                          [attr.guide]="'template-sel-customfield17' + '__' + sanitizedUrl"
                                                          trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                          matAutosizeMaxRows=5 matInput
                                                          formControlName="customField17"></textarea>
                                                        <mat-icon class="clickable"
                                                          (click)="openEditorTextForImageArray(ImageInfo.controls['customField17'].value,i,'customField17',y)"
                                                          matSuffix>
                                                          post_add
                                                        </mat-icon>
                                                        <!-- <mat-hint fxHide.lt-md>Click on the icon to open editor</mat-hint> -->
                                                      </mat-form-field>

                                                    </span>
                                                  </td>
                                                  <td data-th="Action">
                                                    <span class="wordBreak">
                                                      <button [attr.guide]="'template-btn-29' + '__' + sanitizedUrl"
                                                        color="warn" mat-icon-button type="button"
                                                        (click)="deleteText(i,y)">
                                                        <mat-icon>remove_circle_outline
                                                        </mat-icon>
                                                      </button>
                                                    </span>
                                                  </td>
                                                </ng-container>
                                              </tr>
                                            </ng-container>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>

                                  <div
                                    *ngIf="(comp.controls['type'].value == 'serviceLayout') && comp.controls.customField7.value != '6'">

                                    <div class="editSets">
                                      <div class="title-head3" fxLayoutAlign="space-between center" color="primary">
                                        <span>Service Layout</span>

                                        <button [attr.guide]="'template-btn-30' + '__' + sanitizedUrl" class="create"
                                          (click)="addImages(i)" type="button" mat-mini-fab color="primary">
                                          <mat-icon>add</mat-icon>
                                        </button>
                                      </div>
                                      <div id="responsieTable" class="container" style="overflow-x:auto;">
                                        <table fxFlex="100">
                                          <tbody fxFlex="100">
                                            <ng-container formArrayName="images">
                                              <tr fxLayout.xs="column"
                                                *ngFor="let ImageInfo of comp.get('images')?.controls; let y = index">
                                                <ng-container [formGroupName]="y" fxLayoutAlign="space-between center">
                                                  <td fxFlex data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <div style="display: flex; gap: 20px;">
                                                        <mat-form-field fxFlex="100" appearance="outline">
                                                          <mat-label>Title</mat-label>
                                                          <input
                                                            [attr.guide]="'template-inp-customfield4' + '__' + sanitizedUrl"
                                                            [autocomplete]="'off'" trim="blur"
                                                            formControlName="customField4" matInput />
                                                        </mat-form-field>
                                                      </div>
                                                    </span>
                                                  </td>

                                                  <td fxFlex="100" data-th="Filename" fxLayoutGap="10px">
                                                    <span style="width: 100%;" class="wordBreak">
                                                      <div fxFlex="100" style="display: flex; gap: 20px;">
                                                        <calsoft-image style="padding-bottom: 10px;"
                                                          (deleteResult)="updatesImageArray($event, i,'customField6',y)"
                                                          (fileUploadResult)="
                                                  getResultArray($event, i,'customField6',y) " [index]="y"
                                                          [value]="ImageInfo.controls['customField6'].value">
                                                        </calsoft-image>
                                                      </div>
                                                    </span>
                                                  </td>

                                                  <td fxFlex data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <div style="display: flex; gap: 20px;">
                                                        <mat-form-field fxFlex="100" appearance="outline">
                                                          <mat-label>subTitle</mat-label>
                                                          <textarea
                                                            [attr.guide]="'template-sel-customfield17' + '__' + sanitizedUrl"
                                                            trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                            matAutosizeMaxRows=5 matInput
                                                            formControlName="customField17"></textarea>
                                                          <mat-icon class="clickable"
                                                            (click)="openEditorTextForImageArray(ImageInfo.controls['customField16'].value,i,'customField16',y)"
                                                            matSuffix>
                                                            post_add
                                                          </mat-icon>
                                                        </mat-form-field>
                                                      </div>
                                                    </span>
                                                  </td>

                                                  <td fxFlex data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <div style="display: flex; gap: 20px;">
                                                        <mat-form-field fxFlex="100" appearance="outline">
                                                          <mat-label>Description</mat-label>
                                                          <textarea
                                                            [attr.guide]="'template-sel-customfield16' + '__' + sanitizedUrl"
                                                            trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                            matAutosizeMaxRows=5 matInput
                                                            formControlName="customField16"></textarea>
                                                          <mat-icon class="clickable"
                                                            (click)="openEditorTextForImageArray(ImageInfo.controls['customField16'].value,i,'customField16',y)"
                                                            matSuffix>
                                                            post_add
                                                          </mat-icon>
                                                        </mat-form-field>
                                                      </div>
                                                    </span>
                                                  </td>

                                                  <td fxFlex data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <div style="display: flex; gap: 20px;">
                                                        <mat-form-field fxFlex="100" appearance="outline">
                                                          <mat-label>Alt tag</mat-label>
                                                          <input
                                                            [attr.guide]="'template-inp-altimage' + '__' + sanitizedUrl"
                                                            [autocomplete]="'off'" trim="blur"
                                                            formControlName="altImage" matInput />
                                                        </mat-form-field>
                                                      </div>
                                                    </span>
                                                  </td>

                                                  <td fxFlex data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <div style="display: flex; gap: 20px;">
                                                        <mat-form-field fxFlex="100" appearance="outline">
                                                          <mat-label>Button</mat-label>
                                                          <input
                                                            [attr.guide]="'template-inp-customfield5' + '__' + sanitizedUrl"
                                                            [autocomplete]="'off'" trim="blur"
                                                            formControlName="customField5" matInput />
                                                        </mat-form-field>
                                                      </div>
                                                    </span>
                                                  </td>

                                                  <td fxFlex data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <div style="display: flex; gap: 20px;">
                                                        <mat-form-field fxFlex="100" appearance="outline">
                                                          <mat-label>Link</mat-label>
                                                          <input
                                                            [attr.guide]="'template-inp-customfield7' + '__' + sanitizedUrl"
                                                            [autocomplete]="'off'" trim="blur"
                                                            formControlName="customField7" matInput />
                                                        </mat-form-field>
                                                      </div>
                                                    </span>
                                                  </td>

                                                  <td fxFlex data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <div style="display: flex; gap: 20px;">
                                                        <mat-form-field fxFlex="100" appearance="outline">
                                                          <mat-label>Height box</mat-label>
                                                          <input
                                                            [attr.guide]="'template-inp-customfield10' + '__' + sanitizedUrl"
                                                            [autocomplete]="'off'" trim="blur"
                                                            formControlName="customField10" matInput />
                                                        </mat-form-field>
                                                      </div>
                                                    </span>
                                                  </td>

                                                  <td fxFlex data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <div style="display: flex; gap: 20px;">
                                                        <mat-form-field fxFlex="100" appearance="outline">
                                                          <mat-label>Background color</mat-label>
                                                          <input
                                                            [attr.guide]="'template-inp-customfield8' + '__' + sanitizedUrl"
                                                            [autocomplete]="'off'" trim="blur"
                                                            formControlName="customField8" matInput />
                                                        </mat-form-field>
                                                      </div>
                                                    </span>
                                                  </td>

                                                  <td fxFlex data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <div style="display: flex; gap: 20px;">
                                                        <mat-form-field fxFlex="100" appearance="outline">
                                                          <mat-label>Button Background color</mat-label>
                                                          <input
                                                            [attr.guide]="'template-inp-customfield9' + '__' + sanitizedUrl"
                                                            [autocomplete]="'off'" trim="blur"
                                                            formControlName="customField9" matInput />
                                                        </mat-form-field>
                                                      </div>
                                                    </span>
                                                  </td>

                                                  <td data-th="Action">
                                                    <span class="wordBreak">
                                                      <button [attr.guide]="'template-btn-31' + '__' + sanitizedUrl"
                                                        color="warn" mat-icon-button type="button"
                                                        (click)="deleteText(i,y)">
                                                        <mat-icon>remove_circle_outline
                                                        </mat-icon>
                                                      </button>
                                                    </span>
                                                  </td>
                                                </ng-container>
                                              </tr>
                                            </ng-container>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>


                                  <div
                                    *ngIf="(comp.controls['type'].value == 'serviceLayout') && comp.controls.customField7.value == '6'">

                                    <div class="editSets">
                                      <div class="title-head3" fxLayoutAlign="space-between center" color="primary">
                                        <span>Service Layout</span>

                                        <button [attr.guide]="'template-btn-32' + '__' + sanitizedUrl" class="create"
                                          (click)="addImages(i)" type="button" mat-mini-fab color="primary">
                                          <mat-icon>add</mat-icon>
                                        </button>
                                      </div>
                                      <div id="responsieTable" class="container" style="overflow-x:auto;">
                                        <table fxFlex="100">
                                          <tbody fxFlex="100">
                                            <ng-container formArrayName="images">
                                              <tr fxLayout.xs="column"
                                                *ngFor="let ImageInfo of comp.get('images')?.controls; let y = index">
                                                <ng-container [formGroupName]="y" fxLayoutAlign="space-between center">
                                                  <td fxFlex data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <div style="display: flex; gap: 20px;">
                                                        <mat-form-field fxFlex="100" appearance="outline">
                                                          <mat-label>Title</mat-label>
                                                          <input
                                                            [attr.guide]="'template-inp-customfield4' + '__' + sanitizedUrl"
                                                            [autocomplete]="'off'" trim="blur"
                                                            formControlName="customField4" matInput />
                                                        </mat-form-field>
                                                      </div>
                                                    </span>
                                                  </td>

                                                  <td fxFlex data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <div fxFlex="100" style="display: flex; gap: 20px;">
                                                        <calsoft-image style="padding-bottom: 10px;"
                                                          (deleteResult)="updatesImageArray($event, i,'customField6',y)"
                                                          (fileUploadResult)="
                                                  getResultArray($event, i,'customField6',y) " [index]="y"
                                                          [value]="ImageInfo.controls['customField6'].value">
                                                        </calsoft-image>
                                                      </div>
                                                    </span>
                                                  </td>

                                                  <td fxFlex data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <div style="display: flex; gap: 20px;">
                                                        <mat-form-field fxFlex="100" appearance="outline">
                                                          <mat-label>subTitle</mat-label>
                                                          <textarea
                                                            [attr.guide]="'template-sel-customfield17' + '__' + sanitizedUrl"
                                                            trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                            matAutosizeMaxRows=5 matInput
                                                            formControlName="customField17"></textarea>
                                                          <mat-icon class="clickable"
                                                            (click)="openEditorTextForImageArray(ImageInfo.controls['customField16'].value,i,'customField16',y)"
                                                            matSuffix>
                                                            post_add
                                                          </mat-icon>
                                                        </mat-form-field>
                                                      </div>
                                                    </span>
                                                  </td>

                                                  <td fxFlex data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <div style="display: flex; gap: 20px;">
                                                        <mat-form-field fxFlex="100" appearance="outline">
                                                          <mat-label>Description</mat-label>
                                                          <textarea
                                                            [attr.guide]="'template-sel-customfield16' + '__' + sanitizedUrl"
                                                            trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                            matAutosizeMaxRows=5 matInput
                                                            formControlName="customField16"></textarea>
                                                          <mat-icon class="clickable"
                                                            (click)="openEditorTextForImageArray(ImageInfo.controls['customField16'].value,i,'customField16',y)"
                                                            matSuffix>
                                                            post_add
                                                          </mat-icon>
                                                        </mat-form-field>
                                                      </div>
                                                    </span>
                                                  </td>

                                                  <td fxFlex data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <div style="display: flex; gap: 20px;">
                                                        <mat-form-field fxFlex="100" appearance="outline">
                                                          <mat-label>Alt tag</mat-label>
                                                          <input
                                                            [attr.guide]="'template-inp-altimage' + '__' + sanitizedUrl"
                                                            [autocomplete]="'off'" trim="blur"
                                                            formControlName="altImage" matInput />
                                                        </mat-form-field>
                                                      </div>
                                                    </span>
                                                  </td>

                                                  <td fxFlex data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <div style="display: flex; gap: 20px;">
                                                        <mat-form-field fxFlex="100" appearance="outline">
                                                          <mat-label>Email</mat-label>
                                                          <input
                                                            [attr.guide]="'template-inp-customfield5' + '__' + sanitizedUrl"
                                                            [autocomplete]="'off'" trim="blur"
                                                            formControlName="customField5" matInput />
                                                        </mat-form-field>
                                                      </div>
                                                    </span>
                                                  </td>

                                                  <td fxFlex data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <div style="display: flex; gap: 20px;">
                                                        <mat-form-field fxFlex="100" appearance="outline">
                                                          <mat-label>LinkedIn</mat-label>
                                                          <input
                                                            [attr.guide]="'template-inp-customfield7' + '__' + sanitizedUrl"
                                                            [autocomplete]="'off'" trim="blur"
                                                            formControlName="customField7" matInput />
                                                        </mat-form-field>
                                                      </div>
                                                    </span>
                                                  </td>

                                                  <td fxFlex data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <div style="display: flex; gap: 20px;">
                                                        <mat-form-field fxFlex="100" appearance="outline">
                                                          <mat-label>Booking Url</mat-label>
                                                          <input
                                                            [attr.guide]="'template-inp-customfield10' + '__' + sanitizedUrl"
                                                            [autocomplete]="'off'" trim="blur"
                                                            formControlName="customField10" matInput />
                                                        </mat-form-field>
                                                      </div>
                                                    </span>
                                                  </td>

                                                  <td fxFlex data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">

                                                      <mat-form-field fxFlex="100" fxFlex.xs="100" appearance="outline">
                                                        <mat-label>Show Animation </mat-label>
                                                        <mat-select formControlName="customField36">
                                                          <mat-option *ngFor="let status of ShowAnimation"
                                                            [value]="status.value">
                                                            {{status.viewValue}}
                                                          </mat-option>
                                                        </mat-select>
                                                      </mat-form-field>

                                                    </span>
                                                  </td>

                                                  <td data-th="Action">
                                                    <span class="wordBreak">
                                                      <button [attr.guide]="'template-btn-33' + '__' + sanitizedUrl"
                                                        color="warn" mat-icon-button type="button"
                                                        (click)="deleteText(i,y)">
                                                        <mat-icon>remove_circle_outline
                                                        </mat-icon>
                                                      </button>
                                                    </span>
                                                  </td>
                                                </ng-container>
                                              </tr>
                                            </ng-container>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>

                                  <div *ngIf="(comp.controls['type'].value == 'stepFlowLayout')">

                                    <div class="editSets">
                                      <div class="title-head3" fxLayoutAlign="space-between center" color="primary">
                                        <span>Step Flow Layout</span>

                                        <button [attr.guide]="'template-btn-34' + '__' + sanitizedUrl" class="create"
                                          (click)="addImages(i)" type="button" mat-mini-fab color="primary">
                                          <mat-icon>add</mat-icon>
                                        </button>
                                      </div>
                                      <div id="responsieTable" class="container" style="overflow-x:auto;">
                                        <table fxFlex="100">
                                          <tbody fxFlex="100">
                                            <ng-container formArrayName="images">
                                              <tr fxLayout.xs="column"
                                                *ngFor="let ImageInfo of comp.get('images')?.controls;; let y = index">
                                                <ng-container [formGroupName]="y" fxLayoutAlign="space-between center">
                                                  <td fxFlex data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="100" appearance="outline">
                                                        <mat-label>Title</mat-label>
                                                        <input
                                                          [attr.guide]="'template-inp-customfield4' + '__' + sanitizedUrl"
                                                          [autocomplete]="'off'" trim="blur"
                                                          formControlName="customField4" matInput />
                                                      </mat-form-field>
                                                    </span>
                                                  </td>

                                                  <td fxFlex="100" data-th="Filename" fxLayoutGap="10px">
                                                    <span class="">
                                                      <calsoft-image fxFlex style="padding-bottom: 10px;"
                                                        (deleteResult)="updatesImageArray($event, i,'customField10',y)"
                                                        (fileUploadResult)="
                                                  getResultArray($event, i,'customField10',y) " [index]="y"
                                                        [value]="ImageInfo.controls['customField10'].value">
                                                      </calsoft-image>
                                                    </span>
                                                  </td>

                                                  <td fxFlex data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="100" appearance="outline">
                                                        <mat-label>Description</mat-label>
                                                        <textarea
                                                          [attr.guide]="'template-sel-customfield16' + '__' + sanitizedUrl"
                                                          trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                          matAutosizeMaxRows=5 matInput
                                                          formControlName="customField16"></textarea>
                                                        <mat-icon class="clickable"
                                                          (click)="openEditorTextForImageArray(ImageInfo.controls['customField16'].value,i,'customField16',y)"
                                                          matSuffix>
                                                          post_add
                                                        </mat-icon>
                                                      </mat-form-field>
                                                    </span>
                                                  </td>

                                                  <td fxFlex data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="100" appearance="outline">
                                                        <mat-label>Alt tag</mat-label>
                                                        <input
                                                          [attr.guide]="'template-inp-altimage' + '__' + sanitizedUrl"
                                                          [autocomplete]="'off'" trim="blur" formControlName="altImage"
                                                          matInput />
                                                      </mat-form-field>
                                                    </span>
                                                  </td>

                                                  <td fxFlex data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="100" appearance="outline">
                                                        <mat-label>Backgroundcolor</mat-label>
                                                        <input
                                                          [attr.guide]="'template-inp-customfield5' + '__' + sanitizedUrl"
                                                          [autocomplete]="'off'" trim="blur"
                                                          formControlName="customField5" matInput />
                                                      </mat-form-field>
                                                    </span>
                                                  </td>

                                                  <td fxFlex data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="100" appearance="outline">
                                                        <mat-label>Text color</mat-label>
                                                        <input
                                                          [attr.guide]="'template-inp-customfield7' + '__' + sanitizedUrl"
                                                          [autocomplete]="'off'" trim="blur"
                                                          formControlName="customField7" matInput />
                                                      </mat-form-field>
                                                    </span>
                                                  </td>

                                                  <td fxFlex data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">

                                                      <mat-form-field fxFlex="100" appearance="outline">
                                                        <mat-label>Types</mat-label>
                                                        <mat-select formControlName="customField11">
                                                          <mat-option *ngFor="let item of Stepalignment"
                                                            [value]="item.value">
                                                            {{item.viewValue}}
                                                          </mat-option>
                                                        </mat-select>

                                                      </mat-form-field>
                                                    </span>
                                                  </td>

                                                  <td fxFlex data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">

                                                      <mat-form-field fxFlex="100" fxFlex.xs="100" appearance="outline">
                                                        <mat-label>Show Animation </mat-label>
                                                        <mat-select formControlName="customField36">
                                                          <mat-option *ngFor="let status of ShowAnimation"
                                                            [value]="status.value">
                                                            {{status.viewValue}}
                                                          </mat-option>
                                                        </mat-select>
                                                      </mat-form-field>

                                                    </span>
                                                  </td>



                                                  <td data-th="Action">
                                                    <span class="wordBreak">
                                                      <button [attr.guide]="'template-btn-35' + '__' + sanitizedUrl"
                                                        color="warn" mat-icon-button type="button"
                                                        (click)="deleteText(i,y)">
                                                        <mat-icon>remove_circle_outline
                                                        </mat-icon>
                                                      </button>
                                                    </span>
                                                  </td>
                                                </ng-container>
                                              </tr>
                                            </ng-container>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>


                                  <div *ngIf="(comp.controls['type'].value == 'stepperform')">

                                    <div class="editSets">
                                      <div class="title-head3" fxLayoutAlign="space-between center" color="primary">
                                        <span>Step Form</span>

                                        <button [attr.guide]="'template-btn-36' + '__' + sanitizedUrl" class="create"
                                          (click)=" addImages(i)" type="button" mat-mini-fab color="primary">
                                          <mat-icon>add</mat-icon>
                                        </button>
                                      </div>
                                      <div id="responsieTable" class="container">
                                        <table fxFlex="100" style="padding: 10px;" fxLayoutAlign="space-between center">
                                          <tbody fxFlex="100">
                                            <ng-container formArrayName="images">
                                              <tr fxLayout.xs="column"
                                                *ngFor="let ImageInfo of comp.get('images')?.controls; let y = index">
                                                <ng-container [formGroupName]="y" fxLayoutAlign="space-between center">
                                                  <td fxFlex.xs="100" fxFlex="30" data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="100" appearance="outline">
                                                        <mat-label>Title</mat-label>
                                                        <textarea
                                                          [attr.guide]="'template-sel-customfield15' + '__' + sanitizedUrl"
                                                          trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                          matAutosizeMaxRows=5 matInput
                                                          formControlName="customField15"></textarea>
                                                        <mat-icon class="clickable"
                                                          (click)="openEditorTextForImageArray(ImageInfo.controls['customField15'].value,i,'customField15',y)"
                                                          matSuffix>
                                                          post_add
                                                        </mat-icon>
                                                      </mat-form-field>
                                                    </span>
                                                  </td>
                                                  <td fxFlex.xs="100" fxFlex="30" data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="100">
                                                        <mat-label>Dynamic Form</mat-label>
                                                        <mat-select formControlName="customField22"
                                                          [disableOptionCentering]="true" #singleSelect name="item">
                                                          <mat-option>
                                                            <ngx-mat-select-search name="Dynamic Form Search"
                                                              ngDefaultControl [formControl]="
                                                            dynamicFormFilterControl
                                                              " placeholderLabel="Dynamic Form Search"
                                                              [preventHomeEndKeyPropagation]="
                                                                true
                                                              " noEntriesFoundLabel="No data found">
                                                            </ngx-mat-select-search>
                                                          </mat-option>
                                                          <mat-option *ngFor="let opt of filtereddynamicFormTypeList;"
                                                            [value]="opt.formGroupId">
                                                            {{ opt.name }}

                                                          </mat-option>
                                                        </mat-select>
                                                      </mat-form-field>


                                                    </span>
                                                  </td>


                                                  <td data-th="Action">
                                                    <span class="wordBreak">
                                                      <button [attr.guide]="'template-btn-37' + '__' + sanitizedUrl"
                                                        color="warn" mat-icon-button type="button"
                                                        (click)="deleteText(i,y)">
                                                        <mat-icon>remove_circle_outline
                                                        </mat-icon>
                                                      </button>
                                                    </span>
                                                  </td>
                                                </ng-container>
                                              </tr>
                                            </ng-container>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="( comp.controls['type'].value == 'TextAnimationwithtext') ">
                                    <mat-form-field fxFlex>
                                      <mat-label>Title Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield39' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField39" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Title Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield40' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField40" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Description Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield37' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField37" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Description Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield38' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField38" />
                                    </mat-form-field>



                                  </div>

                                  <div *ngIf="(comp.controls['type'].value == 'TextAnimationwithtext')">

                                    <div class="editSets">
                                      <div class="title-head3" fxLayoutAlign="space-between center" color="primary">
                                        <span>Text Animation with Text </span>

                                        <button [attr.guide]="'template-btn-38' + '__' + sanitizedUrl" class="create"
                                          (click)=" addImages(i)" type="button" mat-mini-fab color="primary">
                                          <mat-icon>add</mat-icon>
                                        </button>
                                      </div>

                                      <div id="responsieTable" class="container">
                                        <table fxFlex="100">
                                          <tbody fxFlex="100">
                                            <ng-container formArrayName="images">
                                              <tr fxLayout.xs="column"
                                                *ngFor="let ImageInfo of comp.get('images')?.controls; let y = index">
                                                <ng-container [formGroupName]="y" fxLayoutAlign="space-between center">
                                                  <td fxFlex.xs="100" fxFlex="30" data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="100" appearance="outline">
                                                        <mat-label>Title</mat-label>
                                                        <textarea
                                                          [attr.guide]="'template-sel-customfield15' + '__' + sanitizedUrl"
                                                          trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                          matAutosizeMaxRows=5 matInput
                                                          formControlName="customField15"></textarea>
                                                        <mat-icon class="clickable"
                                                          (click)="openEditorTextForImageArray(ImageInfo.controls['customField15'].value,i,'customField15',y)"
                                                          matSuffix>
                                                          post_add
                                                        </mat-icon>
                                                      </mat-form-field>
                                                    </span>
                                                  </td>

                                                  <td fxFlex.xs="100" fxFlex="30" data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="100" appearance="outline">
                                                        <mat-label>Description</mat-label>
                                                        <textarea
                                                          [attr.guide]="'template-sel-customfield16' + '__' + sanitizedUrl"
                                                          trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                          matAutosizeMaxRows=5 matInput
                                                          formControlName="customField16"></textarea>
                                                        <mat-icon class="clickable"
                                                          (click)="openEditorTextForImageArray(ImageInfo.controls['customField16'].value,i,'customField16',y)"
                                                          matSuffix>
                                                          post_add
                                                        </mat-icon>
                                                      </mat-form-field>
                                                    </span>
                                                  </td>

                                                  <td fxFlex.xs="100" fxFlex="30" data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="100" appearance="outline">
                                                        <mat-label>Title Backgroundcolor</mat-label>
                                                        <textarea
                                                          [attr.guide]="'template-sel-customfield17' + '__' + sanitizedUrl"
                                                          trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                          matAutosizeMaxRows=5 matInput
                                                          formControlName="customField17"></textarea>
                                                        <mat-icon class="clickable"
                                                          (click)="openEditorTextForImageArray(ImageInfo.controls['customField17'].value,i,'customField17',y)"
                                                          matSuffix>
                                                          post_add
                                                        </mat-icon>
                                                      </mat-form-field>
                                                    </span>
                                                  </td>

                                                  <td fxFlex.xs="100" fxFlex="30" data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="100" appearance="outline">
                                                        <mat-label>Description Backgroundcolor</mat-label>
                                                        <textarea
                                                          [attr.guide]="'template-sel-customfield18' + '__' + sanitizedUrl"
                                                          trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                          matAutosizeMaxRows=5 matInput
                                                          formControlName="customField18"></textarea>
                                                        <mat-icon class="clickable"
                                                          (click)="openEditorTextForImageArray(ImageInfo.controls['customField18'].value,i,'customField18',y)"
                                                          matSuffix>
                                                          post_add
                                                        </mat-icon>
                                                      </mat-form-field>
                                                    </span>
                                                  </td>
                                                  <td data-th="Action">
                                                    <span class="wordBreak">
                                                      <button [attr.guide]="'template-btn-39' + '__' + sanitizedUrl"
                                                        color="warn" mat-icon-button type="button"
                                                        (click)="deleteText(i,y)">
                                                        <mat-icon>remove_circle_outline
                                                        </mat-icon>
                                                      </button>
                                                    </span>
                                                  </td>
                                                </ng-container>
                                              </tr>
                                            </ng-container>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>

                                  <div fxLayout="column"
                                    *ngIf="(comp.controls['type'].value == 'scrollableImageForm') ">

                                    <div class="editSets">
                                      <div class="title-head3" color="primary">
                                        <span>Image</span>
                                      </div>
                                      <div id="responsieTable" class="container" style="overflow-x:auto;">
                                        <table class="rwd-table">
                                          <tbody>
                                            <tr>
                                              <th>Image</th>
                                              <th>Filename</th>

                                              <th>Navigation</th>
                                              <th>Category</th>
                                              <th>Action</th>
                                            </tr>
                                            <ng-container formArrayName="images">
                                              <tr *ngFor="let ImageInfo of comp.get('images')?.controls; let k = index">
                                                <ng-container [formGroupName]="k">
                                                  <td data-th="Image" style="width: 60%;">
                                                    <!-- <img style="height: 65px;width: auto;"
                                                      [src]="bannerServerPath+ ImageInfo.controls['img'].value"
                                                      onerror="this.src='assets/images/logo/no-image.png';" alt=""> -->

                                                    <calsoft-common-images
                                                      [src]="bannerServerPath+ ImageInfo.controls['img'].value"
                                                      [height]="'65px'" [width]="'auto'" [alt]="">

                                                    </calsoft-common-images>
                                                  </td>
                                                  <td data-th="Filename" style="width: 90%;">
                                                    <span class="wordBreak">
                                                      {{ ImageInfo.controls['img'].value}}
                                                    </span>
                                                  </td>



                                                  <td data-th="Filename" style="width: 100%;">
                                                    <span style="width: 100%;" class="wordBreak">
                                                      <mat-form-field fxFlex="100">
                                                        <mat-label>Navigation</mat-label>
                                                        <mat-select required formControlName="navigation" name="item">
                                                          <mat-option *ngFor="
                                                        let item of navigation;
                                                        let i = index
                                                      " [value]="item.value">
                                                            {{ item.viewValue }}
                                                          </mat-option>
                                                        </mat-select>
                                                      </mat-form-field>


                                                    </span>
                                                  </td>
                                                  <!-- <td data-th="Navigation" style="width: 90%;">
                                                
    
                                              </td> -->
                                                  <td fxLayout.xs="column" data-th="Category" style="width: 100%;">
                                                    <mat-form-field style="width: 100%;" fxFlex="100">

                                                      <mat-label>{{ImageInfo.controls['navigation'].value
                                                        ==0?'Category':'Url'}}</mat-label>

                                                      <mat-select *ngIf="ImageInfo.controls['navigation']
                                                .value==0" required formControlName="catId"
                                                        [disableOptionCentering]="true" #singleSelect name="item">
                                                        <mat-option>
                                                          <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                            [formControl]="
                                                    categoryFilterControl
                                                  " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                    true
                                                  " noEntriesFoundLabel="No data found">
                                                          </ngx-mat-select-search>
                                                        </mat-option>
                                                        <mat-option *ngFor="
                                                  let opt of filteredCategoryTypeList
                                                " [value]="opt.categoryId">
                                                          {{ opt.categoryName }}
                                                        </mat-option>
                                                      </mat-select>

                                                      <input
                                                        [attr.guide]="'template-inp-navigatedurl' + '__' + sanitizedUrl"
                                                        style="width: 100%;" *ngIf="ImageInfo.controls['navigation']
                                                .value==1" trim="blur" (keydown.enter)="$event.preventDefault()"
                                                        [autocomplete]="'off'" matInput
                                                        formControlName="navigatedUrl" />

                                                    </mat-form-field>
                                                  </td>



                                                  <td data-th="Action">
                                                    <button [attr.guide]="'template-btn-40' + '__' + sanitizedUrl"
                                                      color="warn" mat-icon-button type="button"
                                                      (click)="updateBanner( ImageInfo.controls['img'].value,i,k)">
                                                      <mat-icon>remove_circle_outline
                                                      </mat-icon>
                                                    </button>
                                                  </td>
                                                </ng-container>
                                              </tr>
                                            </ng-container>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                    <div class="editSets1">
                                      <div class="title " fxLayout="row" fxLayoutAlign="center center">
                                        <span *ngIf=" _form.value.conditions[i].images.length<=0"
                                          fxLayoutAlign="center center">No
                                          Images
                                          Uploaded</span>
                                      </div>
                                      <div>
                                        <calsoft-common-file-upload (fileUploadResult)="getResultBanner($event, i)"
                                          [type]="'commonSlider'"></calsoft-common-file-upload>
                                      </div>


                                    </div>
                                    <div fxLayout="column"
                                      *ngIf="comp.controls['customField1'].value=='type3'||comp.controls['customField1'].value=='type4' || comp.controls['customField1'].value=='type5' || comp.controls['customField1'].value=='type6' ">
                                      <div fxFlex fxLayout="column" fxLayoutGap="10">
                                        <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">
                                          <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField2')"
                                            (fileUploadResult)="
                                        getResultts($event, i,'customField2') " [index]="i"
                                            [value]="comp.controls['customField2'].value">
                                          </calsoft-image>
                                          <mat-form-field fxFlex>
                                            <mat-label>Category</mat-label>
                                            <mat-select required formControlName="categoryId1"
                                              [disableOptionCentering]="true" #singleSelect name="item">
                                              <mat-option>
                                                <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                  [formControl]="
                                                categoryFilterControl
                                              " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                true
                                              " noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                              </mat-option>
                                              <mat-option *ngFor="
                                              let opt of filteredCategoryTypeList
                                            " [value]="opt.categoryId">
                                                {{ opt.categoryName }}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                        </div>

                                        <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">

                                          <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField3')"
                                            (fileUploadResult)="
                                      getResultts($event, i,'customField3')" [index]="i"
                                            [value]="comp.controls['customField3'].value">
                                          </calsoft-image>
                                          <mat-form-field fxFlex>
                                            <mat-label>Category</mat-label>
                                            <mat-select required formControlName="categoryId2"
                                              [disableOptionCentering]="true" #singleSelect name="item">
                                              <mat-option>
                                                <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                  [formControl]="
                                                categoryFilterControl
                                              " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                true
                                              " noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                              </mat-option>
                                              <mat-option *ngFor="
                                              let opt of filteredCategoryTypeList
                                            " [value]="opt.categoryId">
                                                {{ opt.categoryName }}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                        </div>
                                        <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">

                                          <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField4')"
                                            (fileUploadResult)="
                                      getResultts($event, i,'customField4')" [index]="i"
                                            [value]="comp.controls['customField4'].value">
                                          </calsoft-image>
                                          <mat-form-field fxFlex>
                                            <mat-label>Category</mat-label>
                                            <mat-select required formControlName="categoryId3"
                                              [disableOptionCentering]="true" #singleSelect name="item">
                                              <mat-option>
                                                <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                  [formControl]="
                                                categoryFilterControl
                                              " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                true
                                              " noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                              </mat-option>
                                              <mat-option *ngFor="
                                              let opt of filteredCategoryTypeList
                                            " [value]="opt.categoryId">
                                                {{ opt.categoryName }}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                        </div>
                                      </div>

                                    </div>

                                    <div fxLayout="column"
                                      *ngIf="comp.controls['customField1'].value=='type7'||comp.controls['customField1'].value=='type8' || comp.controls['customField1'].value=='type9' || comp.controls['customField1'].value=='type10' ">
                                      <div fxFlex fxLayout="column" fxLayoutGap="10">
                                        <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">
                                          <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField2')"
                                            (fileUploadResult)="
                                        getResultts($event, i,'customField2') " [index]="i"
                                            [value]="comp.controls['customField2'].value">
                                          </calsoft-image>
                                          <mat-form-field fxFlex>
                                            <mat-label>Category</mat-label>
                                            <mat-select required formControlName="categoryId1"
                                              [disableOptionCentering]="true" #singleSelect name="item">
                                              <mat-option>
                                                <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                  [formControl]="
                                                categoryFilterControl
                                              " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                true
                                              " noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                              </mat-option>
                                              <mat-option *ngFor="
                                              let opt of filteredCategoryTypeList
                                            " [value]="opt.categoryId">
                                                {{ opt.categoryName }}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>

                                        </div>

                                        <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">

                                          <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField3')"
                                            (fileUploadResult)="
                                      getResultts($event, i,'customField3')" [index]="i"
                                            [value]="comp.controls['customField3'].value">
                                          </calsoft-image>
                                          <mat-form-field fxFlex>
                                            <mat-label>Category</mat-label>
                                            <mat-select required formControlName="categoryId2"
                                              [disableOptionCentering]="true" #singleSelect name="item">
                                              <mat-option>
                                                <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                  [formControl]="
                                                categoryFilterControl
                                              " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                true
                                              " noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                              </mat-option>
                                              <mat-option *ngFor="
                                              let opt of filteredCategoryTypeList
                                            " [value]="opt.categoryId">
                                                {{ opt.categoryName }}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>

                                          <mat-form-field fxFlex>
                                            <mat-label>Alt Tag</mat-label>
                                            <input [attr.guide]="'template-inp-altimage' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" matInput formControlName="altImage" />

                                          </mat-form-field>

                                        </div>

                                      </div>

                                    </div>


                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="(comp.controls['type'].value == 'faq')">

                                    <mat-form-field fxFlex>
                                      <mat-label>Answer Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield39' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField39" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Answer Mobile Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield40' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField40" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Card Height</mat-label>
                                      <input [attr.guide]="'template-inp-customfield27' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField27" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Card Mobile Height </mat-label>
                                      <input [attr.guide]="'template-inp-customfield28' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField28" />
                                    </mat-form-field>
                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="(comp.controls['type'].value == 'faq') && comp.controls.customField25.value == 7">

                                    <mat-form-field fxFlex>
                                      <mat-label>Faq Sub Title Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield30' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField30" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Faq Sub Title Mobile Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield31' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField31" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Faq Background Color </mat-label>
                                      <input [attr.guide]="'template-inp-customfield35' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField35" />
                                    </mat-form-field>
                                  </div>
                                  <div *ngIf="(comp.controls['type'].value == 'faq')">

                                    <div class="editSets">
                                      <div class="title-head3" fxLayoutAlign="space-between center" color="primary">
                                        <span>Faq Questions</span>

                                        <button [attr.guide]="'template-btn-41' + '__' + sanitizedUrl" class="create"
                                          (click)=" addFaq(i)" type="button" mat-mini-fab color="primary">
                                          <mat-icon>add</mat-icon>
                                        </button>
                                      </div>
                                      <div id="responsieTable" class="container">
                                        <table fxFlex="100">
                                          <tbody fxFlex="100">
                                            <ng-container formArrayName="images">
                                              <tr fxLayout.xs="column"
                                                *ngFor="let ImageInfo of comp.get('images')?.controls; let y = index">
                                                <ng-container [formGroupName]="y" fxLayoutAlign="space-between center">
                                                  <td fxFlex="30" fxFlex.xs="100" data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="100" appearance="outline">
                                                        <mat-label>Questions</mat-label>
                                                        <textarea
                                                          [attr.guide]="'template-sel-customfield15' + '__' + sanitizedUrl"
                                                          trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                          matAutosizeMaxRows=5 matInput
                                                          formControlName="customField15"></textarea>
                                                        <mat-icon class="clickable"
                                                          (click)="openEditorTextForImageArray(ImageInfo.controls['customField15'].value,i,'customField15',y)"
                                                          matSuffix>
                                                          post_add
                                                        </mat-icon>
                                                      </mat-form-field>
                                                    </span>
                                                  </td>


                                                  <td fxFlex="30" fxFlex.xs="100" data-th="Filename" fxLayoutGap="10px"
                                                    *ngIf="comp.controls.customField25.value == 7">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="100" appearance="outline">
                                                        <mat-label>Faq Sub Title</mat-label>
                                                        <textarea
                                                          [attr.guide]="'template-sel-customfield17' + '__' + sanitizedUrl"
                                                          trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                          matAutosizeMaxRows=5 matInput
                                                          formControlName="customField17"></textarea>
                                                        <mat-icon class="clickable"
                                                          (click)="openEditorTextForImageArray(ImageInfo.controls['customField17'].value,i,'customField17',y)"
                                                          matSuffix>
                                                          post_add
                                                        </mat-icon>
                                                      </mat-form-field>
                                                    </span>
                                                  </td>
                                                  <td fxFlex="30" fxFlex.xs="100" data-th="Filename" fxLayoutGap="10px"
                                                    *ngIf="comp.controls.customField25.value != 7">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex>
                                                        <mat-label>Column Width</mat-label>
                                                        <input
                                                          [attr.guide]="'template-inp-customfield17' + '__' + sanitizedUrl"
                                                          trim="blur" (keydown.enter)="$event.preventDefault()"
                                                          [autocomplete]="'off'" matInput
                                                          formControlName="customField17" />
                                                      </mat-form-field>
                                                    </span>
                                                  </td>

                                                  <td fxFlex="30" fxFlex.xs="100" data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <calsoft-image fxFlex="100" style="padding-bottom: 10px;"
                                                        (deleteResult)="updatesImageArray($event, i,'customField6',y)"
                                                        (fileUploadResult)="
                                            getResultArray($event, i,'customField6',y) " [index]="y"
                                                        [value]="ImageInfo.controls['customField6'].value">
                                                      </calsoft-image>
                                                    </span>
                                                  </td>

                                                  <td fxFlex="30" fxFlex.xs="100" data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="100" appearance="outline">
                                                        <mat-label>Answer</mat-label>
                                                        <textarea
                                                          [attr.guide]="'template-sel-customfield16' + '__' + sanitizedUrl"
                                                          trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                          matAutosizeMaxRows=5 matInput
                                                          formControlName="customField16"></textarea>
                                                        <mat-icon class="clickable"
                                                          (click)="openEditorTextForImageArray(ImageInfo.controls['customField16'].value,i,'customField16',y)"
                                                          matSuffix>
                                                          post_add
                                                        </mat-icon>
                                                      </mat-form-field>
                                                    </span>
                                                  </td>

                                                  <td data-th="Action">
                                                    <span class="wordBreak">
                                                      <button [attr.guide]="'template-btn-42' + '__' + sanitizedUrl"
                                                        color="warn" mat-icon-button type="button"
                                                        (click)="deleteText(i,y)">
                                                        <mat-icon>remove_circle_outline
                                                        </mat-icon>
                                                      </button>
                                                    </span>
                                                  </td>
                                                </ng-container>
                                              </tr>
                                            </ng-container>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>


                                  <div *ngIf="(comp.controls['type'].value == 'bannerVideo')">

                                    <div class="editSets">
                                      <div class="title-head3" fxLayoutAlign="space-between center" color="primary">
                                        <span>Banner Video</span>

                                        <!-- <button [attr.guide]="'template-btn-43' + '__' + sanitizedUrl" class="create" (click)=" addbannerVedio(i)" type="button" mat-mini-fab
                                        color="primary" [disabled]="i > 1">
                                        <mat-icon>add</mat-icon>
                                      </button> -->
                                      </div>

                                      <div id="responsieTable" class="container">
                                        <table fxFlex="100" class="rwd-table">
                                          <tbody fxFlex="100">
                                            <tr>
                                              <th fxFlex="30">Video Content</th>
                                              <th fxFlex="30">Video Content 1</th>
                                              <th fxFlex="30">Video Id</th>
                                              <th fxFlex="10">Action</th>
                                            </tr>
                                            <ng-container formArrayName="images">
                                              <tr fxLayout.xs="column"
                                                *ngFor="let ImageInfo of comp.get('images')?.controls;; let y = index">
                                                <ng-container [formGroupName]="y" fxLayoutAlign="space-between center">
                                                  <td fxLayout.xs="column" fxLayoutAlign.xs="start" fxFlex="30"
                                                    class="mobilewidth" data-th="Filename"
                                                    fxLayoutAlign="center center">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="100" appearance="outline"
                                                        fxLayoutGap="10px">
                                                        <mat-label>Video Content</mat-label>
                                                        <textarea
                                                          [attr.guide]="'template-sel-customfield15' + '__' + sanitizedUrl"
                                                          trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                          matAutosizeMaxRows=5 matInput
                                                          formControlName="customField15"></textarea>
                                                        <mat-icon class="clickable"
                                                          (click)="openEditorTextForImageArray(ImageInfo.controls['customField15'].value,i,'customField15',y)"
                                                          matSuffix>
                                                          post_add
                                                        </mat-icon>
                                                      </mat-form-field>
                                                    </span>
                                                  </td>
                                                  <td fxLayout.xs="column" fxLayoutAlign.xs="start" fxFlex="30"
                                                    class="mobilewidth" data-th="Filename"
                                                    fxLayoutAlign="center center">
                                                    <span class="wordBreak1">
                                                      <mat-form-field fxFlex="100" appearance="outline"
                                                        fxLayoutGap="10px">
                                                        <mat-label>Video Content1</mat-label>
                                                        <textarea
                                                          [attr.guide]="'template-sel-customfield16' + '__' + sanitizedUrl"
                                                          trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                          matAutosizeMaxRows=5 matInput
                                                          formControlName="customField16"></textarea>
                                                        <mat-icon class="clickable"
                                                          (click)="openEditorTextForImageArray(ImageInfo.controls['customField16'].value,i,'customField16',y)"
                                                          matSuffix>
                                                          post_add
                                                        </mat-icon>
                                                      </mat-form-field>
                                                    </span>
                                                  </td>

                                                  <td fxLayout.xs="column" fxLayoutAlign.xs="start" fxFlex="30"
                                                    class="mobilewidth" data-th="Filename"
                                                    fxLayoutAlign="center center">
                                                    <span class="wordBreak1">
                                                      <mat-form-field appearance="outline" fxFlex="100">
                                                        <mat-label>Video Id</mat-label>
                                                        <textarea
                                                          [attr.guide]="'template-sel-customfield17' + '__' + sanitizedUrl"
                                                          trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                          matAutosizeMaxRows=5 matInput
                                                          formControlName="customField17"></textarea>
                                                        <mat-icon class="clickable"
                                                          (click)="openEditorTextForImageArray(ImageInfo.controls['customField17'].value,i,'customField17',y)"
                                                          matSuffix>
                                                          post_add
                                                        </mat-icon>
                                                      </mat-form-field>

                                                    </span>
                                                  </td>

                                                  <td fxFlex="10" data-th="Action" fxLayoutAlign="center center">
                                                    <span class="wordBreak">
                                                      <button [attr.guide]="'template-btn-44' + '__' + sanitizedUrl"
                                                        color="warn" mat-icon-button type="button"
                                                        (click)="deleteText(i,y)">
                                                        <mat-icon>remove_circle_outline
                                                        </mat-icon>
                                                      </button>
                                                    </span>
                                                  </td>
                                                </ng-container>
                                              </tr>
                                            </ng-container>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                  <div *ngIf="(comp.controls['type'].value == 'SearchWithBackground')">

                                    <div id="responsieTable" class="container">
                                      <table fxFlex="100" class="padding-10">
                                        <tbody fxFlex="100">
                                          <ng-container formArrayName="images">
                                            <ng-container
                                              *ngFor="let ImageInfo of comp.get('images')?.controls;; let y = index">
                                              <div [formGroupName]="y">


                                                <tr fxLayout="row"
                                                  *ngIf="ImageInfo.controls.customField3.value == 'TextWithImage'"
                                                  fxLayoutGap="10px">
                                                  <td fxFlex="50">
                                                    <mat-form-field fxFlex>
                                                      <mat-label>Mobile Font Size</mat-label>
                                                      <input
                                                        [attr.guide]="'template-inp-customfield17' + '__' + sanitizedUrl"
                                                        trim="blur" (keydown.enter)="$event.preventDefault()"
                                                        [autocomplete]="'off'" matInput
                                                        formControlName="customField17" />
                                                    </mat-form-field>
                                                  </td>
                                                  <td fxFlex="50">
                                                    <mat-form-field fxFlex>
                                                      <mat-label>Font Size</mat-label>
                                                      <input
                                                        [attr.guide]="'template-inp-customfield18' + '__' + sanitizedUrl"
                                                        trim="blur" (keydown.enter)="$event.preventDefault()"
                                                        [autocomplete]="'off'" matInput
                                                        formControlName="customField18" />
                                                    </mat-form-field>
                                                  </td>
                                                </tr>

                                                <tr fxLayout="row" fxLayoutGap="10px">


                                                  <mat-form-field fxFlex>
                                                    <mat-label>Title</mat-label>
                                                    <input
                                                      [attr.guide]="'template-inp-customfield16' + '__' + sanitizedUrl"
                                                      trim="blur" (keydown.enter)="$event.preventDefault()"
                                                      [autocomplete]="'off'" matInput formControlName="customField16" />
                                                  </mat-form-field>
                                                </tr>

                                                <tr fxLayout="row" fxLayoutGap="10px">

                                                  <td data-th="Filename" fxFlex="100">
                                                    <span class="wordBreak" *ngIf="ImageInfo.controls['type'].value==1">
                                                      <calsoft-image fxFlex="100" style="padding-bottom: 10px;"
                                                        (deleteResult)="updatesIMage($event, i,'customField24')"
                                                        (fileUploadResult)="
                                                    getResultts($event, i,'customField24')" [index]="i"
                                                        [value]="ImageInfo.controls['customField24'].value">
                                                      </calsoft-image>
                                                    </span>
                                                  </td>


                                                </tr>


                                              </div>

                                            </ng-container>
                                          </ng-container>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>


                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column"
                                    *ngIf="(comp.controls['type'].value == 'table') && (comp.controls['customField33'].value == '2' || comp.controls.customField33.value == '13' || comp.controls['customField33'].value == '4' || comp.controls['customField33'].value == '9' || comp.controls['customField33'].value == '10' || comp.controls['customField33'].value == '16')">

                                    <mat-form-field fxFlex>
                                      <mat-label>Header type</mat-label>
                                      <mat-select formControlName="customField15">
                                        <mat-option *ngFor="let item of tabheaderType" [value]="item.value">
                                          {{item.viewValue}}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>

                                    <mat-form-field fxFlex>
                                      <mat-label>Plan title 1</mat-label>
                                      <input [attr.guide]="'template-inp-customfield16' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField16" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Plan title 2</mat-label>
                                      <input [attr.guide]="'template-inp-customfield17' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField17" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Plan title 3</mat-label>
                                      <input [attr.guide]="'template-inp-customfield18' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField18" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Plan title 4</mat-label>
                                      <input [attr.guide]="'template-inp-customfield19' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField19" />
                                    </mat-form-field>

                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column"
                                    *ngIf="(comp.controls['type'].value == 'table') && (comp.controls['customField33'].value == '9' || comp.controls['customField33'].value == '16')">
                                    <mat-form-field fxFlex>
                                      <mat-label>Plan title 5</mat-label>
                                      <input [attr.guide]="'template-inp-customfield24' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField24" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Plan title 6</mat-label>
                                      <input [attr.guide]="'template-inp-customfield25' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField25" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Plan title 7</mat-label>
                                      <input [attr.guide]="'template-inp-customfield26' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField26" />
                                    </mat-form-field>
                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="(comp.controls['type'].value == 'table') && (comp.controls.customField15.value == '2' || comp.controls['customField33'].value == '4'|| comp.controls['customField33'].value == '9' || comp.controls['customField33'].value == '16')">

                                    <mat-form-field fxFlex>
                                      <mat-label>BackGround color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield20' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField20" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex>
                                      <mat-label>Text header color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield21' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField21" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex>
                                      <mat-label>Column color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield23' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField23" />
                                    </mat-form-field>

                                  </div>


                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="(comp.controls['type'].value == 'table' && comp.controls.customField33.value == '6' )">

                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>Content 1</mat-label>
                                      <textarea [attr.guide]="'template-sel-customfield4' + '__' + sanitizedUrl"
                                        trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5
                                        matInput formControlName="customField4" matInput>
                                  </textarea>
                                      <mat-icon class="clickable"
                                        (click)="openEditorText(comp.controls['customField4'].value,i,'customField4')"
                                        matSuffix>
                                        post_add
                                      </mat-icon>
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>Content 2</mat-label>
                                      <textarea [attr.guide]="'template-sel-customfield5' + '__' + sanitizedUrl"
                                        trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5
                                        matInput formControlName="customField5" matInput>
                                  </textarea>
                                      <mat-icon class="clickable"
                                        (click)="openEditorText(comp.controls['customField5'].value,i,'customField5')"
                                        matSuffix>
                                        post_add
                                      </mat-icon>
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>Content 3</mat-label>
                                      <textarea [attr.guide]="'template-sel-customfield6' + '__' + sanitizedUrl"
                                        trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5
                                        matInput formControlName="customField6" matInput>
                                  </textarea>
                                      <mat-icon class="clickable"
                                        (click)="openEditorText(comp.controls['customField6'].value,i,'customField6')"
                                        matSuffix>
                                        post_add
                                      </mat-icon>
                                    </mat-form-field>

                                  </div>

                                  <!-- tabLayout -->

                                  <div *ngIf="(comp.controls['type'].value == 'tabLayout')">

                                    <div class="editSets">
                                      <div class="title-head3" fxLayoutAlign="space-between center" color="primary">
                                        <span>Tab Layout</span>

                                        <button [attr.guide]="'template-btn-45' + '__' + sanitizedUrl" class="create"
                                          (click)="addTabLayout(i)" type="button" mat-mini-fab color="primary">
                                          <mat-icon>add</mat-icon>
                                        </button>
                                      </div>

                                      <div id="responsieTable" class="container">
                                        <table fxFlex="100" class="padding-10">
                                          <tbody fxFlex="100">
                                            <ng-container formArrayName="images">
                                              <ng-container
                                                *ngFor="let ImageInfo of comp.get('images')?.controls;; let y = index">
                                                <div [formGroupName]="y">
                                                  <tr fxLayout="row" fxLayout.xs="column">
                                                    <ng-container fxLayoutAlign="space-between center">
                                                      <td fxFlex="50" fxFlex.xs="100" data-th="Filename"
                                                        fxLayoutGap="10px">
                                                        <span class="wordBreak">
                                                          <div style="display: flex; gap: 20px;">

                                                            <mat-form-field fxFlex="100" appearance="outline">
                                                              <mat-label>Tab Name</mat-label>
                                                              <textarea
                                                                [attr.guide]="'template-sel-customfield15' + '__' + sanitizedUrl"
                                                                trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                                matAutosizeMaxRows=5 matInput
                                                                formControlName="customField15"></textarea>
                                                              <mat-icon class="clickable"
                                                                (click)="openEditorTextForImageArray(ImageInfo.controls['customField15'].value,i,'customField15',y)"
                                                                matSuffix>
                                                                post_add
                                                              </mat-icon>
                                                              <mat-hint fxHide.lt-md>Click on the icon to open
                                                                editor</mat-hint>
                                                            </mat-form-field>
                                                          </div>
                                                        </span>
                                                      </td>
                                                      <td fxFlex="50" fxFlex.xs="100" data-th="Filename"
                                                        fxLayoutGap="10px"
                                                        *ngIf=" comp.controls.customField13.value == '5'">
                                                        <span class="wordBreak">
                                                          <div style="display: flex; gap: 20px;">
                                                            <mat-form-field fxFlex appearance="outline">
                                                              <mat-label>Id</mat-label>
                                                              <input
                                                                [attr.guide]="'template-inp-customfield16' + '__' + sanitizedUrl"
                                                                (keydown.enter)="$event.preventDefault()" trim="blur"
                                                                [autocomplete]="'off'" trim="blur"
                                                                formControlName="customField16" matInput />
                                                            </mat-form-field>
                                                          </div>
                                                        </span>
                                                      </td>
                                                      <td fxFlex="50" fxFlex.xs="100" data-th="Filename"
                                                        fxLayoutGap="10px">
                                                        <span class="wordBreak">
                                                          <div style="display: flex">
                                                            <mat-form-field fxFlex appearance="outline">
                                                              <mat-label>Type</mat-label>
                                                              <mat-select
                                                                (selectionChange)="onChangeImageTab($event, i,y)"
                                                                required formControlName="customField3" name="item">
                                                                <mat-option *ngFor="let item of tablayout;"
                                                                  [value]="item.value">
                                                                  {{ item.viewValue }}
                                                                </mat-option>
                                                              </mat-select>
                                                            </mat-form-field>
                                                          </div>
                                                        </span>
                                                      </td>

                                                      <td fxFlex="50" fxFlex.xs="100" data-th="Filename"
                                                        fxLayoutGap="10px">
                                                        <span class="wordBreak">
                                                          <div style="display: flex">
                                                            <mat-form-field fxFlex appearance="outline">
                                                              <mat-label>Show Animation </mat-label>
                                                              <mat-select formControlName="customField36">
                                                                <mat-option *ngFor="let status of ShowAnimation"
                                                                  [value]="status.value">
                                                                  {{status.viewValue}}
                                                                </mat-option>
                                                              </mat-select>
                                                            </mat-form-field>
                                                          </div>
                                                        </span>
                                                      </td>

                                                      <td>
                                                        <ng-container
                                                          *ngIf="( ImageInfo.controls['customField3'].value == 'image')">
                                                          <mat-form-field fxFlex>
                                                            <mat-label>Image Count</mat-label>
                                                            <mat-select (selectionChange)="onChange($event, i)" required
                                                              formControlName="layout" name="item">
                                                              <mat-option *ngFor="let item of [1, 2, 3, 4]"
                                                                [value]="item">
                                                                {{ item }}
                                                              </mat-option>
                                                            </mat-select>
                                                            <mat-error *ngIf="
                                                            comp.controls['type'].value == 'image' &&
                                                            comp.controls['value'].value == ''
                                                          ">
                                                              Please fill out this field.
                                                            </mat-error>

                                                          </mat-form-field>


                                                        </ng-container>
                                                      </td>


                                                      <td *ngIf="ImageInfo.controls.customField3.value == 'Category'">
                                                        <mat-form-field fxFlex appearance="outline">
                                                          <mat-label>Category</mat-label>
                                                          <mat-select required formControlName="customField4"
                                                            [disableOptionCentering]="true" #singleSelect name="item">
                                                            <mat-option>
                                                              <ngx-mat-select-search name="Category Search"
                                                                ngDefaultControl [formControl]="
                                                categoryFilterControl
                                              " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                true
                                              " noEntriesFoundLabel="No data found">
                                                              </ngx-mat-select-search>
                                                            </mat-option>
                                                            <mat-option *ngFor="
                                              let opt of filteredCategoryTypeList
                                            " [value]="opt.categoryId">
                                                              {{ opt.categoryName }}
                                                            </mat-option>
                                                          </mat-select>
                                                        </mat-form-field>
                                                      </td>

                                                      <td fxFlex="50" fxFlex.xs="100" data-th="Filename"
                                                        fxLayoutGap="10px"
                                                        *ngIf="ImageInfo.controls.customField3.value == 'ProductScope'">
                                                        <span class="wordBreak">
                                                          <div style="display: flex; gap: 20px;">
                                                            <mat-form-field fxFlex appearance="outline">
                                                              <mat-label>Custom Product Scope</mat-label>
                                                              <mat-select required formControlName="customField5"
                                                                [disableOptionCentering]="true" #singleSelect
                                                                name="item">
                                                                <mat-option>
                                                                  <ngx-mat-select-search
                                                                    name="Custom Product Scope Search" ngDefaultControl
                                                                    [formControl]="
                                                                productScopeFilterControl
                                                                  " placeholderLabel="Product Scope Search"
                                                                    [preventHomeEndKeyPropagation]="
                                                                    true
                                                                  " noEntriesFoundLabel="No data found">
                                                                  </ngx-mat-select-search>
                                                                </mat-option>
                                                                <mat-option
                                                                  (onSelectionChange)="setProductScopeChild($event,opt,'customField20',i,y)"
                                                                  *ngFor="let opt of filteredproductScopeTypeList;"
                                                                  [value]="opt.customProductScopeId">
                                                                  {{ opt.type }}
                                                                </mat-option>
                                                              </mat-select>
                                                              <mat-error *ngIf="
                                                                comp.controls.value.errors?.required
                                                              ">
                                                                Please fill out this field.
                                                              </mat-error>
                                                            </mat-form-field>
                                                          </div>
                                                        </span>
                                                      </td>

                                                      <td data-th="Action">
                                                        <span class="wordBreak">
                                                          <button [attr.guide]="'template-btn-46' + '__' + sanitizedUrl"
                                                            color="warn" mat-icon-button type="button"
                                                            (click)="deleteText(i,y)">
                                                            <mat-icon>remove_circle_outline
                                                            </mat-icon>
                                                          </button>
                                                        </span>
                                                      </td>
                                                    </ng-container>
                                                  </tr>
                                                  <tr fxLayout="row" fxLayout.xs="column" fxLayoutGap="10px">
                                                    <td *ngIf="ImageInfo.controls.customField3.value == 'TextWithImage'"
                                                      fxFlex="30">
                                                      <ng-container>
                                                        <mat-form-field fxFlex>
                                                          <mat-label>Navigation</mat-label>
                                                          <mat-select
                                                            (selectionChange)="doSomething($event,i,'customField2')"
                                                            required formControlName="customField6" name="item">
                                                            <mat-option *ngFor="
                                                            let item of navigation1;
                                                            let i = index
                                                          " [value]="item.value">
                                                              {{ item.viewValue }}
                                                            </mat-option>
                                                          </mat-select>
                                                        </mat-form-field>
                                                      </ng-container>
                                                    </td>

                                                    <td *ngIf="ImageInfo.controls.customField3.value == 'TextWithImage'"
                                                      fxFlex="30">
                                                      <ng-container>
                                                        <mat-form-field fxFlex>
                                                          <mat-label>
                                                            {{ImageInfo.controls['customField6'].value==0?'Category':'Url'}}
                                                          </mat-label>
                                                          <ng-container
                                                            *ngIf="ImageInfo.controls['customField6'].value==0">

                                                            <mat-select required formControlName="customField2"
                                                              [disableOptionCentering]="true" #singleSelect name="item">
                                                              <mat-option>
                                                                <ngx-mat-select-search name="Category Search"
                                                                  ngDefaultControl [formControl]="
                                                            categoryFilterControl
                                                          " placeholderLabel="Category Search"
                                                                  [preventHomeEndKeyPropagation]="
                                                            true
                                                          " noEntriesFoundLabel="No data found">
                                                                </ngx-mat-select-search>
                                                              </mat-option>
                                                              <mat-option *ngFor="
                                                          let opt of filteredCategoryTypeList
                                                        " [value]="opt.categoryName">
                                                                {{ opt.categoryName }}
                                                              </mat-option>
                                                            </mat-select>
                                                          </ng-container>

                                                          <ng-container
                                                            *ngIf="ImageInfo.controls['customField6'].value==1">
                                                            <input
                                                              [attr.guide]="'template-inp-customfield2' + '__' + sanitizedUrl"
                                                              required trim="blur"
                                                              (keydown.enter)="$event.preventDefault()"
                                                              [autocomplete]="'off'" required matInput
                                                              formControlName="customField2" />
                                                          </ng-container>
                                                          <mat-error *ngIf="
                                                        comp.controls.customField2.errors?.required
                                                      ">
                                                            Please fill out this field.
                                                          </mat-error>
                                                        </mat-form-field>
                                                      </ng-container>

                                                    </td>

                                                    <td fxFlex="50" data-th="Filename" fxLayoutGap="10px"
                                                      *ngIf=" comp.controls.customField13.value == '5'">
                                                      <span class="wordBreak">
                                                        <div style="display: flex; gap: 20px;">
                                                          <mat-form-field fxFlex appearance="outline">
                                                            <mat-label>Icon</mat-label>
                                                            <input
                                                              [attr.guide]="'template-inp-customfield14' + '__' + sanitizedUrl"
                                                              (keydown.enter)="$event.preventDefault()" trim="blur"
                                                              [autocomplete]="'off'" trim="blur"
                                                              formControlName="customField14" matInput />
                                                          </mat-form-field>
                                                        </div>
                                                      </span>
                                                    </td>

                                                  </tr>
                                                  <tr fxLayout="row" fxLayout.xs="column"
                                                    *ngIf="ImageInfo.controls.customField3.value == 'TextWithImage'"
                                                    fxLayoutGap="10px">
                                                    <td fxFlex="50">
                                                      <mat-form-field fxFlex>
                                                        <mat-label>Mobile Font Size</mat-label>
                                                        <input
                                                          [attr.guide]="'template-inp-customfield17' + '__' + sanitizedUrl"
                                                          trim="blur" (keydown.enter)="$event.preventDefault()"
                                                          [autocomplete]="'off'" matInput
                                                          formControlName="customField17" />
                                                      </mat-form-field>
                                                    </td>
                                                    <td fxFlex="50">
                                                      <mat-form-field fxFlex>
                                                        <mat-label>Font Size</mat-label>
                                                        <input
                                                          [attr.guide]="'template-inp-customfield18' + '__' + sanitizedUrl"
                                                          trim="blur" (keydown.enter)="$event.preventDefault()"
                                                          [autocomplete]="'off'" matInput
                                                          formControlName="customField18" />
                                                      </mat-form-field>
                                                    </td>
                                                  </tr>

                                                  <tr fxLayout="row" fxLayoutGap="10px" fxLayout.xs="column"
                                                    *ngIf="ImageInfo.controls.customField3.value == 'TextWithImage'">
                                                    <mat-form-field fxFlex>
                                                      <mat-label>Title 2</mat-label>
                                                      <input
                                                        [attr.guide]="'template-inp-customfield19' + '__' + sanitizedUrl"
                                                        trim="blur" (keydown.enter)="$event.preventDefault()"
                                                        [autocomplete]="'off'" matInput
                                                        formControlName="customField19" />
                                                    </mat-form-field>

                                                    <mat-form-field fxFlex>
                                                      <mat-label> Title Type</mat-label>
                                                      <mat-select formControlName="customField20">
                                                        <mat-option *ngFor="let item of layoutType2" [value]="item.id">
                                                          {{item.status}}
                                                        </mat-option>
                                                      </mat-select>
                                                    </mat-form-field>
                                                  </tr>

                                                  <tr fxLayout="row" fxLayoutGap="10px" fxLayout.xs="column"
                                                    *ngIf="ImageInfo.controls.customField3.value == 'TextWithImage'">

                                                    <td data-th="Filename" fxFlex="100">
                                                      <span class="wordBreak"
                                                        *ngIf="ImageInfo.controls['type'].value==1">
                                                        <calsoft-image fxFlex="100" style="padding-bottom: 10px;"
                                                          (deleteResult)="updatesImageArray($event, i,'customField20',y)"
                                                          (fileUploadResult)="
                                                          getResultArray($event, i,'customField24',y)" [index]="i"
                                                          [value]="ImageInfo.controls['customField24'].value">
                                                        </calsoft-image>
                                                      </span>
                                                    </td>
                                                    <td data-th="Filename" fxFlex="100">
                                                      <ng-container data-th="Filename" fxFlex="100"
                                                        *ngIf="ImageInfo.controls['type'].value==2">
                                                        <mat-form-field fxFlex="100" appearance="outline">
                                                          <mat-label>Video Id</mat-label>
                                                          <input [attr.guide]="'template-inp-img' + '__' + sanitizedUrl"
                                                            (keydown.enter)="$event.preventDefault()"
                                                            [autocomplete]="'off'" trim="blur" matInput
                                                            formControlName="img" required />
                                                          <mat-error *ngIf="ImageInfo.controls.img.errors?.required">
                                                            Please fill out this field.
                                                          </mat-error>
                                                        </mat-form-field>
                                                      </ng-container>
                                                    </td>
                                                    <td>
                                                      <ng-container>
                                                        <mat-form-field>
                                                          <mat-label>Type</mat-label>
                                                          <mat-select required formControlName="type" name="item">
                                                            <mat-option *ngFor="
                                                        let item of textWithImage;
                                                        let i = index
                                                      " [value]="item.value">
                                                              {{ item.viewValue }}
                                                            </mat-option>
                                                          </mat-select>
                                                        </mat-form-field>
                                                      </ng-container>
                                                    </td>

                                                    <td>
                                                      <ng-container>
                                                        <mat-form-field>
                                                          <mat-label>Navigation</mat-label>
                                                          <mat-select required
                                                            (selectionChange)="doSomething($event,i,'catId')"
                                                            formControlName="navigation" name="item">
                                                            <mat-option *ngFor="
                                                        let item of navigation;
                                                        let i = index
                                                      " [value]="item.value">
                                                              {{ item.viewValue }}
                                                            </mat-option>
                                                          </mat-select>
                                                        </mat-form-field>
                                                      </ng-container>
                                                    </td>

                                                    <td>
                                                      <mat-form-field>

                                                        <mat-label>
                                                          {{ImageInfo.controls['navigation'].value==0?'Category':'Url'}}
                                                        </mat-label>

                                                        <mat-select *ngIf="ImageInfo.controls['navigation'].value==0"
                                                          required formControlName="catId"
                                                          [disableOptionCentering]="true" #singleSelect name="item">
                                                          <mat-option>
                                                            <ngx-mat-select-search name="Category Search"
                                                              ngDefaultControl [formControl]="
                                                      categoryFilterControl
                                                    " placeholderLabel="Category Search"
                                                              [preventHomeEndKeyPropagation]="
                                                      true
                                                    " noEntriesFoundLabel="No data found">
                                                            </ngx-mat-select-search>
                                                          </mat-option>
                                                          <mat-option *ngFor="
                                                    let opt of filteredCategoryTypeList
                                                  " [value]="opt.categoryId">
                                                            {{ opt.categoryName }}
                                                          </mat-option>
                                                        </mat-select>


                                                        <input
                                                          [attr.guide]="'template-inp-navigatedurl' + '__' + sanitizedUrl"
                                                          *ngIf="ImageInfo.controls['navigation'].value==1" trim="blur"
                                                          (keydown.enter)="$event.preventDefault()"
                                                          [autocomplete]="'off'" matInput
                                                          formControlName="navigatedUrl" />


                                                      </mat-form-field>

                                                    </td>

                                                  </tr>

                                                  <tr fxLayout="row" fxLayoutGap="10px" fxLayout.xs="column"
                                                    *ngIf="ImageInfo.controls.customField3.value == 'TextWithImage'">
                                                    <td fxFlex="50">
                                                      <mat-form-field fxFlex appearance="outline">
                                                        <mat-label>Inner Text</mat-label>
                                                        <textarea
                                                          [attr.guide]="'template-sel-customfield1' + '__' + sanitizedUrl"
                                                          trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                          matAutosizeMaxRows=5 matInput formControlName="customField1"
                                                          require d></textarea>
                                                        <mat-icon class="clickable"
                                                          (click)="openEditorTextForImageArray(ImageInfo.controls['customField1'].value,i,'customField1',y)"
                                                          matSuffix>
                                                          post_add
                                                        </mat-icon>
                                                        <mat-hint fxHide.lt-md>Click on the icon to open
                                                          editor</mat-hint>
                                                      </mat-form-field>
                                                    </td>
                                                    <td>
                                                      <mat-form-field fxFlex appearance="outline">
                                                        <mat-label>Button Name</mat-label>
                                                        <input
                                                          [attr.guide]="'template-inp-customfield5' + '__' + sanitizedUrl"
                                                          (keydown.enter)="$event.preventDefault()"
                                                          [autocomplete]="'off'" trim="blur" matInput
                                                          formControlName="customField5" />

                                                      </mat-form-field>
                                                    </td>
                                                    <td>
                                                      <mat-form-field fxFlex appearance="outline">
                                                        <mat-label>Button Radius</mat-label>
                                                        <input
                                                          [attr.guide]="'template-inp-customfield11' + '__' + sanitizedUrl"
                                                          (keydown.enter)="$event.preventDefault()"
                                                          [autocomplete]="'off'" trim="blur" matInput
                                                          formControlName="customField11" />

                                                      </mat-form-field>
                                                    </td>

                                                    <td *ngIf="ImageInfo.controls.customField3.value == 'TextWithImage'"
                                                      fxFlex="10">
                                                      <button [attr.guide]="'template-btn-47' + '__' + sanitizedUrl"
                                                        [disabled]="!updatepermission" mat-icon-button color="warn"
                                                        (click)="removeOption(i)">
                                                        <mat-icon>remove_circle_outline</mat-icon>
                                                      </button>
                                                    </td>

                                                  </tr>

                                                  <tr fxLayout="row">
                                                    <td fxFlex="100"
                                                      *ngIf="ImageInfo.controls.customField3.value == 'Image' || ImageInfo.controls.customField3.value == 'Imagewithtitle'">
                                                      <div class="editSets">
                                                        <div class="title-head3" color="primary">
                                                          <span>Image</span>
                                                        </div>
                                                        <div id="responsieTable" class="container"
                                                          style="overflow-x: auto;">
                                                          <table class="rwd-table">
                                                            <tbody>
                                                              <tr>
                                                                <th>Image</th>
                                                                <th>Filename</th>
                                                                <th>Title1</th>
                                                                <th
                                                                  *ngIf="ImageInfo.controls.customField3.value == 'Imagewithtitle'">
                                                                  Description 1</th>
                                                                <th>Navigation</th>
                                                                <th>Category</th>
                                                                <th>Action</th>
                                                              </tr>
                                                              <ng-container formArrayName="subChild">
                                                                <tr *ngFor="let subChildImageInfo of ImageInfo.get('subChild')?.controls;
                                                               let k = index">
                                                                  <ng-container [formGroupName]="k">
                                                                    <td data-th="Image" style="width: 60%;">
                                                                      <!-- <img style="height: 65px;width: auto;"
                                                                        [src]="bannerServerPath+ subChildImageInfo.controls['customField6'].value"
                                                                        onerror="this.src='assets/images/logo/no-image.png';"
                                                                        alt=""> -->

                                                                      <calsoft-common-images
                                                                        [src]="bannerServerPath+ subChildImageInfo.controls['customField6'].value"
                                                                        [height]="'65px'" [width]="'auto'" [alt]="">

                                                                      </calsoft-common-images>
                                                                    </td>
                                                                    <td data-th="Filename" style="width: 90%;">
                                                                      <span class="wordBreak">
                                                                        {{
                                                                        subChildImageInfo.controls['customField6'].value}}
                                                                      </span>
                                                                    </td>

                                                                    <td>
                                                                      <!-- <calsoft-image style="padding-bottom: 10px;"
                                                                        (deleteResult)="updatesImageArray($event, i,'customField8',k)"
                                                                        (fileUploadResult)="
                                                              getResultArray($event, i,'customField8',k) " [index]="k"
                                                                        [value]="subChildImageInfo.controls['customField8'].value">
                                                                      </calsoft-image> -->

                                                                    </td>

                                                                    <td data-th="Title1" style="width: 50%;">
                                                                      <span class="wordBreak">
                                                                        <mat-form-field fxFlex appearance="outline">
                                                                          <mat-label>title1</mat-label>
                                                                          <input
                                                                            [attr.guide]="'template-inp-customfield7' + '__' + sanitizedUrl"
                                                                            trim="blur"
                                                                            (keydown.enter)="$event.preventDefault()"
                                                                            [autocomplete]="'off'" matInput
                                                                            formControlName="customField7" />
                                                                        </mat-form-field>
                                                                      </span>
                                                                    </td>

                                                                    <td data-th="Description 1" style="width: 50%;"
                                                                      *ngIf="ImageInfo.controls.customField3.value == 'Imagewithtitle'">
                                                                      <span class="wordBreak">
                                                                        <mat-form-field fxFlex appearance="outline">
                                                                          <mat-label>Description 1</mat-label>
                                                                          <input
                                                                            [attr.guide]="'template-inp-customfield8' + '__' + sanitizedUrl"
                                                                            trim="blur"
                                                                            (keydown.enter)="$event.preventDefault()"
                                                                            [autocomplete]="'off'" matInput
                                                                            formControlName="customField8" />
                                                                        </mat-form-field>
                                                                      </span>
                                                                    </td>

                                                                    <td data-th="Filename" class="mobilewidth"
                                                                      style="width: 20%;">
                                                                      <span class="wordBreak">
                                                                        <mat-form-field fxFlex>
                                                                          <mat-label>Navigation</mat-label>
                                                                          <mat-select required
                                                                            formControlName="navigation" name="item">
                                                                            <mat-option *ngFor="
                                                                            let item of navigation;
                                                                            let i = index
                                                                          " [value]="item.value">
                                                                              {{ item.viewValue }}
                                                                            </mat-option>
                                                                          </mat-select>
                                                                        </mat-form-field>


                                                                      </span>
                                                                    </td>

                                                                    <td fxLayout.xs="column" data-th="Category"
                                                                      class="mobilewidth" style="width: 20%;">
                                                                      <mat-form-field fxFlex>

                                                                        <mat-label>
                                                                          {{subChildImageInfo.controls['navigation'].value
                                                                          ==0?'Category':'Url'}}</mat-label>

                                                                        <mat-select *ngIf="subChildImageInfo.controls['navigation']
                                                                    .value==0" required formControlName="catId"
                                                                          [disableOptionCentering]="true" #singleSelect
                                                                          name="item">
                                                                          <mat-option>
                                                                            <ngx-mat-select-search
                                                                              name="Category Search" ngDefaultControl
                                                                              [formControl]="
                                                                        categoryFilterControl
                                                                      " placeholderLabel="Category Search"
                                                                              [preventHomeEndKeyPropagation]="
                                                                        true
                                                                      " noEntriesFoundLabel="No data found">
                                                                            </ngx-mat-select-search>
                                                                          </mat-option>
                                                                          <mat-option *ngFor="
                                                                      let opt of filteredCategoryTypeList
                                                                    " [value]="opt.categoryId">
                                                                            {{ opt.categoryName }}
                                                                          </mat-option>
                                                                        </mat-select>


                                                                        <input
                                                                          [attr.guide]="'template-inp-navigatedurl' + '__' + sanitizedUrl"
                                                                          *ngIf="subChildImageInfo.controls['navigation']
                                                                    .value==1" trim="blur"
                                                                          (keydown.enter)="$event.preventDefault()"
                                                                          [autocomplete]="'off'" matInput
                                                                          formControlName="navigatedUrl" />


                                                                      </mat-form-field>
                                                                    </td>

                                                                    <td data-th="Action">
                                                                      <button
                                                                        [attr.guide]="'template-btn-48' + '__' + sanitizedUrl"
                                                                        color="warn" mat-icon-button type="button"
                                                                        (click)="updateBannerChild( subChildImageInfo.controls['customField6'].value,i,y,k)">
                                                                        <mat-icon>remove_circle_outline
                                                                        </mat-icon>
                                                                      </button>
                                                                    </td>
                                                                  </ng-container>
                                                                </tr>
                                                              </ng-container>
                                                            </tbody>
                                                          </table>
                                                        </div>
                                                      </div>
                                                      <div class="editSets1">
                                                        <div class="title " fxLayout="row"
                                                          fxLayoutAlign="center center">
                                                          <span
                                                            *ngIf=" _form.value.conditions[i].images[y].subChild.length<=0"
                                                            fxLayoutAlign="center center">No
                                                            Images
                                                            Uploaded</span>
                                                        </div>
                                                        <div
                                                          *ngIf=" _form.value.conditions[i].images[y].subChild.length<=4">
                                                          <calsoft-common-file-upload
                                                            (fileUploadResult)="getResultBannerChild($event, i,y)"
                                                            [type]="'commonSlider'"></calsoft-common-file-upload>
                                                        </div>
                                                      </div>
                                                    </td>
                                                  </tr>

                                                  <tr fxLayout="row">
                                                    <td fxFlex="100"
                                                      *ngIf="ImageInfo.controls.customField3.value == 'Text'">
                                                      <div class="editSets">
                                                        <div class="title-head3" color="primary"
                                                          fxLayoutAlign="space-between center">
                                                          <span>Text</span>
                                                          <button [attr.guide]="'template-btn-49' + '__' + sanitizedUrl"
                                                            class="create" (click)="addImagesArraySub(i,y)"
                                                            type="button" mat-mini-fab color="primary">
                                                            <mat-icon>add</mat-icon>
                                                          </button>
                                                        </div>
                                                        <div id="responsieTable" class="container"
                                                          style="overflow-x: auto;">
                                                          <table class="rwd-table">
                                                            <tbody>
                                                              <tr>
                                                                <th>Text Content</th>
                                                                <th *ngIf=" comp.controls.customField13.value == '5'">
                                                                  Title</th>
                                                                <th *ngIf=" comp.controls.customField13.value == '5'">
                                                                  Button</th>
                                                                <th *ngIf=" comp.controls.customField13.value == '5'">
                                                                  Image1</th>
                                                                <th *ngIf=" comp.controls.customField13.value == '5'">
                                                                  Image2</th>
                                                                <th>Action</th>
                                                              </tr>


                                                              <ng-container formArrayName="subChild">
                                                                <tr fxLayout="row" fxLayout.xs="column"
                                                                  *ngFor="let subChildImageInfo of ImageInfo.get('subChild')?.controls; let M = index">
                                                                  <ng-container [formGroupName]="M">
                                                                    <td data-th="Filename" style="width: 90%;"
                                                                      *ngIf=" comp.controls.customField13.value != '8'">
                                                                      <span class="wordBreak">
                                                                        <mat-form-field fxFlex appearance="outline">
                                                                          <mat-label>Text Content</mat-label>
                                                                          <input
                                                                            [attr.guide]="'template-inp-customfield19' + '__' + sanitizedUrl"
                                                                            trim="blur"
                                                                            (keydown.enter)="$event.preventDefault()"
                                                                            [autocomplete]="'off'" matInput
                                                                            formControlName="customField19" />
                                                                          <mat-icon class="clickable"
                                                                            (click)="openEditorTextForSubChildArray(subChildImageInfo.controls['customField19'].value,i,'customField19', M, y)"
                                                                            matSuffix>
                                                                            post_add
                                                                          </mat-icon>
                                                                        </mat-form-field>
                                                                      </span>
                                                                    </td>

                                                                    <td data-th="Title" style="width: 20%;"
                                                                      *ngIf=" comp.controls.customField13.value == '8'">
                                                                      <mat-form-field fxFlex appearance="outline">
                                                                        <mat-label>Title</mat-label>
                                                                        <input
                                                                          [attr.guide]="'template-inp-customfield5' + '__' + sanitizedUrl"
                                                                          (keydown.enter)="$event.preventDefault()"
                                                                          [autocomplete]="'off'" trim="blur" matInput
                                                                          formControlName="customField5" />

                                                                      </mat-form-field>
                                                                    </td>

                                                                    <td style="width: 20%;" data-th="Button"
                                                                      *ngIf=" comp.controls.customField13.value == '8'">
                                                                      <mat-form-field fxFlex appearance="outline">
                                                                        <mat-label>Button Name</mat-label>
                                                                        <input
                                                                          [attr.guide]="'template-inp-customfield6' + '__' + sanitizedUrl"
                                                                          (keydown.enter)="$event.preventDefault()"
                                                                          [autocomplete]="'off'" trim="blur" matInput
                                                                          formControlName="customField6" />

                                                                      </mat-form-field>
                                                                    </td>

                                                                    <td data-th="Image1" style="width: 30%;"
                                                                      *ngIf=" comp.controls.customField13.value == '8'">
                                                                      <calsoft-image style="padding-bottom: 10px;"
                                                                        (deleteResult)="updatesImageArraySubschild($event, i,'customField8',y,M)"
                                                                        (fileUploadResult)="
                                                                          getResultArraySubChild($event, i,'customField8',y,M) "
                                                                        [index]="M"
                                                                        [value]="subChildImageInfo.controls['customField8'].value">
                                                                      </calsoft-image>
                                                                    </td>

                                                                    <td data-th="Image2" style="width: 30%;"
                                                                      *ngIf=" comp.controls.customField13.value == '8'">
                                                                      <calsoft-image style="padding-bottom: 10px;"
                                                                        (deleteResult)="updatesImageArraySubschild($event, i,'customField9',y,M)"
                                                                        (fileUploadResult)="
                                                                          getResultArraySubChild($event, i,'customField9',y,M) "
                                                                        [index]="M"
                                                                        [value]="subChildImageInfo.controls['customField9'].value">
                                                                      </calsoft-image>
                                                                    </td>

                                                                    <td data-th="Action">
                                                                      <button
                                                                        [attr.guide]="'template-btn-50' + '__' + sanitizedUrl"
                                                                        color="warn" mat-icon-button type="button"
                                                                        (click)="updateBannerChild(subChildImageInfo.controls['customField6'].value,i,y,M)">
                                                                        <mat-icon>remove_circle_outline
                                                                        </mat-icon>
                                                                      </button>
                                                                    </td>

                                                                  </ng-container>
                                                                </tr>
                                                              </ng-container>
                                                            </tbody>
                                                          </table>
                                                        </div>
                                                      </div>
                                                    </td>
                                                  </tr>

                                                </div>

                                              </ng-container>
                                            </ng-container>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="(comp.controls['type'].value == 'servicePlan')">

                                    <mat-form-field fxFlex>
                                      <mat-label>Title Web Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield31' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        trim="blur" formControlName="customField31" matInput />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Title Mobile Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield32' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        trim="blur" formControlName="customField32" matInput />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Title 2 Web Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield33' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        trim="blur" formControlName="customField33" matInput />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Title 2 Mobile Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield34' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        trim="blur" formControlName="customField34" matInput />
                                    </mat-form-field>

                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="(comp.controls['type'].value == 'servicePlan')">

                                    <mat-form-field fxFlex>
                                      <mat-label>Bottom Content Web Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield26' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        trim="blur" formControlName="customField26" matInput />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Bottom Content Mobile Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield36' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        trim="blur" formControlName="customField36" matInput />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Bottom Content 2 Web Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield37' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        trim="blur" formControlName="customField37" matInput />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Bottom Content 2 Mobile Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield38' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        trim="blur" formControlName="customField38" matInput />
                                    </mat-form-field>

                                  </div>

                                  <!-- servicePlan -->


                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="(comp.controls['type'].value == 'servicePlan')">
                                    <mat-form-field fxFlex appearance="outline">
                                      <mat-label>Title 2</mat-label>
                                      <input [attr.guide]="'template-inp-customfield15' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        trim="blur" formControlName="customField15" matInput />
                                      <mat-icon class="clickable"
                                        (click)="openEditorText(comp.controls['customField15'].value,i,'customField15')"
                                        matSuffix>
                                        post_add
                                      </mat-icon>
                                    </mat-form-field>

                                    <mat-form-field fxFlex appearance="outline">
                                      <mat-label>Bottom Content</mat-label>
                                      <input [attr.guide]="'template-inp-customfield10' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        trim="blur" formControlName="customField10" matInput />
                                      <mat-icon class="clickable"
                                        (click)="openEditorText(comp.controls['customField10'].value,i,'customField10')"
                                        matSuffix>
                                        post_add
                                      </mat-icon>
                                    </mat-form-field>

                                    <mat-form-field fxFlex appearance="outline">
                                      <mat-label>Navigation Url</mat-label>
                                      <input [attr.guide]="'template-inp-customfield11' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        trim="blur" formControlName="customField11" matInput />
                                      <mat-icon class="clickable"
                                        (click)="openEditorText(comp.controls['customField11'].value,i,'customField11')"
                                        matSuffix>
                                        post_add
                                      </mat-icon>
                                    </mat-form-field>


                                  </div>


                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="(comp.controls['type'].value == 'servicePlan')">
                                    <mat-form-field fxFlex appearance="outline">
                                      <mat-label>Bottom Content2</mat-label>
                                      <input [attr.guide]="'template-inp-customfield12' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        trim="blur" formControlName="customField12" matInput />
                                      <mat-icon class="clickable"
                                        (click)="openEditorText(comp.controls['customField12'].value,i,'customField12')"
                                        matSuffix>
                                        post_add
                                      </mat-icon>
                                    </mat-form-field>

                                    <mat-form-field fxFlex appearance="outline">
                                      <mat-label>Navigation Url</mat-label>
                                      <input [attr.guide]="'template-inp-customfield14' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        trim="blur" formControlName="customField14" matInput />
                                      <mat-icon class="clickable"
                                        (click)="openEditorText(comp.controls['customField14'].value,i,'customField14')"
                                        matSuffix>
                                        post_add
                                      </mat-icon>
                                    </mat-form-field>

                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="(comp.controls['type'].value == 'servicePlan')">
                                    <mat-form-field fxFlex="30" appearance="outline"
                                      *ngIf="(comp.controls.customField13.value != '3')">
                                      <mat-label>View Detail Page</mat-label>
                                      <mat-select formControlName="customField16">
                                        <mat-option *ngFor="let status of booleanFieldString1" [value]="status.value">
                                          {{status.viewValue}}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>

                                    <mat-form-field *ngIf="(comp.controls['type'].value == 'servicePlan') " fxFlex="30"
                                      appearance="outline">
                                      <mat-label>Service Type</mat-label>
                                      <mat-select formControlName="customField13">
                                        <mat-option *ngFor="let status of tabheaderType" [value]="status.value">
                                          {{status.viewValue}}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>

                                    <mat-form-field fxFlex appearance="outline"
                                      *ngIf="(comp.controls.customField13.value != '3')">
                                      <mat-label>Label Name</mat-label>
                                      <input [attr.guide]="'template-inp-customfield4' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        trim="blur" formControlName="customField4" matInput />
                                    </mat-form-field>

                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="(comp.controls['type'].value == 'servicePlan')">

                                    <mat-form-field fxFlex>
                                      <mat-label>Title 1 Web Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield39' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        trim="blur" formControlName="customField39" matInput />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Title 1 Mobile Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield40' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        trim="blur" formControlName="customField40" matInput />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Description Web Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield29' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        trim="blur" formControlName="customField29" matInput />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Description Mobile Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield30' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        trim="blur" formControlName="customField30" matInput />
                                    </mat-form-field>

                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="(comp.controls['type'].value == 'servicePlan')">


                                    <mat-form-field fxFlex>
                                      <mat-label>Scope Title Web Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield27' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        trim="blur" formControlName="customField27" matInput />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Scope Title Mobile Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield28' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        trim="blur" formControlName="customField28" matInput />
                                    </mat-form-field>

                                  </div>

                                  <div *ngIf="(comp.controls['type'].value == 'servicePlan')">

                                    <div class="editSets">
                                      <div class="title-head3" fxLayoutAlign="space-between center" color="primary">
                                        <span>Service Plan</span>

                                        <button [attr.guide]="'template-btn-51' + '__' + sanitizedUrl" class="create"
                                          (click)="addImages(i)" type="button" mat-mini-fab color="primary">
                                          <mat-icon>add</mat-icon>
                                        </button>
                                      </div>

                                      <div id="responsieTable" class="container">
                                        <table fxFlex="100" class="padding-10">
                                          <tbody fxFlex="100">
                                            <ng-container formArrayName="images">
                                              <ng-container
                                                *ngFor="let ImageInfo of comp.get('images')?.controls; let y = index">
                                                <div [formGroupName]="y">
                                                  <tr fxLayout.xs="column" fxLayout="row">
                                                    <ng-container fxLayoutAlign="space-between center">
                                                      <td fxFlex data-th="Filename" fxLayoutGap="10px">
                                                        <span class="wordBreak">
                                                          <div style="display: flex; gap: 20px;">
                                                            <mat-form-field fxFlex appearance="outline">
                                                              <mat-label>Title 1</mat-label>
                                                              <input
                                                                [attr.guide]="'template-inp-customfield4' + '__' + sanitizedUrl"
                                                                (keydown.enter)="$event.preventDefault()" trim="blur"
                                                                [autocomplete]="'off'" trim="blur"
                                                                formControlName="customField4" matInput />
                                                              <mat-icon class="clickable"
                                                                (click)="openEditorTextForImageArray(ImageInfo.controls['customField4'].value,i,'customField4',y)"
                                                                matSuffix>
                                                                post_add
                                                              </mat-icon>
                                                            </mat-form-field>
                                                          </div>
                                                        </span>
                                                      </td>
                                                      <td fxFlex data-th="Filename" fxLayoutGap="10px">
                                                        <span class="wordBreak">
                                                          <div style="display: flex; gap: 20px;">
                                                            <mat-form-field fxFlex appearance="outline">
                                                              <mat-label>Description</mat-label>
                                                              <input
                                                                [attr.guide]="'template-inp-customfield6' + '__' + sanitizedUrl"
                                                                (keydown.enter)="$event.preventDefault()" trim="blur"
                                                                [autocomplete]="'off'" trim="blur"
                                                                formControlName="customField6" matInput />
                                                              <mat-icon class="clickable"
                                                                (click)="openEditorTextForImageArray(ImageInfo.controls['customField6'].value,i,'customField6',y)"
                                                                matSuffix>
                                                                post_add
                                                              </mat-icon>
                                                            </mat-form-field>
                                                          </div>
                                                        </span>
                                                      </td>
                                                      <td *ngIf="(comp.controls.customField13.value == '3')">
                                                        <mat-form-field fxFlex appearance="outline">
                                                          <mat-label>Bottom Content</mat-label>
                                                          <input
                                                            [attr.guide]="'template-inp-customfield10' + '__' + sanitizedUrl"
                                                            (keydown.enter)="$event.preventDefault()" trim="blur"
                                                            [autocomplete]="'off'" trim="blur"
                                                            formControlName="customField10" matInput />
                                                          <mat-icon class="clickable"
                                                            (click)="openEditorText(comp.controls['customField10'].value,i,'customField10')"
                                                            matSuffix>
                                                            post_add
                                                          </mat-icon>
                                                        </mat-form-field>
                                                      </td>

                                                      <td fxLayoutAlign.xs="center center" data-th="Action">
                                                        <span class="wordBreak">
                                                          <button [attr.guide]="'template-btn-52' + '__' + sanitizedUrl"
                                                            color="warn" mat-icon-button type="button"
                                                            (click)="deleteText(i,y)">
                                                            <mat-icon>remove_circle_outline
                                                            </mat-icon>
                                                          </button>
                                                        </span>
                                                      </td>
                                                    </ng-container>
                                                  </tr>

                                                  <tr fxLayout.xs="column" fxLayout="row">

                                                    <td *ngIf="(comp.controls.customField13.value == '3')">
                                                      <mat-form-field fxFlex appearance="outline">
                                                        <mat-label>Navigation Url</mat-label>
                                                        <input
                                                          [attr.guide]="'template-inp-customfield11' + '__' + sanitizedUrl"
                                                          (keydown.enter)="$event.preventDefault()" trim="blur"
                                                          [autocomplete]="'off'" trim="blur"
                                                          formControlName="customField11" matInput />
                                                        <mat-icon class="clickable"
                                                          (click)="openEditorText(comp.controls['customField11'].value,i,'customField11')"
                                                          matSuffix>
                                                          post_add
                                                        </mat-icon>
                                                      </mat-form-field>
                                                    </td>
                                                    <td *ngIf="(comp.controls.customField13.value == '3')" fxFlex
                                                      data-th="Filename" fxLayoutGap="10px">
                                                      <span class="wordBreak">
                                                        <div fxFlex="100" style=" gap: 20px;">
                                                          <calsoft-image style="padding-bottom: 10px;"
                                                            (deleteResult)="updatesImageArray($event, i,'customField20',y)"
                                                            (fileUploadResult)="
                                                  getResultArray($event, i,'customField20',y) " [index]="y"
                                                            [value]="ImageInfo.controls['customField20'].value">
                                                          </calsoft-image>
                                                        </div>
                                                      </span>
                                                    </td>
                                                  </tr>

                                                  <tr fxLayout="row" *ngIf="(comp.controls.customField13.value == '3')">
                                                    <td fxFlex="100">
                                                      <div class="editSets">
                                                        <div class="title-head3" fxLayoutAlign="space-between center"
                                                          color="primary">
                                                          <span>Item</span>

                                                          <button [attr.guide]="'template-btn-53' + '__' + sanitizedUrl"
                                                            class="create" (click)="addImagesArraySub(i,y)"
                                                            type="button" mat-mini-fab color="primary">
                                                            <mat-icon>add</mat-icon>
                                                          </button>

                                                        </div>
                                                        <div id="responsieTable" class="container">
                                                          <table fxFlex="100" class="padding-10">
                                                            <tbody fxFlex="100">
                                                              <tr>
                                                                <th>Product Item</th>
                                                              </tr>
                                                              <ng-container formArrayName="subChild">
                                                                <tr fxLayout.xs="column" fxLayout="row"
                                                                  *ngFor="let SubImageInfo of ImageInfo.get('subChild')?.controls; let c = index">
                                                                  <ng-container [formGroupName]="c">

                                                                    <td fxFlex data-th="Filename" fxLayoutGap="10px">
                                                                      <span class="wordBreak">
                                                                        <div style="display: flex; gap: 20px;">
                                                                          <mat-form-field fxFlex appearance="outline">
                                                                            <mat-label>Title</mat-label>
                                                                            <input
                                                                              [attr.guide]="'template-inp-customfield1' + '__' + sanitizedUrl"
                                                                              (keydown.enter)="$event.preventDefault()"
                                                                              trim="blur" [autocomplete]="'off'"
                                                                              trim="blur" formControlName="customField1"
                                                                              matInput />
                                                                            <mat-icon class="clickable"
                                                                              (click)="openEditorTextForImageArray(SubImageInfo.controls['customField1'].value,y,'customField1',c)"
                                                                              matSuffix>
                                                                              post_add
                                                                            </mat-icon>
                                                                          </mat-form-field>
                                                                        </div>
                                                                      </span>
                                                                    </td>
                                                                    <td fxFlex data-th="Filename" fxLayoutGap="10px">
                                                                      <span class="wordBreak">
                                                                        <div style="display: flex; gap: 20px;">
                                                                          <mat-form-field fxFlex appearance="outline">
                                                                            <mat-label>Navigation Url</mat-label>
                                                                            <input
                                                                              [attr.guide]="'template-inp-customfield11' + '__' + sanitizedUrl"
                                                                              (keydown.enter)="$event.preventDefault()"
                                                                              trim="blur" [autocomplete]="'off'"
                                                                              trim="blur"
                                                                              formControlName="customField11"
                                                                              matInput />
                                                                            <mat-icon class="clickable"
                                                                              (click)="openEditorText(comp.controls['customField11'].value,y,'customField11')"
                                                                              matSuffix>
                                                                              post_add
                                                                            </mat-icon>
                                                                          </mat-form-field>
                                                                        </div>
                                                                      </span>
                                                                    </td>

                                                                    <td data-th="Action">
                                                                      <button
                                                                        [attr.guide]="'template-btn-54' + '__' + sanitizedUrl"
                                                                        color="warn" mat-icon-button type="button"
                                                                        (click)="updateBannerChild(SubImageInfo.controls['customField6'].value,i,y,c)">
                                                                        <mat-icon>remove_circle_outline
                                                                        </mat-icon>
                                                                      </button>
                                                                    </td>
                                                                  </ng-container>
                                                                </tr>
                                                              </ng-container>
                                                            </tbody>
                                                          </table>
                                                        </div>
                                                      </div>
                                                    </td>
                                                  </tr>


                                                </div>

                                              </ng-container>
                                            </ng-container>

                                            <tr fxLayout="row" *ngIf="(comp.controls.customField13.value != '3')">
                                              <td fxFlex="100">
                                                <div class="editSets">
                                                  <div class="title-head3" fxLayoutAlign="space-between center"
                                                    color="primary">
                                                    <span>Scope</span>

                                                    <button [attr.guide]="'template-btn-55' + '__' + sanitizedUrl"
                                                      class="create" (click)="addSub(i)" type="button" mat-mini-fab
                                                      color="primary">
                                                      <mat-icon>add</mat-icon>
                                                    </button>

                                                  </div>
                                                  <div id="responsieTable" class="container">
                                                    <table fxFlex="100" class="padding-10">
                                                      <tbody fxFlex="100">
                                                        <tr>
                                                          <th>Product Scope</th>
                                                        </tr>
                                                        <ng-container formArrayName="layoutSub">
                                                          <tr fxLayout.xs="column" fxLayout="row"
                                                            *ngFor="let SubImageInfo of comp.get('layoutSub')?.controls; let c = index">
                                                            <ng-container [formGroupName]="c">

                                                              <td fxFlex data-th="Filename" fxLayoutGap="10px">
                                                                <span class="wordBreak">
                                                                  <div style="display: flex; gap: 20px;">
                                                                    <mat-form-field fxFlex appearance="outline">
                                                                      <mat-label>Title</mat-label>
                                                                      <input
                                                                        [attr.guide]="'template-inp-customfield1' + '__' + sanitizedUrl"
                                                                        (keydown.enter)="$event.preventDefault()"
                                                                        trim="blur" [autocomplete]="'off'" trim="blur"
                                                                        formControlName="customField1" matInput />
                                                                      <mat-icon class="clickable"
                                                                        (click)="openEditorTextForImageArray(SubImageInfo.controls['customField1'].value,i,'customField1',c)"
                                                                        matSuffix>
                                                                        post_add
                                                                      </mat-icon>
                                                                    </mat-form-field>
                                                                  </div>
                                                                </span>
                                                              </td>


                                                              <td fxFlex data-th="Filename" fxLayoutGap="10px">
                                                                <span class="wordBreak">
                                                                  <div style="display: flex; gap: 20px;">
                                                                    <mat-form-field fxFlex appearance="outline">
                                                                      <mat-label>Custom Product Scope</mat-label>
                                                                      <mat-select formControlName="customField5"
                                                                        [disableOptionCentering]="true" #singleSelect
                                                                        name="item">
                                                                        <mat-option>
                                                                          <ngx-mat-select-search
                                                                            name="Custom Product Scope Search"
                                                                            ngDefaultControl [formControl]="
                                                                      productScopeFilterControl
                                                                        " placeholderLabel="Product Scope Search"
                                                                            [preventHomeEndKeyPropagation]="
                                                                          true
                                                                        " noEntriesFoundLabel="No data found">
                                                                          </ngx-mat-select-search>
                                                                        </mat-option>
                                                                        <mat-option
                                                                          (onSelectionChange)="setProductScopeLayoutSub($event,opt,'customField20',i,c)"
                                                                          *ngFor="let opt of filteredproductScopeTypeList;"
                                                                          [value]="opt.customProductScopeId">
                                                                          {{ opt.type }}
                                                                        </mat-option>
                                                                      </mat-select>
                                                                    </mat-form-field>
                                                                  </div>
                                                                </span>
                                                              </td>

                                                              <td data-th="Action">
                                                                <button
                                                                  [attr.guide]="'template-btn-56' + '__' + sanitizedUrl"
                                                                  color="warn" mat-icon-button type="button"
                                                                  (click)="deleteLayoutSub(i,c)">
                                                                  <mat-icon>remove_circle_outline
                                                                  </mat-icon>
                                                                </button>
                                                              </td>
                                                            </ng-container>
                                                          </tr>
                                                        </ng-container>
                                                      </tbody>
                                                    </table>
                                                  </div>
                                                </div>
                                              </td>
                                            </tr>





                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>

                                  <!--dragdrop-->
                                  <div fxLayout.gt-md="row" *ngIf="comp.controls['type'].value == 'dragdrop'"
                                    fxLayout.lt-md="column" fxLayoutGap="10px">
                                    <mat-form-field fxFlex>
                                      <mat-label>Title Web Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield31' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        trim="blur" formControlName="customField31" matInput />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Title Mobile Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield32' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        trim="blur" formControlName="customField32" matInput />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Title 1 Web Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield33' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        trim="blur" formControlName="customField33" matInput />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Title 1 Mobile Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield34' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        trim="blur" formControlName="customField34" matInput />
                                    </mat-form-field>


                                  </div>


                                  <div *ngIf="(comp.controls['type'].value == 'dragdrop')">

                                    <div class="editSets">
                                      <div class="title-head3" fxLayoutAlign="space-between center" color="primary">
                                        <span>Service Plan</span>

                                        <button [attr.guide]="'template-btn-57' + '__' + sanitizedUrl" class="create"
                                          (click)="addImages(i)" type="button" mat-mini-fab color="primary">
                                          <mat-icon>add</mat-icon>
                                        </button>
                                      </div>

                                      <div id="responsieTable" class="container">
                                        <table fxFlex="100" class="padding-10">
                                          <tbody fxFlex="100">
                                            <ng-container formArrayName="images">
                                              <ng-container
                                                *ngFor="let ImageInfo of comp.get('images')?.controls; let y = index">
                                                <div [formGroupName]="y">
                                                  <tr fxLayout="row" fxLayout.xs="column">
                                                    <ng-container fxLayoutAlign="space-between center">
                                                      <td fxFlex data-th="Filename" fxLayoutGap="10px">
                                                        <span class="wordBreak">
                                                          <div style="display: flex; gap: 20px;">
                                                            <mat-form-field fxFlex appearance="outline">
                                                              <mat-label>Title 1</mat-label>
                                                              <input
                                                                [attr.guide]="'template-inp-customfield4' + '__' + sanitizedUrl"
                                                                (keydown.enter)="$event.preventDefault()" trim="blur"
                                                                [autocomplete]="'off'" trim="blur"
                                                                formControlName="customField4" matInput />
                                                              <mat-icon class="clickable"
                                                                (click)="openEditorTextForImageArray(ImageInfo.controls['customField4'].value,i,'customField4',y)"
                                                                matSuffix>
                                                                post_add
                                                              </mat-icon>
                                                            </mat-form-field>
                                                          </div>
                                                        </span>
                                                      </td>
                                                      <td fxFlex data-th="Filename" fxLayoutGap="10px">
                                                        <span class="wordBreak">
                                                          <div style="display: flex; gap: 20px;">
                                                            <mat-form-field fxFlex appearance="outline">
                                                              <mat-label>Id</mat-label>
                                                              <input
                                                                [attr.guide]="'template-inp-customfield6' + '__' + sanitizedUrl"
                                                                (keydown.enter)="$event.preventDefault()" trim="blur"
                                                                [autocomplete]="'off'" trim="blur"
                                                                formControlName="customField6" matInput />
                                                              <mat-icon class="clickable"
                                                                (click)="openEditorTextForImageArray(ImageInfo.controls['customField6'].value,i,'customField6',y)"
                                                                matSuffix>
                                                                post_add
                                                              </mat-icon>
                                                            </mat-form-field>
                                                          </div>
                                                        </span>
                                                      </td>

                                                      <td data-th="Action">
                                                        <span class="wordBreak">
                                                          <button [attr.guide]="'template-btn-58' + '__' + sanitizedUrl"
                                                            color="warn" mat-icon-button type="button"
                                                            (click)="deleteText(i,y)">
                                                            <mat-icon>remove_circle_outline
                                                            </mat-icon>
                                                          </button>
                                                        </span>
                                                      </td>
                                                    </ng-container>
                                                  </tr>



                                                  <tr fxLayout="row">
                                                    <td fxFlex="100">
                                                      <div class="editSets">
                                                        <div class="title-head3" fxLayoutAlign="space-between center"
                                                          color="primary">
                                                          <span>Item</span>

                                                          <button [attr.guide]="'template-btn-59' + '__' + sanitizedUrl"
                                                            class="create" (click)="addImagesArraySub(i,y)"
                                                            type="button" mat-mini-fab color="primary">
                                                            <mat-icon>add</mat-icon>
                                                          </button>

                                                        </div>
                                                        <div id="responsieTable" class="container">
                                                          <table fxFlex="100" class="padding-10">
                                                            <tbody fxFlex="100">
                                                              <tr>
                                                                <th>Product Item</th>
                                                              </tr>
                                                              <ng-container formArrayName="subChild">
                                                                <tr fxLayout.xs="column"
                                                                  *ngFor="let SubImageInfo of ImageInfo.get('subChild')?.controls; let c = index">
                                                                  <ng-container [formGroupName]="c">

                                                                    <td fxFlex data-th="Filename" fxLayoutGap="10px">
                                                                      <span class="wordBreak">
                                                                        <div style="display: flex; gap: 20px;">
                                                                          <mat-form-field fxFlex appearance="outline">
                                                                            <mat-label *ngIf="false">Title</mat-label>
                                                                            <input
                                                                              [attr.guide]="'template-inp-customfield1' + '__' + sanitizedUrl"
                                                                              (keydown.enter)="$event.preventDefault()"
                                                                              trim="blur" [autocomplete]="'off'"
                                                                              trim="blur" formControlName="customField1"
                                                                              matInput />
                                                                            <mat-icon class="clickable"
                                                                              (click)="openEditorTextForImageArray(SubImageInfo.controls['customField1'].value,y,'customField1',c)"
                                                                              matSuffix>
                                                                              post_add
                                                                            </mat-icon>
                                                                          </mat-form-field>
                                                                        </div>
                                                                      </span>
                                                                    </td>


                                                                    <td data-th="Action">
                                                                      <button
                                                                        [attr.guide]="'template-btn-60' + '__' + sanitizedUrl"
                                                                        color="warn" mat-icon-button type="button"
                                                                        (click)="updateBannerChild(SubImageInfo.controls['customField6'].value,i,y,c)">
                                                                        <mat-icon>remove_circle_outline
                                                                        </mat-icon>
                                                                      </button>
                                                                    </td>
                                                                  </ng-container>
                                                                </tr>
                                                              </ng-container>
                                                            </tbody>
                                                          </table>
                                                        </div>
                                                      </div>
                                                    </td>
                                                  </tr>


                                                </div>

                                              </ng-container>
                                            </ng-container>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>



                                  <!-- customGroupLayout -->
                                  <div *ngIf="(comp.controls['type'].value == 'customGroupLayout')">

                                    <div class="editSets">
                                      <div class="title-head3" fxLayoutAlign="space-between center" color="primary">
                                        <span>Custom Group Layout</span>

                                        <button [attr.guide]="'template-btn-61' + '__' + sanitizedUrl"
                                          [disabled]="_form.value.conditions[i].images.length>3" class="create"
                                          (click)="addcustomGroupLayout(i)" type="button" mat-mini-fab color="primary">
                                          <mat-icon>add</mat-icon>
                                        </button>
                                      </div>

                                      <div id="responsieTable" class="container">
                                        <table fxFlex="100" class="padding-10">
                                          <tbody fxFlex="100">
                                            <ng-container formArrayName="images">
                                              <ng-container
                                                *ngFor="let ImageInfo of comp.get('images')?.controls; let y = index">

                                                <div [formGroupName]="y">


                                                  <tr fxLayout.xs="column" fxLayout="row">
                                                    <ng-container fxLayoutAlign="space-between center">
                                                      <td fxFlex="50" data-th="Filename" fxLayoutGap="10px">
                                                        <span class="wordBreak">
                                                          <div style="display: flex; gap: 20px;">
                                                            <mat-form-field fxFlex appearance="outline">
                                                              <mat-label>Tab Name</mat-label>
                                                              <input
                                                                [attr.guide]="'template-inp-customfield15' + '__' + sanitizedUrl"
                                                                (keydown.enter)="$event.preventDefault()" trim="blur"
                                                                [autocomplete]="'off'" trim="blur"
                                                                formControlName="customField15" matInput />
                                                            </mat-form-field>
                                                          </div>
                                                        </span>
                                                      </td>
                                                      <td fxFlex="50" data-th="Filename" fxLayoutGap="10px">
                                                        <span class="wordBreak">
                                                          <div style="display: flex">
                                                            <mat-form-field fxFlex appearance="outline">
                                                              <mat-label>Type</mat-label>
                                                              <mat-select required formControlName="customField3"
                                                                name="item">
                                                                <mat-option
                                                                  *ngFor="let item of tablayout1; let i = index"
                                                                  [value]="item.value">
                                                                  {{ item.viewValue }}
                                                                </mat-option>
                                                              </mat-select>
                                                            </mat-form-field>
                                                          </div>
                                                        </span>
                                                      </td>
                                                      <td fxFlex="50" data-th="Filename" fxLayoutGap="10px"
                                                        *ngIf="ImageInfo.controls.customField3.value == 'Category'">
                                                        <span class="wordBreak">
                                                          <div style="display: flex; gap: 20px;">
                                                            <mat-form-field fxFlex appearance="outline">
                                                              <mat-label>Category</mat-label>
                                                              <mat-select required formControlName="customField4"
                                                                [disableOptionCentering]="true" #singleSelect
                                                                name="item">
                                                                <mat-option>
                                                                  <ngx-mat-select-search name="Category Search"
                                                                    ngDefaultControl [formControl]="
                                                  categoryFilterControl
                                                " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                  true
                                                " noEntriesFoundLabel="No data found">
                                                                  </ngx-mat-select-search>
                                                                </mat-option>
                                                                <mat-option *ngFor="
                                                let opt of filteredCategoryTypeList
                                              " [value]="opt.categoryId">
                                                                  {{ opt.categoryName }}
                                                                </mat-option>
                                                              </mat-select>
                                                            </mat-form-field>
                                                          </div>
                                                        </span>
                                                      </td>


                                                      <td fxFlex="50" data-th="Filename" fxLayoutGap="10px"
                                                        *ngIf="ImageInfo.controls.customField3.value == 'ProductScope'">
                                                        <span class="wordBreak">
                                                          <div style="display: flex; gap: 20px;">
                                                            <mat-form-field fxFlex appearance="outline">
                                                              <mat-label>Custom Product Scope</mat-label>
                                                              <mat-select required formControlName="customField5"
                                                                [disableOptionCentering]="true" #singleSelect
                                                                name="item">
                                                                <mat-option>
                                                                  <ngx-mat-select-search
                                                                    name="Custom Product Scope Search" ngDefaultControl
                                                                    [formControl]="
                                                                productScopeFilterControl
                                                                  " placeholderLabel="Product Scope Search"
                                                                    [preventHomeEndKeyPropagation]="
                                                                    true
                                                                  " noEntriesFoundLabel="No data found">
                                                                  </ngx-mat-select-search>
                                                                </mat-option>
                                                                <mat-option
                                                                  (onSelectionChange)="setProductScopeChild($event,opt,'customField20',i,y)"
                                                                  *ngFor="let opt of filteredproductScopeTypeList;"
                                                                  [value]="opt.customProductScopeId">
                                                                  {{ opt.type }}
                                                                </mat-option>
                                                              </mat-select>
                                                              <mat-error *ngIf="
                                                                comp.controls.value.errors?.required
                                                              ">
                                                                Please fill out this field.
                                                              </mat-error>
                                                            </mat-form-field>
                                                          </div>
                                                        </span>
                                                      </td>



                                                      <td data-th="Action">
                                                        <span class="wordBreak">
                                                          <button [attr.guide]="'template-btn-62' + '__' + sanitizedUrl"
                                                            color="warn" mat-icon-button type="button"
                                                            (click)="deleteText(i,y)">
                                                            <mat-icon>remove_circle_outline
                                                            </mat-icon>
                                                          </button>
                                                        </span>
                                                      </td>
                                                    </ng-container>
                                                  </tr>
                                                  <tr fxLayout.xs="column" fxLayout="row">
                                                    <td fxFlex data-th="Filename" fxLayoutGap="10px"
                                                      *ngIf="ImageInfo.controls.customField3.value != 'Image'">
                                                      <span class="wordBreak">
                                                        <div style="display: flex; gap: 20px;">
                                                          <mat-form-field fxFlex appearance="outline">
                                                            <mat-label>SortOrder</mat-label>
                                                            <mat-select required formControlName="customField18"
                                                              name="item">
                                                              <mat-option *ngFor="let item of sortings; let i = index"
                                                                [value]="item.value">
                                                                {{ item.viewValue }}
                                                              </mat-option>
                                                            </mat-select>
                                                          </mat-form-field>
                                                        </div>
                                                      </span>
                                                    </td>
                                                  </tr>
                                                  <tr fxLayout.xs="column" fxLayout="row">
                                                    <td fxFlex="50" data-th="Filename" fxLayoutGap="10px">
                                                      <span class="wordBreak">
                                                        <div style="display: flex; gap: 20px;">
                                                          <mat-form-field fxFlex appearance="outline">
                                                            <mat-label>Tab Font Size</mat-label>
                                                            <input
                                                              [attr.guide]="'template-inp-customfield16' + '__' + sanitizedUrl"
                                                              (keydown.enter)="$event.preventDefault()" trim="blur"
                                                              [autocomplete]="'off'" trim="blur"
                                                              formControlName="customField16" matInput />
                                                          </mat-form-field>
                                                        </div>
                                                      </span>
                                                    </td>
                                                    <td fxFlex="50" data-th="Filename" fxLayoutGap="10px">
                                                      <span class="wordBreak">
                                                        <div style="display: flex; gap: 20px;">
                                                          <mat-form-field fxFlex appearance="outline">
                                                            <mat-label>Tab Web Font Size</mat-label>
                                                            <input
                                                              [attr.guide]="'template-inp-customfield17' + '__' + sanitizedUrl"
                                                              (keydown.enter)="$event.preventDefault()" trim="blur"
                                                              [autocomplete]="'off'" trim="blur"
                                                              formControlName="customField17" matInput />
                                                          </mat-form-field>
                                                        </div>
                                                      </span>
                                                    </td>
                                                  </tr>
                                                  <tr fxLayout.xs="column" fxLayout="row">
                                                    <td fxFlex data-th="Filename" fxLayoutGap="10px"
                                                      *ngIf="ImageInfo.controls.customField3.value == 'Image'">
                                                      <span class="wordBreak">
                                                        <div style="display: flex; gap: 20px;">
                                                          <calsoft-image fxFlex.xs="100" fxFlex="50"
                                                            style="padding-bottom: 10px;"
                                                            (deleteResult)="updatesImageArray($event, i,'customField6',y)"
                                                            (fileUploadResult)="
                                                  getResultArray($event, i,'customField6',y) " [index]="y"
                                                            [value]="ImageInfo.controls['customField6'].value">
                                                          </calsoft-image>
                                                        </div>
                                                      </span>
                                                    </td>
                                                  </tr>
                                                </div>
                                              </ng-container>
                                            </ng-container>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>


                                  <div *ngIf="(comp.controls['type'].value == 'scrollText')">

                                    <div class="editSets">
                                      <div class="title-head3" fxLayoutAlign="space-between center" color="primary">
                                        <span>Scroll Text</span>

                                        <button [attr.guide]="'template-btn-63' + '__' + sanitizedUrl" class="create"
                                          (click)=" addFaq(i)" type="button" mat-mini-fab color="primary">
                                          <mat-icon>add</mat-icon>
                                        </button>
                                      </div>

                                      <div id="responsieTable" class="container">
                                        <table fxFlex="100">
                                          <tbody fxFlex="100">
                                            <ng-container formArrayName="images">
                                              <tr
                                                *ngFor="let ImageInfo of comp.get('images')?.controls;; let y = index">
                                                <ng-container [formGroupName]="y" fxLayoutAlign="space-between center">
                                                  <td fxFlex="90" data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="100" appearance="outline">
                                                        <mat-label>Text</mat-label>
                                                        <textarea
                                                          [attr.guide]="'template-sel-customfield15' + '__' + sanitizedUrl"
                                                          trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                          matAutosizeMaxRows=5 matInput
                                                          formControlName="customField15"></textarea>
                                                        <mat-icon class="clickable"
                                                          (click)="openEditorTextForImageArray(ImageInfo.controls['customField15'].value,i,'customField15',y)"
                                                          matSuffix>
                                                          post_add
                                                        </mat-icon>
                                                      </mat-form-field>
                                                    </span>
                                                  </td>

                                                  <td data-th="Action">
                                                    <span class="wordBreak">
                                                      <button [attr.guide]="'template-btn-64' + '__' + sanitizedUrl"
                                                        color="warn" mat-icon-button type="button"
                                                        (click)="deleteText(i,y)">
                                                        <mat-icon>remove_circle_outline
                                                        </mat-icon>
                                                      </button>
                                                    </span>
                                                  </td>
                                                </ng-container>
                                              </tr>
                                            </ng-container>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>

                                  <div *ngIf="(comp.controls['type'].value == 'CRMComparisonTable')">

                                    <div class="editSets">
                                      <div class="title-head3" fxLayoutAlign="space-between center" color="primary">
                                        <span>Table Information</span>

                                        <button [attr.guide]="'template-btn-65' + '__' + sanitizedUrl" class="create"
                                          (click)=" addFaq(i)" type="button" mat-mini-fab color="primary">
                                          <mat-icon>add</mat-icon>
                                        </button>
                                      </div>

                                      <div id="responsieTable" class="container">
                                        <table fxFlex="100">
                                          <tbody fxFlex="100">
                                            <ng-container formArrayName="images">
                                              <tr
                                                *ngFor="let ImageInfo of comp.get('images')?.controls;; let y = index">
                                                <ng-container [formGroupName]="y" fxLayout="column"
                                                  fxLayoutAlign="space-between center">
                                                  <div fxLayout="row" fxLayout.lt-md="column">
                                                    <td fxFlex data-th="Name" fxLayoutGap="10px">
                                                      <span class="wordBreak">
                                                        <mat-form-field appearance="outline">
                                                          <mat-label>Name</mat-label>
                                                          <textarea
                                                            [attr.guide]="'template-sel-customfield10' + '__' + sanitizedUrl"
                                                            trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                            matAutosizeMaxRows=5 matInput
                                                            formControlName="customField10"></textarea>
                                                          <mat-icon class="clickable"
                                                            (click)="openEditorTextForImageArray(ImageInfo.controls['customField10'].value,i,'customField10',y)"
                                                            matSuffix>
                                                            post_add
                                                          </mat-icon>
                                                        </mat-form-field>
                                                      </span>
                                                    </td>
                                                    <td fxFlex data-th="plan" fxLayoutGap="10px">
                                                      <span class="wordBreak">
                                                        <mat-form-field appearance="outline">
                                                          <mat-label>Plan</mat-label>
                                                          <textarea
                                                            [attr.guide]="'template-sel-customfield11' + '__' + sanitizedUrl"
                                                            trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                            matAutosizeMaxRows=5 matInput
                                                            formControlName="customField11"></textarea>
                                                          <mat-icon class="clickable"
                                                            (click)="openEditorTextForImageArray(ImageInfo.controls['customField11'].value,i,'customField11',y)"
                                                            matSuffix>
                                                            post_add
                                                          </mat-icon>
                                                        </mat-form-field>
                                                      </span>
                                                    </td>
                                                    <td fxFlex data-th="priceperuser" fxLayoutGap="10px">
                                                      <span class="wordBreak">
                                                        <mat-form-field appearance="outline">
                                                          <mat-label>Price Per User</mat-label>
                                                          <textarea
                                                            [attr.guide]="'template-sel-customfield12' + '__' + sanitizedUrl"
                                                            trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                            matAutosizeMaxRows=5 matInput
                                                            formControlName="customField12"></textarea>
                                                          <mat-icon class="clickable"
                                                            (click)="openEditorTextForImageArray(ImageInfo.controls['customField12'].value,i,'customField12',y)"
                                                            matSuffix>
                                                            post_add
                                                          </mat-icon>
                                                        </mat-form-field>
                                                      </span>
                                                    </td>
                                                    <td fxFlex data-th="logo" fxLayoutGap="10px">
                                                      <span class="wordBreak">


                                                        <calsoft-image style="padding-bottom: 10px;"
                                                          (deleteResult)="updatesImageArray($event, i,'customField1 3',y)"
                                                          (fileUploadResult)="
                                              getResultArray($event, i,'customField13',y) " [index]="y"
                                                          [value]="ImageInfo.controls['customField13'].value">
                                                        </calsoft-image>
                                                      </span>
                                                    </td>
                                                  </div>
                                                  <div fxLayout="row" fxLayout.lt-md="column">

                                                    <td fxFlex data-th="Name" fxLayoutGap="10px">
                                                      <span class="wordBreak">
                                                        <mat-form-field appearance="outline">
                                                          <mat-label>Licensing Cost Per User </mat-label>
                                                          <textarea
                                                            [attr.guide]="'template-sel-customfield14' + '__' + sanitizedUrl"
                                                            trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                            matAutosizeMaxRows=5 matInput
                                                            formControlName="customField14"></textarea>
                                                          <mat-icon class="clickable"
                                                            (click)="openEditorTextForImageArray(ImageInfo.controls['customField14'].value,i,'customField14',y)"
                                                            matSuffix>
                                                            post_add
                                                          </mat-icon>
                                                        </mat-form-field>
                                                      </span>
                                                    </td>
                                                    <td fxFlex data-th="Name" fxLayoutGap="10px">
                                                      <span class="wordBreak">
                                                        <mat-form-field appearance="outline">
                                                          <mat-label>Telephony </mat-label>
                                                          <textarea
                                                            [attr.guide]="'template-sel-customfield15' + '__' + sanitizedUrl"
                                                            trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                            matAutosizeMaxRows=5 matInput
                                                            formControlName="customField15"></textarea>
                                                          <mat-icon class="clickable"
                                                            (click)="openEditorTextForImageArray(ImageInfo.controls['customField15'].value,i,'customField15',y)"
                                                            matSuffix>
                                                            post_add
                                                          </mat-icon>
                                                        </mat-form-field>
                                                      </span>
                                                    </td>
                                                    <td fxFlex data-th="Name" fxLayoutGap="10px">
                                                      <span class="wordBreak">
                                                        <mat-form-field appearance="outline">
                                                          <mat-label>Google Analytics Integration </mat-label>
                                                          <textarea
                                                            [attr.guide]="'template-sel-customfield16' + '__' + sanitizedUrl"
                                                            trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                            matAutosizeMaxRows=5 matInput
                                                            formControlName="customField16"></textarea>
                                                          <mat-icon class="clickable"
                                                            (click)="openEditorTextForImageArray(ImageInfo.controls['customField16'].value,i,'customField16',y)"
                                                            matSuffix>
                                                            post_add
                                                          </mat-icon>
                                                        </mat-form-field>
                                                      </span>
                                                    </td>
                                                    <td fxFlex data-th="Name" fxLayoutGap="10px">
                                                      <span class="wordBreak">
                                                        <mat-form-field appearance="outline">
                                                          <mat-label>Sales Productivity Tools </mat-label>
                                                          <textarea
                                                            [attr.guide]="'template-sel-customfield17' + '__' + sanitizedUrl"
                                                            trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                            matAutosizeMaxRows=5 matInput
                                                            formControlName="customField17"></textarea>
                                                          <mat-icon class="clickable"
                                                            (click)="openEditorTextForImageArray(ImageInfo.controls['customField17'].value,i,'customField17',y)"
                                                            matSuffix>
                                                            post_add
                                                          </mat-icon>
                                                        </mat-form-field>
                                                      </span>
                                                    </td>
                                                  </div>


                                                  <td data-th="Action">
                                                    <span class="wordBreak">
                                                      <button [attr.guide]="'template-btn-66' + '__' + sanitizedUrl"
                                                        color="warn" mat-icon-button type="button"
                                                        (click)="deleteText(i,y)">
                                                        <mat-icon>remove_circle_outline
                                                        </mat-icon>
                                                      </button>
                                                    </span>
                                                  </td>
                                                </ng-container>
                                              </tr>
                                            </ng-container>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                  <tr fxLayout="row" *ngIf="(comp.controls['type'].value == 'CRMComparisonTable')">
                                    <td fxFlex="100">
                                      <div class="editSets">
                                        <div class="title-head3" fxLayoutAlign="space-between center" color="primary">
                                          <span>Feature Information </span>

                                          <button [attr.guide]="'template-btn-67' + '__' + sanitizedUrl" class="create"
                                            (click)="addSub(i)" type="button" mat-mini-fab color="primary">
                                            <mat-icon>add</mat-icon>
                                          </button>

                                        </div>
                                        <div id="responsieTable" class="container">
                                          <table fxFlex="100" class="padding-10">
                                            <tbody fxFlex="100">
                                              <tr>
                                                <th>Product Scope</th>
                                              </tr>
                                              <ng-container formArrayName="layoutSub">
                                                <tr fxLayout.xs="column" fxLayout="row"
                                                  *ngFor="let SubImageInfo of comp.get('layoutSub')?.controls; let c = index">
                                                  <ng-container [formGroupName]="c">

                                                    <td fxFlex data-th="FeatureTitle" fxLayoutGap="10px">
                                                      <span class="wordBreak">
                                                        <div style="display: flex; gap: 20px;">
                                                          <mat-form-field fxFlex appearance="outline">
                                                            <mat-label>Enter a Feature</mat-label>
                                                            <input
                                                              [attr.guide]="'template-inp-customfield1' + '__' + sanitizedUrl"
                                                              (keydown.enter)="$event.preventDefault()" trim="blur"
                                                              [autocomplete]="'off'" trim="blur"
                                                              formControlName="customField1" matInput />
                                                            <mat-icon class="clickable"
                                                              (click)="openEditorTextForImageArray(SubImageInfo.controls['customField1'].value,i,'customField1',c)"
                                                              matSuffix>
                                                              post_add
                                                            </mat-icon>
                                                          </mat-form-field>
                                                        </div>
                                                      </span>
                                                    </td>




                                                    <td data-th="Action">
                                                      <button [attr.guide]="'template-btn-68' + '__' + sanitizedUrl"
                                                        color="warn" mat-icon-button type="button"
                                                        (click)="deleteLayoutSub(i,c)">
                                                        <mat-icon>remove_circle_outline
                                                        </mat-icon>
                                                      </button>
                                                    </td>
                                                  </ng-container>
                                                </tr>
                                              </ng-container>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                  <!-- price size table start -->

                                  <div fxLayout="column" *ngIf="(comp.controls['type'].value == 'table')">

                                    <mat-form-field fxFlex>
                                      <mat-label>Select Type</mat-label>
                                      <mat-select formControlName="customField33">
                                        <mat-option *ngFor="let item of tableType" [value]="item.value">
                                          {{item.viewValue}}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>

                                    <mat-form-field fxFlex
                                      *ngIf="(comp.controls.customField33.value == '7') ||  comp.controls.customField33.value == '8' || comp.controls.customField33.value == '12'">
                                      <mat-label>Tax Percentage</mat-label>
                                      <input [attr.guide]="'template-inp-customfield21' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        trim="blur" formControlName="customField21" matInput />
                                    </mat-form-field>

                                    <mat-form-field fxFlex
                                      *ngIf="(comp.controls.customField33.value == '7') || comp.controls.customField33.value == '8' || comp.controls.customField33.value == '12'">
                                      <mat-label>Tax Type</mat-label>
                                      <mat-select formControlName="customField22">
                                        <mat-option *ngFor="let item of taxType" [value]="item.value">
                                          {{item.viewValue}}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>

                                    <mat-form-field fxFlex
                                      *ngIf="(comp.controls.customField33.value == '2' || comp.controls.customField33.value == '13' || comp.controls.customField33.value == '10' )">
                                      <mat-label>Header type</mat-label>
                                      <mat-select formControlName="customField22">
                                        <mat-option *ngFor="let item of tabheaderType" [value]="item.value">
                                          {{item.viewValue}}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>

                                    <mat-form-field fxFlex *ngIf="(comp.controls.customField33.value == '10') ">
                                      <mat-label>Button Background color</mat-label>
                                      <input [attr.guide]="'template-inp-customfield29' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        trim="blur" formControlName="customField29" matInput />
                                    </mat-form-field>

                                    <mat-form-field fxFlex
                                      *ngIf="(comp.controls.customField33.value == '3' || comp.controls['customField33'].value == '14')">
                                      <mat-label>Header Toggle</mat-label>
                                      <mat-select formControlName="customField22">
                                        <mat-option *ngFor="let item of toggleType" [value]="item.value">
                                          {{item.viewValue}}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>

                                    <div fxLayout="row" fxLayoutGap="10"
                                      *ngIf="(comp.controls.customField33.value == '12')">
                                      <div fxFlex>
                                        <mat-form-field fxFlex>
                                          <mat-label>Button1</mat-label>
                                          <input [attr.guide]="'template-inp-customfield17' + '__' + sanitizedUrl"
                                            (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                            formControlName="customField17" matInput />
                                        </mat-form-field>
                                      </div>

                                      <div fxFlex>
                                        <mat-form-field fxFlex>
                                          <mat-label>Button2</mat-label>
                                          <input [attr.guide]="'template-inp-customfield18' + '__' + sanitizedUrl"
                                            (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                            formControlName="customField18" matInput />
                                        </mat-form-field>
                                      </div>

                                      <div fxFlex>
                                        <mat-form-field fxFlex>
                                          <mat-label>Calculation Two</mat-label>
                                          <input [attr.guide]="'template-inp-customfield29' + '__' + sanitizedUrl"
                                            (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                            formControlName="customField29" matInput />
                                        </mat-form-field>
                                      </div>
                                      <div fxFlex>
                                        <mat-form-field fxFlex>
                                          <mat-label>Calculation One</mat-label>
                                          <input [attr.guide]="'template-inp-customfield35' + '__' + sanitizedUrl"
                                            (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                            formControlName="customField35" matInput />
                                        </mat-form-field>
                                      </div>
                                    </div>

                                    <div fxLayout="row" fxLayoutGap="10" fxLayout.xs="column"
                                      *ngIf="(comp.controls.customField33.value == '12')">
                                      <div fxFlex="50" fxFlex.xs="100">
                                        <mat-form-field fxFlex>
                                          <mat-label>Button 1 & 2 Web Fontsize</mat-label>
                                          <input [attr.guide]="'template-inp-customfield14' + '__' + sanitizedUrl"
                                            (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                            formControlName="customField14" matInput />
                                        </mat-form-field>
                                      </div>

                                      <div fxFlex="50" fxFlex.xs="100">
                                        <mat-form-field fxFlex>
                                          <mat-label>Button 1 & 2 Mobile Fontsize</mat-label>
                                          <input [attr.guide]="'template-inp-customfield15' + '__' + sanitizedUrl"
                                            (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                            formControlName="customField15" matInput />
                                        </mat-form-field>
                                      </div>

                                      <div fxFlex="50" fxFlex.xs="100">
                                        <mat-form-field fxFlex>
                                          <mat-label>Button 1 & 2 Font Color</mat-label>
                                          <input [attr.guide]="'template-inp-customfield16' + '__' + sanitizedUrl"
                                            (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                            formControlName="customField16" matInput />
                                        </mat-form-field>
                                      </div>

                                    </div>


                                    <div fxLayout="row" fxLayoutGap="10"
                                      *ngIf="(comp.controls.customField33.value == '12')">
                                      <div fxFlex="50">
                                        <mat-form-field fxFlex>
                                          <mat-label>Set-Up Cost Name</mat-label>
                                          <input [attr.guide]="'template-inp-customfield19' + '__' + sanitizedUrl"
                                            (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                            formControlName="customField19" matInput />
                                        </mat-form-field>
                                      </div>

                                      <div fxFlex="50">
                                        <mat-form-field fxFlex>
                                          <mat-label>Signing Amount Name</mat-label>
                                          <input [attr.guide]="'template-inp-customfield20' + '__' + sanitizedUrl"
                                            (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                            formControlName="customField20" matInput />
                                        </mat-form-field>
                                      </div>

                                    </div>

                                    <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="10">
                                      <div fxFlex.xs="100" fxFlex="33">
                                        <mat-form-field fxFlex="100" appearance="outline">
                                          <mat-label>Title1 Show Animation </mat-label>
                                          <mat-select formControlName="customField36">
                                            <mat-option *ngFor="let status of ShowAnimation" [value]="status.value">
                                              {{status.viewValue}}
                                            </mat-option>
                                          </mat-select>
                                        </mat-form-field>
                                      </div>

                                      <div fxFlex.xs="100" fxFlex="33">
                                        <mat-form-field fxFlex="100" appearance="outline">
                                          <mat-label>Title2 Show Animation </mat-label>
                                          <mat-select formControlName="customField37">
                                            <mat-option *ngFor="let status of ShowAnimation" [value]="status.value">
                                              {{status.viewValue}}
                                            </mat-option>
                                          </mat-select>
                                        </mat-form-field>
                                      </div>

                                      <div fxFlex.xs="100" fxFlex="33">
                                        <mat-form-field fxFlex="100" appearance="outline">
                                          <mat-label>Title3 Show Animation </mat-label>
                                          <mat-select formControlName="customField38">
                                            <mat-option *ngFor="let status of ShowAnimation" [value]="status.value">
                                              {{status.viewValue}}
                                            </mat-option>
                                          </mat-select>
                                        </mat-form-field>
                                      </div>
                                    </div>

                                    <div fxLayout="row" fxLayoutGap="10"
                                      *ngIf="(comp.controls.customField33.value == '12')">
                                      <div fxFlex="33">
                                        <mat-form-field fxFlex="100">
                                          <mat-label> Set-Up Cost Starter </mat-label>
                                          <input [attr.guide]="'template-inp-customfield23' + '__' + sanitizedUrl"
                                            (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                            formControlName="customField23" matInput />
                                        </mat-form-field>
                                      </div>

                                      <div fxFlex="33">
                                        <mat-form-field fxFlex="100">
                                          <mat-label> Set-Up Cost Profession </mat-label>
                                          <input [attr.guide]="'template-inp-customfield24' + '__' + sanitizedUrl"
                                            (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                            formControlName="customField24" matInput />
                                        </mat-form-field>
                                      </div>

                                      <div fxFlex="33">
                                        <mat-form-field fxFlex="100">
                                          <mat-label> Set-Up Cost Advanced </mat-label>
                                          <input [attr.guide]="'template-inp-customfield25' + '__' + sanitizedUrl"
                                            (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                            formControlName="customField25" matInput />
                                        </mat-form-field>
                                      </div>
                                    </div>

                                    <div fxLayout="row" fxLayoutGap="10"
                                      *ngIf="(comp.controls.customField33.value == '12')">
                                      <div fxFlex="33">
                                        <mat-form-field fxFlex="100">
                                          <mat-label> Signing Amount Starter </mat-label>
                                          <input [attr.guide]="'template-inp-customfield26' + '__' + sanitizedUrl"
                                            (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                            formControlName="customField26" matInput />
                                        </mat-form-field>
                                      </div>

                                      <div fxFlex="33">
                                        <mat-form-field fxFlex="100">
                                          <mat-label> Signing Amount Profession </mat-label>
                                          <input [attr.guide]="'template-inp-customfield27' + '__' + sanitizedUrl"
                                            (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                            formControlName="customField27" matInput />
                                        </mat-form-field>
                                      </div>

                                      <div fxFlex="33">
                                        <mat-form-field fxFlex="100">
                                          <mat-label> Signing Amount Advanced </mat-label>
                                          <input [attr.guide]="'template-inp-customfield28' + '__' + sanitizedUrl"
                                            (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                            formControlName="customField28" matInput />
                                        </mat-form-field>
                                      </div>
                                    </div>

                                    <div *ngIf="(comp.controls['customField33'].value == '1')">
                                      <calsoft-excel-productsize-chart [tabledata]="tabledata"
                                        (setData)="getDatas($event)"></calsoft-excel-productsize-chart>
                                    </div>

                                    <div
                                      *ngIf="(comp.controls['customField33'].value == '2' || comp.controls['customField33'].value == '13' || comp.controls['customField33'].value == '4'  || comp.controls.customField33.value == '10')">
                                      <calsoft-price-table-plan [priceplandata]="priceplandata"
                                        (setData)="handleSetData($event)"></calsoft-price-table-plan>
                                    </div>

                                    <div
                                      *ngIf="(comp.controls['customField33'].value == '3' || comp.controls['customField33'].value == '11' || comp.controls['customField33'].value == '14' )">
                                      <calsoft-price-table-plan2 [priceplandata1]="priceplandata1"
                                        (setData1)="handleSetData1($event)"></calsoft-price-table-plan2>
                                    </div>

                                    <div
                                      *ngIf="(comp.controls['customField33'].value == '5' || comp.controls['customField33'].value == '7' || comp.controls.customField33.value == '12' || comp.controls.customField33.value == '8' )">
                                      <calsoft-price-table-plan3 [priceplandata2]="priceplandata2"
                                        (setData2)="handleSetData2($event)"></calsoft-price-table-plan3>
                                    </div>

                                    <div *ngIf="(comp.controls['customField33'].value == '6')">
                                      <calsoft-pricing-table5 [priceplandata3]="priceplandata3"
                                        (setData3)="handleSetData3($event)"></calsoft-pricing-table5>
                                    </div>

                                    <div *ngIf="(comp.controls['customField33'].value == '9')">
                                      <calsoft-price-table-plan4 [priceplandata4]="priceplandata4"
                                        (setData4)="handleSetData4($event)"></calsoft-price-table-plan4>
                                    </div>

                                    <div *ngIf="(comp.controls['customField33'].value == '15')">
                                      <calsoft-price-table-plan5 [priceplandata5]="priceplandata5"
                                        (setData5)="handleSetData5($event)"></calsoft-price-table-plan5>
                                    </div>

                                    <div *ngIf="(comp.controls['customField33'].value == '16')">
                                      <calsoft-price-table-plan6 [priceplandata6]="priceplandata6"
                                        (setData6)="handleSetData6($event)"></calsoft-price-table-plan6>
                                    </div>

                                  </div>


                                  <!-- bannertextWithImage End -->

                                  <div fxLayout="column"
                                    *ngIf="(comp.controls['type'].value == 'banner') ||(comp.controls['type'].value == 'storeLocations') ">
                                    <div class="editSets">
                                      <div class="title-head3" color="primary">
                                        <span>Image</span>
                                      </div>
                                      <div id="responsieTable" class="container" style="overflow-x:auto;">
                                        <table class="rwd-table">
                                          <tbody>
                                            <tr>
                                              <th>Image</th>
                                              <th *ngIf="(comp.controls['type'].value == 'banner')">Filename</th>
                                              <th
                                                *ngIf="(comp.controls['type'].value == 'banner'&& layoutMainType !== 4)">
                                                Alt Tag</th>
                                              <th *ngIf="(comp.controls['type'].value == 'storeLocations')">City</th>
                                              <th *ngIf="(comp.controls['type'].value == 'storeLocations')">Address</th>
                                              <th *ngIf="(comp.controls['type'].value == 'storeLocations')">Phone No
                                              </th>
                                              <th *ngIf="(comp.controls['type'].value == 'storeLocations')">Map Link
                                              </th>
                                              <th
                                                *ngIf="(comp.controls['type'].value == 'banner' && comp.controls['customField1'].value != 'type2'&& layoutMainType !== 4)">
                                                Position</th>
                                              <th *ngIf="(comp.controls['type'].value == 'banner')">Navigation</th>
                                              <th *ngIf="(comp.controls['type'].value == 'banner')">Category</th>
                                              <th *ngIf="(comp.controls['type'].value == 'banner')">Display on Which
                                                View
                                              </th>
                                              <th
                                                *ngIf="(comp.controls['type'].value == 'banner'&& layoutMainType !== 4)">
                                                Title</th>
                                              <th
                                                *ngIf="(comp.controls['type'].value == 'banner'&& layoutMainType !== 4)">
                                                Sub Title</th>
                                              <th
                                                *ngIf="(comp.controls['type'].value == 'banner' && comp.controls.customField1.value == 'type13'&& layoutMainType !== 4)">
                                                Animate Type</th>

                                              <th
                                                *ngIf="(comp.controls['type'].value == 'banner' && comp.controls['customField1'].value != 'type2'&& layoutMainType !== 4)">
                                                Button Color</th>
                                              <th
                                                *ngIf="(comp.controls['type'].value == 'banner' && comp.controls['customField1'].value != 'type2'&& layoutMainType !== 4)">
                                                Button Radius Color
                                              </th>
                                              <th
                                                *ngIf="(comp.controls['type'].value == 'banner' && comp.controls['customField1'].value != 'type2'&& layoutMainType !== 4)">
                                                Button Name</th>

                                              <th>Action</th>
                                            </tr>
                                            <ng-container formArrayName="images">
                                              <ng-container
                                                *ngFor="let ImageInfo of comp.get('images')?.controls;; let k = index">
                                                <ng-container [formGroupName]="k">
                                                  <tr>
                                                    <td data-th="Image">
                                                      <!-- <img style="height: 65px;width: auto;"
                                                        [src]="bannerServerPath+ ImageInfo.controls['img'].value"
                                                        onerror="this.src='assets/images/logo/no-image.png';" alt=""> -->

                                                      <calsoft-common-images
                                                        [src]="bannerServerPath+ ImageInfo.controls['img'].value"
                                                        [height]="'65px'" [width]="'auto'" [alt]="">

                                                      </calsoft-common-images>
                                                    </td>
                                                    <td *ngIf="(comp.controls['type'].value == 'banner')"
                                                      data-th="Filename">
                                                      <span class="wordBreak">
                                                        {{ ImageInfo.controls['img'].value}}
                                                      </span>
                                                    </td>

                                                    <td
                                                      *ngIf="(comp.controls['type'].value == 'banner' && layoutMainType !== 4)"
                                                      data-th="Altname" class="mobilewidth" style="width: 15%;">
                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex>
                                                          <mat-label>Alt Tag</mat-label>
                                                          <input
                                                            [attr.guide]="'template-inp-altimage' + '__' + sanitizedUrl"
                                                            (keydown.enter)="$event.preventDefault()" trim="blur"
                                                            [autocomplete]="'off'" formControlName="altImage"
                                                            matInput />
                                                        </mat-form-field>
                                                      </span>
                                                    </td>

                                                    <td fxLayout.xs="column"
                                                      *ngIf="(comp.controls['type'].value == 'banner' && comp.controls['customField1'].value != 'type2' && layoutMainType !== 4)"
                                                      data-th="Position">
                                                      <mat-form-field fxFlex>
                                                        <mat-label>Set Position</mat-label>
                                                        <mat-select formControlName="customField29" name="item">
                                                          <mat-option *ngFor="
                                                      let item of setposition;
                                                      let i = index
                                                    " [value]="item.value">
                                                            {{ item.viewValue }}
                                                          </mat-option>
                                                        </mat-select>
                                                      </mat-form-field>

                                                    </td>

                                                    <td *ngIf="(comp.controls['type'].value == 'banner')"
                                                      data-th="Navigation" class="mobilewidth" style="width: 20%;">
                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex>
                                                          <mat-label>Navigation</mat-label>
                                                          <mat-select required formControlName="navigation" name="item">
                                                            <mat-option *ngFor="
                                                          let item of navigation;
                                                          let i = index
                                                        " [value]="item.value">
                                                              {{ item.viewValue }}
                                                            </mat-option>
                                                          </mat-select>
                                                        </mat-form-field>


                                                      </span>
                                                    </td>

                                                    <td *ngIf="(comp.controls['type'].value == 'storeLocations')"
                                                      data-th="City" class="mobilewidth" style="width: 15%;">
                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex>
                                                          <mat-label>City</mat-label>
                                                          <input
                                                            [attr.guide]="'template-inp-customfield1' + '__' + sanitizedUrl"
                                                            (keydown.enter)="$event.preventDefault()" trim="blur"
                                                            [autocomplete]="'off'" formControlName="customField1"
                                                            matInput />
                                                        </mat-form-field>


                                                      </span>
                                                    </td>

                                                    <td *ngIf="(comp.controls['type'].value == 'storeLocations')"
                                                      data-th="Address">
                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex>
                                                          <mat-label>Address</mat-label>
                                                          <input
                                                            [attr.guide]="'template-inp-customfield2' + '__' + sanitizedUrl"
                                                            (keydown.enter)="$event.preventDefault()" trim="blur"
                                                            [autocomplete]="'off'" formControlName="customField2"
                                                            matInput />
                                                        </mat-form-field>


                                                      </span>
                                                    </td>
                                                    <td *ngIf="(comp.controls['type'].value == 'storeLocations')"
                                                      data-th="Phone No">
                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex>
                                                          <mat-label>Phone No</mat-label>
                                                          <input
                                                            [attr.guide]="'template-inp-customfield3' + '__' + sanitizedUrl"
                                                            (keydown.enter)="$event.preventDefault()" trim="blur"
                                                            [autocomplete]="'off'" formControlName="customField3"
                                                            matInput />
                                                        </mat-form-field>


                                                      </span>
                                                    </td>

                                                    <td *ngIf="(comp.controls['type'].value == 'storeLocations')"
                                                      data-th="Map Link">
                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex>
                                                          <mat-label>Map Link</mat-label>
                                                          <input
                                                            [attr.guide]="'template-inp-customfield4' + '__' + sanitizedUrl"
                                                            (keydown.enter)="$event.preventDefault()" trim="blur"
                                                            [autocomplete]="'off'" formControlName="customField4"
                                                            matInput />
                                                        </mat-form-field>


                                                      </span>
                                                    </td>


                                                    <td fxLayout.xs="column"
                                                      *ngIf="(comp.controls['type'].value == 'banner')"
                                                      data-th="Category" class="mobilewidth" style="width: 20%;">
                                                      <mat-form-field fxFlex>

                                                        <mat-label>{{ImageInfo.controls['navigation'].value
                                                          ==0?'Category':'Url'}}</mat-label>

                                                        <mat-select *ngIf="ImageInfo.controls['navigation']
                                                .value==0" required formControlName="catId"
                                                          [disableOptionCentering]="true" #singleSelect name="item">
                                                          <mat-option>
                                                            <ngx-mat-select-search name="Category Search"
                                                              ngDefaultControl [formControl]="
                                                    categoryFilterControl
                                                  " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                    true
                                                  " noEntriesFoundLabel="No data found">
                                                            </ngx-mat-select-search>
                                                          </mat-option>
                                                          <mat-option *ngFor="
                                                  let opt of filteredCategoryTypeList
                                                " [value]="opt.categoryId">
                                                            {{ opt.categoryName }}
                                                          </mat-option>
                                                        </mat-select>


                                                        <input
                                                          [attr.guide]="'template-inp-navigatedurl' + '__' + sanitizedUrl"
                                                          *ngIf="ImageInfo.controls['navigation']
                                                .value==1" trim="blur" (keydown.enter)="$event.preventDefault()"
                                                          [autocomplete]="'off'" matInput
                                                          formControlName="navigatedUrl" />


                                                      </mat-form-field>
                                                    </td>


                                                    <td *ngIf="(comp.controls['type'].value == 'banner')"
                                                      data-th="Display on Which View">
                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex>
                                                          <mat-label>Display on Which View</mat-label>
                                                          <mat-select required formControlName="customField22"
                                                            name="item">
                                                            <mat-option *ngFor="
                                                          let item of displayMode;
                                                          let i = index
                                                        " [value]="item.value">
                                                              {{ item.viewValue }}
                                                            </mat-option>
                                                          </mat-select>
                                                        </mat-form-field>
                                                      </span>
                                                    </td>

                                                    <td
                                                      *ngIf="(comp.controls['type'].value == 'banner' && layoutMainType !== 4)"
                                                      data-th="Enter Title Banner">
                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex>
                                                          <mat-label>Title Banner</mat-label>
                                                          <input
                                                            [attr.guide]="'template-inp-customfield30' + '__' + sanitizedUrl"
                                                            trim="blur" formControlName="customField30" matInput />
                                                        </mat-form-field>
                                                      </span>
                                                    </td>

                                                    <td
                                                      *ngIf="(comp.controls['type'].value == 'banner' && layoutMainType !== 4)"
                                                      data-th="Enter SubTitle Banner">
                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex>
                                                          <mat-label>SubTitle Banner</mat-label>
                                                          <input
                                                            [attr.guide]="'template-inp-customfield31' + '__' + sanitizedUrl"
                                                            trim="blur" formControlName="customField31" matInput />
                                                        </mat-form-field>
                                                      </span>
                                                    </td>

                                                    <td
                                                      *ngIf="(comp.controls['type'].value == 'banner' && comp.controls.customField1.value == 'type13'&& layoutMainType !== 4)"
                                                      data-th="Enter SubTitle Banner">
                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex>
                                                          <mat-label>Animate View</mat-label>
                                                          <mat-select required formControlName="customField5"
                                                            name="item">
                                                            <mat-option *ngFor="
                                                          let item of animateType;
                                                          let i = index
                                                        " [value]="item.value">
                                                              {{ item.viewValue }}
                                                            </mat-option>
                                                          </mat-select>
                                                        </mat-form-field>
                                                      </span>
                                                    </td>


                                                    <td
                                                      *ngIf="(comp.controls['type'].value == 'banner' && comp.controls['customField1'].value != 'type2'&& layoutMainType !== 4)"
                                                      data-th="Enter Button color">
                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex>
                                                          <mat-label>Button Color</mat-label>
                                                          <input
                                                            [attr.guide]="'template-inp-customfield33' + '__' + sanitizedUrl"
                                                            trim="blur" formControlName="customField33" matInput />
                                                        </mat-form-field>
                                                      </span>
                                                    </td>
                                                    <td
                                                      *ngIf="(comp.controls['type'].value == 'banner' && comp.controls['customField1'].value != 'type2' && layoutMainType !== 4)"
                                                      data-th="Enter Button radiusColor">
                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex>
                                                          <mat-label>Button Radius Color</mat-label>
                                                          <input
                                                            [attr.guide]="'template-inp-customfield34' + '__' + sanitizedUrl"
                                                            trim="blur" formControlName="customField34" matInput />
                                                        </mat-form-field>
                                                      </span>
                                                    </td>


                                                    <td
                                                      *ngIf="(comp.controls['type'].value == 'banner' && comp.controls['customField1'].value != 'type2' && layoutMainType !== 4)"
                                                      data-th="Button Name">
                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex>
                                                          <mat-label>Button Name</mat-label>
                                                          <input
                                                            [attr.guide]="'template-inp-customfield32' + '__' + sanitizedUrl"
                                                            trim="blur" formControlName="customField32" matInput />
                                                        </mat-form-field>
                                                      </span>
                                                    </td>
                                                    <td data-th="Action">
                                                      <button [attr.guide]="'template-btn-69' + '__' + sanitizedUrl"
                                                        color="warn" mat-icon-button type="button"
                                                        (click)="updateBanner( ImageInfo.controls['img'].value,i,k)">
                                                        <mat-icon>remove_circle_outline
                                                        </mat-icon>
                                                      </button>
                                                    </td>
                                                  </tr>
                                                </ng-container>

                                              </ng-container>

                                            </ng-container>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                    <div class="editSets1">
                                      <div class="title " fxLayout="row" fxLayoutAlign="center center">
                                        <span *ngIf=" _form.value.conditions[i].images.length<=0"
                                          fxLayoutAlign="center center">No
                                          Images
                                          Uploaded</span>
                                      </div>
                                      <div>
                                        <calsoft-common-file-upload (fileUploadResult)="getResultBanner($event, i)"
                                          [type]="'commonSlider'"></calsoft-common-file-upload>
                                      </div>


                                    </div>
                                    <div fxLayout="column"
                                      *ngIf="comp.controls['customField1'].value=='type3'||comp.controls['customField1'].value=='type4' || comp.controls['customField1'].value=='type5' || comp.controls['customField1'].value=='type6' ">
                                      <div fxFlex fxLayout="column" fxLayoutGap="10">
                                        <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">
                                          <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField2')"
                                            (fileUploadResult)="
                                          getResultts($event, i,'customField2') " [index]="i"
                                            [value]="comp.controls['customField2'].value">
                                          </calsoft-image>
                                          <mat-form-field fxFlex>
                                            <mat-label>Category</mat-label>
                                            <mat-select required formControlName="categoryId1"
                                              [disableOptionCentering]="true" #singleSelect name="item">
                                              <mat-option>
                                                <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                  [formControl]="
                                                  categoryFilterControl
                                                " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                  true
                                                " noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                              </mat-option>
                                              <mat-option *ngFor="
                                                let opt of filteredCategoryTypeList
                                              " [value]="opt.categoryId">
                                                {{ opt.categoryName }}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                        </div>

                                        <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">

                                          <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField3')"
                                            (fileUploadResult)="
                                        getResultts($event, i,'customField3')" [index]="i"
                                            [value]="comp.controls['customField3'].value">
                                          </calsoft-image>
                                          <mat-form-field fxFlex>
                                            <mat-label>Category</mat-label>
                                            <mat-select required formControlName="categoryId2"
                                              [disableOptionCentering]="true" #singleSelect name="item">
                                              <mat-option>
                                                <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                  [formControl]="
                                                  categoryFilterControl
                                                " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                  true
                                                " noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                              </mat-option>
                                              <mat-option *ngFor="
                                                let opt of filteredCategoryTypeList
                                              " [value]="opt.categoryId">
                                                {{ opt.categoryName }}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                        </div>
                                        <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">

                                          <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField4')"
                                            (fileUploadResult)="
                                        getResultts($event, i,'customField4')" [index]="i"
                                            [value]="comp.controls['customField4'].value">
                                          </calsoft-image>
                                          <mat-form-field fxFlex>
                                            <mat-label>Category</mat-label>
                                            <mat-select required formControlName="categoryId3"
                                              [disableOptionCentering]="true" #singleSelect name="item">
                                              <mat-option>
                                                <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                  [formControl]="
                                                  categoryFilterControl
                                                " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                  true
                                                " noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                              </mat-option>
                                              <mat-option *ngFor="
                                                let opt of filteredCategoryTypeList
                                              " [value]="opt.categoryId">
                                                {{ opt.categoryName }}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                        </div>
                                      </div>

                                    </div>

                                    <div fxLayout="column"
                                      *ngIf="comp.controls['customField1'].value=='type7'||comp.controls['customField1'].value=='type8' || comp.controls['customField1'].value=='type9' || comp.controls['customField1'].value=='type10' ">
                                      <div fxFlex fxLayout="column" fxLayoutGap="10">
                                        <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">
                                          <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField2')"
                                            (fileUploadResult)="
                                          getResultts($event, i,'customField2') " [index]="i"
                                            [value]="comp.controls['customField2'].value">
                                          </calsoft-image>
                                          <mat-form-field fxFlex>
                                            <mat-label>Category</mat-label>
                                            <mat-select required formControlName="categoryId1"
                                              [disableOptionCentering]="true" #singleSelect name="item">
                                              <mat-option>
                                                <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                  [formControl]="
                                                  categoryFilterControl
                                                " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                  true
                                                " noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                              </mat-option>
                                              <mat-option *ngFor="
                                                let opt of filteredCategoryTypeList
                                              " [value]="opt.categoryId">
                                                {{ opt.categoryName }}
                                              </mat-option>
                                            </mat-select>
                                            <!-- <mat-error *ngIf="
                                              comp.controls.value.errors?.required
                                            ">
                                              Please fill out this field.
                                            </mat-error> -->
                                          </mat-form-field>

                                        </div>

                                        <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">

                                          <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField3')"
                                            (fileUploadResult)="
                                        getResultts($event, i,'customField3')" [index]="i"
                                            [value]="comp.controls['customField3'].value">
                                          </calsoft-image>
                                          <mat-form-field fxFlex>
                                            <mat-label>Category</mat-label>
                                            <mat-select required formControlName="categoryId2"
                                              [disableOptionCentering]="true" #singleSelect name="item">
                                              <mat-option>
                                                <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                  [formControl]="
                                                  categoryFilterControl
                                                " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                  true
                                                " noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                              </mat-option>
                                              <mat-option *ngFor="
                                                let opt of filteredCategoryTypeList
                                              " [value]="opt.categoryId">
                                                {{ opt.categoryName }}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                        </div>

                                      </div>

                                    </div>


                                  </div>


                                  <ng-container
                                    *ngIf="(comp.controls['type'].value == 'banner' && layoutMainType !== 4 )">
                                    <div fxLayout.xs="column" *ngIf="comp.controls['customField1'].value == 'type3'">
                                      <div fxLayout.xs="column" fxLayoutGap="25px">
                                        <mat-form-field fxFlex>
                                          <mat-label>Banner Height Web</mat-label>
                                          <input [attr.guide]="'template-inp-customfield18' + '__' + sanitizedUrl"
                                            trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                            matInput formControlName="customField18" />
                                        </mat-form-field>

                                        <mat-form-field fxFlex>
                                          <mat-label>Banner Width Web</mat-label>
                                          <input [attr.guide]="'template-inp-customfield19' + '__' + sanitizedUrl"
                                            trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                            matInput formControlName="customField19" />
                                        </mat-form-field>

                                        <mat-form-field fxFlex>
                                          <mat-label>Banner Image Tab web</mat-label>
                                          <input [attr.guide]="'template-inp-customfield20' + '__' + sanitizedUrl"
                                            trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                            matInput formControlName="customField20" />
                                        </mat-form-field>
                                      </div>
                                      <div fxLayout.xs="column" fxLayoutGap="25px">
                                        <mat-form-field fxFlex>
                                          <mat-label>Banner Mob Height</mat-label>
                                          <input [attr.guide]="'template-inp-customfield21' + '__' + sanitizedUrl"
                                            trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                            matInput formControlName="customField21" />
                                        </mat-form-field>

                                        <mat-form-field fxFlex>
                                          <mat-label>Banner Mob Width</mat-label>
                                          <input [attr.guide]="'template-inp-customfield22' + '__' + sanitizedUrl"
                                            trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                            matInput formControlName="customField22" />
                                        </mat-form-field>

                                        <mat-form-field fxFlex>
                                          <mat-label>Banner Image Mob Height</mat-label>
                                          <input [attr.guide]="'template-inp-customfield23' + '__' + sanitizedUrl"
                                            trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                            matInput formControlName="customField23" />
                                        </mat-form-field>
                                      </div>
                                      <div fxLayout.xs="column" fxLayoutGap="25px">
                                        <mat-form-field fxFlex>
                                          <mat-label>Banner Image Tab Height</mat-label>
                                          <input [attr.guide]="'template-inp-customfield24' + '__' + sanitizedUrl"
                                            trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                            matInput formControlName="customField24" />
                                        </mat-form-field>

                                        <mat-form-field fxFlex>
                                          <mat-label>Banner Image Tab Width</mat-label>
                                          <input [attr.guide]="'template-inp-customfield25' + '__' + sanitizedUrl"
                                            trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                            matInput formControlName="customField25" />
                                        </mat-form-field>
                                      </div>
                                    </div>
                                  </ng-container>

                                  <!-- brand layout type -->

                                  <div *ngIf="(comp.controls['type'].value == 'slideBanner')">

                                    <div class="editSets">
                                      <div class="title-head3" fxLayoutAlign="space-between center" color="primary">
                                        <span>Banner Title</span>

                                        <button [attr.guide]="'template-btn-70' + '__' + sanitizedUrl" class="create"
                                          (click)=" addslideBanner(i)" type="button" mat-mini-fab color="primary">
                                          <mat-icon>add</mat-icon>
                                        </button>
                                      </div>
                                      <div id="responsieTable" class="container">
                                        <table fxFlex="100" class="rwd-table">
                                          <tbody fxFlex="100">
                                            <tr>
                                            </tr>
                                            <ng-container formArrayName="images">
                                              <tr fxLayout.xs="column" fxLayoutAlign="center center"
                                                fxLayoutAlign="start"
                                                *ngFor="let ImageInfo of comp.get('images')?.controls;; let y = index">
                                                <ng-container [formGroupName]="y">

                                                  <td fxFlex="15" fxFlex.xs="100" data-th="Filename">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="100" appearance="outline">
                                                        <mat-label>Banner Title</mat-label>
                                                        <textarea
                                                          [attr.guide]="'template-sel-customfield11' + '__' + sanitizedUrl"
                                                          trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                          matAutosizeMaxRows=5 matInput
                                                          formControlName="customField11"></textarea>
                                                        <mat-icon class="clickable"
                                                          (click)="openEditorTextForImageArray(ImageInfo.controls['customField11'].value,i,'customField11',y)"
                                                          matSuffix>
                                                          post_add
                                                        </mat-icon>
                                                      </mat-form-field>
                                                    </span>
                                                  </td>
                                                  <td fxFlex.xs="100" fxFlex="15" data-th="Filename">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="100" appearance="outline">
                                                        <mat-label>Font Color</mat-label>
                                                        <input
                                                          [attr.guide]="'template-inp-customfield1' + '__' + sanitizedUrl"
                                                          trim="blur" (keydown.enter)="$event.preventDefault()"
                                                          [autocomplete]="'off'" matInput
                                                          formControlName="customField1" />
                                                      </mat-form-field>
                                                    </span>
                                                  </td>
                                                  <td fxFlex.xs="100" fxFlex="15" data-th="Filename">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="100" appearance="outline">
                                                        <mat-label>Banner Title 1</mat-label>

                                                        <textarea
                                                          [attr.guide]="'template-sel-customfield12' + '__' + sanitizedUrl"
                                                          trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                          matAutosizeMaxRows=5 matInput
                                                          formControlName="customField12"></textarea>
                                                        <mat-icon class="clickable"
                                                          (click)="openEditorTextForImageArray(ImageInfo.controls['customField12'].value,i,'customField12',y)"
                                                          matSuffix>
                                                          post_add
                                                        </mat-icon>
                                                      </mat-form-field>
                                                    </span>
                                                  </td>

                                                  <td fxFlex.xs="100" fxFlex="15" data-th="Filename">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="100" appearance="outline">
                                                        <mat-label>Font Color</mat-label>
                                                        <input
                                                          [attr.guide]="'template-inp-customfield2' + '__' + sanitizedUrl"
                                                          trim="blur" (keydown.enter)="$event.preventDefault()"
                                                          [autocomplete]="'off'" matInput
                                                          formControlName="customField2" />
                                                      </mat-form-field>
                                                    </span>
                                                  </td>

                                                  <td fxFlex.xs="100" fxFlex="15" data-th="Filename">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="100" appearance="outline">
                                                        <mat-label>Banner Title 2</mat-label>
                                                        <textarea
                                                          [attr.guide]="'template-sel-customfield13' + '__' + sanitizedUrl"
                                                          trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                          matAutosizeMaxRows=5 matInput
                                                          formControlName="customField13"></textarea>
                                                        <mat-icon class="clickable"
                                                          (click)="openEditorTextForImageArray(ImageInfo.controls['customField13'].value,i,'customField13',y)"
                                                          matSuffix>
                                                          post_add
                                                        </mat-icon>
                                                      </mat-form-field>
                                                    </span>
                                                  </td>
                                                  <td fxFlex.xs="100" fxFlex="15" data-th="Filename">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="100" appearance="outline">
                                                        <mat-label>Font Color</mat-label>
                                                        <input
                                                          [attr.guide]="'template-inp-customfield3' + '__' + sanitizedUrl"
                                                          trim="blur" (keydown.enter)="$event.preventDefault()"
                                                          [autocomplete]="'off'" matInput
                                                          formControlName="customField3" />
                                                      </mat-form-field>
                                                    </span>
                                                  </td>
                                                  <td data-th="Action">
                                                    <span class="wordBreak">
                                                      <button [attr.guide]="'template-btn-71' + '__' + sanitizedUrl"
                                                        color="warn" mat-icon-button type="button"
                                                        (click)="deleteText(i,y)">
                                                        <mat-icon>remove_circle_outline
                                                        </mat-icon>
                                                      </button>
                                                    </span>
                                                  </td>
                                                </ng-container>
                                              </tr>

                                            </ng-container>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="(comp.controls['type'].value == 'partners') && (comp.controls['customField23'].value=='3') ">
                                    <mat-form-field fxFlex>
                                      <mat-label>Item List Titile Web Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield39' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField39" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Item List Titile Mobile Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield40' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField40" />
                                    </mat-form-field>

                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="(comp.controls['type'].value == 'partners') && (comp.controls['customField23'].value=='2') ">
                                    <mat-form-field fxFlex>
                                      <mat-label>Image Titile Web Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield35' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField35" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Image Titile Mobile Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield36' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField36" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Description Web Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield37' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField37" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex>
                                      <mat-label>Description Mobile Font Size </mat-label>
                                      <input [attr.guide]="'template-inp-customfield38' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField38" />
                                    </mat-form-field>
                                  </div>


                                  <!-- partners -->

                                  <div *ngIf="comp.controls['customField23'].value=='2'">

                                    <div fxLayout="column" *ngIf="(comp.controls['type'].value == 'partners')">
                                      <div class="editSets">
                                        <div class="title-head3" color="primary">
                                          <span>Image</span>
                                        </div>
                                        <div id="responsieTable" class="container" style="overflow-x:auto;">
                                          <table class="rwd-table">
                                            <tbody>
                                              <tr>
                                                <th>Image</th>
                                                <th>Filename</th>
                                                <th>Title</th>
                                                <th>Rating</th>
                                                <th>Distance</th>
                                                <th>Alt Tag</th>
                                                <th>Description</th>
                                                <th>Navigation</th>
                                                <th>Category</th>
                                                <th>Action</th>
                                              </tr>
                                              <ng-container formArrayName="images">
                                                <tr
                                                  *ngFor="let ImageInfo of comp.get('images')?.controls;; let k = index">
                                                  <ng-container [formGroupName]="k">
                                                    <td data-th="Image" style="width: 60%;">
                                                      <!-- <img style="height: 65px;width: auto;"
                                                        [src]="bannerServerPath+ ImageInfo.controls['img'].value"
                                                        onerror="this.src='assets/images/logo/no-image.png';" alt=""> -->

                                                      <calsoft-common-images
                                                        [src]="bannerServerPath+ ImageInfo.controls['img'].value"
                                                        [height]="'65px'" [width]="'auto'" [alt]="">

                                                      </calsoft-common-images>
                                                    </td>
                                                    <td data-th="Filename" style="width: 90%;">
                                                      <span class="wordBreak">
                                                        {{ ImageInfo.controls['img'].value}}
                                                      </span>
                                                    </td>

                                                    <td>
                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex="100" appearance="outline">
                                                          <mat-label>Title</mat-label>
                                                          <input
                                                            [attr.guide]="'template-inp-customfield20' + '__' + sanitizedUrl"
                                                            trim="blur" (keydown.enter)="$event.preventDefault()"
                                                            [autocomplete]="'off'" matInput
                                                            formControlName="customField20" />
                                                        </mat-form-field>
                                                      </span>
                                                    </td>

                                                    <td>
                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex="100" appearance="outline">
                                                          <mat-label>Rating</mat-label>
                                                          <input
                                                            [attr.guide]="'template-inp-customfield8' + '__' + sanitizedUrl"
                                                            trim="blur" (keydown.enter)="$event.preventDefault()"
                                                            [autocomplete]="'off'" matInput
                                                            formControlName="customField8" />
                                                        </mat-form-field>
                                                      </span>
                                                    </td>

                                                    <td>
                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex="100" appearance="outline">
                                                          <mat-label>Distance</mat-label>
                                                          <input
                                                            [attr.guide]="'template-inp-customfield9' + '__' + sanitizedUrl"
                                                            trim="blur" (keydown.enter)="$event.preventDefault()"
                                                            [autocomplete]="'off'" matInput
                                                            formControlName="customField9" />
                                                        </mat-form-field>
                                                      </span>
                                                    </td>


                                                    <td>
                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex="100" appearance="outline">
                                                          <mat-label>Description</mat-label>
                                                          <textarea
                                                            [attr.guide]="'template-sel-customfield21' + '__' + sanitizedUrl"
                                                            trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                            matAutosizeMaxRows=5 matInput
                                                            formControlName="customField21"></textarea>
                                                          <mat-icon class="clickable"
                                                            (click)="openEditorTextForImageArray(ImageInfo.controls['customField21'].value,i,'customField21',k)"
                                                            matSuffix>
                                                            post_add
                                                          </mat-icon>
                                                          <mat-hint fxHide.lt-md>Click on the icon to open
                                                            editor</mat-hint>
                                                        </mat-form-field>
                                                      </span>
                                                    </td>

                                                    <td>
                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex="100" appearance="outline">
                                                          <mat-label>Alt Tag</mat-label>
                                                          <input
                                                            [attr.guide]="'template-inp-altimage' + '__' + sanitizedUrl"
                                                            trim="blur" (keydown.enter)="$event.preventDefault()"
                                                            [autocomplete]="'off'" matInput
                                                            formControlName="altImage" />
                                                        </mat-form-field>
                                                      </span>
                                                    </td>


                                                    <td data-th="Filename" style="width: 20%;">
                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex>
                                                          <mat-label>Navigation</mat-label>
                                                          <mat-select required formControlName="navigation" name="item">
                                                            <mat-option *ngFor="
                                                            let item of navigation;
                                                            let i = index
                                                          " [value]="item.value">
                                                              {{ item.viewValue }}
                                                            </mat-option>
                                                          </mat-select>
                                                        </mat-form-field>


                                                      </span>
                                                    </td>
                                                    <!-- <td data-th="Navigation" style="width: 90%;">
                                                    
        
                                                  </td> -->
                                                    <td data-th="Category" style="width: 20%;">
                                                      <mat-form-field fxFlex="100" style="width: 100%;">

                                                        <mat-label>{{ImageInfo.controls['navigation'].value
                                                          ==0?'Category':'Url'}}</mat-label>

                                                        <mat-select *ngIf="ImageInfo.controls['navigation']
                                                    .value==0" required formControlName="catId"
                                                          [disableOptionCentering]="true" #singleSelect name="item">
                                                          <mat-option>
                                                            <ngx-mat-select-search name="Category Search"
                                                              ngDefaultControl [formControl]="
                                                        categoryFilterControl
                                                      " placeholderLabel="Category Search"
                                                              [preventHomeEndKeyPropagation]="
                                                        true
                                                      " noEntriesFoundLabel="No data found">
                                                            </ngx-mat-select-search>
                                                          </mat-option>
                                                          <mat-option *ngFor="
                                                      let opt of filteredCategoryTypeList
                                                    " [value]="opt.categoryId">
                                                            {{ opt.categoryName }}
                                                          </mat-option>
                                                        </mat-select>


                                                        <input
                                                          [attr.guide]="'template-inp-navigatedurl' + '__' + sanitizedUrl"
                                                          *ngIf="ImageInfo.controls['navigation']
                                                    .value==1" trim="blur" (keydown.enter)="$event.preventDefault()"
                                                          [autocomplete]="'off'" matInput
                                                          formControlName="navigatedUrl" />


                                                      </mat-form-field>
                                                    </td>

                                                    <td data-th="Action">
                                                      <button [attr.guide]="'template-btn-72' + '__' + sanitizedUrl"
                                                        color="warn" mat-icon-button type="button"
                                                        (click)="updateBanner( ImageInfo.controls['img'].value,i,k)">
                                                        <mat-icon>remove_circle_outline
                                                        </mat-icon>
                                                      </button>
                                                    </td>
                                                  </ng-container>
                                                </tr>
                                              </ng-container>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                      <div class="editSets1">
                                        <div class="title " fxLayout="row" fxLayoutAlign="center center">
                                          <span *ngIf=" _form.value.conditions[i].images.length<=0"
                                            fxLayoutAlign="center center">No
                                            Images
                                            Uploaded</span>
                                        </div>
                                        <div>
                                          <calsoft-common-file-upload (fileUploadResult)="getResultBanner($event, i)"
                                            [type]="'commonSlider'"></calsoft-common-file-upload>
                                        </div>


                                      </div>
                                      <div fxLayout="column"
                                        *ngIf="comp.controls['customField1'].value=='type3'||comp.controls['customField1'].value=='type4' || comp.controls['customField1'].value=='type5' || comp.controls['customField1'].value=='type6' ">
                                        <div fxFlex fxLayout="column" fxLayoutGap="10">
                                          <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">
                                            <calsoft-image fxFlex
                                              (deleteResult)="updatesIMage($event, i,'customField2')"
                                              (fileUploadResult)="
                                            getResultts($event, i,'customField2') " [index]="i"
                                              [value]="comp.controls['customField2'].value">
                                            </calsoft-image>
                                            <mat-form-field fxFlex>
                                              <mat-label>Category</mat-label>
                                              <mat-select required formControlName="categoryId1"
                                                [disableOptionCentering]="true" #singleSelect name="item">
                                                <mat-option>
                                                  <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                    [formControl]="
                                                    categoryFilterControl
                                                  " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                    true
                                                  " noEntriesFoundLabel="No data found">
                                                  </ngx-mat-select-search>
                                                </mat-option>
                                                <mat-option *ngFor="
                                                  let opt of filteredCategoryTypeList
                                                " [value]="opt.categoryId">
                                                  {{ opt.categoryName }}
                                                </mat-option>
                                              </mat-select>
                                            </mat-form-field>
                                          </div>

                                          <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">

                                            <calsoft-image fxFlex
                                              (deleteResult)="updatesIMage($event, i,'customField3')"
                                              (fileUploadResult)="
                                          getResultts($event, i,'customField3')" [index]="i"
                                              [value]="comp.controls['customField3'].value">
                                            </calsoft-image>
                                            <mat-form-field fxFlex>
                                              <mat-label>Category</mat-label>
                                              <mat-select required formControlName="categoryId2"
                                                [disableOptionCentering]="true" #singleSelect name="item">
                                                <mat-option>
                                                  <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                    [formControl]="
                                                    categoryFilterControl
                                                  " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                    true
                                                  " noEntriesFoundLabel="No data found">
                                                  </ngx-mat-select-search>
                                                </mat-option>
                                                <mat-option *ngFor="
                                                  let opt of filteredCategoryTypeList
                                                " [value]="opt.categoryId">
                                                  {{ opt.categoryName }}
                                                </mat-option>
                                              </mat-select>
                                            </mat-form-field>
                                          </div>
                                          <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">

                                            <calsoft-image fxFlex
                                              (deleteResult)="updatesIMage($event, i,'customField4')"
                                              (fileUploadResult)="
                                          getResultts($event, i,'customField4')" [index]="i"
                                              [value]="comp.controls['customField4'].value">
                                            </calsoft-image>
                                            <mat-form-field fxFlex>
                                              <mat-label>Category</mat-label>
                                              <mat-select required formControlName="categoryId3"
                                                [disableOptionCentering]="true" #singleSelect name="item">
                                                <mat-option>
                                                  <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                    [formControl]="
                                                    categoryFilterControl
                                                  " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                    true
                                                  " noEntriesFoundLabel="No data found">
                                                  </ngx-mat-select-search>
                                                </mat-option>
                                                <mat-option *ngFor="
                                                  let opt of filteredCategoryTypeList
                                                " [value]="opt.categoryId">
                                                  {{ opt.categoryName }}
                                                </mat-option>
                                              </mat-select>
                                            </mat-form-field>
                                          </div>
                                        </div>

                                      </div>



                                      <div fxLayout="column"
                                        *ngIf="comp.controls['customField1'].value=='type7'||comp.controls['customField1'].value=='type8' || comp.controls['customField1'].value=='type9' || comp.controls['customField1'].value=='type10' ">
                                        <div fxFlex fxLayout="column" fxLayoutGap="10">
                                          <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">
                                            <calsoft-image fxFlex
                                              (deleteResult)="updatesIMage($event, i,'customField2')"
                                              (fileUploadResult)="
                                            getResultts($event, i,'customField2') " [index]="i"
                                              [value]="comp.controls['customField2'].value">
                                            </calsoft-image>
                                            <mat-form-field fxFlex>
                                              <mat-label>Category</mat-label>
                                              <mat-select required formControlName="categoryId1"
                                                [disableOptionCentering]="true" #singleSelect name="item">
                                                <mat-option>
                                                  <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                    [formControl]="
                                                    categoryFilterControl
                                                  " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                    true
                                                  " noEntriesFoundLabel="No data found">
                                                  </ngx-mat-select-search>
                                                </mat-option>
                                                <mat-option *ngFor="
                                                  let opt of filteredCategoryTypeList
                                                " [value]="opt.categoryId">
                                                  {{ opt.categoryName }}
                                                </mat-option>
                                              </mat-select>
                                            </mat-form-field>

                                          </div>

                                          <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">

                                            <calsoft-image fxFlex
                                              (deleteResult)="updatesIMage($event, i,'customField3')"
                                              (fileUploadResult)="
                                          getResultts($event, i,'customField3')" [index]="i"
                                              [value]="comp.controls['customField3'].value">
                                            </calsoft-image>
                                            <mat-form-field fxFlex>
                                              <mat-label>Category</mat-label>
                                              <mat-select required formControlName="categoryId2"
                                                [disableOptionCentering]="true" #singleSelect name="item">
                                                <mat-option>
                                                  <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                    [formControl]="
                                                    categoryFilterControl
                                                  " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                    true
                                                  " noEntriesFoundLabel="No data found">
                                                  </ngx-mat-select-search>
                                                </mat-option>
                                                <mat-option *ngFor="
                                                  let opt of filteredCategoryTypeList
                                                " [value]="opt.categoryId">
                                                  {{ opt.categoryName }}
                                                </mat-option>
                                              </mat-select>
                                            </mat-form-field>

                                            <mat-form-field fxFlex>
                                              <mat-label>Alt Tag</mat-label>
                                              <input [attr.guide]="'template-inp-altimage' + '__' + sanitizedUrl"
                                                (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                trim="blur" matInput formControlName="altImage" />

                                            </mat-form-field>

                                          </div>

                                        </div>

                                      </div>


                                    </div>
                                  </div>


                                  <div *ngIf="comp.controls['customField23'].value=='3'">
                                    <div *ngIf="(comp.controls['type'].value == 'partners')">

                                      <div class="editSets">
                                        <div class="title-head3" fxLayoutAlign="space-between center" color="primary">
                                          <span>Item List</span>

                                          <button [attr.guide]="'template-btn-73' + '__' + sanitizedUrl" class="create"
                                            (click)="addImages(i)" type="button" mat-mini-fab color="primary">
                                            <mat-icon>add</mat-icon>
                                          </button>
                                        </div>

                                        <div id="responsieTable" class="container">
                                          <table fxFlex="100" class="padding-10">
                                            <tbody fxFlex="100">
                                              <ng-container formArrayName="images">
                                                <ng-container
                                                  *ngFor="let ImageInfo of comp.get('images')?.controls;; let y = index">
                                                  <div [formGroupName]="y">
                                                    <tr fxLayout="row">
                                                      <ng-container fxLayoutAlign="space-between center">
                                                        <td fxFlex="50" data-th="Filename" fxLayoutGap="10px">
                                                          <span class="wordBreak">
                                                            <div style="display: flex; gap: 20px;">
                                                              <mat-form-field fxFlex appearance="outline">
                                                                <mat-label>Title</mat-label>
                                                                <input
                                                                  [attr.guide]="'template-inp-customfield15' + '__' + sanitizedUrl"
                                                                  (keydown.enter)="$event.preventDefault()" trim="blur"
                                                                  [autocomplete]="'off'" trim="blur"
                                                                  formControlName="customField15" matInput />
                                                              </mat-form-field>
                                                            </div>
                                                          </span>
                                                        </td>

                                                        <td fxFlex="50" data-th="Filename" fxLayoutGap="10px">
                                                          <span class="wordBreak">
                                                            <div style="display: flex; gap: 20px;">
                                                              <mat-form-field fxFlex appearance="outline">
                                                                <mat-label>Display Title</mat-label>
                                                                <mat-select formControlName="customField1">
                                                                  <mat-option *ngFor="let item of displayTitle"
                                                                    [value]="item.value">
                                                                    {{item.viewValue}}
                                                                  </mat-option>
                                                                </mat-select>
                                                              </mat-form-field>
                                                            </div>
                                                          </span>
                                                        </td>
                                                        <td fxFlex="50" data-th="Filename" fxLayoutGap="10px">
                                                          <span class="wordBreak">
                                                            <div style="display: flex">
                                                              <mat-form-field fxFlex appearance="outline">
                                                                <mat-label>Type</mat-label>
                                                                <mat-select
                                                                  (selectionChange)="onChangeImageTab($event, i,y)"
                                                                  required formControlName="customField3" name="item">
                                                                  <mat-option *ngFor="let item of Partnerslayout;"
                                                                    [value]="item.value">
                                                                    {{ item.viewValue }}
                                                                  </mat-option>
                                                                </mat-select>
                                                              </mat-form-field>
                                                            </div>
                                                          </span>
                                                        </td>

                                                        <td data-th="Action">
                                                          <span class="wordBreak">
                                                            <button
                                                              [attr.guide]="'template-btn-74' + '__' + sanitizedUrl"
                                                              color="warn" mat-icon-button type="button"
                                                              (click)="deleteText(i,y)">
                                                              <mat-icon>remove_circle_outline
                                                              </mat-icon>
                                                            </button>
                                                          </span>
                                                        </td>
                                                      </ng-container>
                                                    </tr>

                                                    <tr fxLayout="row">
                                                      <td fxFlex="100"
                                                        *ngIf="ImageInfo.controls.customField3.value == 'ProductScope'|| ImageInfo.controls.customField3.value == 'Category'">
                                                        <div class="editSets">
                                                          <div class="title-head3" color="primary"
                                                            fxLayoutAlign="space-between center">
                                                            <span>Text</span>
                                                            <button
                                                              [attr.guide]="'template-btn-75' + '__' + sanitizedUrl"
                                                              class="create" (click)="addImagesArraySub(i,y)"
                                                              type="button" mat-mini-fab color="primary">
                                                              <mat-icon>add</mat-icon>
                                                            </button>
                                                          </div>
                                                          <div id="responsieTable" class="container">
                                                            <table class="rwd-table">
                                                              <tbody>
                                                                <tr>
                                                                  <th>Tab Name</th>
                                                                  <th>Menu Id</th>
                                                                  <th>Action</th>
                                                                </tr>


                                                                <ng-container formArrayName="subChild">
                                                                  <tr
                                                                    *ngFor="let subChildImageInfo of ImageInfo.get('subChild')?.controls; let M = index">
                                                                    <ng-container [formGroupName]="M">
                                                                      <td data-th="Filename" style="width: 90%;">
                                                                        <span class="wordBreak">
                                                                          <mat-form-field fxFlex appearance="outline">
                                                                            <mat-label>Tab Name</mat-label>
                                                                            <input
                                                                              [attr.guide]="'template-inp-customfield19' + '__' + sanitizedUrl"
                                                                              trim="blur"
                                                                              (keydown.enter)="$event.preventDefault()"
                                                                              [autocomplete]="'off'" matInput
                                                                              formControlName="customField19" />
                                                                            <mat-icon class="clickable"
                                                                              (click)="openEditorTextForSubChildArray(subChildImageInfo.controls['customField19'].value,i,'customField19', M, y)"
                                                                              matSuffix>
                                                                              post_add
                                                                            </mat-icon>
                                                                          </mat-form-field>
                                                                        </span>
                                                                      </td>

                                                                      <td data-th="Filename" style="width: 90%;">
                                                                        <span class="wordBreak">
                                                                          <mat-form-field fxFlex appearance="outline">
                                                                            <mat-label>Menu Id</mat-label>
                                                                            <input
                                                                              [attr.guide]="'template-inp-customfield21' + '__' + sanitizedUrl"
                                                                              trim="blur"
                                                                              (keydown.enter)="$event.preventDefault()"
                                                                              [autocomplete]="'off'" matInput
                                                                              formControlName="customField21" />
                                                                          </mat-form-field>
                                                                        </span>
                                                                      </td>


                                                                      <td fxFlex="50" data-th="Filename"
                                                                        fxLayoutGap="10px"
                                                                        *ngIf="ImageInfo.controls.customField3.value == 'ProductScope'">
                                                                        <span class="wordBreak">
                                                                          <div style="display: flex; gap: 20px;">
                                                                            <mat-form-field fxFlex appearance="outline">
                                                                              <mat-label>Custom Product
                                                                                Scope</mat-label>
                                                                              <mat-select required
                                                                                formControlName="customField5"
                                                                                [disableOptionCentering]="true"
                                                                                #singleSelect name="item">
                                                                                <mat-option>
                                                                                  <ngx-mat-select-search
                                                                                    name="Custom Product Scope Search"
                                                                                    ngDefaultControl [formControl]="
                                                                productScopeFilterControl
                                                                  " placeholderLabel="Product Scope Search"
                                                                                    [preventHomeEndKeyPropagation]="
                                                                    true
                                                                  " noEntriesFoundLabel="No data found">
                                                                                  </ngx-mat-select-search>
                                                                                </mat-option>
                                                                                <mat-option
                                                                                  (onSelectionChange)="setProductScopeImageLayoutSub($event,opt,'customField20',i,y,M)"
                                                                                  *ngFor="let opt of filteredproductScopeTypeList;"
                                                                                  [value]="opt.customProductScopeId">
                                                                                  {{ opt.type }}
                                                                                </mat-option>
                                                                              </mat-select>
                                                                              <mat-error
                                                                                *ngIf="comp.controls.value.errors?.required">
                                                                                Please fill out this field.
                                                                              </mat-error>
                                                                            </mat-form-field>
                                                                          </div>
                                                                        </span>
                                                                      </td>

                                                                      <td fxFlex="50" data-th="Filename"
                                                                        fxLayoutGap="10px"
                                                                        *ngIf="ImageInfo.controls.customField3.value == 'Category'">
                                                                        <span class="wordBreak">
                                                                          <div style="display: flex; gap: 20px;">
                                                                            <mat-form-field fxFlex appearance="outline">
                                                                              <mat-label>Category</mat-label>
                                                                              <mat-select required
                                                                                formControlName="customField4"
                                                                                [disableOptionCentering]="true"
                                                                                #singleSelect name="item">
                                                                                <mat-option>
                                                                                  <ngx-mat-select-search
                                                                                    name="Category Search"
                                                                                    ngDefaultControl [formControl]="
                                                                categoryFilterControl
                                                              " placeholderLabel="Category Search"
                                                                                    [preventHomeEndKeyPropagation]="
                                                                true
                                                              " noEntriesFoundLabel="No data found">
                                                                                  </ngx-mat-select-search>
                                                                                </mat-option>
                                                                                <mat-option
                                                                                  (onSelectionChange)="setProductScopeImageLayoutSub($event,opt,'customField20',i,y,M)"
                                                                                  *ngFor="
                                                              let opt of filteredCategoryTypeList
                                                            " [value]="opt.categoryId">
                                                                                  {{ opt.categoryName }}
                                                                                </mat-option>
                                                                              </mat-select>
                                                                            </mat-form-field>
                                                                          </div>
                                                                        </span>
                                                                      </td>

                                                                      <td data-th="Action">
                                                                        <button
                                                                          [attr.guide]="'template-btn-76' + '__' + sanitizedUrl"
                                                                          color="warn" mat-icon-button type="button"
                                                                          (click)="updateBannerChild(subChildImageInfo.controls['customField6'].value,i,y,M)">
                                                                          <mat-icon>remove_circle_outline
                                                                          </mat-icon>
                                                                        </button>
                                                                      </td>

                                                                    </ng-container>
                                                                  </tr>
                                                                </ng-container>
                                                              </tbody>
                                                            </table>
                                                          </div>
                                                        </div>
                                                      </td>
                                                    </tr>

                                                  </div>

                                                </ng-container>
                                              </ng-container>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>

                                    </div>
                                  </div>


                                  <!-- brand -->
                                  <div *ngIf="comp.controls['customField23'].value!='15'">
                                    <div fxLayout="column" *ngIf="(comp.controls['type'].value == 'brandsCarousel') ">
                                      <div class="editSets">
                                        <div class="title-head3" color="primary">
                                          <span>Image</span>
                                        </div>
                                        <div id="responsieTable" class="container" style="overflow-x:auto;">
                                          <table class="rwd-table">
                                            <tbody>
                                              <tr>
                                                <th>Image</th>
                                                <th>Filename</th>
                                                <th
                                                  *ngIf="(comp.controls['customField23'].value=='18' || comp.controls['customField23'].value=='30') && layoutMainType !== 4 ">
                                                  Background Color
                                                </th>
                                                <th
                                                  *ngIf="(comp.controls['customField23'].value=='11' || comp.controls['customField23'].value=='15' || comp.controls['customField23'].value=='18' || comp.controls['customField23'].value=='30')&& layoutMainType !== 4  ">
                                                  SubImage 1</th>
                                                <th
                                                  *ngIf="(comp.controls['customField23'].value=='11' || comp.controls['customField23'].value=='15')&& layoutMainType !== 4  ">
                                                  SubImage 2</th>
                                                <th
                                                  *ngIf="comp.controls['customField23'].value=='15' && layoutMainType !== 4 ">
                                                  SubImage 3</th>
                                                <th
                                                  *ngIf="comp.controls['customField23'].value=='15' && layoutMainType !== 4 ">
                                                  SubImage 4</th>
                                                <th
                                                  *ngIf="comp.controls['customField23'].value=='15' && layoutMainType !== 4 ">
                                                  Alt Tag</th>
                                                <th *ngIf="layoutMainType !== 4 ">Title</th>
                                                <th
                                                  *ngIf="(comp.controls['customField23'].value=='12' || comp.controls['customField23'].value=='13' || comp.controls['customField23'].value=='18' ) && layoutMainType !== 4 ">
                                                  Title Sub</th>
                                                <th
                                                  *ngIf="comp.controls['customField23'].value=='12'&& layoutMainType !== 4 ">
                                                  Video Id</th>
                                                <th
                                                  *ngIf="(comp.controls['customField23'].value!='16' && comp.controls['customField23'].value!='19')&& layoutMainType !== 4 ">
                                                  Description</th>
                                                <th
                                                  *ngIf="(comp.controls['customField23'].value=='18' || comp.controls['customField23'].value=='19') && layoutMainType !== 4 ">
                                                  Button</th>
                                                <th
                                                  *ngIf="comp.controls['customField23'].value=='25' && layoutMainType !== 4 ">
                                                  Sub Description</th>
                                                <th
                                                  *ngIf="(comp.controls['customField23'].value=='25' || comp.controls['customField23'].value=='37') && layoutMainType !== 4 ">
                                                  BackGround Color</th>
                                                <th
                                                  *ngIf="comp.controls['customField23'].value=='23'&& layoutMainType !== 4 ">
                                                  Rating</th>
                                                <th>Navigation</th>
                                                <th *ngIf="comp.controls['customField23'].value=='16'">Type</th>
                                                <th>Category</th>
                                                <th
                                                  *ngIf="comp.controls['customField23'].value=='15'&& layoutMainType !== 4 ">
                                                  Animate img type
                                                </th>
                                                <th
                                                  *ngIf="comp.controls['customField23'].value=='15'&& layoutMainType !== 4 ">
                                                  Animate subimg1
                                                  type</th>
                                                <th
                                                  *ngIf="comp.controls['customField23'].value=='15'&& layoutMainType !== 4 ">
                                                  Animate subimg2
                                                  type</th>
                                                <th
                                                  *ngIf="comp.controls['customField23'].value=='15'&& layoutMainType !== 4 ">
                                                  Animate subimg3
                                                  type</th>
                                                <th>Display on Which View</th>
                                                <th>Action</th>
                                              </tr>
                                              <ng-container formArrayName="images">
                                                <tr
                                                  *ngFor="let ImageInfo of comp.get('images')?.controls; let k = index">
                                                  <ng-container [formGroupName]="k">
                                                    <td data-th="Image" style="width: 60%;">
                                                      <!-- <img style="height: 65px;width: auto;"
                                                        [src]="bannerServerPath+ ImageInfo.controls['img'].value"
                                                        onerror="this.src='assets/images/logo/no-image.png';" alt=""> -->
                                                      <calsoft-common-images
                                                        [src]="bannerServerPath+ ImageInfo.controls['img'].value"
                                                        [height]="'65px'" [width]="'auto'" [alt]="">

                                                      </calsoft-common-images>
                                                    </td>
                                                    <td data-th="Filename" style="width: 90%;">
                                                      <span class="wordBreak">
                                                        {{ ImageInfo.controls['img'].value}}
                                                      </span>
                                                    </td>

                                                    <td
                                                      *ngIf="(comp.controls['customField23'].value=='18' || comp.controls['customField23'].value=='30')&& layoutMainType !== 4 ">
                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex="100" appearance="outline">
                                                          <mat-label>Background Color</mat-label>
                                                          <input
                                                            [attr.guide]="'template-inp-customfield11' + '__' + sanitizedUrl"
                                                            trim="blur" (keydown.enter)="$event.preventDefault()"
                                                            [autocomplete]="'off'" matInput
                                                            formControlName="customField11" />
                                                        </mat-form-field>
                                                      </span>
                                                    </td>

                                                    <td
                                                      *ngIf="(comp.controls['customField23'].value=='11' || comp.controls['customField23'].value=='15' || comp.controls['customField23'].value=='18' || comp.controls['customField23'].value=='30')&& layoutMainType !== 4 ">
                                                      <calsoft-image style="padding-bottom: 10px;"
                                                        (deleteResult)="updatesImageArray($event, i,'customField6',k)"
                                                        (fileUploadResult)="
                                              getResultArray($event, i,'customField6',k) " [index]="k"
                                                        [value]="ImageInfo.controls['customField6'].value">
                                                      </calsoft-image>
                                                    </td>
                                                    <td
                                                      *ngIf="(comp.controls['customField23'].value=='11' || comp.controls['customField23'].value=='15')&& layoutMainType !== 4 ">
                                                      <calsoft-image style="padding-bottom: 10px;"
                                                        (deleteResult)="updatesImageArray($event, i,'customField7',k)"
                                                        (fileUploadResult)="
                                              getResultArray($event, i,'customField7',k) " [index]="k"
                                                        [value]="ImageInfo.controls['customField7'].value">
                                                      </calsoft-image>
                                                    </td>
                                                    <td
                                                      *ngIf="comp.controls['customField23'].value=='15'&& layoutMainType !== 4 ">
                                                      <calsoft-image style="padding-bottom: 10px;"
                                                        (deleteResult)="updatesImageArray($event, i,'customField8',k)"
                                                        (fileUploadResult)="
                                              getResultArray($event, i,'customField8',k) " [index]="k"
                                                        [value]="ImageInfo.controls['customField8'].value">
                                                      </calsoft-image>
                                                    </td>
                                                    <td
                                                      *ngIf="comp.controls['customField23'].value=='15'&& layoutMainType !== 4 ">
                                                      <calsoft-image style="padding-bottom: 10px;"
                                                        (deleteResult)="updatesImageArray($event, i,'customField9',k)"
                                                        (fileUploadResult)="
                                              getResultArray($event, i,'customField9',k) " [index]="k"
                                                        [value]="ImageInfo.controls['customField9'].value">
                                                      </calsoft-image>
                                                    </td>

                                                    <td *ngIf=" layoutMainType !== 4 ">
                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex="100" appearance="outline">
                                                          <mat-label>Alt Tag</mat-label>
                                                          <input
                                                            [attr.guide]="'template-inp-altimage' + '__' + sanitizedUrl"
                                                            trim="blur" (keydown.enter)="$event.preventDefault()"
                                                            [autocomplete]="'off'" matInput
                                                            formControlName="altImage" />
                                                        </mat-form-field>
                                                      </span>
                                                    </td>
                                                    <td
                                                      *ngIf="comp.controls['customField23'].value!='16'&& layoutMainType !== 4 ">
                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex="100" appearance="outline">
                                                          <mat-label>Title</mat-label>
                                                          <textarea
                                                            [attr.guide]="'template-sel-customfield20' + '__' + sanitizedUrl"
                                                            trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                            matAutosizeMaxRows=5 matInput
                                                            formControlName="customField20"></textarea>
                                                          <mat-icon class="clickable"
                                                            (click)="openEditorTextForImageArray(ImageInfo.controls['customField20'].value,i,'customField20',k)"
                                                            matSuffix>
                                                            post_add
                                                          </mat-icon>
                                                          <mat-hint fxHide.lt-md>Click on the icon to open
                                                            editor</mat-hint>
                                                        </mat-form-field>
                                                      </span>
                                                    </td>

                                                    <td
                                                      *ngIf="(comp.controls['customField23'].value=='12' || comp.controls['customField23'].value=='13' || comp.controls['customField23'].value=='18')&& layoutMainType !== 4 ">
                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex="100" appearance="outline">
                                                          <mat-label>Title Sub</mat-label>
                                                          <input
                                                            [attr.guide]="'template-inp-customfield8' + '__' + sanitizedUrl"
                                                            trim="blur" (keydown.enter)="$event.preventDefault()"
                                                            [autocomplete]="'off'" matInput
                                                            formControlName="customField8" />
                                                        </mat-form-field>
                                                      </span>
                                                    </td>

                                                    <td
                                                      *ngIf="comp.controls['customField23'].value=='12'&& layoutMainType !== 4 ">
                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex="100" appearance="outline">
                                                          <mat-label>Video Id</mat-label>
                                                          <input
                                                            [attr.guide]="'template-inp-customfield9' + '__' + sanitizedUrl"
                                                            trim="blur" (keydown.enter)="$event.preventDefault()"
                                                            [autocomplete]="'off'" matInput
                                                            formControlName="customField9" />
                                                        </mat-form-field>
                                                      </span>
                                                    </td>


                                                    <td
                                                      *ngIf="(comp.controls['customField23'].value!='16' && comp.controls['customField23'].value!='19')&& layoutMainType !== 4 ">
                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex="100" appearance="outline">
                                                          <mat-label>Description</mat-label>
                                                          <textarea
                                                            [attr.guide]="'template-sel-customfield21' + '__' + sanitizedUrl"
                                                            trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                            matAutosizeMaxRows=5 matInput
                                                            formControlName="customField21"></textarea>
                                                          <mat-icon class="clickable"
                                                            (click)="openEditorTextForImageArray(ImageInfo.controls['customField21'].value,i,'customField21',k)"
                                                            matSuffix>
                                                            post_add
                                                          </mat-icon>
                                                          <mat-hint fxHide.lt-md>Click on the icon to open
                                                            editor</mat-hint>
                                                        </mat-form-field>
                                                      </span>
                                                    </td>

                                                    <td
                                                      *ngIf="(comp.controls['customField23'].value=='18' || comp.controls['customField23'].value=='19')&& layoutMainType !== 4 ">
                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex="100" appearance="outline">
                                                          <mat-label>Button</mat-label>
                                                          <input
                                                            [attr.guide]="'template-inp-customfield9' + '__' + sanitizedUrl"
                                                            trim="blur" (keydown.enter)="$event.preventDefault()"
                                                            [autocomplete]="'off'" matInput
                                                            formControlName="customField9" />
                                                        </mat-form-field>
                                                      </span>
                                                    </td>

                                                    <td
                                                      *ngIf="comp.controls['customField23'].value=='25'&& layoutMainType !== 4 ">
                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex="100" appearance="outline">
                                                          <mat-label>Sub Description</mat-label>
                                                          <textarea
                                                            [attr.guide]="'template-sel-customfield9' + '__' + sanitizedUrl"
                                                            trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                            matAutosizeMaxRows=5 matInput
                                                            formControlName="customField9"></textarea>
                                                          <mat-icon class="clickable"
                                                            (click)="openEditorTextForImageArray(ImageInfo.controls['customField21'].value,i,'customField21',k)"
                                                            matSuffix>
                                                            post_add
                                                          </mat-icon>
                                                          <mat-hint fxHide.lt-md>Click on the icon to open
                                                            editor</mat-hint>
                                                        </mat-form-field>
                                                      </span>
                                                    </td>

                                                    <td
                                                      *ngIf="(comp.controls['customField23'].value=='25' || comp.controls['customField23'].value=='37')&& layoutMainType !== 4  ">
                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex="100" appearance="outline">
                                                          <mat-label>BackGround Color</mat-label>
                                                          <input
                                                            [attr.guide]="'template-inp-customfield5' + '__' + sanitizedUrl"
                                                            trim="blur" (keydown.enter)="$event.preventDefault()"
                                                            [autocomplete]="'off'" matInput
                                                            formControlName="customField5" />
                                                        </mat-form-field>
                                                      </span>
                                                    </td>

                                                    <td
                                                      *ngIf="comp.controls['customField23'].value=='23'&& layoutMainType !== 4 ">
                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex="100" appearance="outline">
                                                          <mat-label>Rating</mat-label>
                                                          <input
                                                            [attr.guide]="'template-inp-customfield9' + '__' + sanitizedUrl"
                                                            trim="blur" (keydown.enter)="$event.preventDefault()"
                                                            [autocomplete]="'off'" matInput
                                                            formControlName="customField9" />
                                                        </mat-form-field>
                                                      </span>
                                                    </td>


                                                    <td data-th="Filename" style="width: 100%;">
                                                      <span style="width: 100%;" class="wordBreak">
                                                        <mat-form-field fxFlex="100">
                                                          <mat-label>Navigation</mat-label>
                                                          <mat-select required formControlName="navigation" name="item">
                                                            <mat-option *ngFor="
                                                          let item of navigation;
                                                          let i = index
                                                        " [value]="item.value">
                                                              {{ item.viewValue }}
                                                            </mat-option>
                                                          </mat-select>
                                                        </mat-form-field>


                                                      </span>
                                                    </td>
                                                    <!-- <td data-th="Navigation" style="width: 90%;">
                                                  
      
                                                </td> -->
                                                    <td fxLayout.xs="column" data-th="Category" style="width: 100%;">
                                                      <mat-form-field style="width: 100%;" fxFlex="100">

                                                        <mat-label>{{ImageInfo.controls['navigation'].value
                                                          ==0?'Category':'Url'}}</mat-label>

                                                        <mat-select *ngIf="ImageInfo.controls['navigation']
                                                  .value==0" required formControlName="catId"
                                                          [disableOptionCentering]="true" #singleSelect name="item">
                                                          <mat-option>
                                                            <ngx-mat-select-search name="Category Search"
                                                              ngDefaultControl [formControl]="
                                                      categoryFilterControl
                                                    " placeholderLabel="Category Search"
                                                              [preventHomeEndKeyPropagation]="
                                                      true
                                                    " noEntriesFoundLabel="No data found">
                                                            </ngx-mat-select-search>
                                                          </mat-option>
                                                          <mat-option *ngFor="
                                                    let opt of filteredCategoryTypeList
                                                  " [value]="opt.categoryId">
                                                            {{ opt.categoryName }}
                                                          </mat-option>
                                                        </mat-select>

                                                        <input
                                                          [attr.guide]="'template-inp-navigatedurl' + '__' + sanitizedUrl"
                                                          style="width: 100%;" *ngIf="ImageInfo.controls['navigation']
                                                  .value==1" trim="blur" (keydown.enter)="$event.preventDefault()"
                                                          [autocomplete]="'off'" matInput
                                                          formControlName="navigatedUrl" />

                                                      </mat-form-field>
                                                    </td>

                                                    <td
                                                      *ngIf="comp.controls['customField23'].value=='15'&& layoutMainType !== 4 "
                                                      data-th="Animate View">
                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex>
                                                          <mat-label>Animate ImageView</mat-label>
                                                          <mat-select formControlName="customField10" name="item">
                                                            <mat-option *ngFor="
                                                      let item of animateType;
                                                      let i = index
                                                    " [value]="item.value">
                                                              {{ item.viewValue }}
                                                            </mat-option>
                                                          </mat-select>
                                                        </mat-form-field>
                                                      </span>
                                                    </td>

                                                    <td
                                                      *ngIf="comp.controls['customField23'].value=='16'&& layoutMainType !== 4 "
                                                      data-th="Animate View">
                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex>
                                                          <mat-label>Animate Type</mat-label>
                                                          <mat-select formControlName="customField10" name="item">
                                                            <mat-option *ngFor="let item of animeType;
                                                      let i = index
                                                    " [value]="item.value">
                                                              {{ item.viewValue }}
                                                            </mat-option>
                                                          </mat-select>
                                                        </mat-form-field>
                                                      </span>
                                                    </td>

                                                    <td
                                                      *ngIf="comp.controls['customField23'].value=='15'&& layoutMainType !== 4 "
                                                      data-th="Animate View">
                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex>
                                                          <mat-label>Animate subimg1 View</mat-label>
                                                          <mat-select formControlName="customField11" name="item">
                                                            <mat-option *ngFor="
                                                    let item of animateType;
                                                    let i = index
                                                  " [value]="item.value">
                                                              {{ item.viewValue }}
                                                            </mat-option>
                                                          </mat-select>
                                                        </mat-form-field>
                                                      </span>
                                                    </td>

                                                    <td
                                                      *ngIf="comp.controls['customField23'].value=='15'&& layoutMainType !== 4 "
                                                      data-th="Animate View">
                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex>
                                                          <mat-label>Animate subimg2 View</mat-label>
                                                          <mat-select formControlName="customField12" name="item">
                                                            <mat-option *ngFor="
                                                  let item of animateType;
                                                  let i = index
                                                " [value]="item.value">
                                                              {{ item.viewValue }}
                                                            </mat-option>
                                                          </mat-select>
                                                        </mat-form-field>
                                                      </span>
                                                    </td>

                                                    <td
                                                      *ngIf="comp.controls['customField23'].value=='15'&& layoutMainType !== 4 "
                                                      data-th="Animate View">
                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex>
                                                          <mat-label>Animate subimg3 View</mat-label>
                                                          <mat-select formControlName="customField13" name="item">
                                                            <mat-option *ngFor="
                                                let item of animateType;
                                                let i = index
                                              " [value]="item.value">
                                                              {{ item.viewValue }}
                                                            </mat-option>
                                                          </mat-select>
                                                        </mat-form-field>
                                                      </span>
                                                    </td>

                                                    <td data-th="Display on Which View">
                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex>
                                                          <mat-label>Display on Which View</mat-label>
                                                          <mat-select required formControlName="customField22"
                                                            name="item">
                                                            <mat-option *ngFor="
                                                          let item of displayMode1;
                                                          let i = index
                                                        " [value]="item.value">
                                                              {{ item.viewValue }}
                                                            </mat-option>
                                                          </mat-select>
                                                        </mat-form-field>
                                                      </span>
                                                    </td>

                                                    <td data-th="Action">
                                                      <button [attr.guide]="'template-btn-77' + '__' + sanitizedUrl"
                                                        color="warn" mat-icon-button type="button"
                                                        (click)="updateBanner( ImageInfo.controls['img'].value,i,k)">
                                                        <mat-icon>remove_circle_outline
                                                        </mat-icon>
                                                      </button>
                                                    </td>
                                                  </ng-container>
                                                </tr>
                                              </ng-container>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                      <div class="editSets1">
                                        <div class="title " fxLayout="row" fxLayoutAlign="center center">
                                          <span *ngIf=" _form.value.conditions[i].images.length<=0"
                                            fxLayoutAlign="center center">No
                                            Images
                                            Uploaded</span>
                                        </div>
                                        <div>
                                          <calsoft-common-file-upload (fileUploadResult)="getResultBanner($event, i)"
                                            [type]="'commonSlider'"></calsoft-common-file-upload>
                                        </div>


                                      </div>
                                      <div fxLayout="column"
                                        *ngIf="comp.controls['customField1'].value=='type3'||comp.controls['customField1'].value=='type4' || comp.controls['customField1'].value=='type5' || comp.controls['customField1'].value=='type6' ">
                                        <div fxFlex fxLayout="column" fxLayoutGap="10">
                                          <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">
                                            <calsoft-image fxFlex
                                              (deleteResult)="updatesIMage($event, i,'customField2')"
                                              (fileUploadResult)="
                                          getResultts($event, i,'customField2') " [index]="i"
                                              [value]="comp.controls['customField2'].value">
                                            </calsoft-image>
                                            <mat-form-field fxFlex>
                                              <mat-label>Category</mat-label>
                                              <mat-select required formControlName="categoryId1"
                                                [disableOptionCentering]="true" #singleSelect name="item">
                                                <mat-option>
                                                  <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                    [formControl]="
                                                  categoryFilterControl
                                                " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                  true
                                                " noEntriesFoundLabel="No data found">
                                                  </ngx-mat-select-search>
                                                </mat-option>
                                                <mat-option *ngFor="
                                                let opt of filteredCategoryTypeList
                                              " [value]="opt.categoryId">
                                                  {{ opt.categoryName }}
                                                </mat-option>
                                              </mat-select>
                                            </mat-form-field>
                                          </div>

                                          <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">

                                            <calsoft-image fxFlex
                                              (deleteResult)="updatesIMage($event, i,'customField3')"
                                              (fileUploadResult)="
                                        getResultts($event, i,'customField3')" [index]="i"
                                              [value]="comp.controls['customField3'].value">
                                            </calsoft-image>
                                            <mat-form-field fxFlex>
                                              <mat-label>Category</mat-label>
                                              <mat-select required formControlName="categoryId2"
                                                [disableOptionCentering]="true" #singleSelect name="item">
                                                <mat-option>
                                                  <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                    [formControl]="
                                                  categoryFilterControl
                                                " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                  true
                                                " noEntriesFoundLabel="No data found">
                                                  </ngx-mat-select-search>
                                                </mat-option>
                                                <mat-option *ngFor="
                                                let opt of filteredCategoryTypeList
                                              " [value]="opt.categoryId">
                                                  {{ opt.categoryName }}
                                                </mat-option>
                                              </mat-select>
                                            </mat-form-field>
                                          </div>
                                          <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">

                                            <calsoft-image fxFlex
                                              (deleteResult)="updatesIMage($event, i,'customField4')"
                                              (fileUploadResult)="
                                        getResultts($event, i,'customField4')" [index]="i"
                                              [value]="comp.controls['customField4'].value">
                                            </calsoft-image>
                                            <mat-form-field fxFlex>
                                              <mat-label>Category</mat-label>
                                              <mat-select required formControlName="categoryId3"
                                                [disableOptionCentering]="true" #singleSelect name="item">
                                                <mat-option>
                                                  <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                    [formControl]="
                                                  categoryFilterControl
                                                " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                  true
                                                " noEntriesFoundLabel="No data found">
                                                  </ngx-mat-select-search>
                                                </mat-option>
                                                <mat-option *ngFor="
                                                let opt of filteredCategoryTypeList
                                              " [value]="opt.categoryId">
                                                  {{ opt.categoryName }}
                                                </mat-option>
                                              </mat-select>
                                            </mat-form-field>
                                          </div>
                                        </div>

                                      </div>

                                      <div fxLayout="column"
                                        *ngIf="comp.controls['customField1'].value=='type7'||comp.controls['customField1'].value=='type8' || comp.controls['customField1'].value=='type9' || comp.controls['customField1'].value=='type10' ">
                                        <div fxFlex fxLayout="column" fxLayoutGap="10">
                                          <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">
                                            <calsoft-image fxFlex
                                              (deleteResult)="updatesIMage($event, i,'customField2')"
                                              (fileUploadResult)="
                                          getResultts($event, i,'customField2') " [index]="i"
                                              [value]="comp.controls['customField2'].value">
                                            </calsoft-image>
                                            <mat-form-field fxFlex>
                                              <mat-label>Category</mat-label>
                                              <mat-select required formControlName="categoryId1"
                                                [disableOptionCentering]="true" #singleSelect name="item">
                                                <mat-option>
                                                  <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                    [formControl]="
                                                  categoryFilterControl
                                                " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                  true
                                                " noEntriesFoundLabel="No data found">
                                                  </ngx-mat-select-search>
                                                </mat-option>
                                                <mat-option *ngFor="
                                                let opt of filteredCategoryTypeList
                                              " [value]="opt.categoryId">
                                                  {{ opt.categoryName }}
                                                </mat-option>
                                              </mat-select>
                                            </mat-form-field>

                                          </div>

                                          <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">

                                            <calsoft-image fxFlex
                                              (deleteResult)="updatesIMage($event, i,'customField3')"
                                              (fileUploadResult)="
                                        getResultts($event, i,'customField3')" [index]="i"
                                              [value]="comp.controls['customField3'].value">
                                            </calsoft-image>
                                            <mat-form-field fxFlex>
                                              <mat-label>Category</mat-label>
                                              <mat-select required formControlName="categoryId2"
                                                [disableOptionCentering]="true" #singleSelect name="item">
                                                <mat-option>
                                                  <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                    [formControl]="
                                                  categoryFilterControl
                                                " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                  true
                                                " noEntriesFoundLabel="No data found">
                                                  </ngx-mat-select-search>
                                                </mat-option>
                                                <mat-option *ngFor="
                                                let opt of filteredCategoryTypeList
                                              " [value]="opt.categoryId">
                                                  {{ opt.categoryName }}
                                                </mat-option>
                                              </mat-select>
                                            </mat-form-field>

                                            <mat-form-field fxFlex>
                                              <mat-label>Alt Tag</mat-label>
                                              <input [attr.guide]="'template-inp-altimage' + '__' + sanitizedUrl"
                                                (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                                trim="blur" matInput formControlName="altImage" />

                                            </mat-form-field>

                                          </div>

                                        </div>

                                      </div>


                                    </div>
                                  </div>
                                  <div *ngIf="(comp.controls['type'].value == 'ScrollNavigationwithImage')">

                                    <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                      *ngIf="(comp.controls['type'].value == 'ScrollNavigationwithImage')">
                                      <mat-form-field fxFlex="100">
                                        <mat-label>Title </mat-label>
                                        <input [attr.guide]="'template-inp-customfield1' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField1" />
                                      </mat-form-field>
                                      <mat-form-field>
                                        <mat-label>Title Web Font Size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield2' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField2" />
                                      </mat-form-field>
                                      <mat-form-field>
                                        <mat-label>Title Mobile Font Size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield3' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField3" />
                                      </mat-form-field>
                                    </div>
                                    <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                      *ngIf="(comp.controls['type'].value == 'ScrollNavigationwithImage')">
                                      <mat-form-field fxFlex>
                                        <mat-label>Description Web Font Size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield4' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField4" />
                                      </mat-form-field>
                                      <mat-form-field fxFlex>
                                        <mat-label>Description Mobile Font Size</mat-label>
                                        <input [attr.guide]="'template-inp-customfield5' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField5" />
                                      </mat-form-field>
                                      <mat-form-field fxFlex>
                                        <mat-label>Slide Image Height</mat-label>
                                        <input [attr.guide]="'template-inp-customfield9' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField9" />
                                      </mat-form-field>
                                      <mat-form-field fxFlex>
                                        <mat-label>Slide Image Mobile Weight</mat-label>
                                        <input [attr.guide]="'template-inp-customfield10' + '__' + sanitizedUrl"
                                          trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                          matInput formControlName="customField10" />
                                      </mat-form-field>
                                    </div>
                                    <div *ngIf="(comp.controls['type'].value == 'ScrollNavigationwithImage')">

                                      <div class="editSets">
                                        <div class="title-head3" fxLayoutAlign="space-between center" color="primary">
                                          <span>Slide Information</span>

                                          <button [attr.guide]="'template-btn-78' + '__' + sanitizedUrl" class="create"
                                            (click)=" addFaq(i)" type="button" mat-mini-fab color="primary">
                                            <mat-icon>add</mat-icon>
                                          </button>
                                        </div>
                                        <div id="responsieTable" class="container">
                                          <table fxFlex="100">
                                            <tbody fxFlex="100">
                                              <ng-container formArrayName="images">
                                                <tr fxLayout.xs="column"
                                                  *ngFor="let ImageInfo of comp.get('images')?.controls; let y = index">
                                                  <ng-container [formGroupName]="y"
                                                    fxLayoutAlign="space-between center">
                                                    <td fxFlex.xs="100" fxFlex="30" data-th="Filename"
                                                      fxLayoutGap="10px">
                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex="100" appearance="outline">
                                                          <mat-label>Slide Name</mat-label>
                                                          <textarea
                                                            [attr.guide]="'template-sel-customfield6' + '__' + sanitizedUrl"
                                                            trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                            matAutosizeMaxRows=5 matInput
                                                            formControlName="customField6"></textarea>
                                                          <mat-icon class="clickable"
                                                            (click)="openEditorTextForImageArray(ImageInfo.controls['customField6'].value,i,'customField6',y)"
                                                            matSuffix>
                                                            post_add
                                                          </mat-icon>
                                                        </mat-form-field>
                                                      </span>
                                                    </td>


                                                    <td fxFlex.xs="100" fxFlex="30" data-th="Filename"
                                                      fxLayoutGap="10px">
                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex="100" appearance="outline">
                                                          <mat-label>Slide Description</mat-label>
                                                          <textarea
                                                            [attr.guide]="'template-sel-customfield7' + '__' + sanitizedUrl"
                                                            trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                            matAutosizeMaxRows=5 matInput
                                                            formControlName="customField7"></textarea>
                                                          <mat-icon class="clickable"
                                                            (click)="openEditorTextForImageArray(ImageInfo.controls['customField7'].value,i,'customField7',y)"
                                                            matSuffix>
                                                            post_add
                                                          </mat-icon>
                                                        </mat-form-field>
                                                      </span>
                                                    </td>

                                                    <td fxFlex.xs="100" fxFlex="30" data-th="Filename"
                                                      fxLayoutGap="10px">
                                                      <span class="wordBreak">
                                                        <calsoft-image fxFlex="100" style="padding-bottom: 10px;"
                                                          (deleteResult)="updatesImageArray($event, i,'customField8',y)"
                                                          (fileUploadResult)="
                                            getResultArray($event, i,'customField8',y) " [index]="y"
                                                          [value]="ImageInfo.controls['customField8'].value">
                                                        </calsoft-image>
                                                      </span>
                                                    </td>


                                                    <td data-th="Action">
                                                      <span class="wordBreak">
                                                        <button [attr.guide]="'template-btn-79' + '__' + sanitizedUrl"
                                                          color="warn" mat-icon-button type="button"
                                                          (click)="deleteText(i,y)">
                                                          <mat-icon>remove_circle_outline
                                                          </mat-icon>
                                                        </button>
                                                      </span>
                                                    </td>
                                                  </ng-container>
                                                </tr>
                                              </ng-container>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>

                                  </div>


                                  <!-- brandsCarousel type 15 -->

                                  <div *ngIf="comp.controls['customField23'].value=='15'">
                                    <div *ngIf="(comp.controls['type'].value == 'brandsCarousel')">

                                      <div class="editSets">
                                        <div class="title-head3" fxLayoutAlign="space-between center" color="primary">
                                          <span>Item List</span>

                                          <button [attr.guide]="'template-btn-80' + '__' + sanitizedUrl" class="create"
                                            (click)="addbrandCarosel(i)" type="button" mat-mini-fab color="primary">
                                            <mat-icon>add</mat-icon>
                                          </button>
                                        </div>

                                        <div id="responsieTable" class="container" style="overflow-x:auto;">
                                          <table class="padding-10">
                                            <tbody>

                                              <ng-container formArrayName="images">
                                                <ng-container
                                                  *ngFor="let ImageInfo of comp.get('images')?.controls; let y = index">
                                                  <div [formGroupName]="y">
                                                    <tr fxLayout="row">
                                                      <ng-container fxLayoutAlign="space-between center">
                                                        <td fxFlex data-th="Filename" fxLayoutGap="10px">
                                                          <span class="wordBreak">
                                                            <div style="display: flex; gap: 20px;">
                                                              <mat-form-field fxFlex appearance="outline">
                                                                <mat-label>Background Color</mat-label>
                                                                <input
                                                                  [attr.guide]="'template-inp-customfield4' + '__' + sanitizedUrl"
                                                                  (keydown.enter)="$event.preventDefault()" trim="blur"
                                                                  [autocomplete]="'off'" trim="blur"
                                                                  formControlName="customField4" matInput />
                                                              </mat-form-field>
                                                            </div>
                                                          </span>
                                                        </td>

                                                        <td fxFlex data-th="Filename" fxLayoutGap="10px">
                                                          <span class="wordBreak">
                                                            <div style="display: flex; gap: 20px;">
                                                              <mat-form-field fxFlex appearance="outline">
                                                                <mat-label>Title</mat-label>
                                                                <input
                                                                  [attr.guide]="'template-inp-customfield5' + '__' + sanitizedUrl"
                                                                  (keydown.enter)="$event.preventDefault()" trim="blur"
                                                                  [autocomplete]="'off'" trim="blur"
                                                                  formControlName="customField5" matInput />
                                                              </mat-form-field>
                                                            </div>
                                                          </span>
                                                        </td>

                                                        <td fxFlex data-th="Filename" fxLayoutGap="10px">
                                                          <span class="wordBreak">
                                                            <div style="display: flex; gap: 20px;">
                                                              <mat-form-field fxFlex appearance="outline">
                                                                <mat-label>Sub title</mat-label>
                                                                <input
                                                                  [attr.guide]="'template-inp-customfield6' + '__' + sanitizedUrl"
                                                                  (keydown.enter)="$event.preventDefault()" trim="blur"
                                                                  [autocomplete]="'off'" trim="blur"
                                                                  formControlName="customField6" matInput />
                                                              </mat-form-field>
                                                            </div>
                                                          </span>
                                                        </td>

                                                        <td fxFlex data-th="Filename" fxLayoutGap="10px">
                                                          <span class="wordBreak">
                                                            <div style="display: flex; gap: 20px;">
                                                              <mat-form-field fxFlex appearance="outline">
                                                                <mat-label>Button 1</mat-label>
                                                                <input
                                                                  [attr.guide]="'template-inp-customfield7' + '__' + sanitizedUrl"
                                                                  (keydown.enter)="$event.preventDefault()" trim="blur"
                                                                  [autocomplete]="'off'" trim="blur"
                                                                  formControlName="customField7" matInput />
                                                              </mat-form-field>
                                                            </div>
                                                          </span>
                                                        </td>

                                                        <td fxFlex data-th="Filename" fxLayoutGap="10px">
                                                          <span class="wordBreak">
                                                            <div style="display: flex; gap: 20px;">
                                                              <mat-form-field fxFlex appearance="outline">
                                                                <mat-label>Button Link</mat-label>
                                                                <input
                                                                  [attr.guide]="'template-inp-customfield8' + '__' + sanitizedUrl"
                                                                  (keydown.enter)="$event.preventDefault()" trim="blur"
                                                                  [autocomplete]="'off'" trim="blur"
                                                                  formControlName="customField8" matInput />
                                                              </mat-form-field>
                                                            </div>
                                                          </span>
                                                        </td>

                                                        <td fxFlex data-th="Filename" fxLayoutGap="10px">
                                                          <span class="wordBreak">
                                                            <div style="display: flex; gap: 20px;">
                                                              <mat-form-field fxFlex appearance="outline">
                                                                <mat-label>Button 2</mat-label>
                                                                <input
                                                                  [attr.guide]="'template-inp-customfield9' + '__' + sanitizedUrl"
                                                                  (keydown.enter)="$event.preventDefault()" trim="blur"
                                                                  [autocomplete]="'off'" trim="blur"
                                                                  formControlName="customField9" matInput />
                                                              </mat-form-field>
                                                            </div>
                                                          </span>
                                                        </td>

                                                        <td fxFlex data-th="Filename" fxLayoutGap="10px">
                                                          <span class="wordBreak">
                                                            <div style="display: flex; gap: 20px;">
                                                              <mat-form-field fxFlex appearance="outline">
                                                                <mat-label>Button Link 2</mat-label>
                                                                <input
                                                                  [attr.guide]="'template-inp-customfield10' + '__' + sanitizedUrl"
                                                                  (keydown.enter)="$event.preventDefault()" trim="blur"
                                                                  [autocomplete]="'off'" trim="blur"
                                                                  formControlName="customField10" matInput />
                                                              </mat-form-field>
                                                            </div>
                                                          </span>
                                                        </td>


                                                        <td fxFlex data-th="Filename" fxLayoutGap="10px">
                                                          <span class="wordBreak">
                                                            <div style="display: flex">
                                                              <mat-form-field fxFlex appearance="outline">
                                                                <mat-label>Type</mat-label>
                                                                <mat-select
                                                                  (selectionChange)="onChangeImageTab($event, i,y)"
                                                                  required formControlName="customField3" name="item">
                                                                  <mat-option *ngFor="let item of Brandslayout;"
                                                                    [value]="item.value">
                                                                    {{ item.viewValue }}
                                                                  </mat-option>
                                                                </mat-select>
                                                              </mat-form-field>
                                                            </div>
                                                          </span>
                                                        </td>

                                                        <td data-th="Action">
                                                          <span class="wordBreak">
                                                            <button
                                                              [attr.guide]="'template-btn-81' + '__' + sanitizedUrl"
                                                              color="warn" mat-icon-button type="button"
                                                              (click)="deleteText(i,y)">
                                                              <mat-icon>remove_circle_outline
                                                              </mat-icon>
                                                            </button>
                                                          </span>
                                                        </td>
                                                      </ng-container>
                                                    </tr>


                                                    <tr fxLayout="row">
                                                      <td *ngIf="ImageInfo.controls.customField3.value == 'Image'">
                                                        <div class="editSets">
                                                          <div class="title-head3" color="primary">
                                                            <span style="width: 100%;">Image</span>
                                                          </div>
                                                          <div id="responsieTable" class="container">
                                                            <table class="rwd-table">
                                                              <tbody>
                                                                <tr>
                                                                  <th>Image</th>
                                                                  <th>Effect</th>
                                                                  <th>Align Left</th>
                                                                  <th>Align Top</th>
                                                                  <th>Height</th>
                                                                  <th>Align Mob Left</th>
                                                                  <th>Align Mob Top</th>
                                                                  <th>Mob Height</th>
                                                                  <th>Action</th>
                                                                </tr>
                                                                <ng-container formArrayName="subChild">
                                                                  <tr *ngFor="let subChildImageInfo of ImageInfo.get('subChild')?.controls;
                                                                 let k = index">
                                                                    <ng-container [formGroupName]="k">
                                                                      <td data-th="Image" style="width: 60%;">
                                                                        <!-- <img style="height: 65px;width: auto;"
                                                                          [src]="bannerServerPath+ subChildImageInfo.controls['customField6'].value"
                                                                          onerror="this.src='assets/images/logo/no-image.png';"
                                                                          alt=""> -->
                                                                        <calsoft-common-images
                                                                          [src]="bannerServerPath+ subChildImageInfo.controls['customField6'].value"
                                                                          [height]="'65px'" [width]="'auto'" [alt]="">

                                                                        </calsoft-common-images>
                                                                      </td>
                                                                      <td data-th="Filename" style="width: 50%;">
                                                                        <span class="wordBreak">
                                                                          <mat-form-field fxFlex appearance="outline">
                                                                            <mat-label>Effect</mat-label>
                                                                            <input
                                                                              [attr.guide]="'template-inp-customfield5' + '__' + sanitizedUrl"
                                                                              trim="blur"
                                                                              (keydown.enter)="$event.preventDefault()"
                                                                              [autocomplete]="'off'" matInput
                                                                              formControlName="customField5" />
                                                                            <!-- <mat-icon class="clickable"
                                                                            (click)="openEditorTextForSubChildArray(subChildImageInfo.controls['customField5'].value,i,'customField5', k, y)"
                                                                            matSuffix>
                                                                            post_add
                                                                          </mat-icon> -->
                                                                          </mat-form-field>
                                                                        </span>
                                                                      </td>

                                                                      <td>
                                                                        <calsoft-image style="padding-bottom: 10px;"
                                                                          (deleteResult)="updatesImageArraySubschild($event, i,'customField13',y,k)"
                                                                          (fileUploadResult)="
                                                                        getResultArraySubChild($event, i,'customField13',y,k) "
                                                                          [index]="k"
                                                                          [value]="subChildImageInfo.controls['customField13'].value">
                                                                        </calsoft-image>
                                                                      </td>

                                                                      <td data-th="Filename" style="width: 50%;">
                                                                        <span class="wordBreak">
                                                                          <mat-form-field fxFlex appearance="outline">
                                                                            <mat-label>Align Left</mat-label>
                                                                            <input
                                                                              [attr.guide]="'template-inp-customfield7' + '__' + sanitizedUrl"
                                                                              trim="blur"
                                                                              (keydown.enter)="$event.preventDefault()"
                                                                              [autocomplete]="'off'" matInput
                                                                              formControlName="customField7" />
                                                                          </mat-form-field>
                                                                        </span>
                                                                      </td>

                                                                      <td data-th="Filename" style="width: 50%;">
                                                                        <span class="wordBreak">
                                                                          <mat-form-field fxFlex appearance="outline">
                                                                            <mat-label>Align Top</mat-label>
                                                                            <input
                                                                              [attr.guide]="'template-inp-customfield8' + '__' + sanitizedUrl"
                                                                              trim="blur"
                                                                              (keydown.enter)="$event.preventDefault()"
                                                                              [autocomplete]="'off'" matInput
                                                                              formControlName="customField8" />
                                                                          </mat-form-field>
                                                                        </span>
                                                                      </td>

                                                                      <td data-th="Filename" style="width: 50%;">
                                                                        <span class="wordBreak">
                                                                          <mat-form-field fxFlex appearance="outline">
                                                                            <mat-label>height</mat-label>
                                                                            <input
                                                                              [attr.guide]="'template-inp-customfield9' + '__' + sanitizedUrl"
                                                                              trim="blur"
                                                                              (keydown.enter)="$event.preventDefault()"
                                                                              [autocomplete]="'off'" matInput
                                                                              formControlName="customField9" />
                                                                          </mat-form-field>
                                                                        </span>
                                                                      </td>

                                                                      <td data-th="Filename" style="width: 50%;">
                                                                        <span class="wordBreak">
                                                                          <mat-form-field fxFlex appearance="outline">
                                                                            <mat-label>Align Mobile Left</mat-label>
                                                                            <input
                                                                              [attr.guide]="'template-inp-customfield10' + '__' + sanitizedUrl"
                                                                              trim="blur"
                                                                              (keydown.enter)="$event.preventDefault()"
                                                                              [autocomplete]="'off'" matInput
                                                                              formControlName="customField10" />
                                                                          </mat-form-field>
                                                                        </span>
                                                                      </td>

                                                                      <td data-th="Filename" style="width: 50%;">
                                                                        <span class="wordBreak">
                                                                          <mat-form-field fxFlex appearance="outline">
                                                                            <mat-label>Align Mobile Top</mat-label>
                                                                            <input
                                                                              [attr.guide]="'template-inp-customfield11' + '__' + sanitizedUrl"
                                                                              trim="blur"
                                                                              (keydown.enter)="$event.preventDefault()"
                                                                              [autocomplete]="'off'" matInput
                                                                              formControlName="customField11" />
                                                                          </mat-form-field>
                                                                        </span>
                                                                      </td>

                                                                      <td data-th="Filename" style="width: 50%;">
                                                                        <span class="wordBreak">
                                                                          <mat-form-field fxFlex appearance="outline">
                                                                            <mat-label>Mobile height</mat-label>
                                                                            <input
                                                                              [attr.guide]="'template-inp-customfield12' + '__' + sanitizedUrl"
                                                                              trim="blur"
                                                                              (keydown.enter)="$event.preventDefault()"
                                                                              [autocomplete]="'off'" matInput
                                                                              formControlName="customField12" />
                                                                          </mat-form-field>
                                                                        </span>
                                                                      </td>


                                                                      <td data-th="Action">
                                                                        <button
                                                                          [attr.guide]="'template-btn-82' + '__' + sanitizedUrl"
                                                                          color="warn" mat-icon-button type="button"
                                                                          (click)="updateBannerChild( subChildImageInfo.controls['customField6'].value,i,y,k)">
                                                                          <mat-icon>remove_circle_outline
                                                                          </mat-icon>
                                                                        </button>
                                                                      </td>
                                                                    </ng-container>
                                                                  </tr>
                                                                </ng-container>
                                                              </tbody>
                                                            </table>
                                                          </div>
                                                        </div>
                                                        <div class="editSets1">
                                                          <div class="title " fxLayout="row"
                                                            fxLayoutAlign="center center">
                                                            <span
                                                              *ngIf=" _form.value.conditions[i].images[y].subChild.length<=0"
                                                              fxLayoutAlign="center center">No
                                                              Images
                                                              Uploaded</span>
                                                          </div>
                                                          <div>
                                                            <calsoft-common-file-upload
                                                              (fileUploadResult)="getResultBannerChild($event, i,y)"
                                                              [type]="'commonSlider'"></calsoft-common-file-upload>
                                                          </div>
                                                        </div>
                                                      </td>
                                                    </tr>

                                                  </div>

                                                </ng-container>
                                              </ng-container>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>

                                    </div>
                                  </div>


                                  <!-- scrollTextWithImage -->
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="(comp.controls['type'].value == 'sliderImageWithText')">
                                    <mat-form-field fxFlex="100">
                                      <mat-label>Title Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield33' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField33" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex="100">
                                      <mat-label>Title Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield34' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField34" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex="100">
                                      <mat-label>Image Title Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield35' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField35" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex="100">
                                      <mat-label>Image Title Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield36' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField36" />
                                    </mat-form-field>


                                  </div>
                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="(comp.controls['type'].value == 'sliderImageWithText')">
                                    <mat-form-field fxFlex="100">
                                      <mat-label>Description Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield37' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField37" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex="100">
                                      <mat-label>Description Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield38' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField38" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex="100">
                                      <mat-label>Inner Text Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield39' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField39" />
                                    </mat-form-field>
                                    <mat-form-field fxFlex="100">
                                      <mat-label>Inner Text Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield40' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField40" />
                                    </mat-form-field>


                                  </div>

                                  <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                    *ngIf="(comp.controls['type'].value == 'sliderImageWithText')">
                                    <mat-form-field fxFlex="40" appearance="outline">
                                      <mat-label>Inner Text</mat-label>
                                      <input [attr.guide]="'template-inp-customfield15' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" trim="blur" [autocomplete]="'off'"
                                        trim="blur" formControlName="customField15" matInput />
                                      <mat-icon class="clickable"
                                        (click)="openEditorText(comp.controls['customField15'].value,i,'customField15')"
                                        matSuffix>
                                        post_add
                                      </mat-icon>
                                    </mat-form-field>

                                  </div>

                                  <div fxLayout="column"
                                    *ngIf="(comp.controls['type'].value == 'sliderImageWithText') ">
                                    <div class="editSets">
                                      <div class="title-head3" color="primary">
                                        <span>Image</span>
                                      </div>
                                      <div id="responsieTable" class="container" style="overflow-x:auto;">
                                        <table class="rwd-table">
                                          <tbody>
                                            <tr>
                                              <th>Image</th>
                                              <th>Filename</th>
                                              <th>Alt Tag</th>
                                              <th>Title</th>
                                              <th>Description</th>
                                              <th>Navigation</th>
                                              <th>Category</th>
                                              <th>Action</th>
                                            </tr>
                                            <ng-container formArrayName="images">
                                              <tr
                                                *ngFor="let ImageInfo of comp.get('images')?.controls;; let k = index">
                                                <ng-container [formGroupName]="k">
                                                  <td data-th="Image" style="width: 60%;">
                                                    <!-- <img style="height: 65px;width: auto;"
                                                      [src]="bannerServerPath+ ImageInfo.controls['img'].value"
                                                      onerror="this.src='assets/images/logo/no-image.png';" alt=""> -->
                                                    <calsoft-common-images
                                                      [src]="bannerServerPath+ ImageInfo.controls['img'].value"
                                                      [height]="'65px'" [width]="'auto'" [alt]="">

                                                    </calsoft-common-images>
                                                  </td>
                                                  <td data-th="Filename" style="width: 90%;">
                                                    <span class="wordBreak">
                                                      {{ ImageInfo.controls['img'].value}}
                                                    </span>
                                                  </td>
                                                  <td>
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="100" appearance="outline">
                                                        <mat-label>Alt Tag</mat-label>
                                                        <input
                                                          [attr.guide]="'template-inp-altimage' + '__' + sanitizedUrl"
                                                          trim="blur" (keydown.enter)="$event.preventDefault()"
                                                          [autocomplete]="'off'" matInput formControlName="altImage" />
                                                      </mat-form-field>
                                                    </span>
                                                  </td>
                                                  <td>
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="100" appearance="outline">
                                                        <mat-label>Title</mat-label>
                                                        <input
                                                          [attr.guide]="'template-inp-customfield20' + '__' + sanitizedUrl"
                                                          trim="blur" (keydown.enter)="$event.preventDefault()"
                                                          [autocomplete]="'off'" matInput
                                                          formControlName="customField20" />
                                                      </mat-form-field>
                                                    </span>
                                                  </td>
                                                  <td>
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="100" appearance="outline">
                                                        <mat-label>Description</mat-label>
                                                        <textarea
                                                          [attr.guide]="'template-sel-customfield21' + '__' + sanitizedUrl"
                                                          trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                          matAutosizeMaxRows=5 matInput
                                                          formControlName="customField21"></textarea>
                                                        <mat-icon class="clickable"
                                                          (click)="openEditorTextForImageArray(ImageInfo.controls['customField21'].value,i,'customField21',k)"
                                                          matSuffix>
                                                          post_add
                                                        </mat-icon>
                                                        <mat-hint fxHide.lt-md>Click on the icon to open
                                                          editor</mat-hint>
                                                      </mat-form-field>
                                                    </span>
                                                  </td>


                                                  <td fxLayout.xs="column" class="mobilewidth" data-th="Filename"
                                                    style="width: 20%;">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex>
                                                        <mat-label>Navigation</mat-label>
                                                        <mat-select required formControlName="navigation" name="item">
                                                          <mat-option *ngFor="
                                                          let item of navigation;
                                                          let i = index
                                                        " [value]="item.value">
                                                            {{ item.viewValue }}
                                                          </mat-option>
                                                        </mat-select>
                                                      </mat-form-field>


                                                    </span>
                                                  </td>
                                                  <!-- <td data-th="Navigation" style="width: 90%;">
                                                  
      
                                                </td> -->
                                                  <td fxLayout="row" fxLayout.xs="column" class="mobilewidth"
                                                    data-th="Category" style="width: 20%;">
                                                    <mat-form-field fxFlex>

                                                      <mat-label>{{ImageInfo.controls['navigation'].value
                                                        ==0?'Category':'Url'}}</mat-label>

                                                      <mat-select *ngIf="ImageInfo.controls['navigation']
                                                  .value==0" required formControlName="catId"
                                                        [disableOptionCentering]="true" #singleSelect name="item">
                                                        <mat-option>
                                                          <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                            [formControl]="
                                                      categoryFilterControl
                                                    " placeholderLabel="Category Search"
                                                            [preventHomeEndKeyPropagation]="
                                                      true
                                                    " noEntriesFoundLabel="No data found">
                                                          </ngx-mat-select-search>
                                                        </mat-option>
                                                        <mat-option *ngFor="
                                                    let opt of filteredCategoryTypeList
                                                  " [value]="opt.categoryId">
                                                          {{ opt.categoryName }}
                                                        </mat-option>
                                                      </mat-select>


                                                      <input
                                                        [attr.guide]="'template-inp-navigatedurl' + '__' + sanitizedUrl"
                                                        *ngIf="ImageInfo.controls['navigation']
                                                  .value==1" trim="blur" (keydown.enter)="$event.preventDefault()"
                                                        [autocomplete]="'off'" matInput
                                                        formControlName="navigatedUrl" />


                                                    </mat-form-field>
                                                  </td>

                                                  <td data-th="Action">
                                                    <button [attr.guide]="'template-btn-83' + '__' + sanitizedUrl"
                                                      color="warn" mat-icon-button type="button"
                                                      (click)="updateBanner( ImageInfo.controls['img'].value,i,k)">
                                                      <mat-icon>remove_circle_outline
                                                      </mat-icon>
                                                    </button>
                                                  </td>
                                                </ng-container>
                                              </tr>
                                            </ng-container>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                    <div class="editSets1">
                                      <div class="title " fxLayout="row" fxLayoutAlign="center center">
                                        <span *ngIf=" _form.value.conditions[i].images.length<=0"
                                          fxLayoutAlign="center center">No
                                          Images
                                          Uploaded</span>
                                      </div>
                                      <div>
                                        <calsoft-common-file-upload (fileUploadResult)="getResultBanner($event, i)"
                                          [type]="'commonSlider'"></calsoft-common-file-upload>
                                      </div>


                                    </div>
                                    <div fxLayout="column"
                                      *ngIf="comp.controls['customField1'].value=='type3'||comp.controls['customField1'].value=='type4' || comp.controls['customField1'].value=='type5' || comp.controls['customField1'].value=='type6' ">
                                      <div fxFlex fxLayout="column" fxLayoutGap="10">
                                        <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">
                                          <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField2')"
                                            (fileUploadResult)="
                                          getResultts($event, i,'customField2') " [index]="i"
                                            [value]="comp.controls['customField2'].value">
                                          </calsoft-image>
                                          <mat-form-field fxFlex>
                                            <mat-label>Category</mat-label>
                                            <mat-select required formControlName="categoryId1"
                                              [disableOptionCentering]="true" #singleSelect name="item">
                                              <mat-option>
                                                <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                  [formControl]="
                                                  categoryFilterControl
                                                " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                  true
                                                " noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                              </mat-option>
                                              <mat-option *ngFor="
                                                let opt of filteredCategoryTypeList
                                              " [value]="opt.categoryId">
                                                {{ opt.categoryName }}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                        </div>

                                        <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">

                                          <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField3')"
                                            (fileUploadResult)="
                                        getResultts($event, i,'customField3')" [index]="i"
                                            [value]="comp.controls['customField3'].value">
                                          </calsoft-image>
                                          <mat-form-field fxFlex>
                                            <mat-label>Category</mat-label>
                                            <mat-select required formControlName="categoryId2"
                                              [disableOptionCentering]="true" #singleSelect name="item">
                                              <mat-option>
                                                <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                  [formControl]="
                                                  categoryFilterControl
                                                " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                  true
                                                " noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                              </mat-option>
                                              <mat-option *ngFor="
                                                let opt of filteredCategoryTypeList
                                              " [value]="opt.categoryId">
                                                {{ opt.categoryName }}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                        </div>
                                        <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">

                                          <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField4')"
                                            (fileUploadResult)="
                                        getResultts($event, i,'customField4')" [index]="i"
                                            [value]="comp.controls['customField4'].value">
                                          </calsoft-image>
                                          <mat-form-field fxFlex>
                                            <mat-label>Category</mat-label>
                                            <mat-select required formControlName="categoryId3"
                                              [disableOptionCentering]="true" #singleSelect name="item">
                                              <mat-option>
                                                <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                  [formControl]="
                                                  categoryFilterControl
                                                " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                  true
                                                " noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                              </mat-option>
                                              <mat-option *ngFor="
                                                let opt of filteredCategoryTypeList
                                              " [value]="opt.categoryId">
                                                {{ opt.categoryName }}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                        </div>
                                      </div>

                                    </div>

                                    <div fxLayout="column"
                                      *ngIf="comp.controls['customField1'].value=='type7'||comp.controls['customField1'].value=='type8' || comp.controls['customField1'].value=='type9' || comp.controls['customField1'].value=='type10' ">
                                      <div fxFlex fxLayout="column" fxLayoutGap="10">
                                        <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">
                                          <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField2')"
                                            (fileUploadResult)="
                                          getResultts($event, i,'customField2') " [index]="i"
                                            [value]="comp.controls['customField2'].value">
                                          </calsoft-image>
                                          <mat-form-field fxFlex>
                                            <mat-label>Category</mat-label>
                                            <mat-select required formControlName="categoryId1"
                                              [disableOptionCentering]="true" #singleSelect name="item">
                                              <mat-option>
                                                <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                  [formControl]="
                                                  categoryFilterControl
                                                " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                  true
                                                " noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                              </mat-option>
                                              <mat-option *ngFor="
                                                let opt of filteredCategoryTypeList
                                              " [value]="opt.categoryId">
                                                {{ opt.categoryName }}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>

                                        </div>

                                        <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">

                                          <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField3')"
                                            (fileUploadResult)="
                                        getResultts($event, i,'customField3')" [index]="i"
                                            [value]="comp.controls['customField3'].value">
                                          </calsoft-image>
                                          <mat-form-field fxFlex>
                                            <mat-label>Category</mat-label>
                                            <mat-select required formControlName="categoryId2"
                                              [disableOptionCentering]="true" #singleSelect name="item">
                                              <mat-option>
                                                <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                  [formControl]="
                                                  categoryFilterControl
                                                " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                  true
                                                " noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                              </mat-option>
                                              <mat-option *ngFor="
                                                let opt of filteredCategoryTypeList
                                              " [value]="opt.categoryId">
                                                {{ opt.categoryName }}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>

                                          <mat-form-field fxFlex>
                                            <mat-label>Alt Tag</mat-label>
                                            <input [attr.guide]="'template-inp-altimage' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" matInput formControlName="altImage" />

                                          </mat-form-field>

                                        </div>

                                      </div>

                                    </div>


                                  </div>


                                  <!-- bannerWithButton -->

                                  <div fxLayout="column"
                                    *ngIf="(comp.controls['type'].value == 'bannerTextWithButton') ">
                                    <div class="editSets">
                                      <div class="title-head3" color="primary">
                                        <span>Image</span>
                                      </div>
                                      <div id="responsieTable" class="container" style="overflow-x:auto;">
                                        <table class="rwd-table">
                                          <tbody>
                                            <tr>
                                              <th fxFlex="10">Image</th>
                                              <th fxFlex="10">Filename</th>
                                              <th fxFlex="15">Title</th>
                                              <th fxFlex="20">Description</th>
                                              <th fxFlex="13">Button</th>
                                              <th fxFlex="14">Navigation</th>
                                              <th fxFlex="13">Position</th>
                                              <th fxFlex="5">Action</th>
                                            </tr>
                                            <ng-container formArrayName="images">
                                              <ng-container
                                                *ngFor="let ImageInfo of comp.get('images')?.controls;; let M = index">
                                                <ng-container [formGroupName]="M">
                                                  <tr fxLayout.xs="column">
                                                    <td data-th="Image">
                                                      <!-- <img style="height: 65px;width: auto;"
                                                        [src]="bannerServerPath+ ImageInfo.controls['img'].value"
                                                        onerror="this.src='assets/images/logo/no-image.png';" alt=""> -->

                                                      <calsoft-common-images
                                                        [src]="bannerServerPath+ ImageInfo.controls['img'].value"
                                                        [height]="'65px'" [width]="'auto'" [alt]="">

                                                      </calsoft-common-images>
                                                    </td>
                                                    <td fxFlex="10" class="mobilewidth" data-th="Filename">
                                                      <span class="wordBreak">
                                                        {{ ImageInfo.controls['img'].value}}
                                                      </span>
                                                    </td>
                                                    <td fxFlex="15" data-th="Title">

                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex="100" appearance="outline">
                                                          <mat-label>Title</mat-label>
                                                          <textarea
                                                            [attr.guide]="'template-sel-customfield4' + '__' + sanitizedUrl"
                                                            trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                            matAutosizeMaxRows=5 matInput
                                                            formControlName="customField4"></textarea>
                                                          <mat-icon class="clickable"
                                                            (click)="openEditorTextForImageArray(ImageInfo.controls['customField4'].value,i,'customField4',M)"
                                                            matSuffix>
                                                            post_add
                                                          </mat-icon>
                                                        </mat-form-field>
                                                      </span>
                                                    </td>

                                                    <td fxFlex="20" data-th="Description">
                                                      <span class="wordBreak">

                                                        <mat-form-field fxFlex="100" appearance="outline">
                                                          <mat-label>Banner Description</mat-label>
                                                          <textarea
                                                            [attr.guide]="'template-sel-customfield5' + '__' + sanitizedUrl"
                                                            trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                            matAutosizeMaxRows=5 matInput
                                                            formControlName="customField5"></textarea>
                                                          <mat-icon class="clickable"
                                                            (click)="openEditorTextForImageArray(ImageInfo.controls['customField5'].value,i,'customField5',M)"
                                                            matSuffix>
                                                            post_add
                                                          </mat-icon>
                                                        </mat-form-field>
                                                      </span>
                                                    </td>

                                                    <td fxFlex="13" data-th="Button">
                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex="80" class="mobilewidth">
                                                          <mat-label>Button</mat-label>
                                                          <input
                                                            [attr.guide]="'template-inp-customfield3' + '__' + sanitizedUrl"
                                                            (keydown.enter)="$event.preventDefault()" trim="blur"
                                                            [autocomplete]="'off'" formControlName="customField3"
                                                            matInput />
                                                        </mat-form-field>
                                                      </span>
                                                    </td>

                                                    <td fxFlex="14" data-th="Navigation">
                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex="80" class="mobilewidth">
                                                          <mat-label>Navigation</mat-label>
                                                          <input
                                                            [attr.guide]="'template-inp-customfield6' + '__' + sanitizedUrl"
                                                            (keydown.enter)="$event.preventDefault()" trim="blur"
                                                            [autocomplete]="'off'" formControlName="customField6"
                                                            matInput />
                                                        </mat-form-field>
                                                      </span>
                                                    </td>

                                                    <td fxLayout.xs="Column" fxFlex="13" data-th="Position">
                                                      <mat-form-field fxFlex="80" class="mobilewidth">
                                                        <mat-label>Alignment</mat-label>
                                                        <mat-select formControlName="customField28">
                                                          <mat-option *ngFor="let item of position2"
                                                            [value]="item.value">
                                                            {{item.viewValue}}
                                                          </mat-option>
                                                        </mat-select>
                                                      </mat-form-field>
                                                    </td>

                                                    <td data-th="Action">
                                                      <button [attr.guide]="'template-btn-84' + '__' + sanitizedUrl"
                                                        color="warn" mat-icon-button type="button"
                                                        (click)="updateBanner( ImageInfo.controls['img'].value,i,M)">
                                                        <mat-icon>remove_circle_outline
                                                        </mat-icon>
                                                      </button>
                                                    </td>

                                                  </tr>

                                                </ng-container>
                                              </ng-container>
                                            </ng-container>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                    <div class="editSets1">
                                      <div class="title " fxLayout="row" fxLayoutAlign="center center">
                                        <span *ngIf=" _form.value.conditions[i].images.length<=0"
                                          fxLayoutAlign="center center">No
                                          Images
                                          Uploaded</span>
                                      </div>
                                      <div>
                                        <calsoft-common-file-upload (fileUploadResult)="getResultBanner($event, i)"
                                          [type]="'commonSlider'"></calsoft-common-file-upload>
                                      </div>
                                    </div>
                                    <div fxLayout="column"
                                      *ngIf="comp.controls['customField1'].value=='type2' || comp.controls['customField1'].value=='type4'">
                                      <div fxFlex fxLayout="column" fxLayoutGap="10">
                                        <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">
                                          <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField2')"
                                            (fileUploadResult)="
                                          getResultts($event, i,'customField2') " [index]="i"
                                            [value]="comp.controls['customField2'].value">
                                          </calsoft-image>
                                          <mat-form-field fxFlex>
                                            <mat-label>Category</mat-label>
                                            <mat-select required formControlName="categoryId1"
                                              [disableOptionCentering]="true" #singleSelect name="item">
                                              <mat-option>
                                                <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                  [formControl]="
                                                  categoryFilterControl
                                                " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                  true
                                                " noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                              </mat-option>
                                              <mat-option *ngFor="
                                                let opt of filteredCategoryTypeList
                                              " [value]="opt.categoryId">
                                                {{ opt.categoryName }}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>

                                          <mat-form-field fxFlex>
                                            <mat-label>Show Animation </mat-label>
                                            <mat-select formControlName="customField19">
                                              <mat-option *ngFor="let status of ShowAnimation1" [value]="status.value">
                                                {{status.viewValue}}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                        </div>
                                        <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                          *ngIf="comp.controls['type'].value === 'bannerTextWithButton'">
                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Title</mat-label>
                                            <input [attr.guide]="'template-inp-customfield5' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField5" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Description</mat-label>
                                            <input [attr.guide]="'template-inp-customfield6' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField6" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Special Description</mat-label>
                                            <input [attr.guide]="'template-inp-customfield8' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField8" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Button</mat-label>
                                            <input [attr.guide]="'template-inp-customfield10' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField10" matInput />
                                          </mat-form-field>
                                        </div>

                                        <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                          *ngIf="comp.controls['type'].value === 'bannerTextWithButton'">
                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Font Color</mat-label>
                                            <input [attr.guide]="'template-inp-customfield27' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField27" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Font Size</mat-label>
                                            <input [attr.guide]="'template-inp-customfield28' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField28" matInput />
                                          </mat-form-field>

                                        </div>

                                        <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">

                                          <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField3')"
                                            (fileUploadResult)="
                                        getResultts($event, i,'customField3')" [index]="i"
                                            [value]="comp.controls['customField3'].value">
                                          </calsoft-image>
                                          <mat-form-field fxFlex>
                                            <mat-label>Category</mat-label>
                                            <mat-select required formControlName="categoryId2"
                                              [disableOptionCentering]="true" #singleSelect name="item">
                                              <mat-option>
                                                <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                  [formControl]="
                                                  categoryFilterControl
                                                " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                  true
                                                " noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                              </mat-option>
                                              <mat-option *ngFor="
                                                let opt of filteredCategoryTypeList
                                              " [value]="opt.categoryId">
                                                {{ opt.categoryName }}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>

                                          <mat-form-field fxFlex>
                                            <mat-label>Show Animation </mat-label>
                                            <mat-select formControlName="customField21">
                                              <mat-option *ngFor="let status of ShowAnimation1" [value]="status.value">
                                                {{status.viewValue}}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>

                                        </div>

                                        <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                          *ngIf="comp.controls['type'].value === 'bannerTextWithButton'">

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Title</mat-label>
                                            <input [attr.guide]="'template-inp-customfield9' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField9" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Description</mat-label>
                                            <input [attr.guide]="'template-inp-customfield14' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField14" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Special Description</mat-label>
                                            <input [attr.guide]="'template-inp-customfield20' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField20" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Button</mat-label>
                                            <input [attr.guide]="'template-inp-customfield23' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField23" matInput />
                                          </mat-form-field>
                                        </div>

                                        <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                          *ngIf="comp.controls['type'].value === 'bannerTextWithButton'">
                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Font Color</mat-label>
                                            <input [attr.guide]="'template-inp-customfield29' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField29" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Font Size</mat-label>
                                            <input [attr.guide]="'template-inp-customfield30' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField30" matInput />
                                          </mat-form-field>

                                        </div>

                                        <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">

                                          <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField4')"
                                            (fileUploadResult)="
                                        getResultts($event, i,'customField4')" [index]="i"
                                            [value]="comp.controls['customField4'].value">
                                          </calsoft-image>
                                          <mat-form-field fxFlex>
                                            <mat-label>Category</mat-label>
                                            <mat-select required formControlName="categoryId3"
                                              [disableOptionCentering]="true" #singleSelect name="item">
                                              <mat-option>
                                                <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                  [formControl]="
                                                  categoryFilterControl
                                                " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                  true
                                                " noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                              </mat-option>
                                              <mat-option *ngFor="
                                                let opt of filteredCategoryTypeList
                                              " [value]="opt.categoryId">
                                                {{ opt.categoryName }}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>

                                          <mat-form-field fxFlex>
                                            <mat-label>Show Animation </mat-label>
                                            <mat-select formControlName="customField15">
                                              <mat-option *ngFor="let status of ShowAnimation1" [value]="status.value">
                                                {{status.viewValue}}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                        </div>

                                        <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                          *ngIf="comp.controls['type'].value === 'bannerTextWithButton'">
                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Title</mat-label>
                                            <input [attr.guide]="'template-inp-customfield16' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField16" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Description</mat-label>
                                            <input [attr.guide]="'template-inp-customfield11' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField11" matInput />
                                          </mat-form-field>
                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Special Description</mat-label>
                                            <input [attr.guide]="'template-inp-customfield24' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField24" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Button</mat-label>
                                            <input [attr.guide]="'template-inp-customfield12' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField12" matInput />
                                          </mat-form-field>
                                        </div>

                                        <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                          *ngIf="comp.controls['type'].value === 'bannerTextWithButton'">
                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Font Color</mat-label>
                                            <input [attr.guide]="'template-inp-customfield31' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField31" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Font Size</mat-label>
                                            <input [attr.guide]="'template-inp-customfield32' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField32" matInput />
                                          </mat-form-field>

                                        </div>

                                      </div>

                                    </div>

                                    <div fxLayout="column" *ngIf="comp.controls['customField1'].value=='type5'">
                                      <div fxFlex fxLayout="column" fxLayoutGap="10">
                                        <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">
                                          <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField2')"
                                            (fileUploadResult)="
                                          getResultts($event, i,'customField2') " [index]="i"
                                            [value]="comp.controls['customField2'].value">
                                          </calsoft-image>
                                          <mat-form-field fxFlex>
                                            <mat-label>Category</mat-label>
                                            <mat-select required formControlName="categoryId1"
                                              [disableOptionCentering]="true" #singleSelect name="item">
                                              <mat-option>
                                                <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                  [formControl]="
                                                  categoryFilterControl
                                                " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                  true
                                                " noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                              </mat-option>
                                              <mat-option *ngFor="
                                                let opt of filteredCategoryTypeList
                                              " [value]="opt.categoryId">
                                                {{ opt.categoryName }}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>

                                          <mat-form-field fxFlex>
                                            <mat-label>Show Animation </mat-label>
                                            <mat-select formControlName="customField19">
                                              <mat-option *ngFor="let status of ShowAnimation1" [value]="status.value">
                                                {{status.viewValue}}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                        </div>
                                        <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                          *ngIf="comp.controls['type'].value === 'bannerTextWithButton'">
                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Title</mat-label>
                                            <input [attr.guide]="'template-inp-customfield5' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField5" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Description</mat-label>
                                            <input [attr.guide]="'template-inp-customfield6' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField6" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Special Description</mat-label>
                                            <input [attr.guide]="'template-inp-customfield8' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField8" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Button</mat-label>
                                            <input [attr.guide]="'template-inp-customfield10' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField10" matInput />
                                          </mat-form-field>
                                        </div>

                                        <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                          *ngIf="comp.controls['type'].value === 'bannerTextWithButton'">
                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Font Color</mat-label>
                                            <input [attr.guide]="'template-inp-customfield27' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField27" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Font Size</mat-label>
                                            <input [attr.guide]="'template-inp-customfield28' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField28" matInput />
                                          </mat-form-field>

                                        </div>

                                        <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">

                                          <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField3')"
                                            (fileUploadResult)="
                                        getResultts($event, i,'customField3')" [index]="i"
                                            [value]="comp.controls['customField3'].value">
                                          </calsoft-image>
                                          <mat-form-field fxFlex>
                                            <mat-label>Category</mat-label>
                                            <mat-select required formControlName="categoryId2"
                                              [disableOptionCentering]="true" #singleSelect name="item">
                                              <mat-option>
                                                <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                  [formControl]="
                                                  categoryFilterControl
                                                " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                  true
                                                " noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                              </mat-option>
                                              <mat-option *ngFor="
                                                let opt of filteredCategoryTypeList
                                              " [value]="opt.categoryId">
                                                {{ opt.categoryName }}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>

                                          <mat-form-field fxFlex>
                                            <mat-label>Show Animation </mat-label>
                                            <mat-select formControlName="customField21">
                                              <mat-option *ngFor="let status of ShowAnimation1" [value]="status.value">
                                                {{status.viewValue}}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>

                                        </div>

                                        <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                          *ngIf="comp.controls['type'].value === 'bannerTextWithButton'">

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Title</mat-label>
                                            <input [attr.guide]="'template-inp-customfield9' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField9" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Description</mat-label>
                                            <input [attr.guide]="'template-inp-customfield14' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField14" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Special Description</mat-label>
                                            <input [attr.guide]="'template-inp-customfield20' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField20" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Button</mat-label>
                                            <input [attr.guide]="'template-inp-customfield23' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField23" matInput />
                                          </mat-form-field>
                                        </div>

                                        <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                          *ngIf="comp.controls['type'].value === 'bannerTextWithButton'">
                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Font Color</mat-label>
                                            <input [attr.guide]="'template-inp-customfield29' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField29" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Font Size</mat-label>
                                            <input [attr.guide]="'template-inp-customfield30' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField30" matInput />
                                          </mat-form-field>

                                        </div>

                                      </div>
                                    </div>
                                  </div>
                                  <!-- categoryCarouselWithBanner -->
                                  <div fxLayout="column"
                                    *ngIf="(comp.controls['type'].value == 'categoryCarouselWithBanner') ">
                                    <div class="editSets">
                                      <div class="title-head3" color="primary">
                                        <span>Image</span>
                                      </div>
                                      <div id="responsieTable" class="container" style="overflow-x:auto;">
                                        <table class="rwd-table">
                                          <tbody>
                                            <tr>
                                              <th fxFlex="10">Image</th>
                                              <th fxFlex="15">Filename</th>
                                              <th fxFlex="15">Title</th>
                                              <th fxFlex="15">Description</th>
                                              <th fxFlex="10">Button</th>
                                              <th fxFlex="10">Navigation</th>
                                              <th fxFlex="20">Position</th>
                                              <th fxFlex="5">Action</th>
                                            </tr>
                                            <ng-container formArrayName="images">
                                              <ng-container
                                                *ngFor="let ImageInfo of comp.get('images')?.controls;; let M = index">
                                                <ng-container [formGroupName]="M">
                                                  <tr fxLayout.xs="column">
                                                    <td fxFlex="10" data-th="Image">
                                                      <!-- <img style="height: 65px;width: auto;"
                                                        [src]="bannerServerPath+ ImageInfo.controls['img'].value"
                                                        onerror="this.src='assets/images/logo/no-image.png';" alt=""> -->

                                                      <calsoft-common-images
                                                        [src]="bannerServerPath+ ImageInfo.controls['img'].value"
                                                        [height]="'65px'" [width]="'auto'" [alt]="">

                                                      </calsoft-common-images>
                                                    </td>
                                                    <td fxFlex="15" data-th="Filename">
                                                      <span class="wordBreak">
                                                        {{ ImageInfo.controls['img'].value}}
                                                      </span>
                                                    </td>
                                                    <td fxFlex="15" data-th="Title">
                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex="90">
                                                          <mat-label>Title</mat-label>
                                                          <input
                                                            [attr.guide]="'template-inp-customfield4' + '__' + sanitizedUrl"
                                                            (keydown.enter)="$event.preventDefault()" trim="blur"
                                                            [autocomplete]="'off'" formControlName="customField4"
                                                            matInput />
                                                        </mat-form-field>
                                                      </span>
                                                    </td>

                                                    <td fxFlex="15" data-th="Description">
                                                      <span class="wordBreak">

                                                        <mat-form-field fxFlex="100" appearance="outline">
                                                          <mat-label>Banner Description</mat-label>
                                                          <textarea
                                                            [attr.guide]="'template-sel-customfield5' + '__' + sanitizedUrl"
                                                            trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                            matAutosizeMaxRows=5 matInput
                                                            formControlName="customField5"></textarea>
                                                          <mat-icon class="clickable"
                                                            (click)="openEditorTextForImageArray(ImageInfo.controls['customField5'].value,i,'customField5',M)"
                                                            matSuffix>
                                                            post_add
                                                          </mat-icon>
                                                        </mat-form-field>
                                                      </span>
                                                    </td>

                                                    <td fxFlex="10" data-th="Button">
                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex="90">
                                                          <mat-label>Button</mat-label>
                                                          <input
                                                            [attr.guide]="'template-inp-customfield3' + '__' + sanitizedUrl"
                                                            (keydown.enter)="$event.preventDefault()" trim="blur"
                                                            [autocomplete]="'off'" formControlName="customField3"
                                                            matInput />
                                                        </mat-form-field>
                                                      </span>
                                                    </td>

                                                    <td fxFlex="10" data-th="Navigation">
                                                      <span class="wordBreak">
                                                        <mat-form-field fxFlex="90">
                                                          <mat-label>Navigation</mat-label>
                                                          <input
                                                            [attr.guide]="'template-inp-customfield6' + '__' + sanitizedUrl"
                                                            (keydown.enter)="$event.preventDefault()" trim="blur"
                                                            [autocomplete]="'off'" formControlName="customField6"
                                                            matInput />
                                                        </mat-form-field>
                                                      </span>
                                                    </td>

                                                    <td fxLayout.xs="column" fxFlex="20" data-th="Position">
                                                      <mat-form-field class="mobilewidth" fxFlex="90">
                                                        <mat-label>Set Position</mat-label>
                                                        <mat-select formControlName="customField29" name="item">
                                                          <mat-option *ngFor="
                                                        let item of setposition1;
                                                        let i = index
                                                      " [value]="item.value">
                                                            {{ item.viewValue }}
                                                          </mat-option>
                                                        </mat-select>
                                                      </mat-form-field>
                                                    </td>

                                                    <td data-th="Action">
                                                      <button [attr.guide]="'template-btn-85' + '__' + sanitizedUrl"
                                                        color="warn" mat-icon-button type="button"
                                                        (click)="updateBanner( ImageInfo.controls['img'].value,i,M)">
                                                        <mat-icon>remove_circle_outline
                                                        </mat-icon>
                                                      </button>
                                                    </td>
                                                  </tr>
                                                </ng-container>
                                              </ng-container>
                                            </ng-container>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                    <div class="editSets1">
                                      <div class="title " fxLayout="row" fxLayoutAlign="center center">
                                        <span *ngIf=" _form.value.conditions[i].images.length<=0"
                                          fxLayoutAlign="center center">No
                                          Images
                                          Uploaded</span>
                                      </div>
                                      <div>
                                        <calsoft-common-file-upload (fileUploadResult)="getResultBanner($event, i)"
                                          [type]="'commonSlider'"></calsoft-common-file-upload>
                                      </div>
                                    </div>
                                    <div fxLayout="column"
                                      *ngIf="comp.controls['customField1'].value=='type2' || comp.controls['customField1'].value=='type3' || comp.controls['customField1'].value=='type4'">
                                      <div fxFlex fxLayout="column" fxLayoutGap="10">
                                        <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">
                                          <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField2')"
                                            (fileUploadResult)="
                                            getResultts($event, i,'customField2') " [index]="i"
                                            [value]="comp.controls['customField2'].value">
                                          </calsoft-image>
                                          <mat-form-field fxFlex>
                                            <mat-label>Category</mat-label>
                                            <mat-select required formControlName="categoryId1"
                                              [disableOptionCentering]="true" #singleSelect name="item">
                                              <mat-option>
                                                <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                  [formControl]="
                                                    categoryFilterControl
                                                  " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                    true
                                                  " noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                              </mat-option>
                                              <mat-option *ngFor="
                                                  let opt of filteredCategoryTypeList
                                                " [value]="opt.categoryId">
                                                {{ opt.categoryName }}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>

                                          <mat-form-field fxFlex>
                                            <mat-label>Show Animation </mat-label>
                                            <mat-select formControlName="customField19">
                                              <mat-option *ngFor="let status of ShowAnimation1" [value]="status.value">
                                                {{status.viewValue}}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                        </div>
                                        <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                          *ngIf="comp.controls['type'].value === 'categoryCarouselWithBanner'">
                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Title</mat-label>
                                            <input [attr.guide]="'template-inp-customfield5' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField5" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Description</mat-label>
                                            <input [attr.guide]="'template-inp-customfield6' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField6" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Special Description</mat-label>
                                            <input [attr.guide]="'template-inp-customfield8' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField8" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Button</mat-label>
                                            <input [attr.guide]="'template-inp-customfield10' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField10" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Alignment</mat-label>
                                            <mat-select formControlName="customField28">
                                              <mat-option *ngFor="let item of position2" [value]="item.value">
                                                {{item.viewValue}}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>

                                        </div>


                                        <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">

                                          <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField4')"
                                            (fileUploadResult)="
                                          getResultts($event, i,'customField4')" [index]="i"
                                            [value]="comp.controls['customField4'].value">
                                          </calsoft-image>
                                          <mat-form-field fxFlex>
                                            <mat-label>Category</mat-label>
                                            <mat-select required formControlName="categoryId3"
                                              [disableOptionCentering]="true" #singleSelect name="item">
                                              <mat-option>
                                                <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                  [formControl]="
                                                    categoryFilterControl
                                                  " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                    true
                                                  " noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                              </mat-option>
                                              <mat-option *ngFor="
                                                  let opt of filteredCategoryTypeList
                                                " [value]="opt.categoryId">
                                                {{ opt.categoryName }}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>

                                          <mat-form-field fxFlex>
                                            <mat-label>Show Animation </mat-label>
                                            <mat-select formControlName="customField15">
                                              <mat-option *ngFor="let status of ShowAnimation1" [value]="status.value">
                                                {{status.viewValue}}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                        </div>

                                        <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                          *ngIf="comp.controls['type'].value === 'categoryCarouselWithBanner'">
                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Title</mat-label>
                                            <input [attr.guide]="'template-inp-customfield16' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField16" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Description</mat-label>
                                            <input [attr.guide]="'template-inp-customfield11' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField11" matInput />
                                          </mat-form-field>
                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Special Description</mat-label>
                                            <input [attr.guide]="'template-inp-customfield24' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField24" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Button</mat-label>
                                            <input [attr.guide]="'template-inp-customfield12' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField12" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Alignment</mat-label>
                                            <mat-select formControlName="customField29">
                                              <mat-option *ngFor="let item of position2" [value]="item.value">
                                                {{item.viewValue}}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>

                                        </div>
                                      </div>


                                    </div>

                                    <div fxLayout="column"
                                      *ngIf="comp.controls['customField1'].value=='type1' || comp.controls['customField1'].value=='type6'">
                                      <div fxFlex fxLayout="column" fxLayoutGap="10">
                                        <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">
                                          <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField2')"
                                            (fileUploadResult)="
                                            getResultts($event, i,'customField2') " [index]="i"
                                            [value]="comp.controls['customField2'].value">
                                          </calsoft-image>
                                          <mat-form-field fxFlex>
                                            <mat-label>Category</mat-label>
                                            <mat-select required formControlName="categoryId1"
                                              [disableOptionCentering]="true" #singleSelect name="item">
                                              <mat-option>
                                                <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                  [formControl]="
                                                    categoryFilterControl
                                                  " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                    true
                                                  " noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                              </mat-option>
                                              <mat-option *ngFor="
                                                  let opt of filteredCategoryTypeList
                                                " [value]="opt.categoryId">
                                                {{ opt.categoryName }}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>

                                          <mat-form-field fxFlex>
                                            <mat-label>Show Animation </mat-label>
                                            <mat-select formControlName="customField19">
                                              <mat-option *ngFor="let status of ShowAnimation1" [value]="status.value">
                                                {{status.viewValue}}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                        </div>
                                        <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                          *ngIf="comp.controls['type'].value === 'categoryCarouselWithBanner'">
                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Title</mat-label>
                                            <input [attr.guide]="'template-inp-customfield5' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField5" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Description</mat-label>
                                            <input [attr.guide]="'template-inp-customfield6' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField6" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Special Description</mat-label>
                                            <input [attr.guide]="'template-inp-customfield8' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField8" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Button</mat-label>
                                            <input [attr.guide]="'template-inp-customfield10' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField10" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Alignment</mat-label>
                                            <mat-select formControlName="customField28">
                                              <mat-option *ngFor="let item of position2" [value]="item.value">
                                                {{item.viewValue}}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                        </div>
                                      </div>

                                    </div>

                                    <div fxLayout="column" *ngIf="comp.controls['customField1'].value=='type5'">
                                      <div fxFlex fxLayout="column" fxLayoutGap="10">

                                        <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">
                                          <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField2')"
                                            (fileUploadResult)="
                                            getResultts($event, i,'customField2') " [index]="i"
                                            [value]="comp.controls['customField2'].value">
                                          </calsoft-image>
                                          <mat-form-field fxFlex>
                                            <mat-label>Category</mat-label>
                                            <mat-select required formControlName="categoryId1"
                                              [disableOptionCentering]="true" #singleSelect name="item">
                                              <mat-option>
                                                <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                  [formControl]="
                                                    categoryFilterControl
                                                  " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                    true
                                                  " noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                              </mat-option>
                                              <mat-option *ngFor="
                                                  let opt of filteredCategoryTypeList
                                                " [value]="opt.categoryId">
                                                {{ opt.categoryName }}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>

                                          <mat-form-field fxFlex>
                                            <mat-label>Show Animation </mat-label>
                                            <mat-select formControlName="customField19">
                                              <mat-option *ngFor="let status of ShowAnimation1" [value]="status.value">
                                                {{status.viewValue}}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                        </div>

                                        <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                          *ngIf="comp.controls['type'].value === 'categoryCarouselWithBanner'">
                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Title</mat-label>
                                            <input [attr.guide]="'template-inp-customfield5' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField5" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Description</mat-label>
                                            <input [attr.guide]="'template-inp-customfield6' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField6" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Special Description</mat-label>
                                            <input [attr.guide]="'template-inp-customfield8' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField8" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Button</mat-label>
                                            <input [attr.guide]="'template-inp-customfield10' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField10" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Alignment</mat-label>
                                            <mat-select formControlName="customField28">
                                              <mat-option *ngFor="let item of position2" [value]="item.value">
                                                {{item.viewValue}}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                        </div>


                                        <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">

                                          <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField4')"
                                            (fileUploadResult)="
                                          getResultts($event, i,'customField4')" [index]="i"
                                            [value]="comp.controls['customField4'].value">
                                          </calsoft-image>
                                          <mat-form-field fxFlex>
                                            <mat-label>Category</mat-label>
                                            <mat-select required formControlName="categoryId3"
                                              [disableOptionCentering]="true" #singleSelect name="item">
                                              <mat-option>
                                                <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                  [formControl]="
                                                    categoryFilterControl
                                                  " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                    true
                                                  " noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                              </mat-option>
                                              <mat-option *ngFor="
                                                  let opt of filteredCategoryTypeList
                                                " [value]="opt.categoryId">
                                                {{ opt.categoryName }}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>

                                          <mat-form-field fxFlex>
                                            <mat-label>Show Animation </mat-label>
                                            <mat-select formControlName="customField15">
                                              <mat-option *ngFor="let status of ShowAnimation1" [value]="status.value">
                                                {{status.viewValue}}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                        </div>

                                        <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                          *ngIf="comp.controls['type'].value === 'categoryCarouselWithBanner'">
                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Title</mat-label>
                                            <input [attr.guide]="'template-inp-customfield16' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField16" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Description</mat-label>
                                            <input [attr.guide]="'template-inp-customfield11' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField11" matInput />
                                          </mat-form-field>
                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Special Description</mat-label>
                                            <input [attr.guide]="'template-inp-customfield24' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField24" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Button</mat-label>
                                            <input [attr.guide]="'template-inp-customfield12' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField12" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Alignment</mat-label>
                                            <mat-select formControlName="customField29">
                                              <mat-option *ngFor="let item of position2" [value]="item.value">
                                                {{item.viewValue}}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>

                                        </div>

                                        <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">
                                          <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField3')"
                                            (fileUploadResult)="
                                            getResultts($event, i,'customField3') " [index]="i"
                                            [value]="comp.controls['customField3'].value">
                                          </calsoft-image>
                                          <mat-form-field fxFlex>
                                            <mat-label>Category</mat-label>
                                            <mat-select required formControlName="categoryId4"
                                              [disableOptionCentering]="true" #singleSelect name="item">
                                              <mat-option>
                                                <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                  [formControl]="
                                                    categoryFilterControl
                                                  " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                    true
                                                  " noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                              </mat-option>
                                              <mat-option *ngFor="
                                                  let opt of filteredCategoryTypeList
                                                " [value]="opt.categoryId">
                                                {{ opt.categoryName }}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>

                                          <mat-form-field fxFlex>
                                            <mat-label>Show Animation </mat-label>
                                            <mat-select formControlName="customField20">
                                              <mat-option *ngFor="let status of ShowAnimation1" [value]="status.value">
                                                {{status.viewValue}}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                        </div>

                                        <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                          *ngIf="comp.controls['type'].value === 'categoryCarouselWithBanner'">
                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Title</mat-label>
                                            <input [attr.guide]="'template-inp-customfield14' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField14" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Description</mat-label>
                                            <input [attr.guide]="'template-inp-customfield19' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField19" matInput />
                                          </mat-form-field>
                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Special Description</mat-label>
                                            <input [attr.guide]="'template-inp-customfield20' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField20" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Button</mat-label>
                                            <input [attr.guide]="'template-inp-customfield21' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField21" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Alignment</mat-label>
                                            <mat-select formControlName="customField30">
                                              <mat-option *ngFor="let item of position2" [value]="item.value">
                                                {{item.viewValue}}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>

                                        </div>

                                      </div>

                                    </div>


                                  </div>

                                  <!-- carouselwithProduct -->

                                  <div fxLayout="column"
                                    *ngIf="(comp.controls['type'].value == 'carouselwithProduct') ">
                                    <div class="editSets">
                                      <div class="title-head3" color="primary">
                                        <span>Image</span>
                                      </div>
                                      <div id="responsieTable" class="container" style="overflow-x:auto;">
                                        <table class="rwd-table">
                                          <tbody>
                                            <tr>
                                              <th fxFlex="10">Image</th>
                                              <th fxFlex="10">Filename</th>
                                              <th fxFlex="15">Title</th>
                                              <th fxFlex="15">Offers</th>
                                              <th fxFlex="15">Button</th>
                                              <th fxFlex="15">Navigation</th>
                                              <th fxFlex="15">Category</th>
                                              <th fxFlex="15">Web Font Size</th>
                                              <th fxFlex="15">Mobile Font Size</th>
                                              <th fxFlex="5">Action</th>
                                            </tr>
                                            <ng-container formArrayName="images">
                                              <tr fxLayout.xs="column" fxLayout="row"
                                                *ngFor="let ImageInfo of comp.get('images')?.controls; let z = index">
                                                <ng-container [formGroupName]="z">
                                                  <td fxFlex="10" data-th="Image" style="width: 60%;">
                                                    <!-- <img style="height: 65px;width: auto;"
                                                      [src]="bannerServerPath+ ImageInfo.controls['img'].value"
                                                      onerror="this.src='assets/images/logo/no-image.png';" alt=""> -->

                                                    <calsoft-common-images
                                                      [src]="bannerServerPath+ ImageInfo.controls['img'].value"
                                                      [height]="'65px'" [width]="'auto'" [alt]="">

                                                    </calsoft-common-images>
                                                  </td>
                                                  <td fxFlex="10" data-th="Filename" class="mobilewidth"
                                                    style="width: 20%;">
                                                    <span class="wordBreak">
                                                      {{ ImageInfo.controls['img'].value}}
                                                    </span>
                                                  </td>

                                                  <td fxFlex="15" data-th="Title" class="mobilewidth"
                                                    style="width: 20%;">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="90">
                                                        <mat-label>Title</mat-label>
                                                        <input
                                                          [attr.guide]="'template-inp-customfield5' + '__' + sanitizedUrl"
                                                          (keydown.enter)="$event.preventDefault()"
                                                          [autocomplete]="'off'" trim="blur"
                                                          formControlName="customField5" matInput />
                                                      </mat-form-field>
                                                    </span>
                                                  </td>

                                                  <td fxFlex="15" data-th="Offers" class="mobilewidth"
                                                    style="width: 20%;">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="90">
                                                        <mat-label>Offer</mat-label>
                                                        <input
                                                          [attr.guide]="'template-inp-customfield8' + '__' + sanitizedUrl"
                                                          (keydown.enter)="$event.preventDefault()"
                                                          [autocomplete]="'off'" trim="blur"
                                                          formControlName="customField8" matInput />
                                                      </mat-form-field>
                                                    </span>
                                                  </td>

                                                  <td fxFlex="15" data-th="Button" class="mobilewidth"
                                                    style="width: 20%;">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="90">
                                                        <mat-label>Button</mat-label>
                                                        <input
                                                          [attr.guide]="'template-inp-customfield10' + '__' + sanitizedUrl"
                                                          (keydown.enter)="$event.preventDefault()"
                                                          [autocomplete]="'off'" trim="blur"
                                                          formControlName="customField10" matInput />
                                                      </mat-form-field>
                                                    </span>
                                                  </td>

                                                  <td fxFlex="15" data-th="Filename" class="mobilewidth"
                                                    style="width: 20%;">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="90">
                                                        <mat-label>Navigation</mat-label>
                                                        <mat-select required formControlName="navigation" name="item">
                                                          <mat-option *ngFor="
                                                              let item of navigation;
                                                              let i = index
                                                            " [value]="item.value">
                                                            {{ item.viewValue }}
                                                          </mat-option>
                                                        </mat-select>
                                                      </mat-form-field>
                                                    </span>
                                                  </td>

                                                  <td fxLayout.xs="column" fxFlex="15" data-th="Category"
                                                    class="mobilewidth" style="width: 20%;">
                                                    <mat-form-field fxFlex="100" fxLayoutAlign.xs="start center"
                                                      fxLayoutAlign="center center">

                                                      <mat-label>{{ImageInfo.controls['navigation'].value
                                                        ==0?'Category':'Url'}}</mat-label>

                                                      <mat-select *ngIf="ImageInfo.controls['navigation']
                                                      .value==0" required formControlName="catId"
                                                        [disableOptionCentering]="true" #singleSelect name="item">
                                                        <mat-option>
                                                          <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                            [formControl]="
                                                          categoryFilterControl
                                                        " placeholderLabel="Category Search"
                                                            [preventHomeEndKeyPropagation]="
                                                          true
                                                        " noEntriesFoundLabel="No data found">
                                                          </ngx-mat-select-search>
                                                        </mat-option>
                                                        <mat-option *ngFor="
                                                        let opt of filteredCategoryTypeList
                                                      " [value]="opt.categoryId">
                                                          {{ opt.categoryName }}
                                                        </mat-option>
                                                      </mat-select>


                                                      <input
                                                        [attr.guide]="'template-inp-navigatedurl' + '__' + sanitizedUrl"
                                                        style="width:100%" *ngIf="ImageInfo.controls['navigation']
                                                      .value==1" trim="blur" (keydown.enter)="$event.preventDefault()"
                                                        [autocomplete]="'off'" matInput
                                                        formControlName="navigatedUrl" />


                                                    </mat-form-field>
                                                  </td>

                                                  <td fxFlex="15" data-th="Title" class="mobilewidth"
                                                    style="width: 20%;">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="90">
                                                        <mat-label>Web Font Size </mat-label>
                                                        <input
                                                          [attr.guide]="'template-inp-customfield34' + '__' + sanitizedUrl"
                                                          trim="blur" (keydown.enter)="$event.preventDefault()"
                                                          [autocomplete]="'off'" matInput
                                                          formControlName="customField34" />
                                                      </mat-form-field>
                                                    </span>
                                                  </td>

                                                  <td fxFlex="15" data-th="Title" class="mobilewidth"
                                                    style="width: 20%;">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="90">
                                                        <mat-label>Mobile Font Size</mat-label>
                                                        <input
                                                          [attr.guide]="'template-inp-customfield35' + '__' + sanitizedUrl"
                                                          (keydown.enter)="$event.preventDefault()"
                                                          [autocomplete]="'off'" trim="blur"
                                                          formControlName="customField35" matInput />
                                                      </mat-form-field>
                                                    </span>
                                                  </td>

                                                  <td fxflex="5" data-th="Action">
                                                    <button [attr.guide]="'template-btn-86' + '__' + sanitizedUrl"
                                                      color="warn" mat-icon-button type="button"
                                                      (click)="updateBanner( ImageInfo.controls['img'].value,i,z)">
                                                      <mat-icon>remove_circle_outline
                                                      </mat-icon>
                                                    </button>
                                                  </td>
                                                </ng-container>
                                              </tr>
                                            </ng-container>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>

                                    <div class="editSets1">
                                      <div class="title " fxLayout="row" fxLayoutAlign="center center">
                                        <span *ngIf=" _form.value.conditions[i].images.length<=0"
                                          fxLayoutAlign="center center">No
                                          Images
                                          Uploaded</span>
                                      </div>
                                      <div>
                                        <calsoft-common-file-upload (fileUploadResult)="getResultBanner($event, i)"
                                          [type]="'commonSlider'"></calsoft-common-file-upload>
                                      </div>


                                    </div>
                                    <div fxLayout="column"
                                      *ngIf="comp.controls['customField1'].value=='type3'||comp.controls['customField1'].value=='type4' || comp.controls['customField1'].value=='type5' || comp.controls['customField1'].value=='type6' ">
                                      <div fxFlex fxLayout="column" fxLayoutGap="10">
                                        <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">
                                          <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField2')"
                                            (fileUploadResult)="
                                              getResultts($event, i,'customField2') " [index]="i"
                                            [value]="comp.controls['customField2'].value">
                                          </calsoft-image>
                                          <mat-form-field fxFlex>
                                            <mat-label>Category</mat-label>
                                            <mat-select required formControlName="categoryId1"
                                              [disableOptionCentering]="true" #singleSelect name="item">
                                              <mat-option>
                                                <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                  [formControl]="
                                                      categoryFilterControl
                                                    " placeholderLabel="Category Search"
                                                  [preventHomeEndKeyPropagation]="
                                                      true
                                                    " noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                              </mat-option>
                                              <mat-option *ngFor="
                                                    let opt of filteredCategoryTypeList
                                                  " [value]="opt.categoryId">
                                                {{ opt.categoryName }}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                        </div>

                                        <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">

                                          <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField3')"
                                            (fileUploadResult)="
                                            getResultts($event, i,'customField3')" [index]="i"
                                            [value]="comp.controls['customField3'].value">
                                          </calsoft-image>
                                          <mat-form-field fxFlex>
                                            <mat-label>Category</mat-label>
                                            <mat-select required formControlName="categoryId2"
                                              [disableOptionCentering]="true" #singleSelect name="item">
                                              <mat-option>
                                                <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                  [formControl]="
                                                      categoryFilterControl
                                                    " placeholderLabel="Category Search"
                                                  [preventHomeEndKeyPropagation]="
                                                      true
                                                    " noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                              </mat-option>
                                              <mat-option *ngFor="
                                                    let opt of filteredCategoryTypeList
                                                  " [value]="opt.categoryId">
                                                {{ opt.categoryName }}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                        </div>
                                        <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">

                                          <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField4')"
                                            (fileUploadResult)="
                                            getResultts($event, i,'customField4')" [index]="i"
                                            [value]="comp.controls['customField4'].value">
                                          </calsoft-image>
                                          <mat-form-field fxFlex>
                                            <mat-label>Category</mat-label>
                                            <mat-select required formControlName="categoryId3"
                                              [disableOptionCentering]="true" #singleSelect name="item">
                                              <mat-option>
                                                <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                  [formControl]="
                                                      categoryFilterControl
                                                    " placeholderLabel="Category Search"
                                                  [preventHomeEndKeyPropagation]="
                                                      true
                                                    " noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                              </mat-option>
                                              <mat-option *ngFor="
                                                    let opt of filteredCategoryTypeList
                                                  " [value]="opt.categoryId">
                                                {{ opt.categoryName }}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                        </div>
                                      </div>

                                    </div>

                                    <div fxLayout="column"
                                      *ngIf="comp.controls['customField1'].value=='type7'||comp.controls['customField1'].value=='type8' || comp.controls['customField1'].value=='type9' || comp.controls['customField1'].value=='type10' ">
                                      <div fxFlex fxLayout="column" fxLayoutGap="10">
                                        <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">
                                          <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField2')"
                                            (fileUploadResult)="
                                              getResultts($event, i,'customField2') " [index]="i"
                                            [value]="comp.controls['customField2'].value">
                                          </calsoft-image>
                                          <mat-form-field fxFlex>
                                            <mat-label>Category</mat-label>
                                            <mat-select required formControlName="categoryId1"
                                              [disableOptionCentering]="true" #singleSelect name="item">
                                              <mat-option>
                                                <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                  [formControl]="
                                                      categoryFilterControl
                                                    " placeholderLabel="Category Search"
                                                  [preventHomeEndKeyPropagation]="
                                                      true
                                                    " noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                              </mat-option>
                                              <mat-option *ngFor="
                                                    let opt of filteredCategoryTypeList
                                                  " [value]="opt.categoryId">
                                                {{ opt.categoryName }}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>

                                        </div>

                                        <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">

                                          <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField3')"
                                            (fileUploadResult)="
                                            getResultts($event, i,'customField3')" [index]="i"
                                            [value]="comp.controls['customField3'].value">
                                          </calsoft-image>
                                          <mat-form-field fxFlex>
                                            <mat-label>Category</mat-label>
                                            <mat-select required formControlName="categoryId2"
                                              [disableOptionCentering]="true" #singleSelect name="item">
                                              <mat-option>
                                                <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                  [formControl]="
                                                      categoryFilterControl
                                                    " placeholderLabel="Category Search"
                                                  [preventHomeEndKeyPropagation]="
                                                      true
                                                    " noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                              </mat-option>
                                              <mat-option *ngFor="
                                                    let opt of filteredCategoryTypeList
                                                  " [value]="opt.categoryId">
                                                {{ opt.categoryName }}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>

                                          <mat-form-field fxFlex>
                                            <mat-label>Alt Tag</mat-label>
                                            <input [attr.guide]="'template-inp-altimage' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" matInput formControlName="altImage" />

                                          </mat-form-field>

                                        </div>

                                      </div>

                                    </div>

                                  </div>

                                  <div fxLayout="column" *ngIf="(comp.controls['type'].value == 'TexthoverWithImage') ">
                                    <div class="editSets">
                                      <div class="title-head3" color="primary">
                                        <span>Image</span>
                                      </div>
                                      <div id="responsieTable" class="container" style="overflow-x:auto;">
                                        <table class="rwd-table">
                                          <tbody>
                                            <tr>
                                              <th fxFlex="10">Image</th>
                                              <th fxFlex="10">Filename</th>
                                              <th fxFlex="15">Title</th>
                                              <th fxFlex="15">Description</th>
                                              <th fxFlex="15">Navigation</th>
                                              <th fxFlex="15">Category</th>
                                              <th fxFlex="5">Action</th>
                                            </tr>
                                            <ng-container formArrayName="images">
                                              <tr fxLayout.xs="column"
                                                *ngFor="let ImageInfo of comp.get('images')?.controls; let z = index">
                                                <ng-container [formGroupName]="z">
                                                  <td fxFlex="10" fxFlex.xs="100" class="mobilewidth" data-th="Image"
                                                    style="width: 60%;">
                                                    <!-- <img style="height: 65px;width: auto;"
                                                      [src]="bannerServerPath+ ImageInfo.controls['img'].value"
                                                      onerror="this.src='assets/images/logo/no-image.png';" alt=""> -->

                                                    <calsoft-common-images
                                                      [src]="bannerServerPath+ ImageInfo.controls['img'].value"
                                                      [height]="'65px'" [width]="'auto'" [alt]="">

                                                    </calsoft-common-images>

                                                  </td>
                                                  <td fxFlex="10" fxFlex.xs="100" class="mobilewidth" data-th="Filename"
                                                    style="width: 20%;">
                                                    <span class="wordBreak">
                                                      {{ ImageInfo.controls['img'].value}}
                                                    </span>
                                                  </td>

                                                  <td fxFlex="15" fxFlex.xs="100" class="mobilewidth" data-th="Title"
                                                    style="width: 20%;">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="90">
                                                        <mat-label>Title</mat-label>
                                                        <input
                                                          [attr.guide]="'template-inp-customfield5' + '__' + sanitizedUrl"
                                                          (keydown.enter)="$event.preventDefault()"
                                                          [autocomplete]="'off'" trim="blur"
                                                          formControlName="customField5" matInput />
                                                      </mat-form-field>
                                                    </span>
                                                  </td>

                                                  <td fxFlex="15" fxFlex.xs="100" class="mobilewidth" data-th="Offers"
                                                    style="width: 20%;">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="90">
                                                        <mat-label>Description</mat-label>
                                                        <input
                                                          [attr.guide]="'template-inp-customfield8' + '__' + sanitizedUrl"
                                                          (keydown.enter)="$event.preventDefault()"
                                                          [autocomplete]="'off'" trim="blur"
                                                          formControlName="customField8" matInput />
                                                      </mat-form-field>
                                                    </span>
                                                  </td>



                                                  <td fxFlex="15" fxFlex.xs="100" class="mobilewidth" data-th="Filename"
                                                    style="width: 20%;">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="90">
                                                        <mat-label>Navigation</mat-label>
                                                        <mat-select required formControlName="navigation" name="item">
                                                          <mat-option *ngFor="
                                                              let item of navigation;
                                                              let i = index
                                                            " [value]="item.value">
                                                            {{ item.viewValue }}
                                                          </mat-option>
                                                        </mat-select>
                                                      </mat-form-field>
                                                    </span>
                                                  </td>

                                                  <td fxLayout.xs="column" fxFlex="15" fxFlex.xs="100"
                                                    class="mobilewidth" data-th="Category" style="width: 20%;">
                                                    <mat-form-field fxFlex="100" fxLayoutAlign="center center"
                                                      fxLayoutAlign.xs="start">

                                                      <mat-label>{{ImageInfo.controls['navigation'].value
                                                        ==0?'Category':'Url'}}</mat-label>

                                                      <mat-select *ngIf="ImageInfo.controls['navigation']
                                                      .value==0" required formControlName="catId"
                                                        [disableOptionCentering]="true" #singleSelect name="item">
                                                        <mat-option>
                                                          <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                            [formControl]="
                                                          categoryFilterControl
                                                        " placeholderLabel="Category Search"
                                                            [preventHomeEndKeyPropagation]="
                                                          true
                                                        " noEntriesFoundLabel="No data found">
                                                          </ngx-mat-select-search>
                                                        </mat-option>
                                                        <mat-option *ngFor="
                                                        let opt of filteredCategoryTypeList
                                                      " [value]="opt.categoryId">
                                                          {{ opt.categoryName }}
                                                        </mat-option>
                                                      </mat-select>


                                                      <input
                                                        [attr.guide]="'template-inp-navigatedurl' + '__' + sanitizedUrl"
                                                        style="width:100%" *ngIf="ImageInfo.controls['navigation']
                                                      .value==1" trim="blur" (keydown.enter)="$event.preventDefault()"
                                                        [autocomplete]="'off'" matInput
                                                        formControlName="navigatedUrl" />


                                                    </mat-form-field>
                                                  </td>

                                                  <td fxflex="5" data-th="Action">
                                                    <button [attr.guide]="'template-btn-87' + '__' + sanitizedUrl"
                                                      color="warn" mat-icon-button type="button"
                                                      (click)="updateBanner( ImageInfo.controls['img'].value,i,z)">
                                                      <mat-icon>remove_circle_outline
                                                      </mat-icon>
                                                    </button>
                                                  </td>
                                                </ng-container>
                                              </tr>
                                            </ng-container>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>

                                    <div class="editSets1">
                                      <div class="title " fxLayout="row" fxLayoutAlign="center center">
                                        <span *ngIf=" _form.value.conditions[i].images.length<=0"
                                          fxLayoutAlign="center center">No
                                          Images
                                          Uploaded</span>
                                      </div>
                                      <div>
                                        <calsoft-common-file-upload (fileUploadResult)="getResultBanner($event, i)"
                                          [type]="'commonSlider'"></calsoft-common-file-upload>
                                      </div>


                                    </div>
                                    <!-- <div fxLayout="column">
                                    <div fxFlex fxLayout="column" fxLayoutGap="10">
                                      <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">
                                        <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField2')"
                                          (fileUploadResult)="
                                              getResultts($event, i,'customField2') " [index]="i"
                                          [value]="comp.controls['customField2'].value">
                                        </calsoft-image>
                                        <mat-form-field fxFlex>
                                          <mat-label>Category</mat-label>
                                          <mat-select required formControlName="categoryId1"
                                            [disableOptionCentering]="true" #singleSelect name="item">
                                            <mat-option>
                                              <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                [formControl]="
                                                      categoryFilterControl
                                                    " placeholderLabel="Category Search"
                                                [preventHomeEndKeyPropagation]="
                                                      true
                                                    " noEntriesFoundLabel="No data found">
                                              </ngx-mat-select-search>
                                            </mat-option>
                                            <mat-option *ngFor="
                                                    let opt of filteredCategoryTypeList
                                                  " [value]="opt.categoryId">
                                              {{ opt.categoryName }}
                                            </mat-option>
                                          </mat-select>
                                        </mat-form-field>
                                      </div>

                                      <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">

                                        <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField3')"
                                          (fileUploadResult)="
                                            getResultts($event, i,'customField3')" [index]="i"
                                          [value]="comp.controls['customField3'].value">
                                        </calsoft-image>
                                        <mat-form-field fxFlex>
                                          <mat-label>Category</mat-label>
                                          <mat-select required formControlName="categoryId2"
                                            [disableOptionCentering]="true" #singleSelect name="item">
                                            <mat-option>
                                              <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                [formControl]="
                                                      categoryFilterControl
                                                    " placeholderLabel="Category Search"
                                                [preventHomeEndKeyPropagation]="
                                                      true
                                                    " noEntriesFoundLabel="No data found">
                                              </ngx-mat-select-search>
                                            </mat-option>
                                            <mat-option *ngFor="
                                                    let opt of filteredCategoryTypeList
                                                  " [value]="opt.categoryId">
                                              {{ opt.categoryName }}
                                            </mat-option>
                                          </mat-select>
                                        </mat-form-field>
                                      </div>
                                      <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">

                                        <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField4')"
                                          (fileUploadResult)="
                                            getResultts($event, i,'customField4')" [index]="i"
                                          [value]="comp.controls['customField4'].value">
                                        </calsoft-image>
                                        <mat-form-field fxFlex>
                                          <mat-label>Category</mat-label>
                                          <mat-select required formControlName="categoryId3"
                                            [disableOptionCentering]="true" #singleSelect name="item">
                                            <mat-option>
                                              <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                [formControl]="
                                                      categoryFilterControl
                                                    " placeholderLabel="Category Search"
                                                [preventHomeEndKeyPropagation]="
                                                      true
                                                    " noEntriesFoundLabel="No data found">
                                              </ngx-mat-select-search>
                                            </mat-option>
                                            <mat-option *ngFor="
                                                    let opt of filteredCategoryTypeList
                                                  " [value]="opt.categoryId">
                                              {{ opt.categoryName }}
                                            </mat-option>
                                          </mat-select>
                                        </mat-form-field>
                                      </div>
                                    </div>

                                  </div> -->

                                    <!-- <div fxLayout="column"
                                    *ngIf="comp.controls['customField1'].value=='type7'||comp.controls['customField1'].value=='type8' || comp.controls['customField1'].value=='type9' || comp.controls['customField1'].value=='type10' ">
                                    <div fxFlex fxLayout="column" fxLayoutGap="10">
                                      <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">
                                        <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField2')"
                                          (fileUploadResult)="
                                              getResultts($event, i,'customField2') " [index]="i"
                                          [value]="comp.controls['customField2'].value">
                                        </calsoft-image>
                                        <mat-form-field fxFlex>
                                          <mat-label>Category</mat-label>
                                          <mat-select required formControlName="categoryId1"
                                            [disableOptionCentering]="true" #singleSelect name="item">
                                            <mat-option>
                                              <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                [formControl]="
                                                      categoryFilterControl
                                                    " placeholderLabel="Category Search"
                                                [preventHomeEndKeyPropagation]="
                                                      true
                                                    " noEntriesFoundLabel="No data found">
                                              </ngx-mat-select-search>
                                            </mat-option>
                                            <mat-option *ngFor="
                                                    let opt of filteredCategoryTypeList
                                                  " [value]="opt.categoryId">
                                              {{ opt.categoryName }}
                                            </mat-option>
                                          </mat-select>
                                        </mat-form-field>

                                      </div>

                                      <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">

                                        <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField3')"
                                          (fileUploadResult)="
                                            getResultts($event, i,'customField3')" [index]="i"
                                          [value]="comp.controls['customField3'].value">
                                        </calsoft-image>
                                        <mat-form-field fxFlex>
                                          <mat-label>Category</mat-label>
                                          <mat-select required formControlName="categoryId2"
                                            [disableOptionCentering]="true" #singleSelect name="item">
                                            <mat-option>
                                              <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                [formControl]="
                                                      categoryFilterControl
                                                    " placeholderLabel="Category Search"
                                                [preventHomeEndKeyPropagation]="
                                                      true
                                                    " noEntriesFoundLabel="No data found">
                                              </ngx-mat-select-search>
                                            </mat-option>
                                            <mat-option *ngFor="
                                                    let opt of filteredCategoryTypeList
                                                  " [value]="opt.categoryId">
                                              {{ opt.categoryName }}
                                            </mat-option>
                                          </mat-select>
                                        </mat-form-field>

                                        <mat-form-field fxFlex>
                                          <mat-label>Alt Tag</mat-label>
                                          <input [attr.guide]="'template-inp-altimage' + '__' + sanitizedUrl" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                            trim="blur" matInput formControlName="altImage"/>

                                        </mat-form-field>

                                      </div>

                                    </div>

                                  </div> -->

                                  </div>

                                  <div *ngIf="(comp.controls['type'].value == 'footer')">

                                    <div class="editSets">
                                      <div class="title-head3" fxLayoutAlign="space-between center" color="primary">
                                        <span>Footer</span>

                                        <button [attr.guide]="'template-btn-88' + '__' + sanitizedUrl" class="create"
                                          (click)="addTabLayout(i)" type="button" mat-mini-fab color="primary">
                                          <mat-icon>add</mat-icon>
                                        </button>
                                      </div>

                                      <div id="responsieTable" class="container" style="overflow-x:auto;">
                                        <table fxFlex="100" class="padding-10">
                                          <tbody fxFlex="100">
                                            <ng-container formArrayName="images">
                                              <ng-container
                                                *ngFor="let ImageInfo of comp.get('images')?.controls; let y = index">
                                                <div [formGroupName]="y">
                                                  <tr fxLayout="row" fxLayout.xs="column">
                                                    <ng-container fxLayoutAlign="space-between center">
                                                      <td fxFlex="50" fxFlex.xs="100" data-th="Filename"
                                                        fxLayoutGap="10px">
                                                        <span class="wordBreak">
                                                          <div style="display: flex; gap: 20px;">
                                                            <mat-form-field fxFlex appearance="outline">
                                                              <mat-label>Title</mat-label>
                                                              <input
                                                                [attr.guide]="'template-inp-customfield15' + '__' + sanitizedUrl"
                                                                (keydown.enter)="$event.preventDefault()" trim="blur"
                                                                [autocomplete]="'off'" trim="blur"
                                                                formControlName="customField15" matInput />
                                                            </mat-form-field>
                                                          </div>
                                                        </span>
                                                      </td>
                                                      <td fxFlex="50" fxFlex.xs="100" data-th="Filename"
                                                        fxLayoutGap="10px">
                                                        <span class="wordBreak">
                                                          <div style="display: flex; gap: 20px;">
                                                            <mat-form-field fxFlex appearance="outline">
                                                              <mat-label>Width</mat-label>
                                                              <input
                                                                [attr.guide]="'template-inp-customfield16' + '__' + sanitizedUrl"
                                                                (keydown.enter)="$event.preventDefault()" trim="blur"
                                                                [autocomplete]="'off'" trim="blur"
                                                                formControlName="customField16" matInput />
                                                            </mat-form-field>
                                                          </div>
                                                        </span>
                                                      </td>
                                                      <td fxFlex="50" fxFlex.xs="100" data-th="Filename"
                                                        fxLayoutGap="10px">
                                                        <span class="wordBreak">
                                                          <div style="display: flex">
                                                            <mat-form-field fxFlex appearance="outline">
                                                              <mat-label>Type</mat-label>
                                                              <mat-select
                                                                (selectionChange)="onChangeImageTab($event, i,y)"
                                                                required formControlName="customField3" name="item">
                                                                <mat-option *ngFor="let item of footertypes;"
                                                                  [value]="item.value">
                                                                  {{ item.viewValue }}
                                                                </mat-option>
                                                              </mat-select>
                                                            </mat-form-field>
                                                          </div>
                                                        </span>
                                                      </td>

                                                      <td data-th="Action">
                                                        <span class="wordBreak">
                                                          <button [attr.guide]="'template-btn-89' + '__' + sanitizedUrl"
                                                            color="warn" mat-icon-button type="button"
                                                            (click)="deleteText(i,y)">
                                                            <mat-icon>remove_circle_outline
                                                            </mat-icon>
                                                          </button>
                                                        </span>
                                                      </td>
                                                    </ng-container>
                                                  </tr>

                                                  <tr fxLayout="row" fxLayout.xs="column">
                                                    <td fxFlex="50" fxFlex.xs="100" data-th="Filename"
                                                      fxLayoutGap="10px">
                                                      <span class="wordBreak">
                                                        <div style="display: flex; gap: 20px;">
                                                          <mat-form-field fxFlex appearance="outline">
                                                            <mat-label>Display Social Media </mat-label>
                                                            <mat-select formControlName="customField12">
                                                              <mat-option *ngFor="let item of displaysocialmedia"
                                                                [value]="item.value">
                                                                {{item.viewValue}}
                                                              </mat-option>
                                                            </mat-select>
                                                          </mat-form-field>
                                                        </div>
                                                      </span>
                                                    </td>
                                                    <td fxFlex="50" fxFlex.xs="100" data-th="Filename"
                                                      fxLayoutGap="10px">
                                                      <span class="wordBreak">
                                                        <div style="display: flex; gap: 20px;">
                                                          <mat-form-field fxFlex appearance="outline">
                                                            <mat-label>Display Subscribe</mat-label>
                                                            <mat-select formControlName="customField13">
                                                              <mat-option *ngFor="let item of displaysubscribe"
                                                                [value]="item.value">
                                                                {{item.viewValue}}
                                                              </mat-option>
                                                            </mat-select>
                                                          </mat-form-field>
                                                        </div>
                                                      </span>
                                                    </td>
                                                    <td fxFlex="50" fxFlex.xs="100" data-th="Filename"
                                                      fxLayoutGap="10px"
                                                      *ngIf="ImageInfo.controls.customField3.value == 'image'">
                                                      <span class="wordBreak">
                                                        <div style="display: flex; gap: 20px;">
                                                          <mat-form-field fxFlex appearance="outline">
                                                            <mat-label>View More link</mat-label>
                                                            <input
                                                              [attr.guide]="'template-inp-customfield17' + '__' + sanitizedUrl"
                                                              (keydown.enter)="$event.preventDefault()" trim="blur"
                                                              [autocomplete]="'off'" trim="blur"
                                                              formControlName="customField17" matInput />
                                                          </mat-form-field>
                                                        </div>
                                                      </span>
                                                    </td>
                                                  </tr>

                                                  <tr fxLayout="row" fxLayout.xs="column">
                                                    <td fxFlex="25" fxFlex.xs="100" data-th="Filename"
                                                      fxLayoutGap="10px">
                                                      <span class="wordBreak">
                                                        <div style="display: flex; gap: 20px;">
                                                          <mat-form-field fxFlex appearance="outline">
                                                            <mat-label>Display Playstore App </mat-label>
                                                            <mat-select formControlName="customField18">
                                                              <mat-option *ngFor="let item of playstore"
                                                                [value]="item.value">
                                                                {{item.viewValue}}
                                                              </mat-option>
                                                            </mat-select>
                                                          </mat-form-field>
                                                        </div>
                                                      </span>
                                                    </td>
                                                    <td fxFlex="25" fxFlex.xs="100" data-th="Filename"
                                                      fxLayoutGap="10px">
                                                      <span class="wordBreak">
                                                        <div style="display: flex; gap: 20px;">
                                                          <mat-form-field fxFlex appearance="outline">
                                                            <mat-label>Display App Store</mat-label>
                                                            <mat-select formControlName="customField19">
                                                              <mat-option *ngFor="let item of Appstore"
                                                                [value]="item.value">
                                                                {{item.viewValue}}
                                                              </mat-option>
                                                            </mat-select>
                                                          </mat-form-field>
                                                        </div>
                                                      </span>
                                                    </td>
                                                    <td fxFlex="25" fxFlex.xs="100" data-th="Filename"
                                                      fxLayoutGap="10px">
                                                      <span class="wordBreak">
                                                        <div style="display: flex; gap: 20px;">
                                                          <mat-form-field fxFlex appearance="outline">
                                                            <mat-label>Playstore Link</mat-label>
                                                            <input
                                                              [attr.guide]="'template-inp-customfield20' + '__' + sanitizedUrl"
                                                              (keydown.enter)="$event.preventDefault()" trim="blur"
                                                              [autocomplete]="'off'" trim="blur"
                                                              formControlName="customField20" matInput />
                                                          </mat-form-field>
                                                        </div>
                                                      </span>
                                                    </td>
                                                    <td fxFlex="25" fxFlex.xs="100" data-th="Filename"
                                                      fxLayoutGap="10px">
                                                      <span class="wordBreak">
                                                        <div style="display: flex; gap: 20px;">
                                                          <mat-form-field fxFlex appearance="outline">
                                                            <mat-label>App Store Link</mat-label>
                                                            <input
                                                              [attr.guide]="'template-inp-customfield21' + '__' + sanitizedUrl"
                                                              (keydown.enter)="$event.preventDefault()" trim="blur"
                                                              [autocomplete]="'off'" trim="blur"
                                                              formControlName="customField21" matInput />
                                                          </mat-form-field>
                                                        </div>
                                                      </span>
                                                    </td>
                                                  </tr>


                                                  <tr fxLayout="row" fxLayout.xs="column" fxLayoutGap="10px"
                                                    *ngIf="ImageInfo.controls.customField3.value == 'textwithimage'">

                                                    <td data-th="Filename" fxFlex="100">
                                                      <span class="wordBreak"
                                                        *ngIf="ImageInfo.controls['type'].value==1">

                                                        <calsoft-image fxFlex="100" style="padding-bottom: 10px;"
                                                          (deleteResult)="updatesImageArray($event, i,'customField24',y)"
                                                          (fileUploadResult)="getResultArray($event, i,'customField24',y) "
                                                          [index]="y"
                                                          [value]="ImageInfo.controls['customField24'].value">
                                                        </calsoft-image>
                                                      </span>
                                                    </td>

                                                    <td fxFlex="100">
                                                      <ng-container>
                                                        <mat-form-field fxFlex="100">
                                                          <mat-label>Navigation</mat-label>
                                                          <mat-select required
                                                            (selectionChange)="doSomething($event,i,'catId')"
                                                            formControlName="navigation" name="item">
                                                            <mat-option *ngFor="
                                                      let item of navigation;
                                                      let i = index
                                                    " [value]="item.value">
                                                              {{ item.viewValue }}
                                                            </mat-option>
                                                          </mat-select>
                                                        </mat-form-field>
                                                      </ng-container>
                                                    </td>

                                                    <td fxFlex="100">
                                                      <mat-form-field fxFlex="100">

                                                        <mat-label>
                                                          {{ImageInfo.controls['navigation'].value==0?'Category':'Url'}}
                                                        </mat-label>

                                                        <mat-select *ngIf="ImageInfo.controls['navigation'].value==0"
                                                          required formControlName="catId"
                                                          [disableOptionCentering]="true" #singleSelect name="item">
                                                          <mat-option>
                                                            <ngx-mat-select-search name="Category Search"
                                                              ngDefaultControl [formControl]="
                                                    categoryFilterControl
                                                  " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                    true
                                                  " noEntriesFoundLabel="No data found">
                                                            </ngx-mat-select-search>
                                                          </mat-option>
                                                          <mat-option *ngFor="
                                                  let opt of filteredCategoryTypeList
                                                " [value]="opt.categoryId">
                                                            {{ opt.categoryName }}
                                                          </mat-option>
                                                        </mat-select>


                                                        <input
                                                          [attr.guide]="'template-inp-navigatedurl' + '__' + sanitizedUrl"
                                                          *ngIf="ImageInfo.controls['navigation'].value==1" trim="blur"
                                                          (keydown.enter)="$event.preventDefault()"
                                                          [autocomplete]="'off'" matInput
                                                          formControlName="navigatedUrl" />


                                                      </mat-form-field>

                                                    </td>

                                                  </tr>



                                                  <tr fxLayout="row" fxLayout.xs="column" fxLayoutGap="10px"
                                                    *ngIf="ImageInfo.controls.customField3.value == 'textwithimage'">
                                                    <td fxFlex="50" fxFlex.xs="100">
                                                      <mat-form-field fxFlex appearance="outline">
                                                        <mat-label>Inner Text</mat-label>
                                                        <textarea
                                                          [attr.guide]="'template-sel-customfield1' + '__' + sanitizedUrl"
                                                          trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                          matAutosizeMaxRows=5 matInput formControlName="customField1"
                                                          require d></textarea>
                                                        <mat-icon class="clickable"
                                                          (click)="openEditorText(comp.controls['customField1'].value,i,'customField1')"
                                                          matSuffix>
                                                          post_add
                                                        </mat-icon>
                                                        <mat-hint fxHide.lt-md>Click on the icon to open
                                                          editor</mat-hint>
                                                      </mat-form-field>
                                                    </td>
                                                    <td fxFlex="50" fxFlex.xs="100">
                                                      <mat-form-field fxFlex appearance="outline">
                                                        <mat-label>Image Type</mat-label>
                                                        <mat-select formControlName="customField30">
                                                          <mat-option *ngFor="let item of imagetype"
                                                            [value]="item.value">
                                                            {{item.viewValue}}
                                                          </mat-option>
                                                        </mat-select>
                                                      </mat-form-field>
                                                    </td>
                                                    <td>
                                                      <mat-form-field fxFlex appearance="outline">
                                                        <mat-label>Image Height</mat-label>
                                                        <input
                                                          [attr.guide]="'template-inp-customfield5' + '__' + sanitizedUrl"
                                                          (keydown.enter)="$event.preventDefault()"
                                                          [autocomplete]="'off'" trim="blur" matInput
                                                          formControlName="customField5" />

                                                      </mat-form-field>
                                                    </td>
                                                    <td *ngIf="ImageInfo.controls.customField30.value == '1'">
                                                      <mat-form-field fxFlex appearance="outline">
                                                        <mat-label>Image Width</mat-label>
                                                        <input
                                                          [attr.guide]="'template-inp-customfield11' + '__' + sanitizedUrl"
                                                          (keydown.enter)="$event.preventDefault()"
                                                          [autocomplete]="'off'" trim="blur" matInput
                                                          formControlName="customField11" />

                                                      </mat-form-field>
                                                    </td>

                                                    <td *ngIf="ImageInfo.controls.customField3.value == 'textwithimage'"
                                                      fxFlex="10">
                                                      <button [attr.guide]="'template-btn-90' + '__' + sanitizedUrl"
                                                        [disabled]="!updatepermission" mat-icon-button color="warn"
                                                        (click)="removeOption(i)">
                                                        <mat-icon>remove_circle_outline</mat-icon>
                                                      </button>
                                                    </td>

                                                  </tr>

                                                  <tr fxLayout="row" fxLayout.xs="column">
                                                    <td fxFlex="100"
                                                      *ngIf="ImageInfo.controls.customField3.value == 'image'">
                                                      <div class="editSets">
                                                        <div class="title-head3" color="primary">
                                                          <span>Image</span>
                                                        </div>
                                                        <div id="responsieTable" class="container">
                                                          <table class="rwd-table">
                                                            <tbody>
                                                              <tr>
                                                                <th>Image</th>
                                                                <th>Filename</th>
                                                                <th>Height</th>
                                                                <th>Navigation</th>
                                                                <th>Category</th>
                                                                <th>Action</th>
                                                              </tr>
                                                              <ng-container formArrayName="subChild">
                                                                <tr fxLayout.xs="column" *ngFor="let subChildImageInfo of ImageInfo.get('subChild')?.controls;
                                                               let k = index">
                                                                  <ng-container [formGroupName]="k">
                                                                    <td data-th="Image" style="width: 60%;">
                                                                      <!-- <img style="height: 65px;width: auto;"
                                                                        [src]="bannerServerPath+ subChildImageInfo.controls['customField6'].value"
                                                                        onerror="this.src='assets/images/logo/no-image.png';"
                                                                        alt=""> -->
                                                                      <calsoft-common-images
                                                                        [src]="bannerServerPath+ subChildImageInfo.controls['customField6'].value"
                                                                        [height]="'65px'" [width]="'auto'" [alt]="">

                                                                      </calsoft-common-images>
                                                                    </td>
                                                                    <td data-th="Filename" style="width: 90%;">
                                                                      <span class="wordBreak">
                                                                        {{
                                                                        subChildImageInfo.controls['customField6'].value}}
                                                                      </span>
                                                                    </td>

                                                                    <td fxLayout.xs="column" data-th="Height"
                                                                      style="width: 100%;">
                                                                      <mat-form-field fxFlex="100">
                                                                        <mat-label>Image Height</mat-label>
                                                                        <input
                                                                          [attr.guide]="'template-inp-customfield5' + '__' + sanitizedUrl"
                                                                          (keydown.enter)="$event.preventDefault()"
                                                                          [autocomplete]="'off'" trim="blur" matInput
                                                                          formControlName="customField5" />

                                                                      </mat-form-field>
                                                                    </td>
                                                                    <td data-th="Navigation" class="mobilewidth"
                                                                      style="width: 20%;">
                                                                      <span class="wordBreak">
                                                                        <mat-form-field fxFlex="100">
                                                                          <mat-label>Navigation</mat-label>
                                                                          <mat-select required
                                                                            formControlName="navigation" name="item">
                                                                            <mat-option *ngFor="
                                                                            let item of navigation;
                                                                            let i = index
                                                                          " [value]="item.value">
                                                                              {{ item.viewValue }}
                                                                            </mat-option>
                                                                          </mat-select>
                                                                        </mat-form-field>


                                                                      </span>
                                                                    </td>

                                                                    <td fxLayout.xs="column" data-th="Category"
                                                                      style="width: 100%;">
                                                                      <mat-form-field fxFlex="100">

                                                                        <mat-label>
                                                                          {{subChildImageInfo.controls['navigation'].value
                                                                          ==0?'Category':'Url'}}</mat-label>

                                                                        <mat-select *ngIf="subChildImageInfo.controls['navigation']
                                                                    .value==0" required formControlName="catId"
                                                                          [disableOptionCentering]="true" #singleSelect
                                                                          name="item">
                                                                          <mat-option>
                                                                            <ngx-mat-select-search
                                                                              name="Category Search" ngDefaultControl
                                                                              [formControl]="
                                                                        categoryFilterControl
                                                                      " placeholderLabel="Category Search"
                                                                              [preventHomeEndKeyPropagation]="
                                                                        true
                                                                      " noEntriesFoundLabel="No data found">
                                                                            </ngx-mat-select-search>
                                                                          </mat-option>
                                                                          <mat-option *ngFor="
                                                                      let opt of filteredCategoryTypeList
                                                                    " [value]="opt.categoryId">
                                                                            {{ opt.categoryName }}
                                                                          </mat-option>
                                                                        </mat-select>


                                                                        <input
                                                                          [attr.guide]="'template-inp-navigatedurl' + '__' + sanitizedUrl"
                                                                          fxFlex="100" *ngIf="subChildImageInfo.controls['navigation']
                                                                    .value==1" trim="blur"
                                                                          (keydown.enter)="$event.preventDefault()"
                                                                          [autocomplete]="'off'" matInput
                                                                          formControlName="navigatedUrl" />


                                                                      </mat-form-field>
                                                                    </td>



                                                                    <td data-th="Action">
                                                                      <button
                                                                        [attr.guide]="'template-btn-91' + '__' + sanitizedUrl"
                                                                        color="warn" mat-icon-button type="button"
                                                                        (click)="updateBannerChild( subChildImageInfo.controls['customField6'].value,i,y,k)">
                                                                        <mat-icon>remove_circle_outline
                                                                        </mat-icon>
                                                                      </button>
                                                                    </td>
                                                                  </ng-container>
                                                                </tr>
                                                              </ng-container>
                                                            </tbody>
                                                          </table>
                                                        </div>
                                                      </div>
                                                      <div class="editSets1">
                                                        <div class="title " fxLayout="row"
                                                          fxLayoutAlign="center center">
                                                          <span
                                                            *ngIf=" _form.value.conditions[i].images[y].subChild.length<=0"
                                                            fxLayoutAlign="center center">No
                                                            Images
                                                            Uploaded</span>
                                                        </div>
                                                        <div
                                                          *ngIf=" _form.value.conditions[i].images[y].subChild.length<=4">
                                                          <calsoft-common-file-upload
                                                            (fileUploadResult)="getResultBannerChild($event, i,y)"
                                                            [type]="'commonSlider'"></calsoft-common-file-upload>
                                                        </div>
                                                      </div>
                                                    </td>
                                                  </tr>

                                                  <tr fxLayout="row">
                                                    <td fxFlex="100"
                                                      *ngIf="ImageInfo.controls.customField3.value == 'text'|| ImageInfo.controls.customField3.value == 'textwithicon'">
                                                      <div class="editSets">
                                                        <div class="title-head3" color="primary"
                                                          fxLayoutAlign="space-between center">
                                                          <span>Text</span>
                                                          <button [attr.guide]="'template-btn-92' + '__' + sanitizedUrl"
                                                            class="create" (click)="addImagesArraySub(i,y)"
                                                            type="button" mat-mini-fab color="primary">
                                                            <mat-icon>add</mat-icon>
                                                          </button>
                                                        </div>
                                                        <div id="responsieTable" class="container">
                                                          <table class="rwd-table">
                                                            <tbody>
                                                              <tr>
                                                                <th>Text Content</th>
                                                                <th>Icon</th>
                                                                <th>Navigation Link</th>
                                                                <th>Action</th>
                                                              </tr>


                                                              <ng-container formArrayName="subChild">
                                                                <tr
                                                                  *ngFor="let subChildImageInfo of ImageInfo.get('subChild')?.controls; let M = index">
                                                                  <ng-container [formGroupName]="M">
                                                                    <td data-th="Filename" style="width: 30%;">
                                                                      <span class="wordBreak">
                                                                        <mat-form-field fxFlex appearance="outline">
                                                                          <mat-label>Text Content</mat-label>
                                                                          <input
                                                                            [attr.guide]="'template-inp-customfield19' + '__' + sanitizedUrl"
                                                                            trim="blur"
                                                                            (keydown.enter)="$event.preventDefault()"
                                                                            [autocomplete]="'off'" matInput
                                                                            formControlName="customField19" />
                                                                          <!-- <mat-icon class="clickable"
                                                                          (click)="openEditorTextForSubChildArray(subChildImageInfo.controls['customField19'].value,i,'customField19', M, y)"
                                                                          matSuffix>
                                                                          post_add
                                                                        </mat-icon> -->
                                                                        </mat-form-field>
                                                                      </span>
                                                                    </td>
                                                                    <td data-th="Filename" style="width: 30%;">
                                                                      <span class="wordBreak">
                                                                        <mat-form-field fxFlex appearance="outline">
                                                                          <mat-label>Icon</mat-label>
                                                                          <input
                                                                            [attr.guide]="'template-inp-customfield20' + '__' + sanitizedUrl"
                                                                            trim="blur"
                                                                            (keydown.enter)="$event.preventDefault()"
                                                                            [autocomplete]="'off'" matInput
                                                                            formControlName="customField20" />
                                                                          <!-- <mat-icon class="clickable"
                                                                          (click)="openEditorTextForSubChildArray(subChildImageInfo.controls['customField20'].value,i,'customField20', M, y)"
                                                                          matSuffix>
                                                                          post_add
                                                                        </mat-icon> -->
                                                                        </mat-form-field>
                                                                      </span>
                                                                    </td>
                                                                    <td data-th="Filename" style="width: 30%;">
                                                                      <span class="wordBreak">
                                                                        <mat-form-field fxFlex appearance="outline">
                                                                          <mat-label>Navigation Link</mat-label>
                                                                          <input
                                                                            [attr.guide]="'template-inp-customfield21' + '__' + sanitizedUrl"
                                                                            trim="blur"
                                                                            (keydown.enter)="$event.preventDefault()"
                                                                            [autocomplete]="'off'" matInput
                                                                            formControlName="customField21" />
                                                                          <!-- <mat-icon class="clickable"
                                                                          (click)="openEditorTextForSubChildArray(subChildImageInfo.controls['customField21'].value,i,'customField21', M, y)"
                                                                          matSuffix>
                                                                          post_add
                                                                        </mat-icon> -->
                                                                        </mat-form-field>
                                                                      </span>
                                                                    </td>

                                                                    <td data-th="Action">
                                                                      <button
                                                                        [attr.guide]="'template-btn-93' + '__' + sanitizedUrl"
                                                                        color="warn" mat-icon-button type="button"
                                                                        (click)="updateBannerChild(subChildImageInfo.controls['customField6'].value,i,y,M)">
                                                                        <mat-icon>remove_circle_outline
                                                                        </mat-icon>
                                                                      </button>
                                                                    </td>

                                                                  </ng-container>
                                                                </tr>
                                                              </ng-container>
                                                            </tbody>
                                                          </table>
                                                        </div>
                                                      </div>
                                                    </td>
                                                  </tr>

                                                </div>

                                              </ng-container>
                                            </ng-container>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>


                                  <div *ngIf="(comp.controls['type'].value == 'OfferTiming')">

                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>Start Date</mat-label>
                                      <input [attr.guide]="'template-inp-customfield10' + '__' + sanitizedUrl" matInput
                                        [matDatepicker]="startPicker" formControlName="customField10"
                                        autocomplete="off" />
                                      <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                                      <mat-datepicker #startPicker></mat-datepicker>
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>End Date</mat-label>
                                      <input [attr.guide]="'template-inp-customfield11' + '__' + sanitizedUrl" matInput
                                        [matDatepicker]="endPicker" formControlName="customField11"
                                        autocomplete="off" />
                                      <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                                      <mat-datepicker #endPicker></mat-datepicker>
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>Start Hours</mat-label>
                                      <input [attr.guide]="'template-inp-customfield12' + '__' + sanitizedUrl"
                                        type="time" [autocomplete]="'off'" trim="blur" matInput
                                        formControlName="customField12" />
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" fxFlex>
                                      <mat-label>End Hours</mat-label>
                                      <input [attr.guide]="'template-inp-customfield14' + '__' + sanitizedUrl"
                                        type="time" [autocomplete]="'off'" trim="blur" matInput
                                        formControlName="customField14" />
                                    </mat-form-field>

                                  </div>


                                  <div *ngIf="(comp.controls['type'].value == 'NumberCount')">

                                    <div class="editSets">
                                      <div class="title-head3" fxLayoutAlign="space-between center" color="primary">
                                        <span>Numbercount</span>

                                        <button [attr.guide]="'template-btn-94' + '__' + sanitizedUrl" class="create"
                                          (click)="addImages(i)" type="button" mat-mini-fab color="primary">
                                          <mat-icon>add</mat-icon>
                                        </button>
                                      </div>

                                      <div id="responsieTable" class="container" style="overflow-x:auto;">
                                        <table fxFlex="100" class="padding-10">
                                          <tbody fxFlex="100">
                                            <ng-container formArrayName="images">
                                              <ng-container
                                                *ngFor="let ImageInfo of comp.get('images')?.controls; let y = index">
                                                <div [formGroupName]="y">
                                                  <tr fxLayout="row" fxLayout.xs="column" fxLayoutGap="10px">
                                                    <ng-container fxLayoutAlign="space-between center">
                                                      <td fxFlex="30" fxFlex.xs="100" data-th="Filename"
                                                        fxLayoutGap="10px">
                                                        <span class="wordBreak">
                                                          <div style="display: flex; gap: 20px;">
                                                            <mat-form-field fxFlex appearance="outline">
                                                              <mat-label>Title</mat-label>
                                                              <input
                                                                [attr.guide]="'template-inp-customfield15' + '__' + sanitizedUrl"
                                                                (keydown.enter)="$event.preventDefault()" trim="blur"
                                                                [autocomplete]="'off'" trim="blur"
                                                                formControlName="customField15" matInput />
                                                            </mat-form-field>
                                                          </div>
                                                        </span>
                                                      </td>
                                                      <td fxFlex="30" fxFlex.xs="100" data-th="Filename"
                                                        fxLayoutGap="10px">
                                                        <span class="wordBreak">
                                                          <div style="display: flex; gap: 20px;">
                                                            <mat-form-field fxFlex appearance="outline">
                                                              <mat-label>Loading Value</mat-label>
                                                              <input
                                                                [attr.guide]="'template-inp-customfield16' + '__' + sanitizedUrl"
                                                                (keydown.enter)="$event.preventDefault()" trim="blur"
                                                                [autocomplete]="'off'" trim="blur"
                                                                formControlName="customField16" matInput />
                                                            </mat-form-field>
                                                          </div>
                                                        </span>
                                                      </td>

                                                      <td fxFlex="20" data-th="Filename" style="width: 100%;">
                                                        <span class="wordBreak">
                                                          <mat-form-field fxFlex="100">
                                                            <mat-label>Navigation</mat-label>
                                                            <mat-select required formControlName="navigation"
                                                              name="item">
                                                              <mat-option *ngFor="
                                                            let item of navigation;
                                                            let i = index
                                                          " [value]="item.value">
                                                                {{ item.viewValue }}
                                                              </mat-option>
                                                            </mat-select>
                                                          </mat-form-field>

                                                        </span>
                                                      </td>

                                                      <td fxLayout.xs="column" fxFlex="20" fxFlex.xs="100"
                                                        class="mobilewidth" data-th="Category" style="width: 20%;">
                                                        <mat-form-field fxFlex="100" fxLayoutAlign="center center"
                                                          fxLayoutAlign.xs="start">

                                                          <mat-label>{{ImageInfo.controls['navigation'].value
                                                            ==0?'Category':'Url'}}</mat-label>

                                                          <mat-select *ngIf="ImageInfo.controls['navigation']
                                                      .value==0" required formControlName="catId"
                                                            [disableOptionCentering]="true" #singleSelect name="item">
                                                            <mat-option>
                                                              <ngx-mat-select-search name="Category Search"
                                                                ngDefaultControl [formControl]="
                                                          categoryFilterControl
                                                        " placeholderLabel="Category Search"
                                                                [preventHomeEndKeyPropagation]="
                                                          true
                                                        " noEntriesFoundLabel="No data found">
                                                              </ngx-mat-select-search>
                                                            </mat-option>
                                                            <mat-option *ngFor="
                                                        let opt of filteredCategoryTypeList
                                                      " [value]="opt.categoryId">
                                                              {{ opt.categoryName }}
                                                            </mat-option>
                                                          </mat-select>


                                                          <input
                                                            [attr.guide]="'template-inp-navigatedurl' + '__' + sanitizedUrl"
                                                            style="width:100%" *ngIf="ImageInfo.controls['navigation']
                                                      .value==1" trim="blur" (keydown.enter)="$event.preventDefault()"
                                                            [autocomplete]="'off'" matInput
                                                            formControlName="navigatedUrl" />


                                                        </mat-form-field>
                                                      </td>



                                                      <td data-th="Action">
                                                        <span class="wordBreak">
                                                          <button [attr.guide]="'template-btn-95' + '__' + sanitizedUrl"
                                                            color="warn" mat-icon-button type="button"
                                                            (click)="deleteText(i,y)">
                                                            <mat-icon>remove_circle_outline
                                                            </mat-icon>
                                                          </button>
                                                        </span>
                                                      </td>
                                                    </ng-container>
                                                  </tr>



                                                </div>

                                              </ng-container>
                                            </ng-container>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>

                                  <div fxLayout="column" *ngIf="(comp.controls['type'].value == 'scrolltextwithform') ">
                                    <div class="editSets">
                                      <div class="title-head3" color="primary">
                                        <span>Image</span>
                                      </div>
                                      <div id="responsieTable" class="container" style="overflow-x:auto;">
                                        <table class="rwd-table">
                                          <tbody>
                                            <tr>
                                              <th fxFlex>Image</th>
                                              <th fxFlex>Filename</th>
                                              <th fxFlex>Action</th>
                                            </tr>
                                            <ng-container formArrayName="images">
                                              <ng-container
                                                *ngFor="let ImageInfo of comp.get('images')?.controls;; let M = index">
                                                <ng-container [formGroupName]="M">
                                                  <tr fxLayout.xs="column">
                                                    <td fxLayout.xs="column" fxFlex data-th="Image">
                                                      <!-- <img style="height: 65px;width: auto;"
                                                        [src]="bannerServerPath+ ImageInfo.controls['img'].value"
                                                        onerror="this.src='assets/images/logo/no-image.png';" alt=""> -->

                                                      <calsoft-common-images
                                                        [src]="bannerServerPath+ ImageInfo.controls['img'].value"
                                                        [height]="'65px'" [width]="'auto'" [alt]="">

                                                      </calsoft-common-images>
                                                    </td>
                                                    <td fxLayout.xs="column" fxFlex data-th="Filename">
                                                      <span class="wordBreak">
                                                        {{ ImageInfo.controls['img'].value}}
                                                      </span>
                                                    </td>

                                                    <td fxLayout.xs="column" fxFlex data-th="Action">
                                                      <button [attr.guide]="'template-btn-96' + '__' + sanitizedUrl"
                                                        color="warn" mat-icon-button type="button"
                                                        (click)="updateBanner( ImageInfo.controls['img'].value,i,M)">
                                                        <mat-icon>remove_circle_outline
                                                        </mat-icon>
                                                      </button>
                                                    </td>

                                                  </tr>

                                                </ng-container>
                                              </ng-container>
                                            </ng-container>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                    <div class="editSets1">
                                      <div class="title " fxLayout="row" fxLayoutAlign="center center">
                                        <span *ngIf=" _form.value.conditions[i].images.length<=0"
                                          fxLayoutAlign="center center">No
                                          Images
                                          Uploaded</span>
                                      </div>
                                      <div>
                                        <calsoft-common-file-upload (fileUploadResult)="getResultBanner($event, i)"
                                          [type]="'commonSlider'"></calsoft-common-file-upload>
                                      </div>
                                    </div>
                                    <div fxLayout="column"
                                      *ngIf="comp.controls['customField1'].value=='type2' || comp.controls['customField1'].value=='type4'">
                                      <div fxFlex fxLayout="column" fxLayoutGap="10">
                                        <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">
                                          <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField2')"
                                            (fileUploadResult)="
                                            getResultts($event, i,'customField2') " [index]="i"
                                            [value]="comp.controls['customField2'].value">
                                          </calsoft-image>
                                          <mat-form-field fxFlex>
                                            <mat-label>Category</mat-label>
                                            <mat-select required formControlName="categoryId1"
                                              [disableOptionCentering]="true" #singleSelect name="item">
                                              <mat-option>
                                                <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                  [formControl]="
                                                    categoryFilterControl
                                                  " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                    true
                                                  " noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                              </mat-option>
                                              <mat-option *ngFor="
                                                  let opt of filteredCategoryTypeList
                                                " [value]="opt.categoryId">
                                                {{ opt.categoryName }}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>

                                          <mat-form-field fxFlex>
                                            <mat-label>Show Animation </mat-label>
                                            <mat-select formControlName="customField19">
                                              <mat-option *ngFor="let status of ShowAnimation1" [value]="status.value">
                                                {{status.viewValue}}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                        </div>
                                        <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                          *ngIf="comp.controls['type'].value === 'bannerTextWithButton'">
                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Title</mat-label>
                                            <input [attr.guide]="'template-inp-customfield5' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField5" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Description</mat-label>
                                            <input [attr.guide]="'template-inp-customfield6' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField6" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Special Description</mat-label>
                                            <input [attr.guide]="'template-inp-customfield8' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField8" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Button</mat-label>
                                            <input [attr.guide]="'template-inp-customfield10' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField10" matInput />
                                          </mat-form-field>
                                        </div>

                                        <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                          *ngIf="comp.controls['type'].value === 'bannerTextWithButton'">
                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Font Color</mat-label>
                                            <input [attr.guide]="'template-inp-customfield27' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField27" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Font Size</mat-label>
                                            <input [attr.guide]="'template-inp-customfield28' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField28" matInput />
                                          </mat-form-field>

                                        </div>

                                        <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">

                                          <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField3')"
                                            (fileUploadResult)="
                                          getResultts($event, i,'customField3')" [index]="i"
                                            [value]="comp.controls['customField3'].value">
                                          </calsoft-image>
                                          <mat-form-field fxFlex>
                                            <mat-label>Category</mat-label>
                                            <mat-select required formControlName="categoryId2"
                                              [disableOptionCentering]="true" #singleSelect name="item">
                                              <mat-option>
                                                <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                  [formControl]="
                                                    categoryFilterControl
                                                  " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                    true
                                                  " noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                              </mat-option>
                                              <mat-option *ngFor="
                                                  let opt of filteredCategoryTypeList
                                                " [value]="opt.categoryId">
                                                {{ opt.categoryName }}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>

                                          <mat-form-field fxFlex>
                                            <mat-label>Show Animation </mat-label>
                                            <mat-select formControlName="customField21">
                                              <mat-option *ngFor="let status of ShowAnimation1" [value]="status.value">
                                                {{status.viewValue}}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>

                                        </div>

                                        <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                          *ngIf="comp.controls['type'].value === 'bannerTextWithButton'">

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Title</mat-label>
                                            <input [attr.guide]="'template-inp-customfield9' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField9" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Description</mat-label>
                                            <input [attr.guide]="'template-inp-customfield14' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField14" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Special Description</mat-label>
                                            <input [attr.guide]="'template-inp-customfield20' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField20" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Button</mat-label>
                                            <input [attr.guide]="'template-inp-customfield23' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField23" matInput />
                                          </mat-form-field>
                                        </div>

                                        <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                          *ngIf="comp.controls['type'].value === 'bannerTextWithButton'">
                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Font Color</mat-label>
                                            <input [attr.guide]="'template-inp-customfield29' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField29" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Font Size</mat-label>
                                            <input [attr.guide]="'template-inp-customfield30' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField30" matInput />
                                          </mat-form-field>

                                        </div>

                                        <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">

                                          <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField4')"
                                            (fileUploadResult)="
                                          getResultts($event, i,'customField4')" [index]="i"
                                            [value]="comp.controls['customField4'].value">
                                          </calsoft-image>
                                          <mat-form-field fxFlex>
                                            <mat-label>Category</mat-label>
                                            <mat-select required formControlName="categoryId3"
                                              [disableOptionCentering]="true" #singleSelect name="item">
                                              <mat-option>
                                                <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                  [formControl]="
                                                    categoryFilterControl
                                                  " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                    true
                                                  " noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                              </mat-option>
                                              <mat-option *ngFor="
                                                  let opt of filteredCategoryTypeList
                                                " [value]="opt.categoryId">
                                                {{ opt.categoryName }}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>

                                          <mat-form-field fxFlex>
                                            <mat-label>Show Animation </mat-label>
                                            <mat-select formControlName="customField15">
                                              <mat-option *ngFor="let status of ShowAnimation1" [value]="status.value">
                                                {{status.viewValue}}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                        </div>

                                        <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                          *ngIf="comp.controls['type'].value === 'bannerTextWithButton'">
                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Title</mat-label>
                                            <input [attr.guide]="'template-inp-customfield16' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField16" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Description</mat-label>
                                            <input [attr.guide]="'template-inp-customfield11' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField11" matInput />
                                          </mat-form-field>
                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Special Description</mat-label>
                                            <input [attr.guide]="'template-inp-customfield24' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField24" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Button</mat-label>
                                            <input [attr.guide]="'template-inp-customfield12' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField12" matInput />
                                          </mat-form-field>
                                        </div>

                                        <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                          *ngIf="comp.controls['type'].value === 'bannerTextWithButton'">
                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Font Color</mat-label>
                                            <input [attr.guide]="'template-inp-customfield31' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField31" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Font Size</mat-label>
                                            <input [attr.guide]="'template-inp-customfield32' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField32" matInput />
                                          </mat-form-field>

                                        </div>

                                      </div>

                                    </div>

                                    <div fxLayout="column" *ngIf="comp.controls['customField1'].value=='type5'">
                                      <div fxFlex fxLayout="column" fxLayoutGap="10">
                                        <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">
                                          <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField2')"
                                            (fileUploadResult)="
                                            getResultts($event, i,'customField2') " [index]="i"
                                            [value]="comp.controls['customField2'].value">
                                          </calsoft-image>
                                          <mat-form-field fxFlex>
                                            <mat-label>Category</mat-label>
                                            <mat-select required formControlName="categoryId1"
                                              [disableOptionCentering]="true" #singleSelect name="item">
                                              <mat-option>
                                                <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                  [formControl]="
                                                    categoryFilterControl
                                                  " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                    true
                                                  " noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                              </mat-option>
                                              <mat-option *ngFor="
                                                  let opt of filteredCategoryTypeList
                                                " [value]="opt.categoryId">
                                                {{ opt.categoryName }}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>

                                          <mat-form-field fxFlex>
                                            <mat-label>Show Animation </mat-label>
                                            <mat-select formControlName="customField19">
                                              <mat-option *ngFor="let status of ShowAnimation1" [value]="status.value">
                                                {{status.viewValue}}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                        </div>
                                        <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                          *ngIf="comp.controls['type'].value === 'bannerTextWithButton'">
                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Title</mat-label>
                                            <input [attr.guide]="'template-inp-customfield5' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField5" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Description</mat-label>
                                            <input [attr.guide]="'template-inp-customfield6' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField6" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Special Description</mat-label>
                                            <input [attr.guide]="'template-inp-customfield8' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField8" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Button</mat-label>
                                            <input [attr.guide]="'template-inp-customfield10' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField10" matInput />
                                          </mat-form-field>
                                        </div>

                                        <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                          *ngIf="comp.controls['type'].value === 'bannerTextWithButton'">
                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Font Color</mat-label>
                                            <input [attr.guide]="'template-inp-customfield27' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField27" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Font Size</mat-label>
                                            <input [attr.guide]="'template-inp-customfield28' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField28" matInput />
                                          </mat-form-field>

                                        </div>

                                        <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">

                                          <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField3')"
                                            (fileUploadResult)="
                                          getResultts($event, i,'customField3')" [index]="i"
                                            [value]="comp.controls['customField3'].value">
                                          </calsoft-image>
                                          <mat-form-field fxFlex>
                                            <mat-label>Category</mat-label>
                                            <mat-select required formControlName="categoryId2"
                                              [disableOptionCentering]="true" #singleSelect name="item">
                                              <mat-option>
                                                <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                  [formControl]="
                                                    categoryFilterControl
                                                  " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                    true
                                                  " noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                              </mat-option>
                                              <mat-option *ngFor="
                                                  let opt of filteredCategoryTypeList
                                                " [value]="opt.categoryId">
                                                {{ opt.categoryName }}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>

                                          <mat-form-field fxFlex>
                                            <mat-label>Show Animation </mat-label>
                                            <mat-select formControlName="customField21">
                                              <mat-option *ngFor="let status of ShowAnimation1" [value]="status.value">
                                                {{status.viewValue}}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>

                                        </div>

                                        <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                          *ngIf="comp.controls['type'].value === 'bannerTextWithButton'">

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Title</mat-label>
                                            <input [attr.guide]="'template-inp-customfield9' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField9" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Description</mat-label>
                                            <input [attr.guide]="'template-inp-customfield14' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField14" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Special Description</mat-label>
                                            <input [attr.guide]="'template-inp-customfield20' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField20" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Button</mat-label>
                                            <input [attr.guide]="'template-inp-customfield23' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField23" matInput />
                                          </mat-form-field>
                                        </div>

                                        <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px"
                                          *ngIf="comp.controls['type'].value === 'bannerTextWithButton'">
                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Font Color</mat-label>
                                            <input [attr.guide]="'template-inp-customfield29' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField29" matInput />
                                          </mat-form-field>

                                          <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Font Size</mat-label>
                                            <input [attr.guide]="'template-inp-customfield30' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" formControlName="customField30" matInput />
                                          </mat-form-field>

                                        </div>

                                      </div>
                                    </div>
                                  </div>


                                  <!-- end brand -->

                                  <div fxLayout="column"
                                    *ngIf="(comp.controls['type'].value == 'iconTextWithBackground') ">

                                    <div class="editSets" style="overflow: scroll;">
                                      <div style="width: 100%;" class="title-head3" color="primary">
                                        <span>Image</span>
                                      </div>
                                      <div id="responsieTable" class="container" style="overflow-x:auto;">
                                        <table class="rwd-table">
                                          <tbody>
                                            <tr>
                                              <th>Image</th>
                                              <th>Filename</th>
                                              <th>Title</th>
                                              <th>Description</th>
                                              <th>Alt Tag</th>
                                              <th>Alignment</th>
                                              <th>Navigation</th>
                                              <th>Category</th>
                                              <th>Action</th>
                                            </tr>
                                            <ng-container formArrayName="images">
                                              <tr *ngFor="let ImageInfo of comp.get('images')?.controls; let k = index">
                                                <ng-container [formGroupName]="k">
                                                  <td data-th="Image" style="width: 60%;">

                                                    <!-- <img style="height: 65px;width: auto;"
                                                      [src]="bannerServerPath+ ImageInfo.controls['img'].value"
                                                      onerror="this.src='assets/images/logo/no-image.png';" alt=""> -->

                                                    <calsoft-common-images
                                                      [src]="bannerServerPath+ ImageInfo.controls['img'].value"
                                                      [height]="'65px'" [width]="'auto'" [alt]="">

                                                    </calsoft-common-images>

                                                  </td>
                                                  <td data-th="Filename" style="width:50%;">
                                                    <span class="wordBreak">
                                                      {{ ImageInfo.controls['img'].value}}
                                                    </span>
                                                  </td>



                                                  <td data-th="Filename" class="mobilewidth" style="width: 80%;">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="100" appearance="outline">
                                                        <mat-label>Title</mat-label>
                                                        <textarea
                                                          [attr.guide]="'template-sel-customfield15' + '__' + sanitizedUrl"
                                                          trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                          matAutosizeMaxRows=5 matInput
                                                          formControlName="customField15"></textarea>
                                                        <mat-icon class="clickable"
                                                          (click)="openEditorTextForImageArray(ImageInfo.controls['customField15'].value, i,'customField15', k)"
                                                          matSuffix>
                                                          post_add
                                                        </mat-icon>
                                                      </mat-form-field>
                                                    </span>
                                                  </td>

                                                  <td data-th="Filename" class="mobilewidth" style="width: 80%;">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="100" appearance="outline">
                                                        <mat-label>Description</mat-label>
                                                        <textarea
                                                          [attr.guide]="'template-sel-customfield16' + '__' + sanitizedUrl"
                                                          trim="blur" matTextareaAutosize matAutosizeMinRows=1
                                                          matAutosizeMaxRows=5 matInput
                                                          formControlName="customField16"></textarea>
                                                        <mat-icon class="clickable"
                                                          (click)="openEditorTextForImageArray(ImageInfo.controls['customField16'].value, i,'customField16', k)"
                                                          matSuffix>
                                                          post_add
                                                        </mat-icon>
                                                      </mat-form-field>
                                                    </span>
                                                  </td>

                                                  <td data-th="Filename" class="mobilewidth" style="width: 80%;">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="100" appearance="outline">
                                                        <mat-label>Alt Tag</mat-label>
                                                        <input
                                                          [attr.guide]="'template-inp-altimage' + '__' + sanitizedUrl"
                                                          (keydown.enter)="$event.preventDefault()"
                                                          [autocomplete]="'off'" trim="blur" matInput
                                                          formControlName="altImage" />
                                                      </mat-form-field>
                                                    </span>
                                                  </td>

                                                  <td data-th="Filename" fxLayout.xs="column" class="mobilewidth"
                                                    style="width:50%;">
                                                    <mat-form-field fxFlex>
                                                      <mat-label>AlignMent</mat-label>
                                                      <mat-select formControlName="customField8" name="item">
                                                        <mat-option *ngFor="
                                                        let item of alignMent1;
                                                        let i = index
                                                      " [value]="item.value">
                                                          {{ item.viewValue }}
                                                        </mat-option>
                                                      </mat-select>
                                                    </mat-form-field>
                                                  </td>

                                                  <td data-th="Filename" style="width: 100%;">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="100">
                                                        <mat-label>Navigation</mat-label>
                                                        <mat-select required formControlName="navigation" name="item">
                                                          <mat-option *ngFor="
                                                        let item of navigation;
                                                        let i = index
                                                      " [value]="item.value">
                                                            {{ item.viewValue }}
                                                          </mat-option>
                                                        </mat-select>
                                                      </mat-form-field>

                                                    </span>
                                                  </td>

                                                  <td data-th="Category" fxLayout.xs="column" class="mobilewidth"
                                                    style="width: 100%;">
                                                    <mat-form-field style="width: 100%;" fxFlex="100" fxFlex.xs="100"
                                                      fxLayoutAlign="center center" fxLayoutAlign.xs="start center">

                                                      <mat-label>{{ImageInfo.controls['navigation'].value
                                                        ==0?'Category':'Url'}}</mat-label>

                                                      <mat-select fxFlex.xs="100" *ngIf="ImageInfo.controls['navigation']
                                                .value==0" required formControlName="catId"
                                                        [disableOptionCentering]="true" #singleSelect name="item">
                                                        <mat-option>
                                                          <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                            [formControl]="
                                                    categoryFilterControl
                                                  " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                    true
                                                  " noEntriesFoundLabel="No data found">
                                                          </ngx-mat-select-search>
                                                        </mat-option>
                                                        <mat-option *ngFor="
                                                  let opt of filteredCategoryTypeList
                                                " [value]="opt.categoryId">
                                                          {{ opt.categoryName }}
                                                        </mat-option>
                                                      </mat-select>


                                                      <input
                                                        [attr.guide]="'template-inp-navigatedurl' + '__' + sanitizedUrl"
                                                        *ngIf="ImageInfo.controls['navigation']
                                                .value==1" trim="blur" (keydown.enter)="$event.preventDefault()"
                                                        [autocomplete]="'off'" matInput
                                                        formControlName="navigatedUrl" />


                                                    </mat-form-field>
                                                  </td>

                                                  <td data-th="Action">
                                                    <button [attr.guide]="'template-btn-97' + '__' + sanitizedUrl"
                                                      color="warn" mat-icon-button type="button"
                                                      (click)="updateBanner( ImageInfo.controls['img'].value,i,k)">
                                                      <mat-icon>remove_circle_outline
                                                      </mat-icon>
                                                    </button>
                                                  </td>
                                                </ng-container>
                                              </tr>
                                            </ng-container>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>


                                    <div class="editSets1">
                                      <div class="title " fxLayout="row" fxLayoutAlign="center center">
                                        <span *ngIf=" _form.value.conditions[i].images.length<=0"
                                          fxLayoutAlign="center center">No
                                          Images
                                          Uploaded</span>
                                      </div>
                                      <div>
                                        <calsoft-common-file-upload (fileUploadResult)="getResultBanner($event, i)"
                                          [type]="'commonSlider'"></calsoft-common-file-upload>
                                      </div>
                                    </div>

                                  </div>

                                  <div fxLayout="column" *ngIf="(comp.controls['type'].value == 'buttonType') ">

                                    <div class="editSets" *ngIf="comp.controls['customField15'].value == '4'">
                                      <div class="title-head3" fxLayoutAlign="space-between center" color="primary">
                                        <span>Button</span>

                                        <button [attr.guide]="'template-btn-98' + '__' + sanitizedUrl" class="create"
                                          (click)=" addImages(i)" type="button" mat-mini-fab color="primary">
                                          <mat-icon>add</mat-icon>
                                        </button>
                                      </div>

                                      <div id="responsieTable" class="container">
                                        <table fxFlex="100" class="rwd-table">
                                          <tbody fxFlex="100">
                                            <tr>
                                              <th fxFlex="50">Name</th>
                                              <th fxFlex="50">Link</th>
                                              <th fxFlex="50">Action</th>
                                            </tr>

                                            <ng-container formArrayName="images">
                                              <tr fxLayout.xs="column"
                                                *ngFor="let ImageInfo of comp.get('images')?.controls; let y = index">
                                                <ng-container [formGroupName]="y" fxLayoutAlign="space-between center">
                                                  <td fxFlex="30" fxFlex.xs="100" data-th="Filename">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="90" class="mobilewidth"
                                                        appearance="outline" fxLayoutGap="10px">
                                                        <mat-label>Name</mat-label>
                                                        <input
                                                          [attr.guide]="'template-inp-customfield15' + '__' + sanitizedUrl"
                                                          (keydown.enter)="$event.preventDefault()"
                                                          [autocomplete]="'off'" trim="blur" matInput
                                                          formControlName="customField15" />
                                                      </mat-form-field>
                                                    </span>
                                                  </td>

                                                  <td fxLayoutGap="10px" fxFlex.xs="100" fxFlex="30" data-th="Filename">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex="90" class="mobilewidth"
                                                        appearance="outline" fxLayoutGap="10px">
                                                        <mat-label>Link</mat-label>
                                                        <input
                                                          [attr.guide]="'template-inp-customfield16' + '__' + sanitizedUrl"
                                                          (keydown.enter)="$event.preventDefault()"
                                                          [autocomplete]="'off'" trim="blur" matInput
                                                          formControlName="customField16" />
                                                      </mat-form-field>
                                                    </span>
                                                  </td>

                                                  <td data-th="Action">
                                                    <span class="wordBreak">
                                                      <button [attr.guide]="'template-btn-99' + '__' + sanitizedUrl"
                                                        fxLayout="row" fxLayoutAlign="end end" color="warn"
                                                        mat-icon-button type="button" (click)="deleteText(i, y)">
                                                        <mat-icon>remove_circle_outline</mat-icon>
                                                      </button>
                                                    </span>
                                                  </td>
                                                </ng-container>
                                              </tr>
                                            </ng-container>


                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                  <!-- mp4 -->
                                  <div fxLayout="column" *ngIf="(comp.controls['type'].value == 'mp4') ">

                                    <div class="editSets" *ngIf="comp.controls['customField34'].value == '2'">
                                      <div class="title-head3" fxLayoutAlign="space-between center" color="primary">
                                        <span>Video ID</span>

                                        <button [attr.guide]="'template-btn-100' + '__' + sanitizedUrl" class="create"
                                          (click)=" addImages(i)" type="button" mat-mini-fab color="primary">
                                          <mat-icon>add</mat-icon>
                                        </button>
                                      </div>

                                      <div id="responsieTable" class="container">
                                        <table fxFlex="100" class="rwd-table">
                                          <tbody fxFlex="100">
                                            <tr>
                                              <th fxFlex="50">Video Id</th>
                                              <th fxFlex="50">Action</th>
                                            </tr>

                                            <ng-container formArrayName="images">
                                              <tr
                                                *ngFor="let ImageInfo of comp.get('images')?.controls;; let y = index">
                                                <ng-container [formGroupName]="y" fxLayoutAlign="space-between center">
                                                  <td fxFlex="90" data-th="Filename" fxLayoutGap="10px">
                                                    <span class="wordBreak">

                                                      <mat-form-field fxFlex="50" appearance="outline">
                                                        <mat-label>Video id</mat-label>
                                                        <input
                                                          [attr.guide]="'template-inp-customfield15' + '__' + sanitizedUrl"
                                                          (keydown.enter)="$event.preventDefault()"
                                                          [autocomplete]="'off'" trim="blur" matInput
                                                          formControlName="customField15" />

                                                      </mat-form-field>
                                                    </span>
                                                  </td>

                                                  <td data-th="Action">
                                                    <span class="wordBreak">
                                                      <button [attr.guide]="'template-btn-101' + '__' + sanitizedUrl"
                                                        color="warn" mat-icon-button type="button"
                                                        (click)="deleteText(i,y)">
                                                        <mat-icon>remove_circle_outline
                                                        </mat-icon>
                                                      </button>
                                                    </span>
                                                  </td>
                                                </ng-container>
                                              </tr>
                                            </ng-container>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>

                                    <div class="editSets" *ngIf="comp.controls['customField34'].value == '1'">
                                      <div class="title-head3" color="primary">
                                        <span>Image</span>
                                      </div>
                                      <div id="responsieTable" class="container">
                                        <table class="rwd-table">
                                          <tbody>
                                            <tr>
                                              <th>Image</th>
                                              <th>Filename</th>
                                              <th>Video Type</th>
                                              <th>Navigation</th>
                                              <th>Category</th>
                                              <th>Action</th>
                                            </tr>
                                            <ng-container formArrayName="images">
                                              <tr
                                                *ngFor="let ImageInfo of comp.get('images')?.controls;; let k = index">
                                                <ng-container [formGroupName]="k">
                                                  <td data-th="Image" style="width: 60%;">
                                                    <video width="350" height="300" controls>
                                                      <source [src]="bannerServerPath + ImageInfo.controls['img'].value"
                                                        type="video/mp4">
                                                      Your browser does not support the video tag.
                                                    </video>

                                                  </td>
                                                  <td data-th="Filename" style="width: 90%;">
                                                    <span class="wordBreak">
                                                      {{ ImageInfo.controls['img'].value}}
                                                    </span>
                                                  </td>
                                                  <td data-th="Filename" style="width: 20%;">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex>
                                                        <mat-label>Video Type</mat-label>
                                                        <mat-select formControlName="type">
                                                          <mat-option *ngFor="let status of videotype"
                                                            [value]="status.value">
                                                            {{status.viewValue}}
                                                          </mat-option>
                                                        </mat-select>
                                                      </mat-form-field>
                                                    </span>
                                                  </td>

                                                  <td data-th="Filename" style="width: 20%;">
                                                    <span class="wordBreak">
                                                      <mat-form-field fxFlex>
                                                        <mat-label>Navigation</mat-label>
                                                        <mat-select required formControlName="navigation" name="item">
                                                          <mat-option *ngFor="
                                                          let item of navigation;
                                                          let i = index
                                                        " [value]="item.value">
                                                            {{ item.viewValue }}
                                                          </mat-option>
                                                        </mat-select>
                                                      </mat-form-field>


                                                    </span>
                                                  </td>

                                                  <td fxLayout.xs="column" data-th="Category" class="mobilewidth"
                                                    style="width: 20%;">
                                                    <mat-form-field fxFlex fxLayoutAlign="center center"
                                                      fxLayoutAlign.xs="start center">

                                                      <mat-label>{{ImageInfo.controls['navigation'].value
                                                        ==0?'Category':'Url'}}</mat-label>

                                                      <mat-select *ngIf="ImageInfo.controls['navigation']
                                                  .value==0" required formControlName="catId"
                                                        [disableOptionCentering]="true" #singleSelect name="item">
                                                        <mat-option>
                                                          <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                            [formControl]="
                                                      categoryFilterControl
                                                    " placeholderLabel="Category Search"
                                                            [preventHomeEndKeyPropagation]="
                                                      true
                                                    " noEntriesFoundLabel="No data found">
                                                          </ngx-mat-select-search>
                                                        </mat-option>
                                                        <mat-option *ngFor="
                                                    let opt of filteredCategoryTypeList
                                                  " [value]="opt.categoryId">
                                                          {{ opt.categoryName }}
                                                        </mat-option>
                                                      </mat-select>


                                                      <input
                                                        [attr.guide]="'template-inp-navigatedurl' + '__' + sanitizedUrl"
                                                        *ngIf="ImageInfo.controls['navigation']
                                                  .value==1" trim="blur" (keydown.enter)="$event.preventDefault()"
                                                        [autocomplete]="'off'" matInput
                                                        formControlName="navigatedUrl" />


                                                    </mat-form-field>
                                                  </td>

                                                  <td data-th="Action">
                                                    <button [attr.guide]="'template-btn-102' + '__' + sanitizedUrl"
                                                      color="warn" mat-icon-button type="button"
                                                      (click)="updateBanner( ImageInfo.controls['img'].value,i,k)">
                                                      <mat-icon>remove_circle_outline
                                                      </mat-icon>
                                                    </button>
                                                  </td>
                                                </ng-container>
                                              </tr>
                                            </ng-container>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>

                                    <div class="editSets1">
                                      <div class="title " fxLayout="row" fxLayoutAlign="center center">
                                        <span *ngIf=" _form.value.conditions[i].images.length<=0"
                                          fxLayoutAlign="center center">No
                                          Images
                                          Uploaded</span>
                                      </div>
                                      <div>
                                        <calsoft-common-file-upload-video
                                          (fileUploadResult)="getResultBanner($event, i)"
                                          [type]="'commonSlider'"></calsoft-common-file-upload-video>
                                      </div>


                                    </div>
                                    <div fxLayout="column"
                                      *ngIf="comp.controls['customField1'].value=='type3'||comp.controls['customField1'].value=='type4' || comp.controls['customField1'].value=='type5' || comp.controls['customField1'].value=='type6' ">
                                      <div fxFlex fxLayout="column" fxLayoutGap="10">
                                        <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">
                                          <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField2')"
                                            (fileUploadResult)="
                                          getResultts($event, i,'customField2') " [index]="i"
                                            [value]="comp.controls['customField2'].value">
                                          </calsoft-image>
                                          <mat-form-field fxFlex>
                                            <mat-label>Category</mat-label>
                                            <mat-select required formControlName="categoryId1"
                                              [disableOptionCentering]="true" #singleSelect name="item">
                                              <mat-option>
                                                <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                  [formControl]="
                                                  categoryFilterControl
                                                " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                  true
                                                " noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                              </mat-option>
                                              <mat-option *ngFor="
                                                let opt of filteredCategoryTypeList
                                              " [value]="opt.categoryId">
                                                {{ opt.categoryName }}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                        </div>

                                        <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">

                                          <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField3')"
                                            (fileUploadResult)="
                                        getResultts($event, i,'customField3')" [index]="i"
                                            [value]="comp.controls['customField3'].value">
                                          </calsoft-image>
                                          <mat-form-field fxFlex>
                                            <mat-label>Category</mat-label>
                                            <mat-select required formControlName="categoryId2"
                                              [disableOptionCentering]="true" #singleSelect name="item">
                                              <mat-option>
                                                <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                  [formControl]="
                                                  categoryFilterControl
                                                " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                  true
                                                " noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                              </mat-option>
                                              <mat-option *ngFor="
                                                let opt of filteredCategoryTypeList
                                              " [value]="opt.categoryId">
                                                {{ opt.categoryName }}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                        </div>
                                        <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">

                                          <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField4')"
                                            (fileUploadResult)="
                                        getResultts($event, i,'customField4')" [index]="i"
                                            [value]="comp.controls['customField4'].value">
                                          </calsoft-image>
                                          <mat-form-field fxFlex>
                                            <mat-label>Category</mat-label>
                                            <mat-select required formControlName="categoryId3"
                                              [disableOptionCentering]="true" #singleSelect name="item">
                                              <mat-option>
                                                <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                  [formControl]="
                                                  categoryFilterControl
                                                " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                  true
                                                " noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                              </mat-option>
                                              <mat-option *ngFor="
                                                let opt of filteredCategoryTypeList
                                              " [value]="opt.categoryId">
                                                {{ opt.categoryName }}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                        </div>
                                      </div>

                                    </div>

                                    <div fxLayout="column"
                                      *ngIf="comp.controls['customField1'].value=='type7'||comp.controls['customField1'].value=='type8' || comp.controls['customField1'].value=='type9' || comp.controls['customField1'].value=='type10' ">
                                      <div fxFlex fxLayout="column" fxLayoutGap="10">
                                        <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">
                                          <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField2')"
                                            (fileUploadResult)="
                                          getResultts($event, i,'customField2') " [index]="i"
                                            [value]="comp.controls['customField2'].value">
                                          </calsoft-image>
                                          <mat-form-field fxFlex>
                                            <mat-label>Category</mat-label>
                                            <mat-select required formControlName="categoryId1"
                                              [disableOptionCentering]="true" #singleSelect name="item">
                                              <mat-option>
                                                <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                  [formControl]="
                                                  categoryFilterControl
                                                " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                  true
                                                " noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                              </mat-option>
                                              <mat-option *ngFor="
                                                let opt of filteredCategoryTypeList
                                              " [value]="opt.categoryId">
                                                {{ opt.categoryName }}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>

                                        </div>

                                        <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">

                                          <calsoft-image fxFlex (deleteResult)="updatesIMage($event, i,'customField3')"
                                            (fileUploadResult)="
                                        getResultts($event, i,'customField3')" [index]="i"
                                            [value]="comp.controls['customField3'].value">
                                          </calsoft-image>
                                          <mat-form-field fxFlex>
                                            <mat-label>Category</mat-label>
                                            <mat-select required formControlName="categoryId2"
                                              [disableOptionCentering]="true" #singleSelect name="item">
                                              <mat-option>
                                                <ngx-mat-select-search name="Category Search" ngDefaultControl
                                                  [formControl]="
                                                  categoryFilterControl
                                                " placeholderLabel="Category Search" [preventHomeEndKeyPropagation]="
                                                  true
                                                " noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                              </mat-option>
                                              <mat-option *ngFor="
                                                let opt of filteredCategoryTypeList
                                              " [value]="opt.categoryId">
                                                {{ opt.categoryName }}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>

                                          <mat-form-field fxFlex>
                                            <mat-label>Alt Tag</mat-label>
                                            <input [attr.guide]="'template-inp-altimage' + '__' + sanitizedUrl"
                                              (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                              trim="blur" matInput formControlName="altImage" />

                                          </mat-form-field>

                                        </div>

                                      </div>

                                    </div>


                                  </div>
                                  <div fxLayout="column" *ngIf="(comp.controls['type'].value == 'vedioBanner') ">

                                    <mat-form-field fxFlex appearance="outline">
                                      <mat-label>Video Title Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield37' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField37" matInput />
                                    </mat-form-field>
                                    <mat-form-field fxFlex appearance="outline">
                                      <mat-label>Video Title Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield38' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField38" matInput />
                                    </mat-form-field>
                                    <mat-form-field fxFlex appearance="outline">
                                      <mat-label>Video Description Web Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield39' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField39" matInput />
                                    </mat-form-field>
                                    <mat-form-field fxFlex appearance="outline">
                                      <mat-label>Video Description Mobile Font Size</mat-label>
                                      <input [attr.guide]="'template-inp-customfield40' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        formControlName="customField40" matInput />
                                    </mat-form-field>


                                  </div>


                                  <!-- vedio  -->

                                  <div fxLayout="column" *ngIf="(comp.controls['type'].value == 'vedioBanner') ">

                                    <div *ngIf="comp.controls.customField25.value == 0">
                                      <calsoft-video fxFlex="40" fxFlex.xs="100" style="padding-bottom: 10px;"
                                        (deleteResult)="updatesIMage($event, i,'customField6')" (fileUploadResult)="
                                    getResultts($event, i,'customField6') " [index]="i"
                                        [value]="comp.controls['customField6'].value">
                                      </calsoft-video>
                                    </div>


                                    <div *ngIf="comp.controls.customField25.value == 1">
                                      <calsoft-image fxFlex="40" fxFlex.xs="100" style="padding-bottom: 10px;"
                                        (deleteResult)="updatesIMage($event, i,'customField6')" (fileUploadResult)="
                                    getResultts($event, i,'customField6') " [index]="i"
                                        [value]="comp.controls['customField6'].value">
                                      </calsoft-image>
                                    </div>

                                    <div *ngIf="comp.controls.customField25.value == 2">

                                      <calsoft-pdf fxFlex="40" fxFlex.xs="100" style="padding-bottom: 10px;"
                                        (deleteResult)="updatesIMage($event, i,'customField6')" (fileUploadResult)="
                                    getResultts($event, i,'customField6') " [index]="i"
                                        [value]="comp.controls['customField6'].value">
                                      </calsoft-pdf>
                                    </div>

                                  </div>
                                  <div fxLayout="column" *ngIf="(comp.controls['type'].value == 'scrolltextwithform') ">

                                    <div>
                                      <calsoft-video fxFlex="40" style="padding-bottom: 10px;"
                                        (deleteResult)="updatesIMage($event, i,'customField10')" (fileUploadResult)="
                                    getResultts($event, i,'customField10') " [index]="i"
                                        [value]="comp.controls['customField10'].value">
                                      </calsoft-video>

                                      <div fxFlex="5">

                                      </div>



                                    </div>


                                  </div>

                                  <br>


                                  <div *ngIf="comp.controls['type'].value == 'textWithImage'  " fxLayout="row"
                                    fxLayout.xs="column" fxLayoutAlign.xs="start" fxLayoutAlign="start center"
                                    fxLayoutGap="10px">
                                    <mat-form-field fxFlex="50" fxFlex.xs="100" appearance="outline">
                                      <mat-label>Inner Text</mat-label>
                                      <textarea [attr.guide]="'template-sel-customfield1' + '__' + sanitizedUrl"
                                        trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5
                                        matInput formControlName="customField1" require d></textarea>
                                      <mat-icon class="clickable"
                                        (click)="openEditorText(comp.controls['customField1'].value,i,'customField1')"
                                        matSuffix>
                                        post_add
                                      </mat-icon>
                                      <mat-hint fxHide.lt-md>Click on the icon to open editor</mat-hint>
                                    </mat-form-field>
                                    <mat-form-field fxFlex appearance="outline">
                                      <mat-label>Button Name</mat-label>
                                      <input [attr.guide]="'template-inp-customfield5' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        matInput formControlName="customField5" />

                                    </mat-form-field>

                                    <mat-form-field fxFlex appearance="outline">
                                      <mat-label>Button Radius</mat-label>
                                      <input [attr.guide]="'template-inp-customfield11' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        matInput formControlName="customField11" />

                                    </mat-form-field>
                                  </div>

                                  <div *ngIf="comp.controls['type'].value == 'freeText'  " fxLayout="row"
                                    fxLayout.lt-md="column" fxLayoutAlign="start center" fxLayoutAlign.xs="start start"
                                    fxLayoutGap="10px">
                                    <mat-form-field fxFlex="50" class="mobilewidth" appearance="outline">
                                      <mat-label>Inner Text</mat-label>
                                      <textarea [attr.guide]="'template-sel-customfield1' + '__' + sanitizedUrl"
                                        trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5
                                        matInput formControlName="customField1" require d></textarea>
                                      <mat-icon class="clickable"
                                        (click)="openEditorText(comp.controls['customField1'].value,i,'customField1')"
                                        matSuffix>
                                        post_add
                                      </mat-icon>
                                      <mat-hint fxHide.lt-md>Click on the icon to open editor</mat-hint>
                                      <mat-error *ngIf="
                                    comp.controls.value.errors?.required
                                  ">
                                        Please fill out this field.
                                      </mat-error>
                                    </mat-form-field>



                                    <mat-form-field fxFlex class="mobilewidth">
                                      <mat-label>AlignMent</mat-label>
                                      <mat-select required formControlName="categoryId6" name="item">
                                        <mat-option *ngFor="
                                          let item of alignMent;
                                          let i = index
                                        " [value]="item.value">
                                          {{ item.viewValue }}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>

                                    <mat-form-field *ngIf="layoutMainType !=4" fxFlex class="mobilewidth"
                                      appearance="outline">
                                      <mat-label>Content Gap</mat-label>
                                      <input [attr.guide]="'template-inp-customfield34' + '__' + sanitizedUrl"
                                        (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" trim="blur"
                                        matInput formControlName="customField34" />

                                    </mat-form-field>

                                    <mat-form-field *ngIf="layoutMainType !=4" fxFlex class="mobilewidth"
                                      appearance="outline">
                                      <mat-label>Content Radius</mat-label>
                                      <input [attr.guide]="'template-inp-customfield24' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField24" />
                                    </mat-form-field>


                                  </div>
                                  <div *ngIf="comp.controls['type'].value == 'freeText' && layoutMainType !=4 "
                                    fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">


                                    <mat-form-field fxFlex class="mobilewidth" appearance="outline">
                                      <mat-label>Scrolling Speeds</mat-label>
                                      <input [attr.guide]="'template-inp-customfield38' + '__' + sanitizedUrl"
                                        trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'"
                                        matInput formControlName="customField38" />
                                    </mat-form-field>

                                    <mat-form-field fxFlex>
                                      <mat-label>Slider Train Animation</mat-label>
                                      <mat-select formControlName="customField39" name="item">
                                        <mat-option *ngFor="
                                          let item of sliderAnimation;
                                          let i = index
                                        " [value]="item.value">
                                          {{ item.viewValue }}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>




                                  </div>
                                  <!-- categoryCarousel -->

                                  <div *ngIf="comp.controls['type'].value == 'categoryCarousel'  " fxLayout="row"
                                    fxLayoutAlign="start center" fxLayoutGap="10px">


                                    <!-- categoryCarousel -->


                                  </div>
                                  <!----Gragdrop--->

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- <pre>{{ _form.value | json }}</pre> -->
                  </div>
                </div>
              </calsoft-scrollbar>
            </div>
          </div>
        </mat-drawer-content>
      </mat-drawer-container>
    </div>

  </div>
</div>


<ng-template #imageDot>
  <div class="padding-10 color-gray font-white-color">
    <span>Add Dot</span>
  </div>

  <div class="padding-10">

    <section class="lookbook">
      <div fxLayout="row" fxLayoutGap="15px" fxLayout.xs="column">
        <div>
          <div class="lookbook-block">

            <!-- <img (dblclick)="setDots($event)" [src]="imageUrl" class="img-fluid w-100" alt="" id="image-container"> -->

            <calsoft-common-images (dblclick)="setDots($event)" [src]="imageUrl" id="image-container" [alt]="">

            </calsoft-common-images>

            <!-- <img (dblclick)="setDots($event)" 
                  src="assets/images/layout/layout-four-blue.png" class="img-fluid w-100"
                   alt="" id="image-container" 
                   >  -->

            <div *ngFor="let dot of dots" class="lookbook-dot" [style.top]="dot.customField3"
              [style.left]="dot.customField4">
              <span>{{dot.customField5}}</span>
              <a>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>


  <div class="padding-10" fxLayoutAlign="end center" fxLayoutGap="10px">
    <button [attr.guide]="'template-btn-103' + '__' + sanitizedUrl" mat-raised-button (click)="close()">Cancel</button>
    <button [attr.guide]="'template-btn-104' + '__' + sanitizedUrl" (click)="saveDot()" mat-raised-button>
      save
      <!-- <mat-icon *ngIf="dotSaved !='Save' ">
                  <mat-spinner color="primary" diameter="20">
                  </mat-spinner>
              </mat-icon>-->
    </button>
  </div>

</ng-template>